/*
 * @license
 * Palo Alto Theme (c) Invisible Themes
 *
 * Modified versions of the theme code
 * are not supported by Groupthought.
 *
 */
function replaceUrlParam(t, e, i) {
  var n = new RegExp("(" + e + "=).*?(&|$)"),
    o = t;
  return t.search(n) >= 0
    ? t.replace(n, "$1" + i + "$2")
    : o + (o.indexOf("?") > 0 ? "&" : "?") + e + "=" + i;
}
!(function (t, e, i, n, o) {
  "use strict";
  (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.keyboardKeys = {
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      SPACE: 32,
      LEFTARROW: 37,
      RIGHTARROW: 39,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let r = u();
  function s() {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = d('[data-section-type*="footer"]')),
      (t.headerHeight = d("[data-header-height]")),
      (t.collectionStickyBarHeight = d("[data-collection-sticky-bar]")),
      t
    );
  }
  function a() {
    document.addEventListener("theme:resize", c), l();
  }
  function l() {
    const {
      windowHeight: t,
      headerHeight: e,
      footerHeight: i,
      collectionStickyBarHeight: n,
    } = s();
    document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.documentElement.style.setProperty(
        "--collection-sticky-bar-height",
        `${n}px`
      );
  }
  function c() {
    const {
        windowHeight: t,
        headerHeight: e,
        footerHeight: i,
        collectionStickyBarHeight: n,
      } = s(),
      o = u();
    o !== r &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      (r = o)),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.documentElement.style.setProperty(
        "--collection-sticky-bar-height",
        `${n}px`
      );
  }
  function d(t) {
    const e = document.querySelector(t);
    return e ? e.clientHeight : 0;
  }
  function u() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function h(t, e) {
    let i;
    return function () {
      if (t) {
        const n = () => t.apply(this, arguments);
        clearTimeout(i), (i = setTimeout(n, e));
      }
    };
  }
  function p() {
    document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
      window.lastWindowWidth !== window.innerWidth &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:width", { bubbles: !0 })
        ),
        (window.lastWindowWidth = window.innerWidth));
  }
  window.lastWindowWidth = window.innerWidth;
  function f(t) {
    document.querySelectorAll("table").forEach((t) => {
      ((t, e = "", i) => {
        const n = i || document.createElement("div");
        n.classList.add(e),
          n.setAttribute("data-scroll-lock-scrollable", ""),
          t.parentNode.insertBefore(n, t),
          n.appendChild(t);
      })(t, "table-wrapper");
    });
  }
  window.addEventListener("resize", h(p, 50)),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    l(),
    window.addEventListener("load", () => {
      a(), f();
    }),
    document.addEventListener("shopify:section:load", (t) => {
      t.target;
      f(), a();
    }),
    (function () {
      function t(t) {
        var e = window.innerWidth || document.documentElement.clientWidth,
          i = window.innerHeight || document.documentElement.clientHeight,
          n = t.getBoundingClientRect();
        return n.top >= 0 && n.bottom <= i && n.left >= 0 && n.right <= e;
      }
      function e(t) {
        var e = window.innerWidth || document.documentElement.clientWidth,
          i = window.innerHeight || document.documentElement.clientHeight,
          n = t.getBoundingClientRect(),
          o = (n.left >= 0 && n.left <= e) || (n.right >= 0 && n.right <= e),
          r = (n.top >= 0 && n.top <= i) || (n.bottom >= 0 && n.bottom <= i);
        return o && r;
      }
      window.visibilityHelper = {
        isElementTotallyVisible: t,
        isElementPartiallyVisible: e,
        inViewportPartially: function (t, i) {
          function n() {
            var n = e(t);
            n != o && ((o = n), "function" == typeof i && i(n, t));
          }
          var o = e(t);
          window.addEventListener("load", n),
            window.addEventListener("resize", n),
            window.addEventListener("scroll", n);
        },
        inViewportTotally: function (e, i) {
          function n() {
            var n = t(e);
            n != o && ((o = n), "function" == typeof i && i(n, e));
          }
          var o = t(e);
          window.addEventListener("load", n),
            window.addEventListener("resize", n),
            window.addEventListener("scroll", n);
        },
      };
    })();
  const m = (t, e) => {
      let i, n;
      return function o(...r) {
        const s = Date.now();
        (n = clearTimeout(n)),
          !i || s - i >= e
            ? (t.apply(null, r), (i = s))
            : (n = setTimeout(o.bind(null, ...r), e - (s - i)));
      };
    },
    g = (t, e = 500) => {
      (t.style.transitionProperty = "height, margin, padding"),
        (t.style.transitionDuration = e + "ms"),
        (t.style.boxSizing = "border-box"),
        (t.style.height = t.offsetHeight + "px"),
        t.offsetHeight,
        (t.style.overflow = "hidden"),
        (t.style.height = 0),
        (t.style.paddingTop = 0),
        (t.style.paddingBottom = 0),
        (t.style.marginTop = 0),
        (t.style.marginBottom = 0),
        window.setTimeout(() => {
          (t.style.display = "none"),
            t.style.removeProperty("height"),
            t.style.removeProperty("padding-top"),
            t.style.removeProperty("padding-bottom"),
            t.style.removeProperty("margin-top"),
            t.style.removeProperty("margin-bottom"),
            t.style.removeProperty("overflow"),
            t.style.removeProperty("transition-duration"),
            t.style.removeProperty("transition-property");
        }, e);
    },
    y = (t, e = 500, i = "block", n = !0) => {
      let o = window.getComputedStyle(t).display;
      if (n && "none" !== o) return;
      t.style.removeProperty("display"),
        "none" === o && (o = i),
        (t.style.display = o);
      let r = t.offsetHeight;
      (t.style.overflow = "hidden"),
        (t.style.height = 0),
        (t.style.paddingTop = 0),
        (t.style.paddingBottom = 0),
        (t.style.marginTop = 0),
        (t.style.marginBottom = 0),
        t.offsetHeight,
        (t.style.boxSizing = "border-box"),
        (t.style.transitionProperty = "height, margin, padding"),
        (t.style.transitionDuration = e + "ms"),
        (t.style.height = r + "px"),
        t.style.removeProperty("padding-top"),
        t.style.removeProperty("padding-bottom"),
        t.style.removeProperty("margin-top"),
        t.style.removeProperty("margin-bottom"),
        window.setTimeout(() => {
          t.style.removeProperty("height"),
            t.style.removeProperty("overflow"),
            t.style.removeProperty("transition-duration"),
            t.style.removeProperty("transition-property");
        }, e);
    };
  function v(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  v.prototype = Error.prototype;
  const b = "[data-collapsible-single]",
    w = "[data-collapsible-trigger]",
    S = "[data-collapsible-content]",
    E = "is-expanded",
    L = "data-collapsible-trigger-mobile",
    k = "aria-expanded",
    x = "aria-controls",
    T = "aria-hidden",
    A = 500,
    C = {};
  class q {
    constructor(t) {
      (this.container = t),
        (this.single = this.container.querySelector(b)),
        (this.triggers = this.container.querySelectorAll(w)),
        (this.resetHeightTimer = 0),
        (this.isTransitioning = !1),
        (this.collapsibleToggleEvent = (t) =>
          m(this.collapsibleToggle(t), 1250)),
        this.init();
    }
    init() {
      this.triggers.forEach((t) => {
        t.addEventListener("click", this.collapsibleToggleEvent),
          t.addEventListener("keyup", this.collapsibleToggleEvent);
      });
    }
    collapsibleToggle(t) {
      t.preventDefault();
      const e = t.target.matches(w) ? t.target : t.target.closest(w),
        i = e.getAttribute(x),
        n = document.getElementById(i),
        o = e.hasAttribute(L),
        r = e.classList.contains(E),
        s = t.keyCode === theme.keyboardKeys.SPACE,
        a = t.keyCode === theme.keyboardKeys.ESCAPE,
        l = window.innerWidth < theme.sizes.small;
      this.isTransitioning ||
        ((!t.keyCode || s || a) &&
          ((!r && a) ||
            (o && !l) ||
            ((this.isTransitioning = !0),
            (e.disabled = !0),
            this.single &&
              this.triggers.forEach((t) => {
                const i = t.classList.contains(E);
                if (e == t || !i) return;
                const n = t.getAttribute(x),
                  o = document.getElementById(n);
                this.closeItem(o, t);
              }),
            r ? this.closeItem(n, e) : this.openItem(n, e))));
    }
    openItem(t, e) {
      let i = t.querySelector(S).offsetHeight;
      this.setDropdownHeight(t, i, e, !1),
        e.classList.add(E),
        e.setAttribute(k, !0);
    }
    closeItem(t, e) {
      let i = t.querySelector(S).offsetHeight;
      requestAnimationFrame(() => {
        (i = 0), this.setDropdownHeight(t, i, e, !0), e.classList.remove(E);
      }),
        this.setDropdownHeight(t, i, e, !0),
        e.classList.remove(E),
        e.setAttribute(k, !1);
    }
    setDropdownHeight(t, e, i, n) {
      (t.style.height = `${e}px`),
        t.setAttribute(T, n),
        t.classList.toggle(E, !n),
        this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
        0 == e &&
          (this.resetHeightTimer = setTimeout(() => {
            t.style.height = "";
          }, A)),
        n
          ? (this.isTransitioning = !1)
          : (this.resetHeightTimer = setTimeout(() => {
              (t.style.height = "auto"), (this.isTransitioning = !1);
            }, A)),
        setTimeout(() => {
          i.disabled = !1;
        }, A);
    }
    onUnload() {
      this.triggers.forEach((t) => {
        t.removeEventListener("click", this.collapsibleToggleEvent),
          t.removeEventListener("keyup", this.collapsibleToggleEvent);
      });
    }
  }
  const P = {
      onLoad() {
        C[this.id] = new q(this.container);
      },
      onUnload() {
        C[this.id].onUnload();
      },
    },
    _ = "[data-quantity-holder]",
    D = "[data-quantity-field]",
    I = "[data-quantity-button]",
    O = "[data-quantity-minus]",
    F = "[data-quantity-plus]",
    H = "read-only",
    M = "is-disabled";
  class j {
    constructor(t, e = !1) {
      (this.holder = t), (this.quantityUpdateCart = e);
    }
    init() {
      (this.quantity = this.holder.querySelector(_)),
        this.quantity &&
          ((this.field = this.quantity.querySelector(D)),
          (this.buttons = this.quantity.querySelectorAll(I)),
          (this.increaseButton = this.quantity.querySelector(F)),
          (this.quantityValue = Number(this.field.value || 0)),
          (this.cartItemID = this.field.getAttribute("data-id")),
          (this.maxValue =
            Number(this.field.getAttribute("max")) > 0
              ? Number(this.field.getAttribute("max"))
              : null),
          (this.minValue =
            Number(this.field.getAttribute("min")) > 0
              ? Number(this.field.getAttribute("min"))
              : 0),
          (this.disableIncrease = this.disableIncrease.bind(this)),
          (this.emptyField = !1),
          (this.updateQuantity = this.updateQuantity.bind(this)),
          (this.decrease = this.decrease.bind(this)),
          (this.increase = this.increase.bind(this)),
          this.disableIncrease(),
          this.quantity.classList.contains(H) ||
            (this.changeValueOnClick(), this.changeValueOnInput()));
    }
    changeValueOnClick() {
      this.buttons.forEach((t) => {
        t.addEventListener("click", (t) => {
          t.preventDefault();
          const e = t.target,
            i = e.matches(O) || e.closest(O),
            n = e.matches(F) || e.closest(F);
          i && this.decrease(), n && this.increase(), this.updateQuantity();
        });
      });
    }
    changeValueOnInput() {
      this.field.addEventListener("input", (t) => {
        (this.quantityValue = this.field.value),
          "" === this.value && (this.emptyField = !0),
          this.updateQuantity();
      });
    }
    updateQuantity() {
      this.maxValue < this.quantityValue &&
        null !== this.maxValue &&
        (this.quantityValue = this.maxValue),
        this.minValue > this.quantityValue &&
          (this.quantityValue = this.minValue),
        (this.field.value = this.quantityValue),
        this.disableIncrease(),
        document.dispatchEvent(new CustomEvent("theme:cart:update")),
        this.quantityUpdateCart && this.updateCart();
    }
    decrease() {
      this.quantityValue > this.minValue
        ? this.quantityValue--
        : (this.quantityValue = 0);
    }
    increase() {
      this.quantityValue++;
    }
    disableIncrease() {
      this.increaseButton.classList.toggle(
        M,
        this.quantityValue >= this.maxValue && null !== this.maxValue
      );
    }
    updateCart() {
      0 == this.quantityValue && $("#sac-check").css("display", "none");
      const t = new CustomEvent("theme:cart:update", {
        bubbles: !0,
        detail: {
          id: this.cartItemID,
          quantity: this.quantityValue,
          valueIsEmpty: this.emptyField,
        },
      });
      console.log(this.quantityValue),
        0 === this.quantityValue &&
          ($("span.cart-count").text(""), window.location.reload()),
        this.holder.dispatchEvent(t);
    }
  }
  const N = {};
  function B(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return N[t.url]
        ? N[t.url]
        : (function (t, e) {
            const i = new Promise((i, n) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      i(t);
                    })
                    .catch((t) => {
                      n(t);
                    })
                : (function (t, e, i) {
                    let n = document.getElementsByTagName("head")[0],
                      o = !1,
                      r = document.createElement("script");
                    (r.src = t),
                      (r.onload = r.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? i()
                            : ((o = !0), e());
                        }),
                      n.appendChild(r);
                  })(
                    t,
                    function () {
                      i();
                    },
                    function () {
                      n();
                    }
                  );
            });
            return (N[t] = i), i;
          })(t.url, t.type);
    if (t.json)
      return N[t.json]
        ? Promise.resolve(N[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((N[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return N[e]
        ? N[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              i = new Promise((e, i) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, i) {
                          i ? e(i) : t();
                        })(e, i, t);
                      },
                    },
                  ]);
                } catch (t) {
                  i(t);
                }
              });
            return (N[e] = i), i;
          })(t);
    }
    return Promise.reject();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const W = "[data-video-id]",
    z = "loaded",
    R = "data-enable-sound",
    V = "data-enable-background",
    U = "data-enable-autoplay",
    G = "data-enable-loop",
    K = "data-video-id",
    X = "data-video-type";
  class Y {
    constructor(t) {
      (this.container = t),
        (this.player = this.container.querySelector(W)),
        this.player &&
          ((this.videoID = this.player.getAttribute(K)),
          (this.videoType = this.player.getAttribute(X)),
          (this.enableBackground = "true" === this.player.getAttribute(V)),
          (this.disableSound = "false" === this.player.getAttribute(R)),
          (this.enableAutoplay = "false" !== this.player.getAttribute(U)),
          (this.enableLoop = "false" !== this.player.getAttribute(G)),
          "vimeo" == this.videoType && this.init());
    }
    init() {
      this.loadVimeoPlayer();
    }
    loadVimeoPlayer() {
      const t = "https://vimeo.com/" + this.videoID;
      let e = "";
      const i = this.player,
        n = {
          url: t,
          background: this.enableBackground,
          muted: this.disableSound,
          autoplay: this.enableAutoplay,
          loop: this.enableLoop,
        };
      for (let t in n)
        e += encodeURIComponent(t) + "=" + encodeURIComponent(n[t]) + "&";
      fetch(`https://vimeo.com/api/oembed.json?${e}`)
        .then((t) => t.json())
        .then(function (t) {
          (i.innerHTML = t.html),
            setTimeout(function () {
              i.parentElement.classList.add(z);
            }, 1e3);
        })
        .catch(function () {
          console.log("error");
        });
    }
  }
  const Q = {
      videoIframe: "[data-video-id]",
      videoWrapper: ".video-wrapper",
      youtubeWrapper: "[data-youtube-wrapper]",
    },
    J = "data-section-id",
    Z = "data-enable-sound",
    tt = "data-check-player-visibility",
    et = "data-video-id",
    it = "data-video-type",
    nt = "loaded",
    ot = [];
  class rt {
    constructor(t) {
      (this.container = t),
        (this.player = this.container.querySelector(Q.videoIframe)),
        this.player &&
          ((this.videoOptionsVars = {}),
          (this.videoID = this.player.getAttribute(et)),
          (this.videoType = this.player.getAttribute(it)),
          "youtube" == this.videoType &&
            ((this.checkPlayerVisibilityFlag =
              "true" === this.player.getAttribute(tt)),
            (this.playerID = this.player.querySelector(Q.youtubeWrapper)
              ? this.player.querySelector(Q.youtubeWrapper).id
              : this.player.id),
            this.player.hasAttribute(Q.dataHideOptions) &&
              (this.videoOptionsVars = {
                cc_load_policy: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                autohide: 0,
                controls: 0,
                branding: 0,
                showinfo: 0,
                rel: 0,
                fs: 0,
                wmode: "opaque",
              }),
            this.init(),
            this.container.addEventListener("touchstart", function (t) {
              if (
                t.target.matches(Q.videoWrapper) ||
                t.target.closest(Q.videoWrapper)
              ) {
                const e = t.target.querySelector(Q.videoIframe).id;
                ot[e].playVideo();
              }
            })));
    }
    init() {
      window.isYoutubeAPILoaded
        ? this.loadYoutubePlayer()
        : B({ url: "https://www.youtube.com/iframe_api" }).then(() =>
            this.loadYoutubePlayer()
          );
    }
    loadYoutubePlayer() {
      const t = {
        ...{
          height: "720",
          width: "1280",
          playerVars: this.videoOptionsVars,
          events: {
            onReady: (t) => {
              const e = t.target.getIframe(),
                i = e.id,
                n = "true" === document.querySelector(`#${i}`).getAttribute(Z);
              e.setAttribute("tabindex", "-1"),
                n ? t.target.unMute() : t.target.mute(),
                t.target.playVideo(),
                this.checkPlayerVisibilityFlag &&
                  (this.checkPlayerVisibility(i),
                  window.addEventListener(
                    "scroll",
                    m(() => {
                      this.checkPlayerVisibility(i);
                    }, 150)
                  ));
            },
            onStateChange: (t) => {
              0 == t.data && t.target.playVideo(),
                1 == t.data &&
                  t.target.getIframe().parentElement.classList.add(nt);
            },
          },
        },
      };
      (t.videoId = this.videoID),
        this.videoID.length &&
          YT.ready(() => {
            ot[this.playerID] = new YT.Player(this.playerID, t);
          }),
        (window.isYoutubeAPILoaded = !0);
    }
    checkPlayerVisibility(t) {
      let e;
      if ("string" == typeof t) e = t;
      else {
        if (null == t.data) return;
        e = t.data.id;
      }
      const i = document.getElementById(e + "-container");
      if (!i) return;
      const n = ot[e],
        o = i.getBoundingClientRect();
      let r =
        visibilityHelper.isElementPartiallyVisible(i) ||
        visibilityHelper.isElementTotallyVisible(i);
      o.top < 0 && i.clientHeight + o.top >= 0 && (r = !0),
        r && n && "function" == typeof n.playVideo
          ? n.playVideo()
          : !r && n && "function" == typeof n.pauseVideo && n.pauseVideo();
    }
    onUnload() {
      const t = "youtube-" + this.container.getAttribute(J);
      ot[t] && ot[t].destroy();
    }
  }
  const st = "[data-notification-form]",
    at = "[data-notification]",
    lt = "[data-popup-close]",
    ct = "pswp--success",
    dt = "notification-popup-visible";
  class ut {
    constructor(t, e) {
      (this.popup = t),
        (this.pswpElement = e),
        (this.notificationForm = null),
        (this.notificationStopSubmit = !0),
        (this.sessionStorage = window.sessionStorage);
      const i = this.pswpElement.querySelector(at);
      (this.outerCloseEvent = (t) => {
        i.contains(t.target) || this.popup.close();
      }),
        this.init();
    }
    init() {
      this.popup.listen("preventDragEvent", (t, e, i) => {
        i.prevent = !1;
      });
      const t = -1 !== window.location.search.indexOf("?customer_posted=true");
      this.notificationForm = this.pswpElement.querySelector(st);
      const e = this.pswpElement.querySelector(lt);
      document.body.classList.add(dt),
        this.pswpElement.addEventListener("mousedown", () => {
          this.popup.framework.unbind(
            window,
            "pointermove pointerup pointercancel",
            this.popup
          );
        }),
        t && this.pswpElement.classList.add(ct),
        this.notificationForm.addEventListener("submit", (t) =>
          this.notificationSubmitEvent(t)
        ),
        this.pswpElement.addEventListener("click", this.outerCloseEvent),
        e.addEventListener("click", () => {
          this.popup.close();
        }),
        this.popup.listen("destroy", () => {
          this.notificationRemoveStorage(),
            this.pswpElement.removeEventListener("click", this.outerCloseEvent),
            document.body.classList.remove(dt);
        });
    }
    notificationSubmitEvent(t) {
      this.notificationStopSubmit &&
        (t.preventDefault(),
        this.notificationRemoveStorage(),
        this.notificationWriteStorage(),
        (this.notificationStopSubmit = !1),
        this.notificationForm.submit());
    }
    notificationWriteStorage() {
      void 0 !== this.sessionStorage &&
        this.sessionStorage.setItem(
          "notification_form_id",
          this.notificationForm.id
        );
    }
    notificationRemoveStorage() {
      this.sessionStorage.removeItem("notification_form_id");
    }
  }
  function ht(t) {
    const i = e.data(t);
    i &&
      (i.on("dragStart", (t, e) => {
        document.ontouchmove = function (t) {
          t.preventDefault();
        };
      }),
      i.on("dragEnd", (t, e) => {
        document.ontouchmove = function (t) {
          return !0;
        };
      }));
  }
  const pt = "html5",
    ft = "youtube",
    mt = "vimeo",
    gt = "[data-deferred-media]",
    yt = "[data-deferred-media-button]",
    vt = "[data-product-single-media-wrapper]",
    bt = "[data-video]",
    wt = ".media--hidden",
    St = "media--hidden",
    Et = "loaded",
    Lt = "data-section-id",
    kt = "data-autoplay-video",
    xt = "data-media-id";
  class Tt {
    constructor(t) {
      (this.container = t),
        (this.id = this.container.getAttribute(Lt)),
        (this.autoplayVideo = "true" === this.container.getAttribute(kt)),
        (this.players = {}),
        this.init();
    }
    init() {
      this.container.querySelectorAll(bt).forEach((t) => {
        const e = t.querySelector(yt);
        e && e.addEventListener("click", this.loadContent.bind(this, t)),
          this.autoplayVideo && this.loadContent(t);
      });
    }
    loadContent(t) {
      if (t.querySelector(gt).getAttribute(Et)) return;
      const e = document.createElement("div");
      e.appendChild(
        t.querySelector("template").content.firstElementChild.cloneNode(!0)
      );
      const i = t.dataset.mediaId,
        n = e.querySelector("video, iframe"),
        o = this.hostFromVideoElement(n),
        r = t.querySelector(gt);
      r.appendChild(n),
        r.setAttribute("loaded", !0),
        (this.players[i] = {
          mediaId: i,
          sectionId: this.id,
          container: t,
          element: n,
          host: o,
          ready: () => {
            this.createPlayer(i);
          },
        });
      const s = this.players[i];
      switch (s.host) {
        case pt:
          this.loadVideo(s, pt);
          break;
        case mt:
          window.isVimeoAPILoaded
            ? this.loadVideo(s, mt)
            : B({ url: "https://player.vimeo.com/api/player.js" }).then(() =>
                this.loadVideo(s, mt)
              );
          break;
        case ft:
          window.isYoutubeAPILoaded
            ? this.loadVideo(s, ft)
            : B({ url: "https://www.youtube.com/iframe_api" }).then(() =>
                this.loadVideo(s, ft)
              );
      }
    }
    hostFromVideoElement(t) {
      if ("VIDEO" === t.tagName) return pt;
      if ("IFRAME" === t.tagName) {
        if (
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
            t.src
          )
        )
          return ft;
        if (t.src.includes("vimeo.com")) return mt;
      }
      return null;
    }
    loadVideo(t, e) {
      t.host === e && t.ready();
    }
    createPlayer(t) {
      const e = this.players[t];
      switch (e.host) {
        case pt:
          e.element.addEventListener("play", () => {
            e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
              bubbles: !0,
            });
          });
          const i = e.element.play();
          void 0 !== i && i.then((t) => {}).catch((t) => {}),
            e.container.addEventListener("theme:media:visible", (t) =>
              this.onVisible(t)
            ),
            e.container.addEventListener("theme:media:hidden", (t) =>
              this.onHidden(t)
            ),
            e.container.addEventListener("xrLaunch", (t) => this.onHidden(t)),
            this.autoplayVideo && this.observeVideo(e, t);
          break;
        case mt:
          (this.players[t].player = new Vimeo.Player(e.element)),
            this.players[t].player.play(),
            e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
              bubbles: !0,
            }),
            (window.isVimeoAPILoaded = !0),
            e.container.addEventListener("theme:media:visible", (t) =>
              this.onVisible(t)
            ),
            e.container.addEventListener("theme:media:hidden", (t) =>
              this.onHidden(t)
            ),
            e.container.addEventListener("xrLaunch", (t) => this.onHidden(t)),
            this.autoplayVideo && this.observeVideo(e, t);
          break;
        case ft:
          if (e.host == ft && e.player) return;
          YT.ready(() => {
            const i = e.container.dataset.videoId;
            (this.players[t].player = new YT.Player(e.element, {
              videoId: i,
              events: {
                onReady: (t) => {
                  t.target.playVideo(),
                    e.container.dispatchEvent(
                      new CustomEvent("theme:media:play"),
                      { bubbles: !0 }
                    );
                },
                onStateChange: (t) => {
                  1 == t.data &&
                    e.container.dispatchEvent(
                      new CustomEvent("theme:media:play"),
                      { bubbles: !0 }
                    ),
                    2 == t.data &&
                      e.container.dispatchEvent(
                        new CustomEvent("theme:media:pause"),
                        { bubbles: !0 }
                      );
                },
              },
            })),
              (window.isYoutubeAPILoaded = !0),
              e.container.addEventListener("theme:media:visible", (t) =>
                this.onVisible(t)
              ),
              e.container.addEventListener("theme:media:hidden", (t) =>
                this.onHidden(t)
              ),
              e.container.addEventListener("xrLaunch", (t) => this.onHidden(t)),
              this.autoplayVideo && this.observeVideo(e, t);
          });
      }
      e.container.addEventListener("theme:media:play", () =>
        this.pauseOtherMedia(t)
      );
    }
    observeVideo(t) {
      new IntersectionObserver(
        (e, i) => {
          e.forEach((e) => {
            const i = 0 == e.intersectionRatio,
              n = !t.element.closest(wt);
            i ? this.pauseVideo(t) : n && this.playVideo(t);
          });
        },
        { threshold: 0 }
      ).observe(t.element);
    }
    playVideo(t) {
      t.player && t.player.playVideo
        ? t.player.playVideo()
        : t.element && t.element.play
        ? t.element.play()
        : t.player && t.player.play && t.player.play(),
        t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
          bubbles: !0,
        });
    }
    pauseVideo(t) {
      t.player && t.player.pauseVideo
        ? t.player.pauseVideo()
        : t.element && t.element.pause
        ? t.element.pause()
        : t.player && t.player.pause && t.player.pause(),
        t.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
          bubbles: !0,
        });
    }
    onHidden(t) {
      if (void 0 !== t.target.dataset.mediaId) {
        const e = t.target.dataset.mediaId,
          i = this.players[e];
        this.pauseVideo(i);
      }
    }
    onVisible(t) {
      if (void 0 !== t.target.dataset.mediaId) {
        const e = t.target.dataset.mediaId,
          i = this.players[e];
        this.playVideo(i), this.pauseOtherMedia(e);
      }
    }
    pauseOtherMedia(t) {
      const e = `[${xt}="${t}"]`,
        i = document.querySelectorAll(`${vt}:not(${e})`);
      i.length &&
        i.forEach((t) => {
          t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            t.classList.add(St);
        });
    }
  }
  const At = (t, e = !1, i = "block") => {
      t && (e ? t.style.removeProperty("display") : (t.style.display = i));
    },
    Ct = (t) => {
      t && (t.style.display = "none");
    };
  function qt() {
    this.entries = [];
  }
  function Pt(t, e) {
    _t(t);
    var i = (function (t, e) {
      _t(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var i = [];
      return (
        e.forEach(function (e) {
          for (var n = 0; n < t.options.length; n++) {
            if (
              (t.options[n].name || t.options[n]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              i[n] = e.value;
              break;
            }
          }
        }),
        i
      );
    })(t, e);
    return (function (t, e) {
      _t(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e);
      var i = t.variants.filter(function (t) {
        return e.every(function (e, i) {
          return t.options[i] === e;
        });
      });
      return i[0] || null;
    })(t, i);
  }
  function _t(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  (qt.prototype.add = function (t, e, i) {
    this.entries.push({ element: t, event: e, fn: i }),
      t.addEventListener(e, i);
  }),
    (qt.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var Dt = '[name="id"]',
    It = '[name="selling_plan"]',
    Ot = '[name^="options"]',
    Ft = '[name="quantity"]',
    Ht = '[name^="properties"]';
  class Mt {
    constructor(t, e, i) {
      (this.element = t),
        (this.form =
          "FORM" == this.element.tagName
            ? this.element
            : this.element.querySelector("form")),
        (this.product = this._validateProductObject(e)),
        (this.variantElement = this.element.querySelector(Dt)),
        (i = i || {}),
        (this._listeners = new qt()),
        this._listeners.add(
          this.element,
          "submit",
          this._onSubmit.bind(this, i)
        ),
        (this.optionInputs = this._initInputs(Ot, i.onOptionChange)),
        (this.planInputs = this._initInputs(It, i.onPlanChange)),
        (this.quantityInputs = this._initInputs(Ft, i.onQuantityChange)),
        (this.propertyInputs = this._initInputs(Ht, i.onPropertyChange));
    }
    destroy() {
      this._listeners.removeAll();
    }
    options() {
      return this._serializeInputValues(this.optionInputs, function (t) {
        return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
      });
    }
    variant() {
      const t = this.options();
      return t.length ? Pt(this.product, t) : this.product.variants[0];
    }
    plan(t) {
      let e = { allocation: null, group: null, detail: null };
      const i = new FormData(this.form).get("selling_plan");
      return (
        i &&
          t &&
          (e.allocation = t.selling_plan_allocations.find(function (t) {
            return t.selling_plan_id.toString() === i.toString();
          })),
        e.allocation &&
          (e.group = this.product.selling_plan_groups.find(function (t) {
            return (
              t.id.toString() === e.allocation.selling_plan_group_id.toString()
            );
          })),
        e.group &&
          (e.detail = e.group.selling_plans.find(function (t) {
            return t.id.toString() === i.toString();
          })),
        e && e.allocation && e.detail && e.allocation ? e : null
      );
    }
    properties() {
      return this._serializeInputValues(this.propertyInputs, function (t) {
        return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
      });
    }
    quantity() {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    }
    getFormState() {
      const t = this.variant();
      return {
        options: this.options(),
        variant: t,
        properties: this.properties(),
        quantity: this.quantity(),
        plan: this.plan(t),
      };
    }
    _setIdInputValue(t) {
      t && t.id
        ? (this.variantElement.value = t.id.toString())
        : (this.variantElement.value = ""),
        this.variantElement.dispatchEvent(new Event("change"));
    }
    _onSubmit(t, e) {
      (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
    }
    _onOptionChange(t) {
      this._setIdInputValue(t.dataset.variant);
    }
    _onFormEvent(t) {
      return void 0 === t
        ? Function.prototype.bind()
        : function (e) {
            (e.dataset = this.getFormState()),
              this._setIdInputValue(e.dataset.variant),
              t(e);
          }.bind(this);
    }
    _initInputs(t, e) {
      return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
        function (t) {
          return this._listeners.add(t, "change", this._onFormEvent(e)), t;
        }.bind(this)
      );
    }
    _serializeInputValues(t, e) {
      return t.reduce(function (t, i) {
        return (
          (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
            t.push(e({ name: i.name, value: i.value })),
          t
        );
      }, []);
    }
    _validateProductObject(t) {
      if ("object" != typeof t) throw new TypeError(t + " is not an object.");
      if (void 0 === t.variants[0].options)
        throw new TypeError(
          "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
        );
      return t;
    }
  }
  const jt = "[data-store-availability-list]",
    Nt = {
      close: ".js-modal-close",
      open: ".js-modal-open-store-availability-modal",
      openClass: "modal--is-active",
      openBodyClass: "modal--is-visible",
      closeModalOnClick: !1,
      scrollIntoView: !1,
    };
  class Bt {
    constructor(t, e) {
      if (((this.modal = document.getElementById(t)), !this.modal)) return !1;
      (this.nodes = {
        parents: [document.querySelector("html"), document.body],
      }),
        (this.config = Object.assign(Nt, e)),
        (this.modalIsOpen = !1),
        (this.focusOnOpen = this.config.focusOnOpen
          ? document.getElementById(this.config.focusOnOpen)
          : this.modal),
        (this.openElement = document.querySelector(this.config.open)),
        this.init();
    }
    init() {
      this.openElement.addEventListener("click", this.open.bind(this)),
        this.modal
          .querySelector(this.config.close)
          .addEventListener("click", this.closeModal.bind(this));
    }
    open(t) {
      let e = !1;
      if ((t ? t.preventDefault() : (e = !0), this.modalIsOpen && !e))
        return void this.closeModal();
      this.modal.classList.add(this.config.openClass),
        this.nodes.parents.forEach((t) => {
          t.classList.add(this.config.openBodyClass);
        }),
        (this.modalIsOpen = !0);
      const i = document.querySelector(jt);
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: i })
      ),
        this.config.scrollIntoView && this.scrollIntoView(),
        this.bindEvents(),
        slate.a11y.trapFocus({ container: this.modal });
    }
    closeModal() {
      if (!this.modalIsOpen) return;
      document.activeElement.blur(),
        this.modal.classList.remove(this.config.openClass);
      var t = this;
      this.nodes.parents.forEach(function (e) {
        e.classList.remove(t.config.openBodyClass);
      }),
        (this.modalIsOpen = !1),
        this.openElement.focus(),
        this.unbindEvents(),
        slate.a11y.removeTrapFocus({ container: this.modal });
      document.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })
      );
    }
    bindEvents() {
      (this.keyupHandler = this.keyupHandler.bind(this)),
        (this.clickHandler = this.clickHandler.bind(this)),
        document.body.addEventListener("keyup", this.keyupHandler),
        document.body.addEventListener("click", this.clickHandler);
    }
    unbindEvents() {
      document.body.removeEventListener("keyup", this.keyupHandler),
        document.body.removeEventListener("click", this.clickHandler);
    }
    keyupHandler(t) {
      t.keyCode === theme.keyboardKeys.ESCAPE && this.closeModal();
    }
    clickHandler(t) {
      !this.config.closeModalOnClick ||
        this.modal.contains(t.target) ||
        t.target.matches(this.config.open) ||
        this.closeModal();
    }
    scrollIntoView() {
      this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
    }
  }
  const $t = "body",
    Wt = "[data-store-availability-modal]",
    zt = "[data-store-availability-modal-open]",
    Rt = "[data-store-availability-modal-close]",
    Vt = "[data-store-availability-modal-product__title]",
    Ut = "store-availabilities-modal--active";
  class Gt {
    constructor(t) {
      this.container = t;
    }
    updateContent(t, e) {
      this._fetchStoreAvailabilities(t, e);
    }
    clearContent() {
      this.container.innerHTML = "";
    }
    _initModal() {
      return new Bt("StoreAvailabilityModal", {
        close: Rt,
        open: zt,
        closeModalOnClick: !0,
        openClass: Ut,
        scrollIntoView: !1,
      });
    }
    _fetchStoreAvailabilities(t, e) {
      const i = "/variants/" + t + "/?section_id=store-availability";
      this.clearContent();
      const n = this;
      fetch(i)
        .then(function (t) {
          return t.text();
        })
        .then(function (t) {
          const i = document.querySelector($t);
          let o = i.querySelector(Wt);
          if (
            (o && o.remove(),
            (n.container.innerHTML = t),
            (n.container.innerHTML = n.container.firstElementChild.innerHTML),
            "" === n.container.firstElementChild.innerHTML.trim())
          )
            return void n.clearContent();
          n.container.querySelector(zt) &&
            ((n.modal = n._initModal()),
            n._updateProductTitle(e),
            (o = n.container.querySelector(Wt)),
            o && i.appendChild(o));
        });
    }
    _updateProductTitle(t) {
      this.container.querySelector(Vt).textContent = t;
    }
  }
  const Kt = "[data-product-form]",
    Xt = "[data-option-position]",
    Yt = '[name^="options"], [data-popout-option]',
    Qt = "sold-out",
    Jt = "unavailable",
    Zt = "data-option-position",
    te = "data-value";
  class ee {
    constructor(t, e) {
      (this.container = t),
        (this.productJSON = e),
        (this.form = this.container.querySelector(Kt)),
        (this.formData = new FormData(this.form)),
        (this.optionElements = this.container.querySelectorAll(Yt)),
        this.productJSON && this.form && this.init();
    }
    init() {
      this.update();
    }
    update() {
      this.getCurrentState(),
        this.optionElements.forEach((t) => {
          const e = t.value || t.getAttribute(te),
            i = t.closest(Xt);
          if (!i) return;
          const n = i.getAttribute(Zt),
            o = parseInt(n, 10) - 1;
          let r = [...this.selections];
          r[o] = e;
          const s = this.productJSON.variants.find((t) => {
            let e = !0;
            for (let i = 0; i < r.length; i++)
              t.options[i] !== r[i] && (e = !1);
            return e;
          });
          t.parentElement.classList.remove(Qt, Jt),
            void 0 === s
              ? t.parentElement.classList.add(Jt)
              : !1 === s?.available && t.parentElement.classList.add(Qt);
        });
    }
    getCurrentState() {
      for (var t of ((this.formData = new FormData(this.form)),
      (this.selections = []),
      this.formData.entries()))
        t[0].includes("options[") && this.selections.push(t[1]);
    }
  }
  const ie = 1,
    ne = "data-notification-popup",
    oe = {
      history: !1,
      focus: !1,
      mainClass: "pswp--notification pswp--not-close-btn",
      closeOnVerticalDrag: !1,
    };
  class re {
    constructor(t) {
      (this.button = t),
        (this.notificationPopupHtml = this.button.getAttribute(ne)),
        "" !== this.notificationPopupHtml.trim() && this.init();
    }
    init() {
      const t = [{ html: this.notificationPopupHtml }];
      (slate.a11y.state.trigger = this.button), new Cn(t, oe, ie);
    }
  }
  const se = "[data-product]",
    ae = "[data-product-form]",
    le = "[data-add-to-cart]",
    ce = "[data-add-to-cart-text]",
    de = "[data-buy-it-now]",
    ue = "[data-compare-price]",
    he = "[data-form-wrapper]",
    pe = "[data-site-header]",
    fe = "[data-product-select]",
    me = "_preorder",
    ge = "[data-price-wrapper]",
    ye = "[data-price-off]",
    ve = "[data-price-off-type]",
    be = "[data-price-off-amount]",
    we = "[data-product-single-media-slider]",
    Se = "[data-product-json]",
    Ee = "[data-product-price]",
    Le = "[data-product-unit-price]",
    ke = "[data-product-base]",
    xe = "[data-product-unit]",
    Te = "[data-subscription-watch-price]",
    Ae = "[data-subscription-selectors]",
    Ce = "[data-toggles-group]",
    qe = "data-group-toggle",
    Pe = "[data-plan-description]",
    _e = "[data-remaining-count]",
    De = "[data-remaining-wrapper]",
    Ie = "[data-product-remaining-json]",
    Oe = "[data-store-availability-container]",
    Fe = "[data-upsell-btn]",
    He = ".shopify-section",
    Me = "hidden",
    je = "variant--soldout",
    Ne = "variant--unavailabe",
    Be = "product__price--sale",
    $e = "product__price--hidden",
    We = "count-is-low",
    ze = "count-is-in",
    Re = "count-is-out",
    Ve = "count-is-unavailable",
    Ue = "data-enable-history-state",
    Ge = "data-notification-popup";
  class Ke {
    constructor(t) {
      if (
        ((this.container = t),
        (this.product = this.container.querySelector(se)),
        (this.productForm = this.container.querySelector(ae)),
        !this.product || !this.productForm)
      ) {
        return void new j(this.container).init();
      }
      (this.storeAvailabilityContainer = this.container.querySelector(Oe)),
        (this.enableHistoryState = "true" === this.container.getAttribute(Ue)),
        (this.hasUnitPricing = this.container.querySelector(xe)),
        (this.subSelectors = this.container.querySelector(Ae)),
        (this.subPrices = this.container.querySelector(Te)),
        (this.priceOffWrap = this.container.querySelector(ye)),
        (this.priceOffAmount = this.container.querySelector(be)),
        (this.priceOffType = this.container.querySelector(ve)),
        (this.planDecription = this.container.querySelector(Pe)),
        (this.latestVariantId = ""),
        (this.latestVariantTitle = ""),
        (this.sellout = null),
        (this.sessionStorage = window.sessionStorage),
        (this.remainingWrapper = this.container.querySelector(De)),
        this.remainingWrapper &&
          ((this.remainingMaxInt = parseInt(
            this.remainingWrapper.dataset.remainingMax,
            10
          )),
          (this.remainingCount = this.container.querySelector(_e)),
          (this.remainingJSONWrapper = this.container.querySelector(Ie)),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
            "" !== this.remainingJSONWrapper.innerHTML &&
            (this.remainingJSON = JSON.parse(
              this.remainingJSONWrapper.innerHTML
            ))),
        this.storeAvailabilityContainer &&
          (this.storeAvailability = new Gt(this.storeAvailabilityContainer));
      new j(this.container).init(), this.init();
    }
    init() {
      let t = null;
      const e = this.container.querySelector(Se);
      e && (t = e.innerHTML),
        t
          ? ((this.productJSON = JSON.parse(t)),
            this.linkForm(),
            (this.sellout = new ee(this.container, this.productJSON)))
          : console.error("Missing product JSON");
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new Mt(this.productForm, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState()),
        this.subsToggleListeners();
    }
    onOptionChange(t) {
      this.pushState(t.dataset), this.updateProductImage(t);
    }
    onPlanChange(t) {
      this.subPrices && this.pushState(t.dataset);
    }
    pushState(t) {
      (this.productState = this.setProductState(t)),
        this.updateAddToCartState(t),
        this.updateProductPrices(t),
        this.updateSaleText(t),
        this.updateSubscriptionText(t),
        this.fireHookEvent(t),
        this.updateRemaining(t),
        this.sellout?.update(t),
        this.enableHistoryState && this.updateHistoryState(t),
        this.storeAvailability &&
          (t.variant
            ? this.storeAvailability.updateContent(
                t.variant.id,
                this.productForm.product.title
              )
            : this.storeAvailability.clearContent());
    }
    updateAddToCartState(t) {
      const e = t.variant,
        i = this.container.querySelectorAll(ge),
        n = this.container.querySelectorAll(le),
        o = this.container.querySelectorAll(ce),
        r = this.container.querySelectorAll(he),
        s = this.container.querySelector(de);
      let a = theme.strings.add_to_cart;
      this.productJSON.tags.includes(me) && (a = theme.strings.preorder),
        i.length &&
          i.forEach((t) => {
            e ? t.classList.remove($e) : t.classList.add($e);
          }),
        n.length &&
          n.forEach((t) => {
            if (
              !t.matches(Fe) &&
              ((t.disabled = !0),
              s && s.classList.add(Me),
              e &&
                ((t.disabled = !1),
                e.available && s && s.classList.remove(Me),
                t.hasAttribute(Ge)))
            ) {
              const i = t.id.replace("AddToCart", "NotificationForm"),
                n = this.sessionStorage.getItem("notification_form_id");
              let o = !1,
                r = e.id,
                s = e.title;
              if (n) {
                const t = n.substring(0, n.lastIndexOf("--")),
                  e = n.split("--").slice(-1)[0];
                (o = i === t),
                  o &&
                    ((this.latestVariantId = r),
                    (this.latestVariantTitle = s),
                    (r = Number(e)),
                    this.productJSON.variants.forEach((t) => {
                      t.id === r && (s = t.title);
                    }));
              }
              let a = t.getAttribute(Ge);
              "" != this.latestVariantId &&
                "" != this.latestVariantTitle &&
                ((a = a.replaceAll(this.latestVariantId, r)),
                (a = a.replaceAll(this.latestVariantTitle, s))),
                t.setAttribute(Ge, a),
                o && (this.scrollToForm(this.product.closest(He)), new re(t)),
                (this.latestVariantId = r),
                (this.latestVariantTitle = s);
            }
          }),
        o.length &&
          o.forEach((t) => {
            e
              ? e.available
                ? (t.innerHTML = a)
                : ((t.innerHTML = theme.strings.sold_out),
                  t.parentNode.hasAttribute(Ge) &&
                    (t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`))
              : (t.innerHTML = theme.strings.unavailable);
          }),
        r.length &&
          r.forEach((t) => {
            if (e) {
              e.available
                ? t.classList.remove(je, Ne)
                : (t.classList.add(je), t.classList.remove(Ne));
              const i = t.querySelector(fe);
              i && (i.value = e.id);
            } else t.classList.add(Ne), t.classList.remove(je);
          });
    }
    updateHistoryState(t) {
      const e = t.variant,
        i = t.plan,
        n = window.location.href;
      if (e && n.includes("/product")) {
        const t = new window.URL(n),
          o = t.searchParams;
        o.set("variant", e.id),
          i && i.detail && i.detail.id && this.productState.hasPlan
            ? o.set("selling_plan", i.detail.id)
            : o.delete("selling_plan"),
          (t.search = o.toString());
        const r = t.toString();
        window.history.replaceState({ path: r }, "", r);
      }
    }
    updateRemaining(t) {
      const e = t.variant,
        i = [ze, Re, Ve, We];
      if (e && this.remainingWrapper && this.remainingJSON) {
        const t = this.remainingJSON[e.id];
        ("out" === t || t < 1) &&
          (this.remainingWrapper.classList.remove(...i),
          this.remainingWrapper.classList.add(Re)),
          ("in" === t || t >= this.remainingMaxInt) &&
            (this.remainingWrapper.classList.remove(...i),
            this.remainingWrapper.classList.add(ze)),
          ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
            (this.remainingWrapper.classList.remove(...i),
            this.remainingWrapper.classList.add(We),
            this.remainingCount && (this.remainingCount.innerHTML = t));
      } else
        !e &&
          this.remainingWrapper &&
          (this.remainingWrapper.classList.remove(...i),
          this.remainingWrapper.classList.add(Ve));
    }
    getBaseUnit(t) {
      return 1 === t.unit_price_measurement.reference_value
        ? t.unit_price_measurement.reference_unit
        : t.unit_price_measurement.reference_value +
            t.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container.querySelectorAll(Ce).forEach((t) => {
        t.addEventListener(
          "change",
          function (t) {
            const e = t.target.value.toString(),
              i = this.container.querySelector(`[${qe}="${e}"]`),
              n = this.container.querySelectorAll(`[${qe}]`);
            if (i) {
              i.classList.remove(Me);
              const t = i.querySelector('[name="selling_plan"]');
              (t.checked = !0), t.dispatchEvent(new Event("change"));
            }
            n.forEach((t) => {
              if (t !== i) {
                t.classList.add(Me);
                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                  (t.checked = !1), t.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(t) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(t)
        : this.productState.onSale
        ? this.updateSaleTextStandard(t)
        : this.priceOffWrap && this.priceOffWrap.classList.add(Me);
    }
    updateSaleTextStandard(t) {
      if (!this.priceOffType) return;
      this.priceOffType.innerHTML =
        window.theme.strings.sale_badge_text || "sale";
      const e = t.variant;
      if (
        window.theme.settings.savingBadgeType &&
        "percentage" === window.theme.settings.savingBadgeType
      ) {
        const t = (e.compare_at_price - e.price) / e.compare_at_price,
          i = Math.floor(100 * t);
        this.priceOffAmount.innerHTML = `${i}%`;
      } else {
        const t = e.compare_at_price - e.price;
        this.priceOffAmount.innerHTML = n.formatMoney(t, theme.moneyFormat);
      }
      this.priceOffWrap.classList.remove(Me);
    }
    updateSaleTextSubscription(t) {
      this.priceOffType.innerHTML =
        window.theme.strings.subscription || "subscripton";
      const e = t.variant,
        i = t.plan.detail.price_adjustments[0],
        o = i.value;
      i && "percentage" === i.value_type
        ? (this.priceOffAmount.innerHTML = `${o}%`)
        : i && "price" === i.value_type
        ? (this.priceOffAmount.innerHTML = n.formatMoney(
            e.price - i.value,
            theme.moneyFormat
          ))
        : (this.priceOffAmount.innerHTML = n.formatMoney(o, theme.moneyFormat)),
        this.priceOffWrap.classList.remove(Me);
    }
    updateSubscriptionText(t) {
      t.plan && this.planDecription && null !== t.plan.detail.description
        ? ((this.planDecription.innerHTML = t.plan.detail.description),
          this.planDecription.classList.remove(Me))
        : this.planDecription && this.planDecription.classList.add(Me);
    }
    updateProductPrices(t) {
      const e = t.variant,
        i = t.plan;
      this.container.querySelectorAll(ge).forEach((t) => {
        const o = t.querySelector(ue),
          r = t.querySelector(Ee);
        let s = "",
          a = "";
        this.productState.available &&
          ((s = e.compare_at_price), (a = e.price)),
          this.productState.hasPlan && (a = i.allocation.price),
          this.productState.planSale &&
            ((s = i.allocation.compare_at_price), (a = i.allocation.price)),
          o &&
            (this.productState.onSale || this.productState.planSale
              ? (o.classList.remove(Me), r.classList.add(Be))
              : (o.classList.add(Me), r.classList.remove(Be)),
            (o.innerHTML = theme.settings.currency_code_enable
              ? n.formatMoney(s, theme.moneyWithCurrencyFormat)
              : n.formatMoney(s, theme.moneyFormat))),
          (r.innerHTML =
            0 === a
              ? window.theme.strings.free
              : theme.settings.currency_code_enable
              ? n.formatMoney(a, theme.moneyWithCurrencyFormat)
              : n.formatMoney(a, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(t);
    }
    updateProductUnits(t) {
      const e = t.variant,
        i = t.plan;
      let o = null;
      if (
        (e && e.unit_price && (o = e.unit_price),
        i &&
          i.allocation &&
          i.allocation.unit_price &&
          (o = i.allocation.unit_price),
        o)
      ) {
        const t = this.getBaseUnit(e),
          i =
            0 === o
              ? window.theme.strings.free
              : n.formatMoney(o, theme.moneyFormat);
        (this.container.querySelector(Le).innerHTML = i),
          (this.container.querySelector(ke).innerHTML = t),
          At(this.container.querySelector(xe));
      } else Ct(this.container.querySelector(xe));
    }
    fireHookEvent(t) {
      const e = t.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant: e },
          bubbles: !0,
        })
      );
    }
    setProductState(t) {
      const e = t.variant,
        i = t.plan,
        n = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !e || (e.requires_selling_plan && !i)
          ? (n.available = !1)
          : (e.available || (n.soldOut = !0),
            e.compare_at_price > e.price && (n.onSale = !0),
            e.unit_price && (n.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (n.requiresPlan = !0),
            i &&
              this.subPrices &&
              ((n.hasPlan = !0),
              i.allocation.per_delivery_price !== i.allocation.price &&
                (n.planPerDelivery = !0),
              e.price > i.allocation.price && (n.planSale = !0))),
        n
      );
    }
    updateProductImage(t) {
      const i = t.dataset.variant;
      if (i) {
        const t = i.featured_media ? i.featured_media.id : "",
          n = this.container.querySelector(we),
          o = e.data(n);
        if (o && o.isActive) {
          const e = n.querySelector(`[data-id="${t}"]`);
          if (e) {
            const t = parseInt([...e.parentNode.children].indexOf(e));
            o.select(t);
          }
        }
      }
    }
    scrollToForm(t) {
      const e = document.querySelector(pe).dataset.height;
      visibilityHelper.isElementPartiallyVisible(t) ||
        visibilityHelper.isElementTotallyVisible(t) ||
        setTimeout(() => {
          const i = t.getBoundingClientRect().top - e;
          window.scrollTo({ top: i, left: 0, behavior: "smooth" });
        }, 400);
    }
  }
  const Xe = {
    onLoad() {
      this.section = new Ke(this.container);
    },
  };
  const Ye = { color: "ash" },
    Qe = "[data-swatch]",
    Je = "[data-grid-swatches]",
    Ze = "[data-swatch-template]",
    ti = "data-swatch",
    ei = "data-swatch-handle",
    ii = "data-swatch-label";
  let ni = {};
  class oi {
    constructor(t = {}) {
      (this.settings = { ...Ye, ...t }), (this.match = this.init());
    }
    getColor() {
      return this.match;
    }
    init() {
      return B({ json: theme.assets.swatches })
        .then((t) => this.matchColors(t, this.settings.color))
        .catch((t) => {
          console.log("failed to load swatch colors script"), console.log(t);
        });
    }
    matchColors(t, e) {
      let i = "#E5E5E5",
        n = null;
      const o = theme.assets.base || "/",
        r = e.toLowerCase().replace(/\s/g, ""),
        s = t.colors;
      if (s) {
        let t = null;
        if (
          s.filter((e, i) => {
            if (
              Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === r
            )
              return (t = i), e;
          }).length &&
          null !== t
        ) {
          const e = Object.values(s[t])[0];
          (i = e),
            (e.includes(".jpg") ||
              e.includes(".jpeg") ||
              e.includes(".png") ||
              e.includes(".svg")) &&
              ((n = `${o}${e}`), (i = "#888888"));
        }
      }
      return { color: this.settings.color, path: n, hex: i };
    }
  }
  class ri {
    constructor(t) {
      (this.element = t), (this.colorString = t.getAttribute(ti));
      new oi({ color: this.colorString }).getColor().then((t) => {
        (this.colorMatch = t), this.init();
      });
    }
    init() {
      this.colorMatch &&
        this.colorMatch.hex &&
        this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
        this.colorMatch &&
          this.colorMatch.path &&
          this.element.style.setProperty(
            "background-image",
            `url(${this.colorMatch.path})`
          );
    }
  }
  class si {
    constructor(t, e) {
      (this.template = document.querySelector(Ze).innerHTML),
        (this.wrap = t),
        (this.container = e),
        (this.handle = t.getAttribute(ei));
      const i = t.getAttribute(ii).trim().toLowerCase();
      (function (t) {
        const e = `${theme.routes.root}products/${t}.js`;
        return window
          .fetch(e)
          .then((t) => t.json())
          .catch((t) => {
            console.error(t);
          });
      })(this.handle).then((t) => {
        (this.product = t),
          (this.colorOption = t.options.find(function (t) {
            return t.name.toLowerCase() === i || null;
          })),
          this.colorOption &&
            ((this.swatches = this.colorOption.values), this.init());
      });
    }
    init() {
      (this.wrap.innerHTML = ""),
        this.swatches.forEach((t) => {
          let e = this.product.variants.find((e) => e.options.includes(t));
          e &&
            (this.wrap.innerHTML += i.render(this.template, {
              color: t,
              uniq: `${this.product.id}-${e.id}`,
              variant: e.id,
              variantUrl: `${this.product.url}?variant=${e.id}`,
            }));
        }),
        (this.swatchElements = this.wrap.querySelectorAll(Qe)),
        this.swatchElements.forEach((t) => {
          new ri(t);
        });
    }
  }
  const ai = (t) => {
      ni = [];
      t.querySelectorAll(Qe).forEach((t) => {
        ni.push(new ri(t));
      });
    },
    li = {
      onLoad() {
        ai(this.container);
      },
    },
    ci = "form",
    di = "[data-popout]",
    ui = "[data-popout-list]",
    hi = "[data-popout-toggle]",
    pi = "[data-popout-input]",
    fi = "[data-popout-option]",
    mi = "[data-popout-text]",
    gi = "[aria-current]",
    yi = "[data-product-image]",
    vi = "[data-product-grid-item]",
    bi = "select-popout__list--visible",
    wi = "select-popout--alt",
    Si = "--current",
    Ei = "is-visible",
    Li = "aria-current",
    ki = "aria-expanded",
    xi = "data-value",
    Ti = "data-popout-prevent",
    Ai = "data-quantity-field";
  let Ci = {};
  class qi {
    constructor(t) {
      (this.popout = t),
        (this.popoutList = this.popout.querySelector(ui)),
        (this.popoutToggle = this.popout.querySelector(hi)),
        (this.popoutText = this.popout.querySelector(mi)),
        (this.popoutInput = this.popout.querySelector(pi)),
        (this.popoutOptions = this.popout.querySelectorAll(fi)),
        (this.popoutPrevent = "true" === this.popout.getAttribute(Ti)),
        (this.popupToggleFocusoutEvent = (t) => this.popupToggleFocusout(t)),
        (this.popupListFocusoutEvent = (t) => this.popupListFocusout(t)),
        (this.popupToggleClickEvent = (t) => this.popupToggleClick(t)),
        (this.popoutKeyupEvent = (t) => this.popoutKeyup(t)),
        (this.popupOptionsClickEvent = (t) => this.popupOptionsClick(t)),
        (this._connectOptionsDispatchEvent = (t) =>
          this._connectOptionsDispatch(t)),
        (this.bodyClick = this.bodyClick.bind(this)),
        (this.updatePopout = this.updatePopout.bind(this)),
        this._connectOptions(),
        this._connectToggle(),
        this._onFocusOut(),
        this.popoutInput &&
          this.popoutInput.hasAttribute(Ai) &&
          document.addEventListener("theme:cart:update", this.updatePopout);
    }
    unload() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((t) => {
          t.removeEventListener(
            "theme:popout:click",
            this.popupOptionsClickEvent
          ),
            t.removeEventListener("click", this._connectOptionsDispatchEvent);
        }),
        this.popoutToggle.removeEventListener(
          "click",
          this.popupToggleClickEvent
        ),
        this.popoutToggle.removeEventListener(
          "focusout",
          this.popupToggleFocusoutEvent
        ),
        this.popoutList.removeEventListener(
          "focusout",
          this.popupListFocusoutEvent
        ),
        this.popout.removeEventListener("keyup", this.popoutKeyupEvent),
        document.removeEventListener("theme:cart:update", this.updatePopout),
        document.body.removeEventListener("click", this.bodyClick);
    }
    popupToggleClick(t) {
      const e = "true" === t.currentTarget.getAttribute(ki);
      if (this.popoutList.closest(vi)) {
        const t = this.popoutList.closest(vi).querySelector(yi);
        t && t.classList.toggle(Ei, !e);
      }
      t.currentTarget.setAttribute(ki, !e),
        this.popoutList.classList.toggle(bi);
    }
    popupToggleFocusout(t) {
      this.popout.contains(t.relatedTarget) || this._hideList();
    }
    popupListFocusout(t) {
      const e = t.currentTarget.contains(t.relatedTarget);
      this.popoutList.classList.contains(bi) && !e && this._hideList();
    }
    popupOptionsClick(t) {
      if ("#" === t.target.closest(fi).attributes.href.value) {
        t.preventDefault();
        let e = "";
        if (
          (t.currentTarget.getAttribute(xi) &&
            (e = t.currentTarget.getAttribute(xi)),
          (this.popoutInput.value = e),
          this.popoutPrevent)
        ) {
          this.popoutInput.dispatchEvent(new Event("change")),
            !t.detail.preventTrigger &&
              this.popoutInput.hasAttribute(Ai) &&
              this.popoutInput.dispatchEvent(new Event("input"));
          const i = this.popoutList.querySelector(`[class*="${Si}"]`);
          let n = Si;
          if (i && i.classList.length)
            for (const t of i.classList)
              if (t.includes(Si)) {
                n = t;
                break;
              }
          const o = this.popoutList.querySelector(`.${n}`);
          o &&
            (o.classList.remove(`${n}`),
            t.currentTarget.parentElement.classList.add(`${n}`));
          const r = this.popoutList.querySelector(gi);
          r &&
            (r.removeAttribute(Li), t.currentTarget.setAttribute(Li, "true")),
            "" !== e && (this.popoutText.textContent = e),
            this.popupToggleFocusout(t),
            this.popupListFocusout(t);
        } else this._submitForm(e);
      }
    }
    updatePopout() {
      const t = this.popoutList.querySelector(
        `[${xi}="${this.popoutInput.value}"]`
      );
      t
        ? (t.dispatchEvent(
            new CustomEvent("theme:popout:click", {
              cancelable: !0,
              bubbles: !0,
              detail: { preventTrigger: !0 },
            })
          ),
          t.parentElement.nextSibling || this.popout.classList.add(wi))
        : this.popout.classList.add(wi);
    }
    popoutKeyup(t) {
      t.which === theme.keyboardKeys.ESCAPE &&
        (this._hideList(), this.popoutToggle.focus());
    }
    bodyClick(t) {
      const e = this.popout.contains(t.target);
      this.popoutList.classList.contains(bi) && !e && this._hideList();
    }
    _connectToggle() {
      this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
    }
    _connectOptions() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((t) => {
          t.addEventListener("theme:popout:click", this.popupOptionsClickEvent),
            t.addEventListener("click", this._connectOptionsDispatchEvent);
        });
    }
    _connectOptionsDispatch(t) {
      const e = new CustomEvent("theme:popout:click", {
        cancelable: !0,
        bubbles: !0,
        detail: { preventTrigger: !1 },
      });
      t.target.dispatchEvent(e) || t.preventDefault();
    }
    _onFocusOut() {
      this.popoutToggle.addEventListener(
        "focusout",
        this.popupToggleFocusoutEvent
      ),
        this.popoutList.addEventListener(
          "focusout",
          this.popupListFocusoutEvent
        ),
        this.popout.addEventListener("keyup", this.popoutKeyupEvent),
        document.body.addEventListener("click", this.bodyClick);
    }
    _submitForm() {
      const t = this.popout.closest(ci);
      t && t.submit();
    }
    _hideList() {
      this.popoutList.classList.remove(bi),
        this.popoutToggle.setAttribute(ki, !1);
    }
  }
  const Pi = {
      onLoad() {
        Ci[this.id] = [];
        this.container.querySelectorAll(di).forEach((t) => {
          Ci[this.id].push(new qi(t));
        });
      },
      onUnload() {
        Ci[this.id].forEach((t) => {
          "function" == typeof t.unload && t.unload();
        });
      },
    },
    _i = "[data-add-to-cart]",
    Di = "[data-deferred-media]",
    Ii = "[data-deferred-media-button]",
    Oi = "[data-popup-close]",
    Fi = "[data-popout]",
    Hi = "[data-product]",
    Mi = "[data-product-form]",
    ji = "[data-product-single-media-slider]",
    Ni = "[data-thumbnail-id]",
    Bi = "[data-product-single-media-thumbs]",
    $i = "[data-product-single-media-wrapper]",
    Wi = "[data-model]",
    zi = ".product-single__thumbnail-link",
    Ri = "[data-product-slideshow-progress]",
    Vi = "[data-product-json]",
    Ui = "has-media-active",
    Gi = "is-loading",
    Ki = "media--hidden",
    Xi = "no-outline",
    Yi = "js-quick-view-visible",
    Qi = "notification-popup-visible",
    Ji = "fill",
    Zi = "id",
    tn = "data-media-id",
    en = "data-section-id",
    nn = "data-thumbnail-id",
    on = "loaded",
    rn = "tabindex",
    sn = "AddToCartForm--",
    an = "AddToCart--";
  class ln {
    constructor(t, e) {
      (this.popup = t),
        (this.pswpElement = e),
        (this.container = this.pswpElement.querySelector(Hi)),
        (this.sectionId = this.container.getAttribute(en)),
        (this.product = JSON.parse(this.container.querySelector(Vi).innerHTML)),
        (this.body = document.body),
        (this.closeOnEscapeEvent = (t) => this.closeOnEscape(t)),
        (this.outerCloseEvent = (t) => {
          this.container.contains(t.target) || this.popup.close();
        }),
        this.init();
    }
    init() {
      this.addFormSuffix(),
        this.initProductSlider(),
        this.initMediaSwitch(),
        this.initProductVideo(),
        this.initProductModel(),
        this.initShopifyXrLaunch(),
        ai(this.container);
      const t = this.container.querySelectorAll(Fi);
      let i = {};
      t.length &&
        t.forEach((t, e) => {
          i[e] = new qi(t);
        }),
        new Ke(this.container.parentNode),
        slate.a11y.trapFocus({ container: this.container }),
        Shopify.PaymentButton && Shopify.PaymentButton.init(),
        this.container.classList.remove(Gi);
      const n = this.container.querySelector(Oi);
      n.addEventListener("keyup", (t) => {
        (t.keyCode !== theme.keyboardKeys.ENTER &&
          t.keyCode !== theme.keyboardKeys.SPACE) ||
          this.popup.close();
      }),
        n.addEventListener("click", () => {
          this.popup.close();
        }),
        this.pswpElement.addEventListener("click", this.outerCloseEvent),
        document.dispatchEvent(
          new CustomEvent("theme:popup:open", { bubbles: !0 })
        ),
        this.popup.listen("preventDragEvent", (t, e, i) => {
          i.prevent = !1;
        }),
        this.pswpElement.addEventListener("mousedown", () => {
          this.popup.framework.unbind(
            window,
            "pointermove pointerup pointercancel",
            this.popup
          );
        }),
        this.popup.listen("initialZoomInEnd", () => {
          this.body.classList.add(Yi);
        }),
        this.popup.listen("close", () => {}),
        this.popup.listen("destroy", () => {
          const t = this.container.querySelector(ji),
            i = e.data(t) || null;
          i && i.pausePlayer(),
            slate.a11y.removeTrapFocus(),
            this.body.classList.remove(Yi),
            document.removeEventListener("keyup", this.closeOnEscapeEvent),
            document.addEventListener("keyup", this.closeOnEscapeEvent),
            this.pswpElement.removeEventListener("click", this.outerCloseEvent);
        }),
        document.addEventListener("keyup", this.closeOnEscapeEvent);
    }
    closeOnEscape(t) {
      const e = this.body.classList.contains(Yi),
        i = this.body.classList.contains(Qi);
      t.keyCode === theme.keyboardKeys.ESCAPE && e && !i && this.popup.close();
    }
    initProductSlider() {
      const t = this.container.querySelector(ji),
        i = this.container.querySelector(Bi),
        n = this.container.querySelectorAll($i),
        o = this.container.querySelector(Ri),
        r = 3500;
      let s = 0;
      if (n.length > 1) {
        this.container.style.setProperty("--autoplay-speed", "3500ms"),
          o &&
            (o.classList.add(Ji),
            (s = setTimeout(() => {
              o.classList.remove(Ji);
            }, r)));
        const a = new e(t, {
          wrapAround: !0,
          pageDots: !1,
          prevNextButtons: !0,
          adaptiveHeight: !0,
          pauseAutoPlayOnHover: !1,
          selectedAttraction: 0.2,
          friction: 1,
          autoPlay: !1,
          on: {
            ready: () => {
              t.setAttribute(rn, "-1");
            },
            settle: () => {
              const t = a.selectedElement,
                e = t.getAttribute(tn);
              t.setAttribute(rn, "0"),
                a.cells.forEach((e) => {
                  e.element !== t && e.element.setAttribute(rn, "-1");
                }),
                this.switchMedia(e);
            },
            change: () => {
              s && clearTimeout(s),
                o &&
                  (o.classList.remove(Ji),
                  setTimeout(() => {
                    o.classList.add(Ji);
                  }),
                  (s = setTimeout(() => {
                    o.classList.remove(Ji);
                  }, r)));
            },
            dragEnd: () => {
              a.playPlayer();
            },
          },
        });
        if (
          (n.length &&
            n.forEach((t) => {
              t.addEventListener("theme:media:play", () => {
                (a.options.draggable = !1),
                  a.updateDraggable(),
                  t.closest(ji).classList.add(Ui);
              }),
                t.addEventListener("theme:media:pause", () => {
                  (a.options.draggable = !0),
                    a.updateDraggable(),
                    t.closest(ji).classList.remove(Ui);
                });
            }),
          ht(t),
          i)
        ) {
          new e(i, {
            asNavFor: t,
            contain: !0,
            pageDots: !1,
            prevNextButtons: !1,
            on: {
              ready: () => {
                i.setAttribute(rn, "-1");
              },
            },
          });
          ht(i);
          const n = this.container.querySelectorAll(zi);
          n.length &&
            n.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault();
              });
            });
        }
      }
    }
    handleMediaFocus(t) {
      if (
        t.keyCode !== theme.keyboardKeys.ENTER &&
        t.keyCode !== theme.keyboardKeys.TAB
      )
        return;
      const i = `quickview-${t.currentTarget.getAttribute(nn)}`,
        n = this.container.querySelector(`[${tn}="${i}"]`),
        o = parseInt([...n.parentNode.children].indexOf(n)),
        r = this.container.querySelector(ji),
        s = this.container.querySelector(Bi),
        a = e.data(r) || null,
        l = e.data(s) || null;
      a &&
        a.isActive &&
        o > -1 &&
        t.keyCode === theme.keyboardKeys.ENTER &&
        a.select(o),
        l && l.isActive && o > -1 && l.select(o);
    }
    switchMedia(t) {
      const e = document.querySelectorAll($i),
        i = this.container.querySelector(`${$i}[${tn}="${t}"]`),
        n = !this.body.classList.contains(Xi);
      e.length &&
        e.forEach((t) => {
          t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            t.classList.add(Ki);
        }),
        n && i.focus(),
        i.closest(ji).classList.remove(Ui),
        i.classList.remove(Ki),
        i.dispatchEvent(new CustomEvent("theme:media:visible"), {
          bubbles: !0,
        });
      const o = i.querySelector(Di);
      o &&
        "true" !== o.getAttribute(on) &&
        i.querySelector(Ii).dispatchEvent(new Event("click"));
    }
    initMediaSwitch() {
      const t = this.container.querySelectorAll(Ni);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("keyup", this.handleMediaFocus.bind(this)),
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
        });
    }
    initProductVideo() {
      this.videos = new Tt(this.container);
    }
    initProductModel() {
      const t = this.container.querySelectorAll(Wi);
      t.length &&
        t.forEach((t) => {
          PaloAlto.ProductModel.init(t, this.sectionId);
        });
    }
    initShopifyXrLaunch() {
      document.addEventListener("shopify_xr_launch", () => {
        this.container
          .querySelector(`${Wi}:not(.${Ki})`)
          .dispatchEvent(new CustomEvent("xrLaunch"));
      });
    }
    addFormSuffix() {
      const t = `${this.sectionId}-${this.product.handle}`,
        e = this.container.querySelector(Mi),
        i = this.container.querySelector(_i);
      e.setAttribute(Zi, sn + t), i.setAttribute(Zi, an + t);
    }
  }
  const cn = 400,
    dn = ".pswp",
    un = ".pswp__custom-close",
    hn = "iframe, video",
    pn = ".pswp__custom-iframe",
    fn = ".pswp__thumbs",
    mn = ".pswp__button, .pswp__caption-close",
    gn = "is-current",
    yn = "pswp--custom-loader",
    vn = "pswp--custom-opening",
    bn = "pswp__loader",
    wn = "pswp--open",
    Sn = "pswp__button--close",
    En = "pswp--notification",
    Ln = "popup-quick-view",
    kn = "js-drawer-open-cart",
    xn = "data-pswp-option-classes",
    Tn = "data-video-type",
    An = `<div class="${bn}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
  class Cn {
    constructor(t, e = "", i = 0, n = null) {
      (this.items = t),
        (this.triggerBtn = n),
        (this.pswpElements = document.querySelectorAll(dn)),
        (this.pswpElement = this.pswpElements[i]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.popupThumbsContainer = this.pswpElement.querySelector(fn)),
        (this.closeBtn = this.pswpElement.querySelector(un));
      (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
        (this.onCloseCallback = () => this.onClose()),
        (this.dispatchPopupInitEventCallback = () =>
          this.dispatchPopupInitEvent()),
        (this.setCurrentThumbCallback = () => this.setCurrentThumb()),
        this.init();
    }
    init() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", { bubbles: !0 })
      ),
        this.pswpElement.classList.add(vn),
        this.initLoader(),
        B({ url: window.theme.assets.photoswipe })
          .then(() => this.loadPopup())
          .catch((t) => console.error(t));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(yn) &&
        "" !== this.options &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(xn, this.options.mainClass);
        let t = document.createElement("div");
        (t.innerHTML = An), (t = t.firstChild), this.pswpElement.appendChild(t);
      } else this.pswpElement.setAttribute(xn, "");
    }
    loadPopup() {
      const t = window.themePhotoswipe.PhotoSwipe.default,
        e = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.contains(yn) &&
        this.pswpElement.classList.remove(yn),
        this.pswpElement.classList.remove(vn),
        (this.popup = new t(this.pswpElement, e, this.items, this.options)),
        this.popup.listen("afterInit", this.dispatchPopupInitEventCallback),
        this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback),
        this.popup.listen("beforeChange", this.setCurrentThumbCallback),
        this.popup.listen("close", this.onCloseCallback),
        this.popup.init(),
        this.initPopupCallback();
    }
    initPopupCallback() {
      this.isVideo && this.hideUnusedButtons(),
        this.initVideo(),
        this.thumbsActions(),
        slate.a11y.trapFocus({ container: this.pswpElement }),
        this.pswpElement.classList.contains(Ln) &&
          new ln(this.popup, this.pswpElement),
        this.pswpElement.classList.contains(En) &&
          new ut(this.popup, this.pswpElement),
        (this.closePopup = () => this.popup.close()),
        this.closeBtn &&
          this.closeBtn.addEventListener("click", () => this.popup.close),
        document.addEventListener("theme:cart:added", this.closePopup);
    }
    dispatchPopupInitEvent() {
      this.triggerBtn &&
        this.triggerBtn.dispatchEvent(
          new CustomEvent("theme:popup:init", { bubbles: !0 })
        );
    }
    initVideo() {
      const t = this.pswpElement.querySelector(pn);
      if (t) {
        const e = t.getAttribute(Tn);
        (this.isVideo = !0),
          "youtube" == e
            ? new rt(t.parentElement)
            : "vimeo" == e && new Y(t.parentElement);
      }
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.firstChild &&
        (this.popupThumbsContainer.addEventListener("wheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) =>
          this.stopDisabledScroll(t)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(`${fn} > *`)),
        this.popupThumbs.forEach((t, e) => {
          t.addEventListener("click", (i) => {
            i.preventDefault(),
              t.parentElement.querySelector(`.${gn}`).classList.remove(gn),
              t.classList.add(gn),
              this.popup.goTo(e);
          });
        }));
    }
    hideUnusedButtons() {
      this.pswpElement.querySelectorAll(mn).forEach((t) => {
        t.classList.contains(Sn) || (t.style.display = "none");
      });
    }
    stopDisabledScroll(t) {
      t.stopPropagation();
    }
    onClose() {
      const t = this.pswpElement.querySelector(hn);
      if (
        (t && t.parentNode.removeChild(t),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(xn, "");
      const e = this.pswpElement.querySelector(`.${bn}`);
      e && this.pswpElement.removeChild(e),
        slate.a11y.removeTrapFocus({ container: this.pswpElement }),
        document.removeEventListener("theme:cart:added", this.closePopup),
        setTimeout(() => {
          const t = this.recentlyOpenedPopupsCount(),
            e = document.body.classList.contains(kn);
          0 !== t ||
            e ||
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            );
        }, cn);
    }
    recentlyOpenedPopupsCount() {
      let t = 0;
      return (
        this.pswpElements.forEach((e) => {
          e.classList.contains(wn) && (t += 1);
        }),
        t
      );
    }
    setCurrentThumb() {
      if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
        return;
      const t = this.pswpElement.querySelector(`${fn} > .${gn}`);
      if ((t && t.classList.remove(gn), !this.popupThumbs)) return;
      const e = this.popupThumbs[this.popup.getCurrentIndex()];
      e.classList.add(gn), this.scrollThumbs(e);
    }
    scrollThumbs(t) {
      const e =
          this.popupThumbsContainer.scrollLeft +
          this.popupThumbsContainer.offsetWidth,
        i = t.offsetLeft;
      if (e <= i + t.offsetWidth || e > i) {
        const e = parseInt(window.getComputedStyle(t).marginLeft);
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: i - e,
          behavior: "smooth",
        });
      }
    }
  }
  const qn = 0,
    Pn = 400,
    _n = "[data-button-quick-view]",
    Dn = "[data-cart-drawer]",
    In = "is-loading",
    On = "js-quick-view-from-cart",
    Fn = "data-handle",
    Hn = {
      history: !1,
      focus: !1,
      mainClass: "popup-quick-view pswp--not-close-btn",
      showHideOpacity: !0,
      closeOnVerticalDrag: !1,
      closeOnScroll: !1,
      modal: !1,
      escKey: !1,
    };
  class Mn {
    constructor(t) {
      this.container = t;
      this.container.querySelectorAll(_n).forEach((t) => {
        t.addEventListener("click", (t) => this.initPhotoswipe(t)),
          t.addEventListener("theme:popup:init", () => {
            t.classList.remove(In),
              t.closest(Dn) &&
                setTimeout(() => {
                  document.body.classList.remove(On);
                }, Pn);
          });
      });
    }
    initPhotoswipe(t) {
      t.preventDefault();
      const e = t.target.matches(_n) ? t.target : t.target.closest(_n);
      e.classList.add(In),
        e.closest(Dn) && document.body.classList.add(On),
        (slate.a11y.state.trigger = e);
      const i = `${theme.routes.root}products/${e.getAttribute(
        Fn
      )}?section_id=api-quickview`;
      fetch(i)
        .then((t) => t.text())
        .then((t) => {
          new Cn([{ html: t }], Hn, qn, e);
        })
        .catch(function (t) {
          console.log("error: ", t);
        });
    }
  }
  const jn = {
      cartDrawerEnabled: "drawer" === window.theme.settings.cartType,
      timers: { addProductTimeout: 1e3, itemRemovalDelay: 500 },
      animations: { data: "data-aos", method: "fade-up" },
      isQuickViewEnabled: "view" == theme.settings.quickButton,
    },
    Nn = "[data-section-id]",
    Bn = "[data-aos]",
    $n = "[data-additional-checkout-button]",
    Wn = "[data-api-content]",
    zn = "[data-api-line-items]",
    Rn = "[data-api-upsell-items]",
    Vn = "[data-add-to-cart]",
    Un = "[data-cart-error-close]",
    Gn = "[data-cart-drawer]",
    Kn = "[data-cart-drawer-template]",
    Xn = "[data-cart-drawer-toggle]",
    Yn = "[data-cart-drawer-body]",
    Qn = "[data-cart-errors]",
    Jn = "[data-cart-form]",
    Zn = "[data-cart-acceptance-checkbox]",
    to = "[data-cart-checkout-buttons]",
    eo = "[data-cart-checkout-button]",
    io = "[data-cart-total-discount]",
    no = "[data-item-remove]",
    oo = "[data-cart-items-qty]",
    ro = "[data-cart-total]",
    so = "[data-cart-message]",
    ao = "[data-message-default]",
    lo = "[data-cart-page]",
    co = "[data-cart-message-progress]",
    uo = "[data-cart-original-total]",
    ho = "[data-cart-original-total-price]",
    po = "[data-cart-discounts-holder]",
    fo = "[data-empty-message]",
    mo = "[data-foot-holder]",
    go = "[data-cart-item]",
    yo = "[data-items-holder]",
    vo = "[data-items-wrapper]",
    bo = "[data-close-error]",
    wo = "[data-cart-errors-container]",
    So = "[data-upsell-holder]",
    Eo = "[data-error-message]",
    Lo = "[data-terms-error-message]",
    ko = "[data-pair-products-holder]",
    xo = "[data-pair-products]",
    To = "data-product-id",
    Ao = "[data-left-to-spend]",
    Co = "[data-quickbuy-form]",
    qo = "[data-product-media-container]",
    Po = "[data-form-wrapper]",
    _o = ".popup-quick-view",
    Do = "hidden",
    Io = "is-hidden",
    Oo = "js-drawer-open-cart",
    Fo = "is-open",
    Ho = "is-visible",
    Mo = "is-loading",
    jo = "is-disabled",
    No = "is-success",
    Bo = "cart__toggle--has-items",
    $o = "variant--soldout",
    Wo = "is-removed",
    zo = "aos-animate",
    Ro = "is-updated",
    Vo = "data-limit",
    Uo = "data-cart-message",
    Go = "data-cart-total-price",
    Ko = "aria-expanded",
    Xo = "disabled",
    Yo = "value",
    Qo = "data-id",
    Jo = "data-cart-errors-container-quickbuy",
    Zo = "data-notification-popup";
  (window.cart = new (class {
    constructor() {
      "/password" !== window.location.pathname && this.init();
    }
    init() {
      (this.cartToggleButtons = document.querySelectorAll(Xn)),
        (this.cartPage = document.querySelector(lo)),
        (this.cartDrawer = document.querySelector(Gn)),
        (this.cart = this.cartDrawer || this.cartPage),
        this.assignArguments(),
        (this.flktyUpsell = null),
        (this.form = null),
        (this.collapsible = null),
        (this.build = this.build.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.updateCart = this.updateCart.bind(this)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.formSubmitHandler = m(this.formSubmitHandler.bind(this), 50)),
        (this.closeCartError = h(() => g(this.cartErrorHolder, 400), 250)),
        (this.cartDrawerCloseEvent = null),
        (this.errorTimer = 0),
        (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
        (this.isCartPage = Boolean(null === this.cartDrawer)),
        (this.showAnimations = Boolean(
          "true" === document.body.dataset.animations
        )),
        (this.toggleClassesOnContainers =
          this.toggleClassesOnContainers.bind(this)),
        (this.totalItems = 0),
        (this.isCartDrawerOpen = !1),
        (this.isCartDrawerLoaded = !1),
        (this.cartDiscounts = 0),
        (this.cartDrawerEnabled = jn.cartDrawerEnabled),
        (this.cartLimitErrorIsHidden = !0),
        (this.cartAnimationTimer = 0),
        this.cartEvents(),
        this.cartAddEvent(),
        this.cartDrawerToggleEvents(),
        this.initQuantity(),
        this.buttonHolder && (this.collapsible = new q(this.buttonHolder)),
        this.isCartPage && this.renderPairProducts(),
        document.addEventListener("theme:popup:open", this.closeCartDrawer);
    }
    assignArguments() {
      (this.cartDrawerBody = document.querySelector(Yn)),
        (this.emptyMessage = document.querySelector(fo)),
        (this.buttonHolder = document.querySelector(mo)),
        (this.itemsHolder = document.querySelector(yo)),
        (this.cartItemsQty = document.querySelector(oo)),
        (this.itemsWrapper = document.querySelector(vo)),
        (this.items = document.querySelectorAll(go)),
        (this.cartTotal = document.querySelector(ro)),
        (this.cartMessage = document.querySelectorAll(so)),
        (this.cartOriginalTotal = document.querySelector(uo)),
        (this.cartOriginalTotalPrice = document.querySelector(ho)),
        (this.cartTotalDiscountTemplate = document.querySelector(io).innerHTML),
        (this.cartErrorHolder = document.querySelector(Qn)),
        (this.cartCloseErrorMessage = document.querySelector(Un)),
        (this.pairProductsHolder = document.querySelector(ko)),
        (this.pairProducts = document.querySelector(xo)),
        (this.upsellHolders = document.querySelectorAll(So)),
        (this.cartTermsCheckbox = document.querySelector(Zn)),
        (this.cartCheckoutButtonWrapper = document.querySelector(to)),
        (this.cartCheckoutButton = document.querySelector(eo)),
        (this.cartForm = document.querySelector(Jn)),
        (this.cartItemCount = 0),
        this.cartMessage.length > 0 &&
          ((this.cartFreeLimitShipping =
            100 *
            Number(this.cartMessage[0].getAttribute(Vo)) *
            window.Shopify.currency.rate),
          (this.subtotal = Number(this.cartMessage[0].getAttribute(Go)))),
        this.updateProgress();
    }
    initQuantity() {
      (this.items = document.querySelectorAll(go)),
        this.items.length &&
          this.items.forEach((t) => {
            new j(t, !0).init(), this.customEventsHandle(t);
          });
    }
    customEventsHandle(t) {
      t.addEventListener(
        "theme:cart:update",
        h((e) => {
          this.updateCart(
            { id: e.detail.id, quantity: e.detail.quantity },
            t,
            e.detail.valueIsEmpty
          );
        }, 250)
      );
    }
    cartEvents() {
      const t = document.querySelectorAll(no);
      t.length &&
        ((this.totalItems = t.length),
        t.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            const i = t.closest(go);
            this.updateCart({ id: t.getAttribute(Qo), quantity: 0 }, i);
          });
        })),
        this.cartCloseErrorMessage &&
          (this.cartCloseErrorMessage.removeEventListener(
            "click",
            this.closeCartError
          ),
          this.cartCloseErrorMessage.addEventListener(
            "click",
            this.closeCartError
          )),
        this.cartTermsCheckbox &&
          (this.cartTermsCheckbox.removeEventListener(
            "change",
            this.formSubmitHandler
          ),
          this.cartCheckoutButtonWrapper.removeEventListener(
            "click",
            this.formSubmitHandler
          ),
          this.cartForm.removeEventListener("submit", this.formSubmitHandler),
          this.cartTermsCheckbox.addEventListener(
            "change",
            this.formSubmitHandler
          ),
          this.cartCheckoutButtonWrapper.addEventListener(
            "click",
            this.formSubmitHandler
          ),
          this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    cartAddEvent() {
      document.addEventListener("click", (t) => {
        const e = t.target;
        if (e.matches(Vn) || (e.closest(Vn) && e)) {
          const i = e.matches(Vn) ? e : e.closest(Vn),
            n = i.closest(Po);
          let o = "";
          if (
            (t.preventDefault(),
            i.hasAttribute(Zo) && n && n.classList.contains($o))
          )
            return void new re(i);
          if (
            (i.hasAttribute(To)
              ? (o = `id=${Number(i.getAttribute(To))}`)
              : ((this.form = e.closest("form")),
                (o = new FormData(this.form)),
                (o = new URLSearchParams(o).toString())),
            null !== this.form && this.form.querySelector('[type="file"]'))
          )
            return;
          if (i.hasAttribute(Xo)) return;
          this.addToCart(o, i),
            document.dispatchEvent(
              new CustomEvent("theme:cart:add", {
                bubbles: !0,
                detail: { selector: e },
              })
            );
        }
      });
    }
    getCart() {
      if (this.cartDrawer && !this.isCartDrawerLoaded) {
        const t = !1;
        this.renderCartDrawer(t);
      }
      fetch(theme.routes.root + "cart.js")
        .then(this.handleErrors)
        .then((t) => t.json())
        .then(
          (t) => (
            (this.cartItemCount = t.item_count),
            (this.newTotalItems = t.items.length),
            this.buildTotalPrice(t),
            this.cartMessage.length > 0 &&
              ((this.subtotal = t.total_price), this.updateProgress()),
            fetch(theme.routes.root + "cart?section_id=api-cart-items")
          )
        )
        .then((t) => t.text())
        .then((t) => {
          const e = document.createElement("div");
          (e.innerHTML = t),
            this.cartToggleButtons.forEach((t) => {
              t.classList.remove(Bo),
                this.newTotalItems > 0 && t.classList.add(Bo);
            });
          const i = e.querySelector(Wn);
          this.build(i), this.updateItemsQuantity(this.cartItemCount);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e = null) {
      this.cartDrawerEnabled &&
        e &&
        (e.classList.add(Mo), e.setAttribute(Xo, !0)),
        fetch(theme.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            if ((e && (e.disabled = !0), this.addLoadingClass(), t.status))
              return this.addToCartError(t, e), void this.removeLoadingClass();
            this.cartDrawerEnabled
              ? this.getCart()
              : (window.location = theme.routes.cart_url);
          })
          .catch((t) => console.log(t));
    }
    updateCart(t = {}, e = null, i = !1) {
      let n = null,
        o = null,
        r = null,
        s = t.quantity;
      this.addLoadingClass(),
        0 == s &&
          e &&
          (e.classList.add(Wo),
          setTimeout(() => {
            e.remove();
          }, jn.timers.itemRemovalDelay)),
        this.items.forEach((t) => {
          t.classList.add(jo),
            t.querySelector("input").blur(),
            t.querySelectorAll("input, button").forEach((t) => {
              t.setAttribute("disabled", !0);
            });
        }),
        fetch(theme.routes.root + "cart.js")
          .then(this.handleErrors)
          .then((t) => t.json())
          .then((e) => {
            const i = e.items.findIndex((e) => e.key === t.id);
            (o = e.item_count), (r = e.items[i].title);
            const n = { line: `${i + 1}`, quantity: s };
            return fetch(theme.routes.root + "cart/change.js", {
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(n),
            });
          })
          .then(this.handleErrors)
          .then((t) => t.json())
          .then((t) => {
            (n = t.item_count),
              (this.cartItemCount = n),
              0 !== this.cartItemCount
                ? $("span.cart-count").text(this.cartItemCount)
                : $("span.cart-count").text(""),
              i && (s = 1),
              0 !== s &&
                ((this.cartLimitErrorIsHidden = n !== o),
                this.toggleLimitError(r)),
              this.buildTotalPrice(t),
              (this.cartDiscounts = t.total_discount),
              this.updateItemsQuantity(this.cartItemCount),
              this.cartMessage.length > 0 &&
                ((this.subtotal = t.total_price), this.updateProgress()),
              this.getCart();
          })
          .catch((t) => console.log(t));
    }
    toggleLimitError(t) {
      (this.cartErrorHolder.querySelector(Eo).innerText = t),
        this.cartLimitErrorIsHidden
          ? g(this.cartErrorHolder, 400)
          : y(this.cartErrorHolder, 400);
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new v({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    addToCartError(t, e) {
      this.cartDrawerEnabled &&
        e &&
        null !== e.closest(Gn) &&
        !e.closest(Gn) &&
        this.closeCartDrawer();
      let i = e.closest(Nn);
      i || (i = e.closest(xo));
      let n = i.querySelector(wo);
      if (null !== e) {
        const t = e.closest(So),
          i = e.closest(Co);
        t && t.querySelector(wo) && (n = t.querySelector(wo)),
          i && i.closest(qo) && (n = i.closest(qo).querySelector(wo)),
          e.classList.remove(Mo),
          e.removeAttribute(Xo);
      }
      n &&
        (n.classList.add(Ho),
        (n.innerHTML = `<div class="errors">${t.message}: ${t.description}<button type="button" class="product__errors__close" data-close-error>${theme.icons.closeSmall}</button></div>`),
        n.hasAttribute(Jo) &&
          (this.errorTimer && clearTimeout(this.errorTimer),
          (this.errorTimer = setTimeout(() => {
            n.classList.remove(Ho),
              setTimeout(() => {
                n.innerHTML = "";
              }, 300);
          }, 3e3))));
      const o = document.querySelector(bo);
      o &&
        o.addEventListener("click", (t) => {
          const e = t.target;
          (e.matches(bo) || e.closest(bo)) &&
            (t.preventDefault(),
            this.errorTimer && clearTimeout(this.errorTimer),
            n.classList.remove(Ho),
            setTimeout(() => {
              n.innerHTML = "";
            }, 300));
        });
    }
    renderCartDrawer(t = !0) {
      const e = document.querySelector(Kn);
      e &&
        ((this.cartDrawer.innerHTML = e.innerHTML),
        this.assignArguments(),
        this.initQuantity(),
        this.cartEvents(),
        this.buttonHolder && (this.collapsible = new q(this.buttonHolder)),
        (this.cartDrawerToggle = this.cartDrawer.querySelector(Xn)),
        this.cartDrawerToggle.addEventListener(
          "click",
          this.cartDrawerToggleClickEvent
        ),
        (this.isCartDrawerLoaded = !0),
        this.renderPairProducts(),
        document.dispatchEvent(
          new CustomEvent("theme:cart:loaded", { bubbles: !0 })
        ),
        t && this.openCartDrawer(),
        window.simplyOtp.initializeSimplyOtp());
    }
    openCartDrawer() {
      handleFloCartBtn();
      // this.isCartDrawerOpen ||
      //   (this.isCartDrawerLoaded
      //     ? (document.dispatchEvent(
      //         new CustomEvent("theme:cart:open", { bubbles: !0 })
      //       ),
      //       document.dispatchEvent(
      //         new CustomEvent("theme:scroll:lock", {
      //           bubbles: !0,
      //           detail: this.cartDrawer,
      //         })
      //       ),
      //       document.dispatchEvent(
      //         new CustomEvent("theme:scroll:lock", {
      //           bubbles: !0,
      //           detail: this.cartDrawerBody,
      //         })
      //       ),
      //       document.body.classList.add(Oo),
      //       this.cartDrawer.classList.add(Fo),
      //       this.cartDrawer.querySelectorAll(Bn).forEach((t) => {
      //         t.classList.add(zo);
      //       }),
      //       this.cartToggleButtons.forEach((t) => {
      //         t.setAttribute(Ko, !0);
      //       }),
      //       slate.a11y.trapFocus({ container: this.cartDrawer }),
      //       this.observeAdditionalCheckoutButtons(),
      //       (this.isCartDrawerOpen = !0))
      //     : this.renderCartDrawer());
    }
    closeCartDrawer() {
      if (!this.isCartDrawerOpen) return;
      document.dispatchEvent(
        new CustomEvent("theme:cart:close", { bubbles: !0 })
      ),
        this.cartAnimationTimer && clearTimeout(this.cartAnimationTimer),
        (this.cartAnimationTimer = setTimeout(() => {
          this.cartDrawer.querySelectorAll(Bn).forEach((t) => {
            t.classList.remove(zo);
          });
        }, 300)),
        g(this.cartErrorHolder, 400),
        slate.a11y.removeTrapFocus(),
        this.cartToggleButtons.forEach((t) => {
          t.setAttribute(Ko, !1);
        }),
        document.body.classList.remove(Oo),
        this.cartDrawer.classList.remove(Fo),
        this.itemsHolder.classList.remove(Ro);
      document.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })
      ),
        (this.isCartDrawerOpen = !1);
    }
    toggleCartDrawer() {
      this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    cartDrawerToggleEvents() {
      this.cartDrawer &&
        (this.cartDrawer.addEventListener("keyup", (t) => {
          t.which === theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
        }),
        (this.cartDrawerToggleClickEvent = (t) => {
          t.preventDefault();
          const e = t.target;
          "false" === e.getAttribute(Ko) && (slate.a11y.state.trigger = e),
            this.toggleCartDrawer();
        }),
        (this.cartDrawerCloseEvent = (t) => {
          const e = t.target.matches(Xn),
            i = document.querySelector(Gn).contains(t.target),
            n = t.target.closest(_o),
            o = t.target.closest(".discountify_modal");
          e || i || n || o || this.closeCartDrawer();
        }),
        this.cartToggleButtons.forEach((t) => {
          t.addEventListener("click", this.cartDrawerToggleClickEvent);
        }),
        document.addEventListener("mousedown", this.cartDrawerCloseEvent));
    }
    toggleClassesOnContainers() {
      const t = this;
      this.emptyMessage.classList.toggle(Do, t.hasItemsInCart()),
        this.buttonHolder.classList.toggle(Do, !t.hasItemsInCart()),
        this.itemsHolder.classList.toggle(Do, !t.hasItemsInCart()),
        this.cartItemsQty.classList.toggle(Do, !t.hasItemsInCart());
    }
    build(t) {
      const e = t.querySelector(zn),
        i = t.querySelector(Rn),
        n = Boolean(null === e && null === i);
      this.totalItems !== this.newTotalItems &&
        ((this.totalItems = this.newTotalItems),
        this.toggleClassesOnContainers()),
        this.isCartDrawerOpen && this.itemsHolder.classList.add(Ro),
        n
          ? ((this.itemsHolder.innerHTML = t),
            (this.pairProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = e.innerHTML),
            (this.pairProductsHolder.innerHTML = i.innerHTML),
            this.renderPairProducts()),
        this.cartEvents(),
        this.initQuantity(),
        this.resetButtonClasses(),
        this.removeLoadingClass(),
        document.dispatchEvent(
          new CustomEvent("theme:cart:added", { bubbles: !0 })
        ),
        this.cartDrawer && this.openCartDrawer();
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    buildTotalPrice(t) {
      const e = document.querySelector(po);
      if (
        (t.original_total_price > t.total_price &&
        t.cart_level_discount_applications.length > 0
          ? (this.cartOriginalTotal.classList.remove(Do),
            0 === t.original_total_price
              ? (this.cartOriginalTotalPrice.innerHTML =
                  window.theme.strings.free)
              : (this.cartOriginalTotalPrice.innerHTML = n.formatMoney(
                  t.original_total_price,
                  theme.moneyWithCurrencyFormat
                )))
          : this.cartOriginalTotal.classList.add(Do),
        (this.cartTotal.innerHTML =
          0 === t.total_price
            ? window.theme.strings.free
            : n.formatMoney(t.total_price, theme.moneyWithCurrencyFormat)),
        t.cart_level_discount_applications.length > 0)
      ) {
        const i = this.buildCartTotalDiscounts(
          t.cart_level_discount_applications
        );
        e.classList.remove(Do), (e.innerHTML = i);
      } else e.classList.add(Do);
    }
    buildCartTotalDiscounts(t) {
      let e = "";
      return (
        t.forEach((t) => {
          e += i.render(this.cartTotalDiscountTemplate, {
            discountTitle: t.title,
            discountTotalAllocatedAmount: n.formatMoney(
              t.total_allocated_amount,
              theme.moneyFormat
            ),
          });
        }),
        e
      );
    }
    freeShippingMessageHandle(t) {
      this.cartMessage.length > 0 &&
        document.querySelectorAll(so).forEach((e) => {
          const i =
              e.hasAttribute(Uo) && "true" === e.getAttribute(Uo) && 0 !== t,
            n = e.querySelector(ao);
          e.classList.toggle(No, t >= this.cartFreeLimitShipping && i),
            e.classList.toggle(Io, 0 === t),
            n.classList.toggle(Io, t >= this.cartFreeLimitShipping);
        });
    }
    updateProgress() {
      const t = (this.subtotal / this.cartFreeLimitShipping) * 100,
        e = theme.settings.currency_code_enable
          ? n.formatMoney(
              this.cartFreeLimitShipping - this.subtotal,
              theme.moneyWithCurrencyFormat
            )
          : n.formatMoney(
              this.cartFreeLimitShipping - this.subtotal,
              theme.moneyFormat
            );
      this.cartMessage.length > 0 &&
        document.querySelectorAll(so).forEach((i) => {
          const n = i.querySelectorAll(co),
            o = i.querySelector(Ao);
          o && (o.innerHTML = e.replace(".00", "").replace(",00", "")),
            n.length &&
              n.forEach((e, i) => {
                e.classList.toggle(
                  Io,
                  this.subtotal / this.cartFreeLimitShipping >= 1
                ),
                  e.style.setProperty("--progress-width", `${t}%`),
                  0 === i && e.setAttribute(Yo, t);
              }),
            this.freeShippingMessageHandle(this.subtotal);
        });
    }
    renderPairProducts() {
      if (
        ((this.flktyUpsell = null),
        (this.pairProductsHolder = document.querySelector(ko)),
        (this.pairProducts = document.querySelector(xo)),
        (this.upsellHolders = document.querySelectorAll(So)),
        null === this.pairProductsHolder || void 0 === this.pairProductsHolder)
      )
        return;
      const t = this;
      this.upsellHolders.length > 1
        ? (this.flktyUpsell = new e(this.pairProducts, {
            wrapAround: !0,
            pageDots: !0,
            adaptiveHeight: !0,
            prevNextButtons: !1,
            on: {
              ready: function () {
                t.showUpsell(),
                  new Mn(t.cart),
                  this.reloadCells(),
                  this.resize();
              },
            },
          }))
        : (this.showUpsell(), new Mn(this.cart));
    }
    showUpsell() {
      null !== this.pairProductsHolder &&
        void 0 !== this.pairProductsHolder &&
        !this.isCartPage &&
        this.showAnimations &&
        t.refreshHard();
    }
    updateItemsQuantity(t) {
      let e = theme.strings.cart_items_one,
        i = theme.strings.cart_items_many;
      (e = e.split("}}")[1]),
        (i = i.split("}}")[1]),
        this.cartItemsQty &&
          (this.cartItemsQty.textContent = 1 === t ? `${t} ${e}` : `${t} ${i}`);
    }
    observeAdditionalCheckoutButtons() {
      const t = this.cart.querySelector($n);
      if (t) {
        const e = new MutationObserver(() => {
          slate.a11y.removeTrapFocus(),
            slate.a11y.trapFocus({ container: this.cart }),
            e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
    formSubmitHandler() {
      const t = document.querySelector(Zn).checked,
        e = document.querySelector(Lo);
      if (t) g(e, 400), this.cartCheckoutButton.removeAttribute(Xo);
      else {
        if (document.querySelector(Lo).length > 0) return;
        (e.innerText = theme.strings.cart_acceptance_error),
          this.cartCheckoutButton.setAttribute(Xo, !0),
          y(e, 400);
      }
    }
    resetButtonClasses() {
      const t = document.querySelectorAll(Vn);
      t &&
        t.forEach((t) => {
          t.classList.contains(Mo) &&
            (t.classList.remove(Mo),
            t.classList.add(No),
            setTimeout(() => {
              t.removeAttribute(Xo), t.classList.remove(No);
            }, jn.timers.addProductTimeout));
        });
    }
    addLoadingClass() {
      this.cartDrawer
        ? this.cartDrawer.classList.add(Mo)
        : this.itemsWrapper && this.itemsWrapper.classList.add(Mo);
    }
    removeLoadingClass() {
      this.cartDrawer
        ? this.cartDrawer.classList.remove(Mo)
        : this.itemsWrapper && this.itemsWrapper.classList.remove(Mo);
    }
    destroy() {
      this.cartDrawerToggle &&
        this.cartDrawerToggle.removeEventListener(
          "click",
          this.cartDrawerToggleClickEvent
        ),
        this.cartToggleButtons.forEach((t) => {
          t.removeEventListener("click", this.cartDrawerToggleClickEvent);
        }),
        document.removeEventListener("mousedown", this.cartDrawerCloseEvent),
        null !== this.collapsible && this.collapsible.onUnload();
    }
  })()),
    i.filters.define("handle", function (t) {
      t = t.toLowerCase();
      for (
        var e = ['"', "'", "\\", "(", ")", "[", "]"], i = 0;
        i < e.length;
        ++i
      )
        t = t.replace(e[i], "");
      return (
        "-" == (t = t.replace(/\W+/g, "-")).charAt(t.length - 1) &&
          (t = t.replace(/-+\z/, "")),
        "-" == t.charAt(0) && (t = t.replace(/\A-+/, "")),
        t
      );
    }),
    i.filters.define("last", function (t) {
      const e = t.split("-");
      return e[e.length - 1];
    }),
    i.filters.define("asset_url", function (t) {
      let e = theme.assets.image;
      return (e = e.replace("image", t)), e;
    });
  const tr = "[data-range-slider]",
    er = "[data-range-left]",
    ir = "[data-range-right]",
    nr = "[data-range-line]",
    or = "[data-range-holder]",
    rr = "data-se-min",
    sr = "data-se-max",
    ar = "data-se-min-value",
    lr = "data-se-max-value",
    cr = "data-se-step",
    dr = "data-range-filter-update",
    ur = "[data-field-price-min]",
    hr = "[data-field-price-max]",
    pr = "is-initialized";
  class fr {
    constructor(t) {
      (this.container = t),
        this.init(),
        (this.initListener = () => this.init()),
        document.addEventListener("theme:filters:init", this.initListener);
    }
    init() {
      if (((this.slider = this.container.querySelector(tr)), !this.slider))
        return;
      (this.resizeFilters = h(this.reset.bind(this), 50)),
        (this.onMoveEvent = (t) => this.onMove(t)),
        (this.onStopEvent = (t) => this.onStop(t)),
        (this.onStartEvent = (t) => this.onStart(t)),
        (this.startX = 0),
        (this.x = 0),
        (this.touchLeft = this.slider.querySelector(er)),
        (this.touchRight = this.slider.querySelector(ir)),
        (this.lineSpan = this.slider.querySelector(nr)),
        (this.min = parseFloat(this.slider.getAttribute(rr))),
        (this.max = parseFloat(this.slider.getAttribute(sr))),
        (this.step = 0),
        (this.normalizeFact = 26);
      let t = this.min;
      this.slider.hasAttribute(ar) &&
        (t = parseFloat(this.slider.getAttribute(ar)));
      let e = this.max;
      this.slider.hasAttribute(lr) &&
        (e = parseFloat(this.slider.getAttribute(lr))),
        t < this.min && (t = this.min),
        e > this.max && (e = this.max),
        t > e && (t = e),
        this.slider.getAttribute(cr) &&
          (this.step = Math.abs(parseFloat(this.slider.getAttribute(cr)))),
        this.reset(),
        window.addEventListener("theme:resize", this.resizeFilters),
        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(t),
        this.setMaxValue(e),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.touchRight.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.slider.classList.add(pr);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0),
        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact);
    }
    setMinValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          e *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(ar, t);
    }
    setMaxValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          e *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(lr, t);
    }
    onStart(t) {
      t.preventDefault();
      let e = t;
      t.touches && (e = t.touches[0]),
        t.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : t.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = e.pageX - this.x),
        (this.selectedTouch = t.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.addEventListener("touchend", this.onStopEvent, {
          passive: !0,
        });
    }
    onMove(t) {
      let e = t;
      if (
        (t.touches && (e = t.touches[0]),
        (this.x = e.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.slider.getAttribute("on-change"))
      ) {
        new Function("min, max", this.slider.getAttribute("on-change"))(
          this.slider.getAttribute(ar),
          this.slider.getAttribute(lr)
        );
      }
      this.onChange(this.slider.getAttribute(ar), this.slider.getAttribute(lr));
    }
    onStop(t) {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.removeEventListener("touchend", this.onStopEvent, {
          passive: !0,
        }),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(
          this.slider.getAttribute(ar),
          this.slider.getAttribute(lr)
        );
    }
    onChange(t, e) {
      const i = this.slider.closest(or);
      if (i) {
        const n = i.querySelector(ur),
          o = i.querySelector(hr);
        n && o && ((n.value = parseInt(t)), (o.value = parseInt(e)));
      }
    }
    onChanged(t, e) {
      this.slider.hasAttribute(dr) &&
        this.slider.dispatchEvent(
          new CustomEvent("theme:filter:range-update", { bubbles: !0 })
        );
    }
    calculateValue() {
      const t =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let e = this.lineSpan.offsetLeft / this.initialValue,
        i = e + t;
      if (
        ((e = e * (this.max - this.min) + this.min),
        (i = i * (this.max - this.min) + this.min),
        0 !== this.step)
      ) {
        let t = Math.floor(e / this.step);
        (e = this.step * t),
          (t = Math.floor(i / this.step)),
          (i = this.step * t);
      }
      this.selectedTouch === this.touchLeft && this.slider.setAttribute(ar, e),
        this.selectedTouch === this.touchRight &&
          this.slider.setAttribute(lr, i);
    }
    unload() {
      document.removeEventListener("theme:filters:init", this.initListener),
        window.removeEventListener("theme:resize", this.resizeFilters);
    }
  }
  const mr = "[data-slider]",
    gr = "[data-product-media-container]",
    yr = "[data-product-media-slideshow]",
    vr = "[data-product-media-slideshow-slide]",
    br = "[data-product-slideshow-progress]",
    wr = ".flickity-button",
    Sr = "[data-product]",
    Er = "[data-popup-close]",
    Lr = "fill",
    kr = "js-quick-view-visible",
    xr = {};
  class Tr {
    constructor(t) {
      (this.container = t),
        (this.body = document.body),
        (this.sliders = this.container.querySelectorAll(mr)),
        "slideshow" !== theme.settings.productGridHover ||
          window.theme.touch ||
          this.productGridSlideshow(),
        new Mn(this.container),
        ((t) => {
          t.querySelectorAll(Je).forEach((t) => {
            new si(t, void 0);
          });
        })(this.container);
    }
    productGridSlideshow() {
      const t = this.container.querySelectorAll(yr),
        i = this.container.querySelectorAll(gr);
      t.length &&
        t.forEach((t) => {
          const i = t.closest(gr),
            n = i.querySelector(br),
            o = t.querySelectorAll(vr).length,
            r = 2200,
            s = !this.sliders.length;
          let a = new e.data(t),
            l = 0,
            c = vr;
          !a.isActive &&
            o > 1 &&
            ((a = new e(t, {
              draggable: s,
              cellSelector: c,
              contain: !0,
              wrapAround: !0,
              imagesLoaded: !0,
              lazyLoad: !0,
              pageDots: !1,
              prevNextButtons: !1,
              adaptiveHeight: !1,
              pauseAutoPlayOnHover: !1,
              selectedAttraction: 0.2,
              friction: 1,
              on: {
                ready: () => {
                  this.container.style.setProperty(
                    "--autoplay-speed",
                    "2200ms"
                  );
                },
                change: () => {
                  l && clearTimeout(l),
                    n.classList.remove(Lr),
                    requestAnimationFrame(() => {
                      n.classList.add(Lr);
                    }),
                    (l = setTimeout(() => {
                      n.classList.remove(Lr);
                    }, r));
                },
                dragEnd: () => {
                  a.playPlayer();
                },
              },
            })),
            window.theme.touch ||
              (i.addEventListener("mouseenter", () => {
                n.classList.add(Lr),
                  l && clearTimeout(l),
                  (l = setTimeout(() => {
                    n.classList.remove(Lr);
                  }, r)),
                  (a.options.autoPlay = r),
                  a.playPlayer();
              }),
              i.addEventListener("mouseleave", () => {
                a.stopPlayer(), l && clearTimeout(l), n.classList.remove(Lr);
              })));
        }),
        i.length &&
          i.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.target.matches(wr) && t.preventDefault();
            });
          });
    }
    popupClose() {
      const t = document.querySelector(Sr);
      if (t) {
        t.querySelector(Er).dispatchEvent(new Event("click"));
      }
    }
    onBlockSelect() {
      this.body.classList.contains(kr) && this.popupClose();
    }
    onDeselect() {
      this.body.classList.contains(kr) && this.popupClose();
    }
    onUnload() {
      this.body.classList.contains(kr) && this.popupClose();
    }
  }
  const Ar = {
      onLoad() {
        xr[this.id] = new Tr(this.container);
      },
      onBlockSelect() {
        xr[this.id].onBlockSelect();
      },
      onDeselect() {
        xr[this.id].onDeselect();
      },
      onUnload() {
        xr[this.id].onUnload();
      },
    },
    Cr = "#AjaxinateLoop",
    qr = "#AjaxinatePagination";
  let Pr = {};
  class _r {
    constructor(t) {
      (this.container = t),
        (this.endlessScroll = null),
        theme.settings.enableInfinityScroll && this.init();
    }
    init() {
      this.loadMoreFix(),
        (this.endlessScroll = new o({
          container: Cr,
          pagination: qr,
          method: "scroll",
          callback: () => {
            t.refreshHard();
          },
        }));
    }
    loadMoreFix() {
      o.prototype.loadMore = function () {
        (this.request = new XMLHttpRequest()),
          (this.request.onreadystatechange = function () {
            if (!this.request.responseXML) return;
            if (4 === !this.request.readyState || 200 === !this.request.status)
              return;
            const t = this.request.responseXML.querySelector(
                this.settings.container
              ),
              e = this.request.responseXML.querySelector(
                this.settings.pagination
              );
            this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
              null == e
                ? this.removePaginationElement()
                : ((this.paginationElement.innerHTML = e.innerHTML),
                  this.settings.callback &&
                    "function" == typeof this.settings.callback &&
                    this.settings.callback(this.request.responseXML),
                  this.initialize());
          }.bind(this)),
          this.request.open("GET", this.nextPageUrl, !0),
          (this.request.responseType = "document"),
          this.request.send();
      };
    }
    unload() {
      this.endlessScroll && this.endlessScroll.destroy();
    }
  }
  const Dr = {
      onLoad() {
        Pr = new _r(this.container);
      },
      onUnload: function () {
        "function" == typeof Pr.unload && Pr.unload();
      },
    },
    Ir = 300,
    Or = "[data-toggle-filters]",
    Fr = "[data-close-filters]",
    Hr = "[data-open-filters]",
    Mr = "[data-collection-wrapper]",
    jr = "[data-input-sort]",
    Nr = "[data-collection-filters]",
    Br = "[data-collection-filters-list]",
    $r = "[data-collection-sticky-bar]",
    Wr = "[data-collection-filter]",
    zr = "[data-collection-filter-tag]",
    Rr = "[data-collection-filter-tag-button]",
    Vr = "[data-collection-filters-form]",
    Ur = "[data-filter-reset-button]",
    Gr = "[data-filter-tag-reset-button]",
    Kr = '[data-section-type="popups"]',
    Xr = "[data-collection-products]",
    Yr = "[data-field-price-min]",
    Qr = "[data-field-price-max]",
    Jr = "[data-se-min-value]",
    Zr = "[data-se-max-value]",
    ts = "data-se-min-value",
    es = "data-se-max-value",
    is = "data-se-min",
    ns = "data-se-max",
    os = "[data-search-form]",
    rs = "collection__filters--visible",
    ss = "is-active",
    as = "is-expanded",
    ls = "is-loading",
    cs = "popup--visible",
    ds = "data-prevent-scroll-lock",
    us = {};
  class hs {
    constructor(t) {
      (this.container = t),
        (this.sectionId = t.dataset.sectionId),
        (this.enableFilters = "true" === t.dataset.enableFilters),
        (this.filterMode = t.dataset.filterMode),
        (this.collectionHandle = this.container.dataset.collection),
        (this.productGrid = this.container.querySelector(Xr)),
        (this.filters = this.container.querySelector(Nr)),
        (this.filtersStickyBar = this.container.querySelector($r)),
        (this.filtersForm = this.container.querySelector(Vr)),
        (this.searchForm = this.container.querySelector(os)),
        (this.inputSort = this.container.querySelectorAll(jr)),
        (this.filterData = []),
        (this.rangeSlider = null),
        (this.hideFilters = this.hideFilters.bind(this)),
        (this.showFilters = this.showFilters.bind(this)),
        (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
        (this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
        (this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
        (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
        (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
        (this.updateRangeEvent = this.updateRange.bind(this)),
        (this.debouncedSubmitEvent = h(function (t) {
          this.onSubmitHandler(t);
        }, 500)),
        (this.debouncedSortEvent = h(function (t) {
          this.onSortChange(t);
        }, 500)),
        (this.productGridEvents = {}),
        this.initTagFilters(),
        this.initFacetedFilters(),
        this.bindToggleButtonsEvents(),
        this.bindFilterButtonsEvents(),
        this.initProductGridEvents(),
        ai(this.container),
        (this.collapsible = new q(this.container)),
        l(),
        window.addEventListener("popstate", this.onHistoryChange.bind(this));
    }
    initFacetedFilters() {
      "tag" != this.filterMode &&
        "group" != this.filterMode &&
        this.enableFilters &&
        (this.rangeSlider = new fr(this.container));
    }
    updateRange() {
      const t = this.filtersForm.querySelector(Jr),
        e = this.filtersForm.querySelector(Zr),
        i = this.filtersForm.querySelector(Yr),
        n = this.filtersForm.querySelector(Qr);
      if (t.hasAttribute(ts) && e.hasAttribute(es)) {
        const o = parseFloat(i.placeholder, 10),
          r = parseFloat(n.placeholder, 10),
          s = parseFloat(t.getAttribute(ts), 10),
          a = parseFloat(e.getAttribute(es), 10);
        (o === s && r === a) ||
          ((i.value = parseInt(s)),
          (n.value = parseInt(a)),
          this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
      }
    }
    onSubmitHandler(t) {
      t.preventDefault();
      const e = new FormData(t.target.closest("form")),
        i = new URLSearchParams(e),
        n = this.filtersForm.querySelector(Jr),
        o = this.filtersForm.querySelector(Zr),
        r = this.filtersForm.querySelector(Yr),
        s = this.filtersForm.querySelector(Qr);
      if (n && o && r && s && n.hasAttribute(is) && o.hasAttribute(ns)) {
        const t = parseFloat(n.getAttribute(is), 10),
          e = parseFloat(o.getAttribute(ns), 10),
          a = r.value ? parseFloat(r.value, 10) : t,
          l = s.value ? parseFloat(s.value, 10) : e;
        a <= t &&
          l >= e &&
          (i.delete("filter.v.price.gte"), i.delete("filter.v.price.lte"));
      }
      this.renderSection(i.toString(), t);
    }
    onHistoryChange(t) {
      if (!this.filters) return;
      const e = t.state?.searchParams || "";
      this.renderSection(e, null, !1);
    }
    renderSection(t, e, i = !0) {
      this.startLoading();
      const n = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
        o = (t) => t.url === n;
      this.filterData.some(o)
        ? this.renderSectionFromCache(o, e)
        : this.renderSectionFromFetch(n, e),
        i && this.updateURLHash(t);
    }
    renderSectionFromFetch(t, e) {
      fetch(t)
        .then((t) => t.text())
        .then((e) => {
          const i = e;
          (this.filterData = [...this.filterData, { html: i, url: t }]),
            this.renderFilters(i),
            this.renderProductGrid(i),
            this.finishLoading();
        });
    }
    renderSectionFromCache(t, e) {
      const i = this.filterData.find(t).html;
      this.renderFilters(i, e), this.renderProductGrid(i), this.finishLoading();
    }
    renderProductGrid(t) {
      const e = new DOMParser()
        .parseFromString(t, "text/html")
        .querySelector(Xr);
      e &&
        ((this.productGrid.innerHTML = e.innerHTML),
        this.initProductGridEvents());
    }
    renderFilters(t) {
      const e = new DOMParser()
        .parseFromString(t, "text/html")
        .querySelector(Nr);
      e &&
        ((this.filters.innerHTML = e.innerHTML),
        (this.filtersForm = document.querySelector(Vr)),
        this.bindFilterButtonsEvents(),
        this.bindToggleButtonsEvents(),
        ai(this.container),
        (this.collapsible = new q(this.container)),
        document.dispatchEvent(
          new CustomEvent("theme:filters:init", { bubbles: !0 })
        ));
    }
    updateURLHash(t) {
      history.pushState(
        { searchParams: t },
        "",
        `${window.location.pathname}${t && "?".concat(t)}`
      );
    }
    bindFilterButtonsEvents() {
      this.container.querySelectorAll(Ur).forEach((t) => {
        t.addEventListener("click", this.onFilterResetClick, { once: !0 });
      }),
        this.filtersForm &&
          (this.filtersForm.addEventListener(
            "input",
            this.debouncedSubmitEvent.bind(this)
          ),
          this.filtersForm.addEventListener(
            "theme:filter:range-update",
            this.updateRangeEvent
          ));
    }
    onFilterResetClick(t) {
      t.preventDefault(),
        this.renderSection(
          new URL(t.currentTarget.href).searchParams.toString()
        );
    }
    bindToggleButtonsEvents() {
      this.container.querySelectorAll(Or).forEach((t) => {
        t.addEventListener("click", this.onFilterToggleClick);
      }),
        this.container.querySelectorAll(Fr).forEach((t) => {
          t.addEventListener("click", this.hideFilters);
        }),
        this.container.querySelectorAll(Hr).forEach((t) => {
          t.addEventListener("click", this.showFilters);
        }),
        this.container
          .querySelector(Mr)
          .addEventListener("keyup", this.onKeyUpHandler);
    }
    onKeyUpHandler(t) {
      t.keyCode === theme.keyboardKeys.ESCAPE && this.hideFilters();
    }
    onFilterToggleClick(t) {
      t.preventDefault();
      this.filters.classList.contains(rs)
        ? this.hideFilters()
        : this.showFilters();
    }
    showFilters() {
      const t = document.querySelector(Br);
      if (
        ((slate.a11y.state.trigger = document.querySelector(Or)),
        slate.a11y.trapFocus({ container: this.filters }),
        window.innerWidth < theme.sizes.widescreen &&
          (this.filters.classList.add(rs),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t })
          )),
        this.filtersStickyBar)
      ) {
        let t = this.getStickyBarOffsetTop();
        window.scrollTo({ top: t, left: 0, behavior: "smooth" });
      }
    }
    hideFilters() {
      let t = this.filters.classList.contains(rs),
        e = this.container.classList.contains(ls);
      t && (this.filters.classList.remove(rs), slate.a11y.removeTrapFocus()),
        e ||
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Ir })
          );
    }
    initTagFilters() {
      ("tag" != this.filterMode && "group" != this.filterMode) ||
        !this.enableFilters ||
        ((this.tags = this.container.dataset.tags.split("+").filter((t) => t)),
        this.bindFilterTagButtonsEvents(),
        this.bindSortChangeEvent(),
        (this.resizeEvent = () => this.hideFilters()),
        document.addEventListener("theme:resize:width", this.resizeEvent));
    }
    renderTagFiltersProducts(e) {
      this.startLoading(),
        "object" == typeof this.endlessCollection &&
          this.endlessCollection.unload(),
        fetch(e)
          .then((t) => t.text())
          .then((i) => {
            const n = i,
              o = new DOMParser().parseFromString(n, "text/html"),
              r = o.querySelector(Xr).innerHTML,
              s = o.querySelector(Nr).innerHTML;
            (this.productGrid.innerHTML = r),
              (this.filters.innerHTML = s),
              (this.inputSort = this.container.querySelectorAll(jr)),
              (this.filtersForm = document.querySelector(Vr)),
              (this.filterData = [...this.filterData, { html: n, url: e }]),
              this.bindFilterTagButtonsEvents(),
              this.bindSortChangeEvent(),
              this.bindToggleButtonsEvents(),
              this.initProductGridEvents(),
              ai(this.container),
              (this.collapsible = new q(this.container)),
              t.refreshHard(),
              console.log("url", e),
              history.replaceState &&
                window.history.pushState({ path: e }, "", e);
          })
          .catch((t) => {
            this.finishLoading(), console.log(`Error: ${t}`);
          });
    }
    bindFilterTagButtonsEvents() {
      this.container.querySelectorAll(Rr).forEach((t) => {
        t.addEventListener("click", this.onFilterTagButtonClick.bind(this), {
          once: !0,
        });
      }),
        this.container.querySelectorAll(Gr).forEach((t) => {
          t.addEventListener("click", this.onFilterTagClearClick, { once: !0 });
        }),
        this.container.querySelectorAll(Ur).forEach((t) => {
          t.addEventListener("click", this.onFilterTagResetClick, { once: !0 });
        });
    }
    bindSortChangeEvent() {
      this.container.querySelectorAll(jr).forEach((t) => {
        t.addEventListener("input", this.debouncedSortEvent.bind(this));
      });
    }
    onFilterTagButtonClick(t) {
      t.preventDefault();
      const e = t.currentTarget,
        i = e.dataset.tag;
      if (e.parentNode.classList.contains(ss)) {
        let t = this.tags.indexOf(i);
        e.parentNode.classList.remove(ss), t > -1 && this.tags.splice(t, 1);
      } else e.parentNode.classList.add(ss), this.tags.push(i);
      let n =
        this.collectionHandle +
        "/" +
        this.tags.join("+") +
        "?sort_by=" +
        this.getSortValue();
      this.container.querySelector(Wr).classList.remove(as),
        this.container.querySelector(Wr).setAttribute("aria-expanded", !1),
        this.container.setAttribute("data-tags", "[" + this.tags + "]"),
        this.renderTagFiltersProducts(n);
    }
    onFilterTagClearClick(t) {
      t.preventDefault();
      const e = t.currentTarget.dataset.tag,
        i = this.tags.indexOf(e);
      i > -1 && this.tags.splice(i, 1);
      const n =
        this.collectionHandle +
        "/" +
        this.tags.join("+") +
        "?sort_by=" +
        this.getSortValue();
      this.container.setAttribute("data-tags", "[" + this.tags + "]"),
        this.renderTagFiltersProducts(n);
    }
    onSortChange() {
      let t =
        this.collectionHandle +
        "/" +
        this.tags.join("+") +
        "?sort_by=" +
        this.getSortValue();
      this.renderTagFiltersProducts(t);
    }
    getSortValue() {
      let t = "";
      return (
        this.inputSort.forEach((e) => {
          e.checked && (t = e.value);
        }),
        t
      );
    }
    onFilterTagResetClick(t) {
      t.preventDefault(),
        this.container.querySelectorAll(zr).forEach((t) => {
          t.classList.remove(ss);
        }),
        this.container.querySelectorAll(Wr).forEach((t) => {
          t.classList.remove(as), t.setAttribute("aria-expanded", !1);
        }),
        (this.tags = []),
        this.container.setAttribute("data-tags", "");
      let e = this.collectionHandle + "/?sort_by=" + this.getSortValue();
      this.renderTagFiltersProducts(e);
    }
    getProductsOffsetTop() {
      return (
        this.productGrid.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        this.filtersStickyBar.offsetHeight
      );
    }
    getStickyBarOffsetTop() {
      return (
        this.filtersStickyBar.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top
      );
    }
    initProductGridEvents() {
      (this.productGridEvents = new Tr(this.container)),
        theme.settings.enableInfinityScroll && this.initInfinityScroll(),
        setTimeout(() => {
          this.finishLoading();
        }, 1.5 * Ir);
    }
    initInfinityScroll() {
      (this.endlessCollection = new _r(this.container)),
        (this.endlessCollection.endlessScroll.settings.callback = () => {
          this.initProductGridEvents();
        });
    }
    startLoading() {
      this.container.classList.add(ls),
        this.hideFilters(),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        );
      let t = this.getProductsOffsetTop();
      window.scrollTo({ top: t, left: 0, behavior: "smooth" });
    }
    finishLoading() {
      const e = document.querySelectorAll(`${Kr} .${cs}`),
        i = e.length > 0;
      if ((this.container.classList.remove(ls), i)) {
        let t = 0;
        [...e].forEach((e) => {
          e.hasAttribute(ds) && (t += 1);
        }),
          t === e.length &&
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", {
                bubbles: !0,
                detail: Ir,
              })
            );
      } else
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Ir })
        );
      t.refreshHard();
    }
    onDeselect() {
      this.productGridEvents && this.productGridEvents.onDeselect();
    }
    onUnload() {
      "object" == typeof this.endlessCollection &&
        this.endlessCollection.unload(),
        this.productGridEvents && this.productGridEvents.onUnload(),
        this.collapsible.onUnload(),
        this.rangeSlider && this.rangeSlider.unload(),
        document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
  }
  const ps = {
    onLoad() {
      us[this.id] = new hs(this.container);
    },
    onDeselect() {
      us[this.id].onDeselect();
    },
    onUnload() {
      us[this.id].onUnload();
    },
  };
  (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const fs = window.Shopify.theme.sections.registered,
    ms = window.Shopify.theme.sections.instances,
    gs = "data-section-id",
    ys = "data-section-type";
  class vs {
    constructor(t = null, e = []) {
      (this.type = t),
        (this.components = (function (t) {
          if ((void 0 !== t && "object" != typeof t) || null === t)
            throw new TypeError(
              "Theme Sections: The components object provided is not a valid"
            );
          return t;
        })(e)),
        (this.callStack = {
          onLoad: [],
          onUnload: [],
          onSelect: [],
          onDeselect: [],
          onBlockSelect: [],
          onBlockDeselect: [],
          onReorder: [],
        }),
        e.forEach((t) => {
          for (const [e, i] of Object.entries(t)) {
            const t = this.callStack[e];
            Array.isArray(t) && "function" == typeof i
              ? t.push(i)
              : (console.warn(
                  `Unregisted function: '${e}' in component: '${this.type}'`
                ),
                console.warn(i));
          }
        });
    }
    getStack() {
      return this.callStack;
    }
  }
  class bs {
    constructor(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === t.getAttribute(gs))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              gs +
              " attribute."
          );
        return t;
      })(t)),
        (this.id = t.getAttribute(gs)),
        (this.type = e.type),
        (this.callStack = e.getStack());
      try {
        this.onLoad();
      } catch (t) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(t);
      }
    }
    callFunctions(t, e = null) {
      this.callStack[t].forEach((t) => {
        const i = { id: this.id, type: this.type, container: this.container };
        e ? t.call(i, e) : t.call(i);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(t) {
      this.callFunctions("onSelect", t);
    }
    onDeselect(t) {
      this.callFunctions("onDeselect", t);
    }
    onBlockSelect(t) {
      this.callFunctions("onBlockSelect", t);
    }
    onBlockDeselect(t) {
      this.callFunctions("onBlockDeselect", t);
    }
    onReorder(t) {
      this.callFunctions("onReorder", t);
    }
  }
  function ws(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== fs[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    const i = new vs(t, e);
    return (fs[t] = i), fs;
  }
  function Ss(t, e) {
    (t = ks(t)),
      void 0 === e && (e = document.querySelectorAll("[" + ys + "]")),
      (e = xs(e)),
      t.forEach(function (t) {
        const i = fs[t];
        void 0 !== i &&
          (e = e.filter(function (e) {
            return (
              !(Es(e).length > 0) &&
              null !== e.getAttribute(ys) &&
              (e.getAttribute(ys) !== t || (ms.push(new bs(e, i)), !1))
            );
          }));
      });
  }
  function Es(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
    if (t instanceof Element || i instanceof Element)
      xs(t).forEach(function (t) {
        e = e.concat(
          ms.filter(function (e) {
            return e.container === t;
          })
        );
      });
    else if ("string" == typeof t || "string" == typeof i) {
      ks(t).forEach(function (t) {
        e = e.concat(
          ms.filter(function (e) {
            return e.type === t;
          })
        );
      });
    }
    return e;
  }
  function Ls(t) {
    for (var e, i = 0; i < ms.length; i++)
      if (ms[i].id === t) {
        e = ms[i];
        break;
      }
    return e;
  }
  function ks(t) {
    return (
      "*" === t
        ? (t = Object.keys(fs))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === bs
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === bs &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function xs(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + gs + '="' + e + '"]');
      null !== i && Ss(i.getAttribute(ys), i);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + gs + '="' + e + '"]');
      "object" == typeof Es(i)[0] &&
        Es(i).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + gs + '="' + e + '"]');
      "object" == typeof Es(i)[0] &&
        Es(i).forEach(function (t) {
          var e = ms
            .map(function (t) {
              return t.id;
            })
            .indexOf(t.id);
          ms.splice(e, 1), t.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = Ls(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = Ls(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = Ls(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = Ls(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    })),
    ws("collection-template", ps);
  const Ts = ".template-customers-addresses",
    As = "[data-form]",
    Cs = "[data-form-new]",
    qs = "[data-button-new]",
    Ps = "[data-button-edit]",
    _s = "[data-button-delete]",
    Ds = "[data-button-cancel]",
    Is = "data-form-edit",
    Os = "AddressCountryNew",
    Fs = "AddressProvinceNew",
    Hs = "AddressProvinceContainerNew",
    Ms = "[data-country-option]",
    js = "AddressCountry",
    Ns = "AddressProvince",
    Bs = "AddressProvinceContainer",
    $s = 'input[type="text"]:not(.optional)',
    Ws = "data-form-id",
    zs = "is-hidden",
    Rs = "validation--showup";
  class Vs {
    constructor(t) {
      (this.section = t),
        (this.addressNewForm = this.section.querySelector(Cs)),
        (this.accountForms = this.section.querySelectorAll(As)),
        this.init(),
        this.validate();
    }
    init() {
      if (this.addressNewForm) {
        const t = this.section,
          e = this.addressNewForm;
        this.customerAddresses();
        const i = t.querySelectorAll(qs);
        i.length &&
          i.forEach((t) => {
            t.addEventListener("click", function (i) {
              i.preventDefault(), t.classList.add(zs), e.classList.remove(zs);
            });
          });
        const n = t.querySelectorAll(Ps);
        n.length &&
          n.forEach((e) => {
            e.addEventListener("click", function (e) {
              e.preventDefault();
              const i = this.getAttribute(Ws);
              t.querySelector(`[${Is}="${i}"]`).classList.toggle(zs);
            });
          });
        const o = t.querySelectorAll(_s);
        o.length &&
          o.forEach((t) => {
            t.addEventListener("click", function (t) {
              t.preventDefault();
              const e = this.getAttribute(Ws);
              confirm(theme.strings.delete_confirm) &&
                Shopify.postLink("/account/addresses/" + e, {
                  parameters: { _method: "delete" },
                });
            });
          });
        const r = t.querySelectorAll(Ds);
        r.length &&
          r.forEach((t) => {
            t.addEventListener("click", function (t) {
              t.preventDefault(),
                this.closest(As).classList.add(zs),
                document.querySelector(qs).classList.remove(zs);
            });
          });
      }
    }
    customerAddresses() {
      Shopify.CountryProvinceSelector &&
        new Shopify.CountryProvinceSelector(Os, Fs, { hideElement: Hs });
      this.section.querySelectorAll(Ms).forEach((t) => {
        const e = t.getAttribute(Ws),
          i = `${js}_${e}`,
          n = `${Ns}_${e}`,
          o = `${Bs}_${e}`;
        new Shopify.CountryProvinceSelector(i, n, { hideElement: o });
      });
    }
    validate() {
      this.accountForms.forEach((t) => {
        const e = t.querySelector("form"),
          i = e.querySelectorAll($s);
        e.addEventListener("submit", (t) => {
          let e = !1;
          i.forEach((t) => {
            t.value
              ? t.nextElementSibling.classList.remove(Rs)
              : (t.nextElementSibling.classList.add(Rs), (e = !0));
          }),
            e && t.preventDefault();
        });
      });
    }
  }
  const Us = document.querySelector(Ts);
  Us && new Vs(Us);
  const Gs = "[data-account-form]",
    Ks = "[data-show-reset]",
    Xs = "[data-hide-reset]",
    Ys = "[data-recover-password]",
    Qs = "[data-login-form]",
    Js = "[data-recover-success]",
    Zs = "[data-recover-success-text]",
    ta = "#recover",
    ea = "is-hidden";
  class ia {
    constructor(t) {
      (this.form = t),
        (this.showButton = t.querySelector(Ks)),
        (this.hideButton = t.querySelector(Xs)),
        (this.recover = t.querySelector(Ys)),
        (this.login = t.querySelector(Qs)),
        (this.success = t.querySelector(Js)),
        (this.successText = t.querySelector(Zs)),
        this.init();
    }
    init() {
      window.location.hash == ta
        ? this.showRecoverPasswordForm()
        : this.hideRecoverPasswordForm(),
        this.success && this.successText.classList.remove(ea),
        this.showButton.addEventListener(
          "click",
          (t) => {
            t.preventDefault(), this.showRecoverPasswordForm();
          },
          !1
        ),
        this.hideButton.addEventListener(
          "click",
          (t) => {
            t.preventDefault(), this.hideRecoverPasswordForm();
          },
          !1
        );
    }
    showRecoverPasswordForm() {
      return (
        this.recover.classList.remove(ea),
        this.login.classList.add(ea),
        (window.location.hash = ta),
        !1
      );
    }
    hideRecoverPasswordForm() {
      return (
        this.login.classList.remove(ea),
        this.recover.classList.add(ea),
        (window.location.hash = ""),
        !1
      );
    }
  }
  const na = document.querySelector(Gs);
  na && new ia(na), ws("search-template", ps);
  const oa = "[data-ticker-scale]",
    ra = "[data-ticker-text]",
    sa = "data-clone",
    aa = "data-marquee-speed",
    la = "ticker--animated",
    ca = "ticker--unloaded",
    da = "ticker__comparitor",
    ua = 1.63,
    ha = 100;
  class pa {
    constructor(t, e = !1) {
      (this.frame = t),
        (this.stopClone = e),
        (this.scale = this.frame.querySelector(oa)),
        (this.text = this.frame.querySelector(ra)),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(da),
        this.frame.appendChild(this.comparitor),
        this.scale.classList.remove(ca),
        (this.resizeEvent = h(() => this.checkWidth(), 100)),
        this.listen();
    }
    listen() {
      document.addEventListener("theme:resize:width", this.resizeEvent),
        this.checkWidth();
    }
    checkWidth() {
      const t =
        2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
      if (
        this.frame.clientWidth - t < this.comparitor.clientWidth ||
        this.stopClone
      ) {
        if ((this.text.classList.add(la), 1 === this.scale.childElementCount)) {
          if (
            ((this.clone = this.text.cloneNode(!0)),
            this.clone.setAttribute(sa, ""),
            this.scale.appendChild(this.clone),
            this.stopClone)
          )
            for (let t = 0; t < 10; t++) {
              const t = this.text.cloneNode(!0);
              t.setAttribute(sa, ""), this.scale.appendChild(t);
            }
          let t = this.frame.getAttribute(aa);
          null === t && (t = 100);
          const e = ua * (100 / parseInt(t, 10)),
            i = (this.text.clientWidth / ha) * e;
          this.scale.style.setProperty("--animation-time", `${i}s`);
        }
      } else {
        this.text.classList.add(la);
        let t = this.scale.querySelector(`[${sa}]`);
        t && this.scale.removeChild(t), this.text.classList.remove(la);
      }
    }
    unload() {
      document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
  }
  const fa = "[data-bar]",
    ma = "[data-slide]",
    ga = "[data-ticker-frame]",
    ya = "[data-slider]",
    va = "[data-ticker-scale]",
    ba = "[data-ticker-text]",
    wa = "data-slide",
    Sa = "data-slider-speed",
    Ea = "data-stop",
    La = "style",
    ka = "data-target-referrer",
    xa = "desktop",
    Ta = "mobile",
    Aa = "ticker--animated",
    Ca = {};
  class qa {
    constructor(t) {
      (this.barHolder = t),
        (this.locationPath = location.href),
        (this.slides = this.barHolder.querySelectorAll(ma)),
        (this.slider = this.barHolder.querySelector(ya)),
        (this.flkty = null),
        this.init();
    }
    init() {
      this.removeAnnouncement(),
        this.slider &&
          (this.initSlider(),
          document.addEventListener(
            "theme:resize:width",
            this.initSlider.bind(this)
          )),
        this.slider || this.initTickers(!0);
    }
    removeAnnouncement() {
      for (let t = 0; t < this.slides.length; t++) {
        const e = this.slides[t];
        e.hasAttribute(ka) &&
          (-1 !== this.locationPath.indexOf(e.getAttribute(ka)) ||
            window.Shopify.designMode ||
            e.parentNode.removeChild(e));
      }
    }
    initSlider() {
      if (this.slider.querySelectorAll(ma)) {
        let t = `${ma}`;
        (t =
          window.innerWidth < theme.sizes.small
            ? `${ma}:not(.${xa})`
            : `${ma}:not(.${Ta})`),
          null != this.flkty && this.flkty.destroy(),
          (this.flkty = new e(this.slider, {
            cellSelector: t,
            pageDots: !1,
            prevNextButtons: !1,
            wrapAround: !0,
            autoPlay: parseInt(this.slider.getAttribute(Sa), 10),
            on: {
              ready: () => {
                setTimeout(() => {
                  this.slider.dispatchEvent(
                    new CustomEvent("slider-is-loaded", {
                      bubbles: !0,
                      detail: { slider: this },
                    })
                  );
                }, 10);
              },
            },
          })),
          this.flkty.reposition();
      }
      this.slider.addEventListener("slider-is-loaded", () => {
        this.initTickers();
      });
    }
    initTickers(t = !1) {
      this.barHolder.querySelectorAll(ga).forEach((e) => {
        new pa(e, t);
        const i = e.querySelectorAll(ma);
        if (0 !== i.length) {
          const t = e.querySelectorAll(`${ma}.${Ta}`),
            n = e.querySelectorAll(`${ma}.${xa}`);
          i.length === t.length
            ? e.parentNode.classList.add(Ta)
            : i.length === n.length && e.parentNode.classList.add(xa);
        }
      });
    }
    toggleTicker(t, e) {
      const i = t.target.closest(va),
        n = document.querySelector(`[${wa}="${t.detail.blockId}"]`);
      e &&
        n &&
        (i.setAttribute(Ea, ""),
        i.querySelectorAll(ba).forEach((t) => {
          t.classList.remove(Aa),
            (t.style.transform = `translate3d(${-(
              n.offsetLeft - parseInt(getComputedStyle(n).marginLeft, 10)
            )}px, 0, 0)`);
        })),
        !e &&
          n &&
          (i.querySelectorAll(ba).forEach((t) => {
            t.classList.add(Aa), t.removeAttribute(La);
          }),
          i.removeAttribute(Ea));
    }
    onBlockSelect(t) {
      const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
      this.slider &&
        null !== this.flkty &&
        (this.flkty.select(e), this.flkty.pausePlayer()),
        this.slider || this.toggleTicker(t, !0);
    }
    onBlockDeselect(t) {
      this.slider && null !== this.flkty && this.flkty.unpausePlayer(),
        this.slider || this.toggleTicker(t, !1);
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.initSlider.bind(this)
      );
    }
  }
  const Pa = {
    onLoad() {
      Ca[this.id] = [];
      const t = this.container.querySelector(fa);
      t && Ca[this.id].push(new qa(t));
    },
    onBlockSelect(t) {
      Ca[this.id].length &&
        Ca[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
    },
    onBlockDeselect(t) {
      Ca[this.id].length &&
        Ca[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
        });
    },
  };
  ws("announcement-bar", Pa), ws("marquee", Pa);
  const _a = "[data-collapsible-trigger]",
    Da = "is-expanded";
  ws("accordions", [
    {
      onBlockSelect(t) {
        const e = t.target.querySelector(_a);
        e.classList.contains(Da) || e.dispatchEvent(new Event("click"));
      },
    },
    P,
  ]);
  const Ia = "[data-share-button]",
    Oa = "[data-share-button-tooltip]",
    Fa = "is-visible",
    Ha = "is-hiding",
    Ma = {};
  class ja {
    constructor(t) {
      (this.container = t),
        (this.button = this.container.querySelector(Ia)),
        (this.tooltip = this.container.querySelector(Oa)),
        (this.transitionSpeed = 200),
        (this.hideTransitionTimeout = 0),
        this.init();
    }
    init() {
      this.button &&
        this.button.addEventListener("click", () => {
          let t = window.location.href;
          this.button.dataset.shareLink && (t = this.button.dataset.shareLink),
            this.tooltip.classList.contains(Fa) ||
              navigator.clipboard.writeText(t).then(() => {
                this.tooltip.classList.add(Fa),
                  setTimeout(() => {
                    this.tooltip.classList.add(Ha),
                      this.tooltip.classList.remove(Fa),
                      this.hideTransitionTimeout &&
                        clearTimeout(this.hideTransitionTimeout),
                      (this.hideTransitionTimeout = setTimeout(() => {
                        this.tooltip.classList.remove(Ha);
                      }, this.transitionSpeed));
                  }, 1500);
              });
        });
    }
  }
  const Na = {
    onLoad() {
      Ma[this.id] = new ja(this.container);
    },
  };
  ws("article", [Na]);
  const Ba = "[data-banner]",
    $a = "[data-slider]",
    Wa = "[data-banners-media]",
    za = "data-index";
  let Ra = {};
  class Va {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector($a)),
        (this.banners = this.container.querySelectorAll(Ba)),
        (this.links = this.container.querySelectorAll("a")),
        (this.slider = this.container.querySelector($a)),
        (this.sliderMedia = this.container.querySelector(Wa)),
        (this.flkty = null),
        (this.flktyMedia = null),
        (this.sliderResizeEvent = () => this.resizeSlider()),
        this.initSliders(),
        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
    }
    initSliders() {
      if (this.slider.children.length <= 1) return;
      const t = document.documentElement.classList.contains("supports-touch");
      let i = window.innerWidth < window.theme.sizes.small;
      (this.flktyMedia = new e(this.sliderMedia, {
        draggable: !1,
        wrapAround: !1,
        fade: !0,
        prevNextButtons: !1,
        adaptiveHeight: !1,
        pageDots: !1,
        setGallerySize: !1,
      })),
        ht(this.sliderMedia),
        (this.flkty = new e(this.slider, {
          draggable: i,
          prevNextButtons: !1,
          pageDots: !0,
          cellAlign: "left",
          adaptiveHeight: !1,
          imagesLoaded: !0,
          lazyLoad: !0,
          asNavFor: this.sliderMedia,
          on: {
            ready: () => {
              this.links.forEach((e) => {
                e.addEventListener("focus", (i) => {
                  const n = Number(e.closest(Ba).getAttribute(za));
                  window.innerWidth >= theme.sizes.small &&
                    !t &&
                    this.flktyMedia.selectCell(n);
                });
              }),
                this.banners.forEach((e) => {
                  e.addEventListener("mouseenter", (i) => {
                    const n = Number(e.getAttribute(za));
                    window.innerWidth >= theme.sizes.small &&
                      !t &&
                      this.flktyMedia.selectCell(n);
                  }),
                    e.addEventListener("keyup", (t) => {
                      if (
                        t.keyCode === slate.utils.keyboardKeys.ENTER ||
                        t.keyCode === slate.utils.keyboardKeys.SPACE
                      ) {
                        const t = Number(e.getAttribute(za));
                        this.flkty.selectCell(t);
                      }
                    });
                });
            },
            change: (e) => {
              (window.innerWidth < theme.sizes.small || t) &&
                this.flktyMedia.select(e);
            },
          },
        })),
        ht(this.slider);
    }
    resizeSlider() {
      this.flkty && (this.flkty.resize(), this.toggleDraggable()),
        this.flktyMedia && this.flktyMedia.resize();
    }
    toggleDraggable() {
      (this.flkty.options.draggable =
        window.innerWidth < window.theme.sizes.small),
        this.flkty.updateDraggable();
    }
    onBlockSelect(t) {
      const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
      this.flktyMedia && this.flktyMedia.selectCell(e);
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.sliderResizeEvent
      );
    }
  }
  ws("banner-with-text-columns", {
    onLoad() {
      Ra[this.id] = new Va(this);
    },
    onBlockSelect(t) {
      Ra[this.id].onBlockSelect(t);
    },
  }),
    ws("blog-posts", Dr);
  const Ua = "[data-video-play]",
    Ga = "data-video-play";
  class Ka {
    constructor(t) {
      (this.container = t),
        (this.videoPlay = this.container.querySelectorAll(Ua)),
        this.init();
    }
    init() {
      this.videoPlay.length &&
        this.videoPlay.forEach((t) => {
          t.addEventListener("click", (e) => {
            if (t.hasAttribute(Ga) && "" !== t.getAttribute(Ga).trim()) {
              e.preventDefault();
              const i = [{ html: t.getAttribute(Ga) }];
              (slate.a11y.state.trigger = t), new Cn(i);
            }
          });
        });
    }
  }
  const Xa = {
      onLoad() {
        new Ka(this.container);
      },
    },
    Ya = "[data-slider]",
    Qa = "[data-slider-item]",
    Ja = "[data-media-container]",
    Za = ".flickity-button",
    tl = "carousel--inactive",
    el = {};
  class il {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector(Ya)),
        (this.flkty = null),
        (this.gutter = 0),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        this.listen();
    }
    initSlider() {
      this.slider.classList.remove(tl),
        (this.flkty = new e(this.slider, {
          pageDots: !1,
          cellAlign: "left",
          groupCells: !0,
          contain: !0,
          on: {
            ready: () => {
              this.setSliderArrowsPosition(this.slider);
            },
          },
        }));
    }
    destroySlider() {
      this.slider.classList.add(tl),
        null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
    }
    checkSlidesSize() {
      const t =
        this.container.querySelector(Qa).currentStyle ||
        window.getComputedStyle(this.container.querySelector(Qa));
      this.gutter = parseInt(t.marginRight);
      const e = this.slider.offsetWidth < this.getItemsWidth();
      window.innerWidth >= theme.sizes.small && e
        ? this.initSlider()
        : this.destroySlider();
    }
    getItemsWidth() {
      let t = 0;
      const e = this.slider.querySelectorAll(Qa);
      return (
        e.length &&
          e.forEach((e) => {
            t += e.offsetWidth + this.gutter;
          }),
        t
      );
    }
    listen() {
      this.slider &&
        (this.checkSlidesSize(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        ));
    }
    setSliderArrowsPosition(t) {
      const e = t.querySelectorAll(Za),
        i = t.querySelector(Ja);
      e.length &&
        i &&
        e.forEach((t) => {
          t.style.top = i.offsetHeight / 2 + "px";
        });
    }
    onBlockSelect(t) {
      if (null !== this.flkty) {
        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
          i = parseInt(this.flkty.slides[0].cells.length),
          n = Math.floor(e / i);
        this.flkty.select(n);
      } else {
        const e =
            this.slider.currentStyle || window.getComputedStyle(this.slider),
          i = parseInt(e.paddingLeft),
          n = t.target.offsetLeft - i;
        this.slider.scrollTo({ top: 0, left: n, behavior: "smooth" });
      }
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.checkSlidesSizeOnResize
      );
    }
  }
  ws("columns-with-image", [
    {
      onLoad() {
        el[this.id] = new il(this);
      },
      onUnload(t) {
        el[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        el[this.id].onBlockSelect(t);
      },
    },
    Xa,
  ]);
  const nl = "[data-form-message-close]",
    ol = "[data-form-message]",
    rl = "hide-down",
    sl = "notification-visible";
  let al = {};
  class ll {
    constructor(t) {
      (this.container = t.container),
        (this.closeButton = this.container.querySelector(nl)),
        (this.messageWrapper = this.container.querySelector(ol)),
        this.messageWrapper &&
          (this.hidePopups(), this.closeFormMessage(), this.autoHideMessage());
    }
    hidePopups() {
      document.body.classList.add(sl);
    }
    showPopups() {
      document.body.classList.remove(sl);
    }
    closeFormMessage() {
      this.closeButton.addEventListener("click", this.closeMessage.bind(this));
    }
    closeMessage(t) {
      t.preventDefault(),
        this.messageWrapper.classList.add(rl),
        this.showPopups();
    }
    autoHideMessage() {
      setTimeout(() => {
        this.messageWrapper.classList.add(rl), this.showPopups();
      }, 1e4);
    }
  }
  ws("contact-form", {
    onLoad() {
      al[this.id] = new ll(this);
    },
  });
  const cl = "[data-product]",
    dl = "[data-slider]",
    ul = "[data-slide]",
    hl = "[data-product-media-container]",
    pl = ".flickity-button",
    fl = "a, button",
    ml = "tabindex",
    gl = {};
  class yl {
    constructor(t) {
      (this.container = t),
        (this.product = this.container.querySelectorAll(cl)),
        (this.productSlider = this.container.querySelectorAll(dl)),
        (this.checkSliderOnResize = () => this.checkSlider()),
        (this.flkty = []),
        (this.videoObj = []),
        (this.quickViewObj = []),
        this.listen();
    }
    checkSlider() {
      window.innerWidth >= theme.sizes.small
        ? this.productSlider.forEach((t) => {
            this.initProductSlider(t);
          })
        : this.productSlider.forEach((t) => {
            this.destroyProductSlider(t);
          });
    }
    initProductSlider(t) {
      const i = t.querySelectorAll(ul).length,
        n = t.dataset.slider;
      i > 1 &&
        (void 0 !== this.flkty[n] && this.flkty[n].isActive
          ? this.setSliderArrowsPosition(t)
          : (this.flkty[n] = new e(t, {
              prevNextButtons: !0,
              pageDots: !0,
              wrapAround: !0,
              on: {
                ready: () => {
                  this.setSliderArrowsPosition(t);
                },
                change: (t) => {
                  this.flkty[n].cells.forEach((e, i) => {
                    e.element.querySelectorAll(fl).forEach((e) => {
                      e.setAttribute(ml, i === t ? "0" : "-1");
                    });
                  });
                },
              },
            })));
    }
    destroyProductSlider(t) {
      const e = t.dataset.slider;
      "object" == typeof this.flkty[e] && this.flkty[e].destroy();
    }
    setSliderArrowsPosition(t) {
      const e = t.querySelectorAll(pl),
        i = t.querySelector(hl);
      e.length &&
        i &&
        e.forEach((t) => {
          t.style.top = i.offsetHeight / 2 + "px";
        });
    }
    listen() {
      this.checkSlider(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSliderOnResize
        );
    }
    onUnload() {
      if (this.flkty)
        for (const t in this.flkty)
          this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
      document.removeEventListener(
        "theme:resize:width",
        this.checkSliderOnResize
      );
    }
  }
  ws("custom-content", [
    {
      onLoad() {
        gl[this.id] = new yl(this.container);
      },
      onUnload(t) {
        gl[this.id].onUnload(t);
      },
    },
    Xa,
    Ar,
  ]);
  const vl = "[data-slider]",
    bl = "[data-slide]",
    wl = "[data-product-media-container]",
    Sl = ".flickity-button",
    El = "carousel--inactive",
    Ll = "data-slider-id",
    kl = "data-slider-show-image",
    xl = {};
  class Tl {
    constructor(t) {
      (this.container = t),
        (this.columns = parseInt(this.container.dataset.columns)),
        (this.sliders = this.container.querySelectorAll(vl)),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        (this.resetSliderEvent = (t) => this.resetSlider(t)),
        (this.flkty = []),
        this.listen();
    }
    initSlider(t) {
      const i = t.getAttribute(Ll);
      t.classList.remove(El),
        void 0 !== this.flkty[i] && this.flkty[i].isActive
          ? this.setSliderArrowsPosition(t)
          : (this.flkty[i] = new e(t, {
              pageDots: !1,
              cellSelector: bl,
              cellAlign: "left",
              groupCells: !0,
              contain: !0,
              wrapAround: !1,
              adaptiveHeight: !1,
              on: {
                ready: () => {
                  this.setSliderArrowsPosition(t);
                },
              },
            }));
    }
    destroySlider(t) {
      const e = t.getAttribute(Ll);
      t.classList.add(El),
        "object" == typeof this.flkty[e] && this.flkty[e].destroy();
    }
    resetSlider(t) {
      const e = t.target,
        i = e.getAttribute(Ll);
      "object" == typeof this.flkty[i]
        ? this.flkty[i].select(0, !1, !0)
        : e.scrollTo({ left: 0, behavior: "instant" });
    }
    checkSlidesSize() {
      this.sliders.length &&
        this.sliders.forEach((t) => {
          const e = this.columns,
            i = window.innerWidth >= theme.sizes.large,
            n =
              window.innerWidth >= theme.sizes.small &&
              window.innerWidth < theme.sizes.large;
          let o = t.querySelectorAll(bl).length;
          t.hasAttribute(kl) && (o += 1),
            (i && o > e) || (n && o > 2)
              ? this.initSlider(t)
              : this.destroySlider(t);
        });
    }
    setSliderArrowsPosition(t) {
      const e = t.querySelectorAll(Sl),
        i = t.querySelector(wl);
      e.length &&
        i &&
        e.forEach((t) => {
          t.style.top = i.offsetHeight / 2 + "px";
        });
    }
    listen() {
      this.sliders.length &&
        (this.checkSlidesSize(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        ),
        this.sliders.forEach((t) => {
          t.addEventListener("theme:tab:change", this.resetSliderEvent);
        }));
    }
    onBlockSelect(t) {
      const i = t.target.closest(vl),
        n = e.data(i) || null;
      if (i)
        if (null !== n && n.isActive) {
          const e = parseInt(
              [...t.target.parentNode.children].indexOf(t.target)
            ),
            i = parseInt(n.slides[0].cells.length),
            o = Math.floor(e / i);
          n.select(o);
        } else {
          const e = i.currentStyle || window.getComputedStyle(i),
            n = parseInt(e.paddingLeft),
            o = t.target.offsetLeft - n;
          i.scrollTo({ top: 0, left: o, behavior: "smooth" });
        }
    }
    onUnload() {
      if (this.flkty)
        for (const t in this.flkty)
          this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
      document.removeEventListener(
        "theme:resize:width",
        this.checkSlidesSizeOnResize
      ),
        this.sliders.length &&
          this.sliders.forEach((t) => {
            t.removeEventListener("theme:tab:change", this.resetSliderEvent);
          });
    }
  }
  const Al = {
    onLoad() {
      xl[this.id] = [];
      this.container.querySelectorAll(vl).forEach((t) => {
        xl[this.id].push(new Tl(this.container));
      });
    },
    onUnload() {
      xl[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      xl[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
  };
  ws("featured-collection", [Ar, Al]), ws("featured-video", Xa);
  class Cl {
    constructor(t, e) {
      (this.configuration = {
        expires: null,
        path: "/",
        domain: window.location.hostname,
        sameSite: "none",
        secure: !0,
      }),
        (this.name = t),
        (this.value = e);
    }
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((t) => t.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
  }
  const ql = "[data-newsletter-form]",
    Pl = "[data-popup]",
    _l = "has-success",
    Dl = "has-error",
    Il = "newsletter_form_id",
    Ol = {};
  class Fl {
    constructor(t) {
      (this.newsletter = t),
        (this.sessionStorage = window.sessionStorage),
        (this.popup = this.newsletter.closest(Pl)),
        (this.stopSubmit = !0),
        (this.isChallengePage = !1),
        (this.formID = null),
        (this.formIdSuccess = null),
        this.checkForChallengePage(),
        (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
        this.isChallengePage || this.init();
    }
    init() {
      this.newsletter.addEventListener("submit", this.newsletterSubmit),
        this.showMessage();
    }
    newsletterSubmitEvent(t) {
      this.stopSubmit &&
        (t.preventDefault(),
        this.removeStorage(),
        this.writeStorage(),
        (this.stopSubmit = !1),
        this.newsletter.submit());
    }
    checkForChallengePage() {
      this.isChallengePage =
        window.location.pathname === theme.routes.root + "challenge";
    }
    writeStorage() {
      void 0 !== this.sessionStorage &&
        this.sessionStorage.setItem(Il, this.newsletter.id);
    }
    readStorage() {
      this.formID = this.sessionStorage.getItem(Il);
    }
    removeStorage() {
      this.sessionStorage.removeItem(Il);
    }
    showMessage() {
      if ((this.readStorage(), this.newsletter.id === this.formID)) {
        const t = document.getElementById(this.formID),
          e = -1 !== window.location.search.indexOf("?customer_posted=true"),
          i = -1 !== window.location.search.indexOf("accepts_marketing");
        e
          ? (t.classList.remove(Dl),
            t.classList.add(_l),
            this.popup &&
              ((this.cookie = new Cl(
                this.popup.dataset.cookieName,
                "user_has_closed"
              )),
              this.cookie.write()))
          : i && (t.classList.remove(_l), t.classList.add(Dl)),
          (e || i) && this.scrollToForm(t);
      }
    }
    scrollToForm(t) {
      const e = t.getBoundingClientRect();
      visibilityHelper.isElementPartiallyVisible(t) ||
        visibilityHelper.isElementTotallyVisible(t) ||
        setTimeout(() => {
          window.scrollTo({ top: e.top, left: 0, behavior: "smooth" });
        }, 400);
    }
    onUnload() {
      this.newsletter.removeEventListener("submit", this.newsletterSubmit);
    }
  }
  const Hl = {
      onLoad() {
        Ol[this.id] = [];
        this.container.querySelectorAll(ql).forEach((t) => {
          Ol[this.id].push(new Fl(t));
        });
      },
      onUnload() {
        Ol[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Ml = "[data-collapsible-trigger-mobile]",
    jl = "is-expanded";
  ws("footer", [
    Pi,
    Hl,
    P,
    {
      onBlockSelect(t) {
        const e = t.target.querySelector(Ml);
        e && !e.classList.contains(jl) && e.dispatchEvent(new Event("click"));
      },
      onBlockDeselect(t) {
        const e = t.target.querySelector(Ml);
        e && e.classList.contains(jl) && e.dispatchEvent(new Event("click"));
      },
    },
  ]);
  const Nl = "[data-slider]";
  let Bl = {};
  class $l {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector(Nl));
    }
    onBlockSelect(t) {
      const e =
          this.slider.currentStyle || window.getComputedStyle(this.slider),
        i = parseInt(e.paddingLeft),
        n = t.target.offsetLeft - i;
      this.slider.scrollTo({ top: 0, left: n, behavior: "smooth" });
    }
  }
  ws("icons-row", {
    onLoad() {
      Bl[this.id] = new $l(this);
    },
    onBlockSelect(t) {
      Bl[this.id].onBlockSelect(t);
    },
  });
  const Wl = "[data-accordion-item]",
    zl = "[data-accordion-button]",
    Rl = "is-expanded",
    Vl = {};
  class Ul {
    constructor(t) {
      (this.container = t.container),
        (this.imageAccordionsItems = this.container.querySelectorAll(Wl)),
        (this.buttons = this.container.querySelectorAll(zl)),
        (this.accordionExpandEvent = (t) => this.accordionExpand(t)),
        (this.accordionFocusEvent = (t) => this.accordionFocus(t)),
        this.init();
    }
    init() {
      this.imageAccordionsItems.forEach((t) => {
        t.addEventListener(
          "mouseenter",
          this.accordionExpandEvent.bind(this, t)
        );
      }),
        this.buttons.forEach((t) => {
          t.addEventListener("focusin", this.accordionFocusEvent.bind(this, t));
        });
    }
    accordionExpand(t) {
      t.classList.contains(Rl) ||
        (this.imageAccordionsItems.forEach((t) => {
          t.classList.remove(Rl);
        }),
        t.classList.add(Rl));
    }
    accordionFocus(t) {
      t.closest(Wl).dispatchEvent(new Event("mouseenter"));
    }
    onBlockSelect(t) {
      const e = t.target;
      e && e.dispatchEvent(new Event("mouseenter"));
    }
  }
  ws("image-accordions", {
    onLoad() {
      Vl[this.id] = new Ul(this);
    },
    onBlockSelect(t) {
      Vl[this.id].onBlockSelect(t);
    },
  }),
    ws("image-with-text", Xa),
    ws("list-collections", Al);
  const Gl = {},
    Kl = "[data-slider-gallery]",
    Xl = "[data-slider-info]",
    Yl = "[data-slide-item]";
  class Ql {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector(Kl)),
        (this.sliderNav = this.container.querySelector(Xl)),
        this.initSlider();
    }
    initSlider() {
      const t = this.container.querySelectorAll(Yl).length;
      let i = e.data(this.slider) || null,
        n = e.data(this.sliderNav) || null;
      t <= 1 ||
        ((i = new e(this.slider, {
          fade: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          prevNextButtons: !1,
          pageDots: !1,
        })),
        ht(this.slider),
        (n = new e(this.sliderNav, {
          fade: !0,
          wrapAround: !0,
          imagesLoaded: !0,
          lazyLoad: !0,
          asNavFor: this.slider,
          prevNextButtons: !0,
          pageDots: !1,
        })),
        n.on("change", () => {
          i.selectCell(n.selectedIndex);
        }),
        i.on("change", () => {
          n.selectCell(i.selectedIndex);
        }));
    }
    onBlockSelect(t) {
      const i = e.data(this.slider) || null,
        n = e.data(this.sliderNav) || null,
        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
      null !== i && i.select(o), null !== n && n.select(o);
    }
  }
  ws("locations", {
    onLoad() {
      Gl[this.id] = new Ql(this);
    },
    onBlockSelect(t) {
      Gl[this.id].onBlockSelect(t);
    },
  });
  const Jl = {},
    Zl = "[data-slider]",
    tc = "[data-slider-item]";
  class ec {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector(Zl)),
        (this.sliderResizeEvent = () => this.checkSlides()),
        (this.flkty = null),
        this.checkSlides(),
        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
    }
    checkSlides() {
      const t = this.container.offsetWidth;
      let e = this.getSlidesWidth();
      window.innerWidth >= theme.sizes.small && e > t
        ? this.initSlider()
        : this.destroySlider();
    }
    getSlidesWidth() {
      let t = 0;
      const e = this.container.querySelectorAll(tc);
      return (
        e.length &&
          e.forEach((e) => {
            t += e.offsetWidth;
          }),
        t
      );
    }
    initSlider() {
      null !== e.data(this.slider) &&
        ((this.flkty = new e(this.slider, {
          contain: !0,
          wrapAround: !0,
          pageDots: !1,
        })),
        ht(this.slider));
    }
    destroySlider() {
      e.data(this.slider) && this.flkty.destroy();
    }
    onBlockSelect(t) {
      const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
      if (null !== this.flkty) this.flkty.select(e);
      else {
        const e =
            this.slider.currentStyle || window.getComputedStyle(this.slider),
          i = parseInt(e.paddingLeft),
          n = t.target.offsetLeft - i;
        this.slider.scrollTo({ top: 0, left: n, behavior: "smooth" });
      }
    }
    onUnload() {
      e.data(this.slider) && this.flkty.destroy(),
        document.removeEventListener(
          "theme:resize:width",
          this.sliderResizeEvent
        );
    }
  }
  ws("logo-list", {
    onLoad() {
      Jl[this.id] = new ec(this);
    },
    onUnload(t) {
      Jl[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      Jl[this.id].onBlockSelect(t);
    },
  });
  const ic = {},
    nc = "[data-slider]",
    oc = "[data-slide-item]",
    rc = "[data-pointer]",
    sc = "[data-product-media-container]",
    ac = "a, button",
    lc = ".flickity-button",
    cc = "data-pointer",
    dc = "tabindex",
    uc = "pointer--selected",
    hc = "is-selected";
  class pc {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector(nc)),
        (this.slides = this.container.querySelectorAll(oc)),
        (this.pointers = this.container.querySelectorAll(rc)),
        (this.flkty = null),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        (this.onDrawerOpen = () => this.drawerOpen()),
        (this.pointersInit = (t) => this.dotPointers(t)),
        (this.pointersOver = () => this.dotPointerIn()),
        (this.pointersOut = () => this.dotPointerOut()),
        new Mn(this.container),
        this.listen();
    }
    listen() {
      this.slider &&
        (this.checkSlidesSize(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        ),
        document.addEventListener("theme:drawer:open", this.onDrawerOpen)),
        this.pointers.length > 0 &&
          this.pointers.forEach((t) => {
            t.addEventListener("click", this.pointersInit),
              t.addEventListener("mouseover", this.pointersOver),
              t.addEventListener("mouseleave", this.pointersOut);
          });
    }
    checkSlidesSize() {
      const t = window.innerWidth >= theme.sizes.small;
      if (t)
        return (
          PaloAlto.Drawer.close(),
          void (this.slides.length > 2
            ? this.initSlider()
            : (this.destroySlider(), this.slidesTabIndex()))
        );
      !t && this.slides.length > 1 ? this.initSlider() : this.destroySlider();
    }
    initSlider() {
      null !== this.flkty
        ? this.setSliderArrowsPosition()
        : (this.flkty = new e(this.slider, {
            prevNextButtons: !0,
            wrapAround: !0,
            adaptiveHeight: !1,
            cellAlign: "left",
            groupCells: !1,
            contain: !0,
            on: {
              ready: () => {
                this.slidesTabIndex(),
                  this.setSliderArrowsPosition(),
                  this.dotPointers();
              },
              change: () => {
                this.slidesTabIndex(), this.dotPointers();
              },
            },
          }));
    }
    drawerOpen() {
      null !== this.flkty &&
        setTimeout(() => {
          this.flkty.resize();
        }, 0);
    }
    setSliderArrowsPosition() {
      if (window.innerWidth >= theme.sizes.small) {
        const t = this.slider.querySelectorAll(lc),
          e = this.slider.querySelector(sc);
        t.length &&
          e &&
          t.forEach((t) => {
            t.style.top = e.offsetHeight / 2 + "px";
          });
      }
    }
    slidesTabIndex() {
      if (this.slides.length < 3)
        return void this.slider.querySelectorAll(ac).forEach((t) => {
          t.setAttribute(dc, "0");
        });
      const t = e.data(this.slider);
      t.cells.forEach((t) => {
        t.element.querySelectorAll(ac).forEach((t) => {
          t.setAttribute(dc, "-1");
        });
      }),
        t.cells.forEach((t) => {
          if (t.element.classList.contains(hc)) {
            t.element.querySelectorAll(ac).forEach((t) => {
              t.setAttribute(dc, "0");
            });
            (t.element.nextSibling
              ? t.element.nextSibling
              : t.element.parentNode.firstChild
            )
              .querySelectorAll(ac)
              .forEach((t) => {
                t.setAttribute(dc, "0");
              });
          }
        });
    }
    destroySlider() {
      "object" == typeof this.flkty &&
        null !== this.flkty &&
        (this.flkty.destroy(), (this.flkty = null));
    }
    dotPointers(t) {
      if (
        (this.pointers.forEach((t) => {
          t.classList.remove(uc);
        }),
        t)
      ) {
        const e = t.target.getAttribute(cc);
        return void this.flkty.select(e);
      }
      const e = null == this.flkty ? 0 : this.flkty.selectedIndex;
      e >= 0 && this.pointers[e].classList.add(uc);
    }
    dotPointerIn() {
      this.pointers.forEach((t) => {
        t.style.setProperty("--look-animation", "none");
      });
    }
    dotPointerOut() {
      this.pointers.forEach((t) => {
        t.style.removeProperty("--look-animation");
      });
    }
    onBlockSelect(t) {
      const i = e.data(this.slider) || null,
        n = parseInt([...t.target.parentNode.children].indexOf(t.target));
      null !== i && i.select(n);
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.checkSlidesSizeOnResize
      ),
        document.removeEventListener("theme:drawer:open", this.onDrawerOpen);
    }
  }
  ws("look", {
    onLoad() {
      ic[this.id] = new pc(this);
    },
    onUnload(t) {
      ic[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      ic[this.id].onBlockSelect(t);
    },
  });
  const fc = "[data-grid]";
  ws("mosaic", {
    onBlockSelect(t) {
      const e = t.target.closest(fc),
        i = e.currentStyle || window.getComputedStyle(e),
        n = parseInt(i.paddingLeft),
        o = t.target.offsetLeft - n;
      e.scrollTo({ top: 0, left: o, behavior: "smooth" });
    },
  }),
    ws("newsletter", Hl),
    ws("overlapping-images", Xa);
  const mc = "[data-toggle-admin]",
    gc = "[data-toggle-newsletter]",
    yc = "[data-form-admin]",
    vc = "[data-form-newsletter]";
  let bc = {};
  class wc {
    constructor(t) {
      (this.container = t.container),
        (this.toggleAdmin = this.container.querySelector(mc)),
        (this.toggleNewsletter = this.container.querySelector(gc)),
        (this.adminForm = this.container.querySelector(yc)),
        (this.newsletterForm = this.container.querySelector(vc)),
        (this.adminErrors = this.adminForm.querySelector(".errors")),
        (this.newsletterErrors = this.newsletterForm.querySelector(".errors")),
        this.init();
    }
    init() {
      this.toggleAdmin.addEventListener("click", (t) => {
        t.preventDefault(), this.showPasswordForm();
      }),
        this.toggleNewsletter.addEventListener("click", (t) => {
          t.preventDefault(), this.hidePasswordForm();
        }),
        "#login" == window.location.hash || this.adminErrors
          ? this.showPasswordForm()
          : this.hidePasswordForm();
    }
    showPasswordForm() {
      At(this.adminForm),
        Ct(this.newsletterForm),
        (window.location.hash = "#login");
    }
    hidePasswordForm() {
      At(this.newsletterForm), Ct(this.adminForm), (window.location.hash = "");
    }
  }
  ws("password-template", {
    onLoad() {
      bc[this.id] = new wc(this);
    },
  });
  const Sc = "[data-large-promo]",
    Ec = "[data-large-promo-inner]",
    Lc = "[data-tracking-consent]",
    kc = "[data-tracking-consent-inner]",
    xc = "[data-confirm-cookies]",
    Tc = "[data-popup-bar]",
    Ac = "[data-popup-bar-holder]",
    Cc = "[data-popup-bar-toggle]",
    qc = "[data-popup-body]",
    Pc = "[data-popup-close]",
    _c = "[data-popup-underlay]",
    Dc = "[data-newsletter-form]",
    Ic = "data-target-referrer",
    Oc = "data-prevent-scroll-lock",
    Fc = "has-success",
    Hc = "has-error",
    Mc = "selected",
    jc = "has-block-selected",
    Nc = "popup--expanded",
    Bc = "popup--visible",
    $c = "mobile",
    Wc = "desktop";
  let zc = {},
    Rc = 0;
  class Vc {
    constructor(t, e) {
      if (
        ((this.popupContainer = t),
        (this.popup = e),
        (this.popupBody = e.querySelector(qc)),
        (this.delay = t.dataset.popupDelay),
        (this.isSubmitted =
          -1 !== window.location.href.indexOf("accepts_marketing") ||
          -1 !== window.location.href.indexOf("customer_posted=true")),
        (this.a11y = slate.a11y),
        (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
        ("always" === this.delay || this.isSubmitted) && this.always(),
        this.delay && this.delay.includes("delayed") && !this.isSubmitted)
      ) {
        const t = this.delay.includes("_")
          ? parseInt(this.delay.split("_")[1])
          : 10;
        this.delayed(t);
      }
      "bottom" !== this.delay || this.isSubmitted || this.bottom(),
        "idle" !== this.delay || this.isSubmitted || this.idle();
    }
    always() {
      this.showPopup();
    }
    delayed(t = 10) {
      setTimeout(() => {
        this.showPopup();
      }, 1e3 * t);
    }
    bottom() {
      document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
    idle() {
      if (!(!0 === this.checkPopupTarget())) return;
      let t = 0;
      const e = [
          "mousemove",
          "mousedown",
          "click",
          "touchmove",
          "touchstart",
          "touchend",
          "keydown",
          "keypress",
        ],
        i = ["load", "resize", "scroll"],
        n = () => {
          (t = setTimeout(() => {
            (t = 0), this.showPopup();
          }, 6e4)),
            e.forEach((t) => {
              document.addEventListener(t, o);
            }),
            i.forEach((t) => {
              window.addEventListener(t, o);
            });
        },
        o = () => {
          t && clearTimeout(t),
            e.forEach((t) => {
              document.removeEventListener(t, o);
            }),
            i.forEach((t) => {
              window.removeEventListener(t, o);
            }),
            n();
        };
      n();
    }
    showPopup() {
      if (!0 === this.checkPopupTarget()) {
        if ((this.popup.classList.add(Bc), this.popup.hasAttribute(Oc)))
          return !1;
        this.scrollLock();
      }
    }
    hidePopup() {
      this.popup.classList.remove(Bc), this.scrollUnlock();
    }
    checkPopupTarget() {
      const t = this.popup.parentNode.classList.contains($c),
        e = this.popup.parentNode.classList.contains(Wc);
      return !(
        (t && window.innerWidth >= theme.sizes.small) ||
        (e && window.innerWidth < theme.sizes.small)
      );
    }
    scrollLock() {
      this.a11y.trapFocus({ container: this.popupBody }),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.popupBody,
          })
        );
    }
    scrollUnlock() {
      this.a11y.removeTrapFocus(),
        (Rc = setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
        }, 300));
    }
    resetScrollUnlock() {
      Rc && clearTimeout(Rc);
    }
    showPopupOnScroll() {
      window.scrollY + window.innerHeight >= document.body.clientHeight &&
        (this.showPopup(),
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        ));
    }
    onUnload() {
      document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
  }
  class Uc {
    constructor(t) {
      if (
        ((this.popupContainer = t),
        (this.locationPath = location.href),
        !this.popupContainer.hasAttribute(Ic))
      )
        return !1;
      -1 !== this.locationPath.indexOf(this.popupContainer.getAttribute(Ic)) ||
        window.Shopify.designMode ||
        this.popupContainer.parentNode.removeChild(this.popupContainer);
    }
  }
  class Gc {
    constructor(t) {
      (this.popupContainer = t),
        (this.popup = this.popupContainer.querySelector(Ec)),
        (this.popupBody = this.popup.querySelector(qc)),
        (this.close = this.popup.querySelector(Pc)),
        (this.underlay = this.popup.querySelector(_c)),
        (this.form = this.popup.querySelector(Dc)),
        (this.cookie = new Cl(
          this.popupContainer.dataset.cookieName,
          "user_has_closed"
        )),
        (this.isTargeted = new Uc(this.popupContainer)),
        (this.a11y = slate.a11y),
        this.init();
    }
    init() {
      (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
        (window.Shopify.designMode
          ? this.showPopup()
          : new Vc(this.popupContainer, this.popup),
        this.form &&
          setTimeout(() => {
            this.form.classList.contains(Fc) && this.showPopupIfNoCookie();
          }),
        this.initClosers());
    }
    checkPopupTarget() {
      const t = this.popup.parentNode.classList.contains($c),
        e = this.popup.parentNode.classList.contains(Wc);
      return !(
        (t && window.innerWidth >= theme.sizes.small) ||
        (e && window.innerWidth < theme.sizes.small)
      );
    }
    showPopupIfNoCookie() {
      this.showPopup();
    }
    initClosers() {
      this.close.addEventListener("click", this.closePopup.bind(this)),
        this.underlay.addEventListener("click", this.closePopup.bind(this)),
        this.popupContainer.addEventListener("keyup", (t) => {
          t.keyCode === theme.keyboardKeys.ESCAPE && this.closePopup(t);
        });
    }
    closePopup(t) {
      t.preventDefault(), this.hidePopup(), this.cookie.write();
    }
    scrollLock() {
      this.resetScrollUnlock(),
        this.a11y.trapFocus({ container: this.popupBody }),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.popupBody,
          })
        );
    }
    scrollUnlock() {
      this.a11y.removeTrapFocus(),
        this.resetScrollUnlock(),
        (Rc = setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
        }, 300));
    }
    resetScrollUnlock() {
      Rc && clearTimeout(Rc);
    }
    showPopup() {
      !0 === this.checkPopupTarget() &&
        (this.popup.classList.add(Bc), this.scrollLock());
    }
    hidePopup() {
      this.popup.classList.remove(Bc), this.scrollUnlock();
    }
    onBlockSelect(t) {
      this.popupContainer.contains(t.target) &&
        (this.popup.classList.add(Mc),
        this.popupContainer.classList.add(jc),
        this.showPopup());
    }
    onBlockDeselect(t) {
      this.popupContainer.contains(t.target) &&
        (this.popup.classList.remove(Mc),
        this.popupContainer.classList.remove(jc),
        this.hidePopup());
    }
  }
  class Kc {
    constructor(t) {
      (this.popupContainer = t),
        (this.popup = this.popupContainer.querySelector(kc)),
        (this.close = this.popup.querySelector(Pc)),
        (this.acceptButton = this.popup.querySelector(xc)),
        (this.enable = "true" === this.popupContainer.dataset.enable),
        window.Shopify.loadFeatures(
          [{ name: "consent-tracking-api", version: "0.1" }],
          (t) => {
            if (t) throw t;
            const e = window.Shopify.customerPrivacy.userCanBeTracked(),
              i = window.Shopify.customerPrivacy.getTrackingConsent();
            (this.enableTracking = !e && "no_interaction" === i && this.enable),
              window.Shopify.designMode && (this.enableTracking = !0),
              this.init();
          }
        );
    }
    init() {
      this.enableTracking && this.showPopup(), this.clickEvents();
    }
    clickEvents() {
      this.close.addEventListener("click", (t) => {
        t.preventDefault(),
          window.Shopify.customerPrivacy.setTrackingConsent(!1, () =>
            this.hidePopup()
          );
      }),
        this.acceptButton.addEventListener("click", (t) => {
          t.preventDefault(),
            window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
              this.hidePopup()
            );
        }),
        document.addEventListener("trackingConsentAccepted", () => {
          console.log("trackingConsentAccepted event fired");
        });
    }
    showPopup() {
      this.popup.classList.add(Bc);
    }
    hidePopup() {
      this.popup.classList.remove(Bc);
    }
    onBlockSelect(t) {
      this.popupContainer.contains(t.target) &&
        this.enableTracking &&
        (this.showPopup(),
        this.popup.classList.add(Mc),
        this.popup.parentNode.classList.add(jc));
    }
    onBlockDeselect(t) {
      this.popupContainer.contains(t.target) &&
        (this.popup.classList.remove(Mc),
        this.popupContainer.classList.remove(jc),
        this.hidePopup());
    }
  }
  class Xc {
    constructor(t) {
      (this.popupContainer = t),
        (this.popup = this.popupContainer.querySelector(Ac)),
        (this.popupBody = this.popup.querySelector(qc)),
        (this.close = this.popup.querySelector(Pc)),
        (this.underlay = this.popup.querySelector(_c)),
        (this.toggle = this.popup.querySelector(Cc)),
        (this.cookie = new Cl(
          this.popupContainer.dataset.cookieName,
          "user_has_closed"
        )),
        (this.form = this.popup.querySelector(Dc)),
        (this.isTargeted = new Uc(this.popupContainer)),
        (this.a11y = slate.a11y),
        this.init();
    }
    init() {
      (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
        (window.Shopify.designMode
          ? this.showPopup()
          : new Vc(this.popupContainer, this.popup),
        this.initPopupToggleButton(),
        this.initClosers(),
        this.form &&
          setTimeout(() => {
            this.form.classList.contains(Fc) && this.showPopupIfNoCookie(),
              this.form.classList.contains(Hc) &&
                this.toggle.dispatchEvent(new Event("click"));
          }));
    }
    checkPopupTarget() {
      const t = this.popup.parentNode.classList.contains($c),
        e = this.popup.parentNode.classList.contains(Wc);
      return !(
        (t && window.innerWidth >= theme.sizes.small) ||
        (e && window.innerWidth < theme.sizes.small)
      );
    }
    showPopupIfNoCookie() {
      this.showPopup(), this.toggle.dispatchEvent(new Event("click"));
    }
    initPopupToggleButton() {
      this.toggle.addEventListener("click", (t) => {
        t.preventDefault(),
          this.popup.classList.toggle(Nc),
          this.popup.classList.contains(Nc)
            ? this.scrollLock()
            : this.scrollUnlock();
      });
    }
    showPopup() {
      !0 === this.checkPopupTarget() && this.popup.classList.add(Bc);
    }
    hidePopup() {
      this.popup.classList.remove(Bc), this.scrollUnlock();
    }
    initClosers() {
      this.close.addEventListener("click", this.closePopup.bind(this)),
        this.underlay.addEventListener("click", () =>
          this.toggle.dispatchEvent(new Event("click"))
        ),
        this.popupContainer.addEventListener("keyup", (t) => {
          t.keyCode === theme.keyboardKeys.ESCAPE &&
            (this.popup.classList.remove(Nc), this.scrollUnlock());
        });
    }
    closePopup(t) {
      t.preventDefault(), this.cookie.write(), this.hidePopup();
    }
    scrollLock() {
      this.a11y.trapFocus({ container: this.popupBody }),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.popupBody,
          })
        );
    }
    scrollUnlock() {
      this.a11y.removeTrapFocus(),
        this.resetScrollUnlock(),
        (Rc = setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
        }, 300));
    }
    resetScrollUnlock() {
      Rc && clearTimeout(Rc);
    }
    onBlockSelect(t) {
      this.popupContainer.contains(t.target) &&
        (this.showPopup(),
        this.popup.classList.add(Nc),
        this.popup.classList.add(Mc),
        this.popup.parentNode.classList.add(jc),
        this.resetScrollUnlock(),
        this.scrollLock());
    }
    onBlockDeselect(t) {
      this.popupContainer.contains(t.target) &&
        (this.popup.classList.remove(Nc),
        this.popup.classList.remove(Mc),
        this.popup.parentNode.classList.remove(jc),
        this.hidePopup());
    }
  }
  ws("popups", [
    {
      onLoad() {
        zc[this.id] = [];
        const t = this.container.querySelectorAll(Sc);
        t.length &&
          t.forEach((t) => {
            zc[this.id].push(new Gc(t));
          });
        const e = this.container.querySelectorAll(Tc);
        e.length &&
          e.forEach((t) => {
            zc[this.id].push(new Xc(t));
          });
        const i = this.container.querySelectorAll(Lc);
        i.length &&
          i.forEach((t) => {
            zc[this.id].push(new Kc(t));
          });
      },
      onBlockSelect(t) {
        zc[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        zc[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
      onUnload(t) {
        zc[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload(t);
        });
      },
    },
    Hl,
  ]);
  const Yc = "[data-press-items]",
    Qc = "[data-logo-slider]",
    Jc = "[data-logo-slide]",
    Zc = "a, button",
    td = "data-logo-index",
    ed = "tabindex";
  let id = {};
  class nd {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector(Yc)),
        (this.sliderNav = this.container.querySelector(Qc)),
        (this.sliderResizeEvent = () => this.checkSlides()),
        this.initSlider(),
        this.checkSlides(),
        window.addEventListener("load", this.resizeSlider.bind(this)),
        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
    }
    checkSlides() {
      const t = this.container.offsetWidth,
        i = this.container.querySelectorAll(Jc),
        n = e.data(this.sliderNav) || null;
      null !== n &&
        ((n.options.draggable = !1),
        (n.options.wrapAround = !1),
        (n.options.contain = !0),
        this.getSlidesWidth() > t &&
          i.length > 2 &&
          ((n.options.draggable = !0),
          (n.options.wrapAround = !0),
          (n.options.contain = !1)),
        n.resize(),
        n.updateDraggable());
    }
    getSlidesWidth() {
      const t = this.container.querySelectorAll(Jc);
      let e = 0;
      return (
        t.length &&
          t.forEach((t) => {
            e += t.offsetWidth;
          }),
        e
      );
    }
    initSlider() {
      let t = e.data(this.slider) || null,
        i = e.data(this.sliderNav) || null;
      (t = new e(this.slider, {
        fade: !0,
        wrapAround: !0,
        adaptiveHeight: !0,
        prevNextButtons: !1,
        pageDots: !1,
      })),
        (i = new e(this.sliderNav, {
          draggable: !1,
          wrapAround: !1,
          contain: !0,
          imagesLoaded: !0,
          lazyLoad: !0,
          asNavFor: this.slider,
          prevNextButtons: !1,
          adaptiveHeight: !1,
          pageDots: !1,
          on: {
            ready: () => {
              this.container.querySelectorAll(Jc).forEach((e) => {
                e.addEventListener("keyup", (i) => {
                  if (
                    i.keyCode === slate.utils.keyboardKeys.ENTER ||
                    i.keyCode === slate.utils.keyboardKeys.SPACE
                  ) {
                    const i = Number(e.getAttribute(td));
                    t.selectCell(i);
                  }
                });
              });
            },
          },
        })),
        ht(this.slider),
        ht(this.sliderNav),
        i.on("change", (e) => {
          t.selectCell(e);
        }),
        t.on("change", (e) => {
          i.selectCell(e),
            t.cells.forEach((t, i) => {
              t.element.querySelectorAll(Zc).forEach((t) => {
                t.setAttribute(ed, i === e ? "0" : "-1");
              });
            });
        });
    }
    resizeSlider() {
      const t = e.data(this.slider);
      t && t.resize();
    }
    onBlockSelect(t) {
      const i = e.data(this.slider) || null,
        n = e.data(this.sliderNav) || null,
        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
      null !== i && i.select(o), null !== n && n.select(o);
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.sliderResizeEvent
      );
    }
  }
  ws("press", {
    onLoad() {
      id[this.id] = new nd(this);
    },
    onUnload(t) {
      id[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      id[this.id].onBlockSelect(t);
    },
  });
  const od = "[data-tooltip]",
    rd = "[data-tooltip-container]",
    sd = "tooltip-default",
    ad = "is-visible",
    ld = "is-hiding",
    cd = "data-tooltip",
    dd = "data-tooltip-container",
    ud = "data-tooltip-stop-mouseenter",
    hd = {};
  class pd {
    constructor(t) {
      (this.tooltip = t),
        this.tooltip.hasAttribute(cd) &&
          ((this.rootClass = sd),
          (this.label = this.tooltip.getAttribute(cd)),
          (this.transitionSpeed = 200),
          (this.hideTransitionTimeout = 0),
          (this.addPinEvent = () => this.addPin()),
          (this.addPinMouseEvent = () => this.addPin(!0)),
          (this.removePinEvent = (t) => m(this.removePin(t), 50)),
          (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
          this.init());
    }
    init() {
      if (!document.querySelector(rd)) {
        const t = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow"></div><div class="${this.rootClass}__text"></div></div>`,
          e = document.createElement("div");
        (e.className = this.rootClass),
          e.setAttribute(dd, ""),
          (e.innerHTML = t),
          document.body.appendChild(e);
      }
      this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
        this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
        document.addEventListener("theme:tooltip:close", this.removePinEvent);
    }
    addPin(t = !1) {
      const e = document.querySelector(rd);
      if (e && ((t && !this.tooltip.hasAttribute(ud)) || !t)) {
        const t = e.querySelector(`.${this.rootClass}__inner`);
        e.querySelector(`.${this.rootClass}__text`).textContent = this.label;
        const i = t.offsetWidth,
          n = this.tooltip.getBoundingClientRect(),
          o = n.top,
          r = n.width,
          s = o + n.height + window.scrollY;
        let a = n.left - i / 2 + r / 2;
        const l = a + i - window.innerWidth;
        l > 0 && (a -= l),
          a < 0 && (a = 0),
          (e.style.transform = `translate(${a}px, ${s}px)`),
          e.classList.remove(ld),
          e.classList.add(ad),
          document.addEventListener("theme:scroll", this.removePinEvent);
      }
    }
    removePin(t, e = !1, i = !1) {
      const n = document.querySelector(rd),
        o = n.classList.contains(ad);
      n &&
        ((e && !this.tooltip.hasAttribute(ud)) || !e) &&
        (o &&
          (i || t.detail.hideTransition) &&
          (n.classList.add(ld),
          this.hideTransitionTimeout &&
            clearTimeout(this.hideTransitionTimeout),
          (this.hideTransitionTimeout = setTimeout(() => {
            n.classList.remove(ld);
          }, this.transitionSpeed))),
        n.classList.remove(ad),
        document.removeEventListener("theme:scroll", this.removePinEvent));
    }
    unload() {
      this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.removeEventListener(
          "mouseleave",
          this.removePinMouseEvent
        ),
        this.tooltip.removeEventListener(
          "theme:tooltip:init",
          this.addPinEvent
        ),
        document.removeEventListener(
          "theme:tooltip:close",
          this.removePinEvent
        ),
        document.removeEventListener("theme:scroll", this.removePinEvent);
    }
  }
  const fd = {
      onLoad() {
        hd[this.id] = [];
        this.container.querySelectorAll(od).forEach((t) => {
          hd[this.id].push(new pd(t));
        });
      },
      onUnload() {
        hd[this.id].forEach((t) => {
          "function" == typeof t.unload && t.unload();
        });
      },
    },
    md = "[data-product-single-media-group]",
    gd = "[data-product-single-media-slider]",
    yd = "[data-zoom-wrapper]",
    vd = "pswp-zoom-gallery",
    bd = "pswp-zoom-gallery--single",
    wd = "is-moving",
    Sd = "data-image-width",
    Ed = "data-image-height";
  class Ld {
    constructor(t) {
      (this.container = t),
        (this.mediaContainer = this.container.querySelector(md)),
        (this.slider = this.container.querySelector(gd)),
        (this.zoomWrappers = this.container.querySelectorAll(yd)),
        (this.zoomEnable = "true" === this.mediaContainer.dataset.gallery),
        this.zoomEnable && this.init();
    }
    init() {
      this.zoomWrappers.length &&
        this.zoomWrappers.forEach((t, e) => {
          t.addEventListener("click", (i) => {
            i.preventDefault();
            (this.slider && this.slider.classList.contains(wd)) ||
              ((slate.a11y.state.trigger = t), this.createZoom(e));
          });
        });
    }
    createZoom(t) {
      const e = this;
      let i = [],
        n = 0;
      this.zoomWrappers.forEach((o) => {
        const r = o.getAttribute("href"),
          s = parseInt(o.getAttribute(Sd)),
          a = parseInt(o.getAttribute(Ed));
        if (
          (i.push({ src: r, w: s, h: a, msrc: r }),
          (n += 1),
          e.zoomWrappers.length === n)
        ) {
          let e = `${vd}`;
          1 === n && (e = `${vd} ${bd}`);
          new Cn(i, {
            barsSize: { top: 60, bottom: 60 },
            history: !1,
            focus: !1,
            index: t,
            mainClass: e,
            showHideOpacity: !0,
            showAnimationDuration: 250,
            hideAnimationDuration: 250,
            closeOnScroll: !1,
            closeOnVerticalDrag: !1,
            captionEl: !1,
            closeEl: !0,
            closeElClasses: ["caption-close"],
            tapToClose: !1,
            clickToCloseNonZoomable: !1,
            maxSpreadZoom: 2,
            loop: !0,
            spacing: 0,
            allowPanToNext: !0,
            pinchToClose: !1,
          });
        }
      });
    }
  }
  const kd = "[data-product-single-media-slider]",
    xd = "[data-thumbnail-id]",
    Td = "[data-product-single-media-thumbs]",
    Ad = "[data-product-single-media-wrapper]",
    Cd = "[data-model]",
    qd = ".product-single__thumbnail-link",
    Pd = "[data-deferred-media]",
    _d = "[data-deferred-media-button]",
    Dd = "[data-form-wrapper]",
    Id = "[data-product-rating]",
    Od = "#shopify-product-reviews",
    Fd = "a, button",
    Hd = "[data-upsell-holder]",
    Md = "[data-upsell-slider]",
    jd = "featured-product",
    Nd = "featured-product--onboarding",
    Bd = "has-media-active",
    $d = "is-selected",
    Wd = "media--hidden",
    zd = "no-outline",
    Rd = "is-moving",
    Vd = "data-media-id",
    Ud = "data-section-id",
    Gd = "data-thumbnail-id",
    Kd = "loaded",
    Xd = "tabindex",
    Yd = {};
  class Qd {
    constructor(t) {
      (this.container = t.container),
        (this.sectionId = this.container.getAttribute(Ud)),
        (this.formWrapper = this.container.querySelector(Dd)),
        (this.isFlickityDragging = !1),
        (this.flktyNavResize = null),
        (this.enableHistoryState = !this.container.classList.contains(jd)),
        (this.tooltips = []),
        this.scrollToReviews(),
        new Mn(this.container),
        this.container.classList.contains(Nd) ||
          (new Ld(this.container),
          this.initProductSlider(),
          this.initUpsellSlider(),
          this.initMediaSwitch(),
          this.initProductVideo(),
          this.initProductModel(),
          this.initShopifyXrLaunch());
    }
    initProductSlider() {
      const t = this.container.querySelector(kd),
        i = this.container.querySelector(Td),
        n = this.container.querySelectorAll(Ad);
      if (n.length > 1) {
        const o = new e(t, {
          wrapAround: !0,
          pageDots: !0,
          adaptiveHeight: !0,
          on: {
            ready: () => {
              t.setAttribute(Xd, "-1"),
                n.forEach((t) => {
                  if (!t.classList.contains($d)) {
                    const e = t.querySelectorAll(Fd);
                    e.length &&
                      e.forEach((t) => {
                        t.setAttribute(Xd, "-1");
                      });
                  }
                });
            },
            dragStart: () => {
              t.classList.add(Rd);
            },
            dragMove: () => {
              this.isFlickityDragging = !0;
            },
            staticClick: () => {
              this.isFlickityDragging = !1;
            },
            settle: (e) => {
              const i = o.selectedElement.getAttribute(Vd);
              o.cells.forEach((t, i) => {
                const n = t.element.querySelectorAll(Fd);
                n.length &&
                  n.forEach((t) => {
                    t.setAttribute(Xd, i === e ? "0" : "-1");
                  });
              }),
                this.switchMedia(i),
                t.classList.remove(Rd);
            },
          },
        });
        if (
          (n.length &&
            n.forEach((t) => {
              t.addEventListener("theme:media:play", () => {
                (o.options.draggable = !1),
                  o.updateDraggable(),
                  t.closest(kd).classList.add(Bd);
              }),
                t.addEventListener("theme:media:pause", () => {
                  (o.options.draggable = !0),
                    o.updateDraggable(),
                    t.closest(kd).classList.remove(Bd);
                });
            }),
          ht(t),
          null !== i)
        ) {
          const n = new e(i, {
            asNavFor: t,
            contain: !0,
            pageDots: !1,
            prevNextButtons: !1,
            resize: !0,
            on: {
              ready: () => {
                i.setAttribute(Xd, "-1");
              },
            },
          });
          (this.flktyNavResize = () => n.resize()),
            document.addEventListener(
              "theme:resize:width",
              this.flktyNavResize
            ),
            ht(i);
          const o = this.container.querySelectorAll(qd);
          o.length &&
            o.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault();
              });
            });
        }
      }
    }
    initUpsellSlider() {
      const t = this.container.querySelector(Md);
      if (this.container.querySelectorAll(Hd).length > 1) {
        const i = new e(t, {
          wrapAround: !0,
          pageDots: !0,
          adaptiveHeight: !0,
          prevNextButtons: !1,
        });
        i.on("change", (t) => {
          i.cells.forEach((e, i) => {
            const n = e.element.querySelectorAll(Fd);
            n.length &&
              n.forEach((e) => {
                e.setAttribute(Xd, i === t ? "0" : "-1");
              });
          });
        });
      }
    }
    handleMediaFocus(t) {
      if (
        t.keyCode !== theme.keyboardKeys.ENTER &&
        t.keyCode !== theme.keyboardKeys.TAB
      )
        return;
      const i = t.currentTarget.getAttribute(Gd),
        n = this.container.querySelector(`[${Vd}="${i}"]`),
        o = parseInt([...n.parentNode.children].indexOf(n)),
        r = this.container.querySelector(kd),
        s = this.container.querySelector(Td),
        a = e.data(r) || null,
        l = e.data(s) || null;
      a &&
        a.isActive &&
        o > -1 &&
        t.keyCode === theme.keyboardKeys.ENTER &&
        a.select(o),
        l && l.isActive && o > -1 && l.select(o);
    }
    switchMedia(t) {
      const e = document.querySelectorAll(`${Ad}`),
        i = this.container.querySelector(`${Ad}[${Vd}="${t}"]`),
        n = !document.body.classList.contains(zd);
      e.length &&
        e.forEach((t) => {
          t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            t.classList.add(Wd);
        }),
        n && i.focus(),
        i.closest(kd).classList.remove(Bd),
        i.classList.remove(Wd),
        i.dispatchEvent(new CustomEvent("theme:media:visible"), {
          bubbles: !0,
        });
      const o = i.querySelector(Pd);
      o &&
        "true" !== o.getAttribute(Kd) &&
        i.querySelector(_d).dispatchEvent(new Event("click"));
    }
    initMediaSwitch() {
      const t = this.container.querySelectorAll(xd);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("keyup", this.handleMediaFocus.bind(this)),
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
        });
    }
    initProductVideo() {
      this.videos = new Tt(this.container);
    }
    initProductModel() {
      const t = this.container.querySelectorAll(Cd);
      t.length &&
        t.forEach((t) => {
          PaloAlto.ProductModel.init(t, this.sectionId);
        });
    }
    initShopifyXrLaunch() {
      document.addEventListener("shopify_xr_launch", () => {
        this.container
          .querySelector(`${Cd}:not(.${Wd})`)
          .dispatchEvent(new CustomEvent("xrLaunch"));
      });
    }
    onUnload() {
      null !== this.flktyNavResize &&
        document.removeEventListener("theme:resize:width", this.flktyNavResize);
    }
    scrollToReviews() {
      const t = this.container.querySelector(Id);
      t &&
        ["click", "keydown"].forEach((e) => {
          t.addEventListener(e, (t) => {
            if (t.keyCode !== theme.keyboardKeys.ENTER || "click" != t.type) {
              const t = document.querySelector(Od);
              if (!t) return;
              t.scrollIntoView({ behavior: "smooth" });
            }
          });
        });
    }
  }
  const Jd = {
    onLoad() {
      Yd[this.id] = new Qd(this);
    },
    onUnload: function () {
      Yd[this.id].onUnload();
    },
  };
  ws("product-template", [Xe, Jd, li, Na, P, fd, Pi]),
    ws("featured-product", [Xe, Jd, li, Na, P, fd, Pi]);
  const Zd = "is-disabled",
    tu = "data-circle-text-parallax";
  class eu {
    constructor(t) {
      (this.circleText = t),
        (this.rotateDegree = 70),
        (this.adjustRotateDegree = this.rotateDegree / 2),
        (this.scrollEvent = () => this.updateParallax()),
        this.init();
    }
    init() {
      this.circleText.hasAttribute(tu) &&
        document.addEventListener("theme:scroll", this.scrollEvent);
    }
    updateParallax() {
      if (this.circleText.classList.contains(Zd)) return;
      const t = Math.round(window.innerHeight),
        e = Math.round(window.scrollY),
        i = e + t,
        n = Math.round(this.circleText.getBoundingClientRect().top + e),
        o = this.circleText.offsetHeight;
      if (n < i && !(n + o < e)) {
        const e = (100 * (i - n - o / 2)) / t;
        let r = ((this.rotateDegree * e) / 100) * -1;
        e > 0 &&
          (this.circleText.style.transform = `rotate(${
            this.adjustRotateDegree + r
          }deg)`);
      }
    }
    unload() {
      document.removeEventListener("theme:scroll", this.scrollEvent);
    }
  }
  const iu = { href: "href", mediaId: "data-media-id" },
    nu = "[data-deferred-media]",
    ou = "[data-deferred-media-button]",
    ru = "[data-product-content-wrapper]",
    su = "[data-product-single-media-wrapper]",
    au = "[data-model]",
    lu = "[data-product-link]",
    cu = "[data-product-single-media-image]",
    du = "[data-slider-contents]",
    uu = "[data-slider-images]",
    hu = "[data-tab-button]",
    pu = "[data-tab-item]",
    fu = "[data-circle-text]",
    mu = {
      aosAnimate: "aos-animate",
      tabButtonActive: "products-list__nav__button--active",
      tabItemActive: "products-list__item--active",
      mediaHidden: "media--hidden",
      isDisabled: "is-disabled",
    },
    gu = {};
  class yu {
    constructor(t) {
      (this.container = t.container),
        (this.sectionId = this.container.dataset.sectionId),
        (this.tabButtons = this.container.querySelectorAll(hu)),
        (this.tabItems = this.container.querySelectorAll(pu)),
        (this.slidersImages = this.container.querySelectorAll(uu)),
        (this.slidersContents = this.container.querySelectorAll(du)),
        (this.videos = {}),
        (this.flktyImages = null),
        (this.flktyContent = null),
        (this.sliderResizeEvent = () => this.resizeSlider()),
        this.initButtons(),
        this.initSliders(),
        this.initProductVideo(),
        this.initProductModel(),
        this.initShopifyXrLaunch(),
        this.initCircleText(),
        this.listen();
    }
    listen() {
      (this.slidersImages.length > 0 || this.slidersContents.length > 0) &&
        document.addEventListener("theme:resize", this.sliderResizeEvent);
    }
    resizeSlider() {
      this.flktyImages && this.flktyImages.resize(),
        this.flktyContent && this.flktyContent.resize();
    }
    initButtons() {
      this.tabButtons.length &&
        this.tabButtons.forEach((t) => {
          t.addEventListener("click", (e) => {
            if (t.classList.contains(mu.tabButtonActive)) return;
            const i = t.getAttribute(iu.href),
              n = this.container.querySelector(i),
              o = n.querySelector(su),
              r = o ? o.dataset.mediaId : null,
              s = n.querySelector(fu);
            this.tabButtons.forEach((t) => {
              t.classList.remove(mu.tabButtonActive);
            }),
              this.tabItems.forEach((t) => {
                const e = t.querySelector(fu);
                t.classList.remove(mu.tabItemActive),
                  e?.classList.add(mu.isDisabled),
                  theme.settings.animations &&
                    t.querySelectorAll(`.${mu.aosAnimate}`).forEach((t) => {
                      t.classList.remove(mu.aosAnimate),
                        setTimeout(() => {
                          t.classList.add(mu.aosAnimate);
                        });
                    });
              }),
              t.classList.add(mu.tabButtonActive),
              n.classList.add(mu.tabItemActive),
              document.dispatchEvent(new Event("theme:resize")),
              s &&
                (s.classList.remove(mu.isDisabled),
                document.dispatchEvent(new Event("theme:scroll"))),
              r ? this.switchMedia(r) : this.pauseAllMedia(),
              e.preventDefault();
          });
        });
    }
    initSliders() {
      this.slidersImages.forEach((t) => {
        (this.flktyImages = new e(t, {
          fade: !0,
          sync: t.parentNode.querySelector(du),
          pageDots: !1,
          prevNextButtons: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
        })),
          this.flktyImages.on("settle", (e) => {
            const i = t.querySelectorAll(su);
            for (let t = 0; t < i.length; t++)
              t === e
                ? i[t].querySelector(cu).removeAttribute("tabindex")
                : i[t].querySelector(cu).setAttribute("tabindex", "-1");
          });
      }),
        this.slidersContents.forEach((t) => {
          (this.flktyContent = new e(t, {
            fade: !0,
            sync: t.parentNode.querySelector(uu),
            pageDots: !1,
            prevNextButtons: !1,
            wrapAround: !0,
            adaptiveHeight: !0,
            autoPlay: 4e3,
            pauseAutoPlayOnHover: !0,
          })),
            this.flktyContent.on("settle", (e) => {
              const i = t.querySelectorAll(ru);
              for (let t = 0; t < i.length; t++)
                t === e
                  ? i[t].querySelectorAll(lu).forEach((t) => {
                      t.removeAttribute("tabindex");
                    })
                  : i[t].querySelectorAll(lu).forEach((t) => {
                      t.setAttribute("tabindex", "-1");
                    });
            });
        });
    }
    initProductVideo() {
      this.videos = new Tt(this.container);
    }
    initProductModel() {
      const t = this.container.querySelectorAll(au);
      t.length &&
        t.forEach((t) => {
          PaloAlto.ProductModel.init(t, this.sectionId);
        });
    }
    initShopifyXrLaunch() {
      document.addEventListener("shopify_xr_launch", () => {
        this.container
          .querySelector(`${au}:not(.${mu.mediaHidden})`)
          .dispatchEvent(new CustomEvent("xrLaunch"));
      });
    }
    switchMedia(t) {
      const e = this.container.querySelector(`${su}[${iu.mediaId}="${t}"]`),
        i = !document.body.classList.contains(mu.noOutline);
      this.pauseAllMedia(),
        i && e.focus(),
        e.classList.remove(mu.mediaHidden),
        e.dispatchEvent(new CustomEvent("theme:media:visible"), {
          bubbles: !0,
        });
      const n = e.querySelector(nu);
      n &&
        "true" !== n.getAttribute(iu.loaded) &&
        e.querySelector(ou).dispatchEvent(new Event("click"));
    }
    pauseAllMedia() {
      const t = document.querySelectorAll(`${su}`);
      t.length &&
        t.forEach((t) => {
          t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            t.classList.add(mu.mediaHidden);
        });
    }
    initCircleText() {
      this.container.querySelectorAll(fu).forEach((t) => {
        new eu(t);
      });
    }
    onBlockSelect(t) {
      t.target.dispatchEvent(new Event("click"));
    }
    onUnload() {
      document.removeEventListener("theme:resize", this.sliderResizeEvent);
    }
  }
  ws("products-list", {
    onLoad() {
      gu[this.id] = new yu(this);
    },
    onUnload() {
      gu[this.id].onUnload();
    },
    onBlockSelect(t) {
      gu[this.id].onBlockSelect(t);
    },
  });
  const vu = "[data-product-block]",
    bu = "[data-related-products]",
    wu = "data-section-id",
    Su = "data-product-id",
    Eu = "data-limit",
    Lu = {};
  class ku {
    constructor(t) {
      (this.container = t),
        (this.relatedProducts = this.container.querySelector(bu)),
        this.init();
    }
    init() {
      const e = this.container.getAttribute(wu),
        i = this.container.getAttribute(Su),
        n = this.container.getAttribute(Eu),
        o = `${theme.routes.product_recommendations_url}?section_id=${e}&limit=${n}&product_id=${i}`;
      fetch(o)
        .then((t) => t.text())
        .then((e) => {
          const i = document.createElement("div");
          i.innerHTML = e;
          const n = i.querySelector(bu);
          n.querySelectorAll(vu).length &&
            ((this.relatedProducts.innerHTML = n.innerHTML),
            (this.productGrid = new Tr(this.container)),
            (this.gridSlider = new Tl(this.container)),
            t.refreshHard());
        });
    }
    onDeselect() {
      this.productGrid && this.productGrid.onDeselect();
    }
    onUnload() {
      this.productGrid && this.productGrid.onUnload(),
        this.gridSlider && this.gridSlider.onUnload();
    }
  }
  ws("related-products", {
    onLoad() {
      Lu[this.id] = new ku(this.container);
    },
    onDeselect() {
      Lu[this.id].onDeselect();
    },
    onUnload() {
      Lu[this.id].onUnload();
    },
  });
  const xu = {},
    Tu = "[data-slider]",
    Au = "[data-item]",
    Cu = "[data-button-show]",
    qu = "[data-button-hide]",
    Pu = "[data-item-products]",
    _u = "[data-item-products-slider]",
    Du = "[data-item-product]",
    Iu = "a, button",
    Ou = "blog-item--active",
    Fu = "blog-item__products--visible",
    Hu = "flickity-enabled",
    Mu = "is-selected",
    ju = {
      slider: "data-slider",
      slidePosition: "data-slide-position",
      sectionId: "data-section-id",
      tabIndex: "tabindex",
    };
  class Nu {
    constructor(t) {
      (this.container = t.container),
        (this.flkty = null),
        (this.slider = this.container.querySelector(Tu)),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        (this.isFullWidth = this.container.hasAttribute(ju.fullWidth)),
        (this.gutter = 0),
        (this.clickOutsideItemEvent = (t) => {
          if (!(t.target.matches(Au) || t.target.closest(Au))) {
            const t = this.container.querySelectorAll(Au);
            t.length &&
              t.forEach((t) => {
                const e = t.querySelector(Pu);
                e && (e.classList.remove(Fu), this.changeTabIndex(e)),
                  t.classList.remove(Ou);
              });
          }
        }),
        this.bindButtons(),
        this.listen();
    }
    initSlider() {
      (this.flkty = new e(this.slider, {
        prevNextButtons: !0,
        pageDots: !1,
        cellAlign: "left",
        wrapAround: !1,
        groupCells: !0,
        contain: !0,
        on: {
          ready: () => {
            this.handleFocus();
          },
        },
      })),
        this.flkty.on("change", () => {
          const t = this.container.querySelectorAll(Au);
          this.handleFocus(),
            t.length &&
              t.forEach((t) => {
                const e = t.querySelector(Pu);
                t.classList.remove(Ou),
                  e && t.querySelector(Pu).classList.remove(Fu);
              }),
            this.flkty &&
              !this.flkty.options.draggable &&
              ((this.flkty.options.draggable = !0),
              this.flkty.updateDraggable());
        });
    }
    destroySlider() {
      null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
    }
    checkSlidesSize() {
      const t =
        this.container.querySelector(Au).currentStyle ||
        window.getComputedStyle(this.container.querySelector(Au));
      this.gutter = parseInt(t.marginRight);
      const e = this.slider.offsetWidth + this.gutter < this.getItemsWidth();
      window.innerWidth >= theme.sizes.small && e
        ? this.initSlider()
        : this.destroySlider();
    }
    getItemsWidth() {
      let t = 0;
      const e = this.slider.querySelectorAll(Au);
      return (
        e.length &&
          e.forEach((e) => {
            t += e.offsetWidth + this.gutter;
          }),
        t
      );
    }
    bindButtons() {
      const t = this.container.querySelectorAll(_u),
        i = this.container.querySelectorAll(Cu),
        n = this.container.querySelectorAll(qu);
      i.length &&
        i.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault(),
              this.container.querySelectorAll(Au).forEach((t) => {
                const e = t.querySelector(Pu);
                t.classList.remove(Ou),
                  e && (e.classList.remove(Fu), this.changeTabIndex(e));
              });
            const i = t.closest(Au),
              n = i.querySelector(Pu);
            if ((i.classList.add(Ou), n)) {
              n.classList.add(Fu), this.changeTabIndex(n, "enable");
              const t = n.querySelector(_u),
                e = t.querySelectorAll(Du);
              if (t.classList.contains(Hu)) {
                const i = t
                  .querySelector(`.${Mu}`)
                  .getAttribute(ju.slidePosition);
                e.forEach((t, e) => {
                  t.setAttribute(ju.tabIndex, e === i ? "0" : "-1");
                });
              }
            }
            null !== this.flkty &&
              ((this.flkty.options.draggable = !1),
              this.flkty.updateDraggable()),
              (slate.a11y.state.trigger = t);
          });
        }),
        n.length &&
          n.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              const i = t.closest(Au),
                n = i.querySelector(Pu);
              i.classList.remove(Ou),
                n && (n.classList.remove(Fu), this.changeTabIndex(n)),
                null !== this.flkty &&
                  ((this.flkty.options.draggable = !0),
                  this.flkty.updateDraggable()),
                slate.a11y.state.trigger.focus();
            });
          }),
        t.length &&
          t.forEach((t) => {
            if (t.querySelectorAll(Du).length > 1) {
              const i = new e(t, {
                prevNextButtons: !0,
                contain: !0,
                pageDots: !1,
                wrapAround: !0,
                on: {
                  change: (t) => {
                    i.cells.forEach((e, i) => {
                      e.element.querySelectorAll(Iu).forEach((e) => {
                        e.setAttribute(ju.tabIndex, i === t ? "0" : "-1");
                      });
                    });
                  },
                },
              });
            }
          }),
        this.slider.addEventListener("keyup", (t) => {
          if (t.keyCode === slate.utils.keyboardKeys.ESCAPE) {
            const e = t.target.hasAttribute(ju.slider)
              ? t.target.querySelectorAll(Au)
              : t.target.closest(Tu).querySelectorAll(Au);
            e.length &&
              (e.forEach((t) => {
                const e = t.querySelector(Pu);
                t.classList.remove(Ou),
                  e && (e.classList.remove(Fu), this.changeTabIndex(e));
              }),
              this.flkty &&
                ((this.flkty.options.draggable = !0),
                this.flkty.updateDraggable())),
              slate.a11y.state.trigger.focus();
          }
        });
    }
    handleFocus() {
      const t = this.container.querySelectorAll(Au);
      t.length &&
        t.forEach((t) => {
          const e = t.classList.contains(Mu),
            i = t.querySelector(Pu);
          e
            ? (this.changeTabIndex(t, "enable"), i && this.changeTabIndex(i))
            : (this.changeTabIndex(t), i && i.classList.remove(Fu));
        });
    }
    listen() {
      this.slider &&
        (this.checkSlidesSize(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        )),
        document.addEventListener("mousedown", this.clickOutsideItemEvent);
    }
    changeTabIndex(t, e = "") {
      const i = "enable" === e ? "0" : "-1";
      t.querySelectorAll(Iu).forEach((t) => {
        t.setAttribute(ju.tabIndex, i);
      });
    }
    onBlockSelect(t) {
      if (null !== this.flkty) {
        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
          i = parseInt(this.flkty.slides[0].cells.length),
          n = Math.floor(e / i);
        this.flkty.select(n);
      } else {
        const e =
            this.slider.currentStyle || window.getComputedStyle(this.slider),
          i = parseInt(e.paddingLeft),
          n = t.target.offsetLeft - i;
        this.slider.scrollTo({ top: 0, left: n, behavior: "smooth" });
      }
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.checkSlidesSizeOnResize
      ),
        document.removeEventListener("mousedown", this.clickOutsideItemEvent);
    }
  }
  ws("shoppable-blog", {
    onLoad() {
      xu[this.id] = new Nu(this);
    },
    onUnload(t) {
      xu[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      xu[this.id].onBlockSelect(t);
    },
  });
  const Bu = "[data-scroll-down]",
    $u = "[data-site-header]",
    Wu = "[data-slide]",
    zu = "a, button",
    Ru = "[data-main]",
    Vu = "[data-slider]",
    Uu = "data-style",
    Gu = "data-current-style",
    Ku = "tabindex",
    Xu = "data-slide-position",
    Yu = "site-header--fixed",
    Qu = {};
  class Ju {
    constructor(t) {
      (this.container = t.container),
        (this.header = document.querySelector($u)),
        (this.flkty = null),
        this.initSlider(),
        this.initZoomAnimation(),
        this.bindScrollButton();
    }
    initSlider() {
      const t = this.container.querySelectorAll(Wu).length,
        i = parseInt(this.container.dataset.duration),
        n = "true" === this.container.dataset.pageDots && t > 1,
        o = "true" === this.container.dataset.navArrows && t > 1,
        r = "slide" !== this.container.dataset.transition;
      let s = "true" === this.container.dataset.autoplay;
      if ((s && (s = i), t > 1))
        (this.flkty = new e(this.container, {
          fade: r,
          cellSelector: Wu,
          autoPlay: s,
          wrapAround: !0,
          adaptiveHeight: !0,
          setGallerySize: !0,
          imagesLoaded: !0,
          pageDots: n,
          prevNextButtons: o,
          on: {
            ready: () => {
              const t = this.container
                .querySelector(`${Wu}[${Xu}="1"]`)
                .getAttribute(Uu);
              this.container.setAttribute(Gu, t);
            },
            change: (t) => {
              const e = this.flkty.selectedElement.getAttribute(Uu);
              this.container.setAttribute(Gu, e),
                this.flkty.cells.forEach((e, i) => {
                  e.element.querySelectorAll(zu).forEach((e) => {
                    e.setAttribute(Ku, i === t ? "0" : "-1");
                  });
                });
            },
          },
        })),
          ht(this.container);
      else if (1 === t) {
        const t = this.container.querySelector(Wu).getAttribute(Uu);
        this.container.setAttribute(Gu, t);
      }
    }
    initZoomAnimation() {
      if ("true" !== this.container.dataset.zoomAnimation) return;
      const t = this.container,
        e = document.body.querySelector(Ru).children[0],
        i = this.container.parentNode === e,
        n = "true" == this.header.dataset.transparent,
        o = () => {
          const e =
              i & n
                ? 0
                : parseInt(
                    this.header.dataset.height || this.header.offsetHeight
                  ),
            o = t.getBoundingClientRect(),
            r = t.offsetHeight,
            s = i ? e - o.top : e - o.top + window.innerHeight;
          let a = 0.1;
          i && (a *= 1.5);
          let l = 1 + (s / r) * a;
          (l = l > 1 ? l : 1), t.style.setProperty("--scale", l);
        };
      o(), (this.zoomOnScrollEvent = m(o, 5));
      new IntersectionObserver(
        (t) => {
          t[0].isIntersecting
            ? window.addEventListener("scroll", this.zoomOnScrollEvent)
            : window.removeEventListener("scroll", this.zoomOnScrollEvent);
        },
        { root: null, rootMargin: "0px", threshold: 0 }
      ).observe(t);
    }
    bindScrollButton() {
      const t = this.container.querySelector(Bu);
      t &&
        t.addEventListener("click", (t) => {
          t.preventDefault();
          const e = this.header.classList.contains(Yu) ? 60 : 0,
            i = parseInt(
              Math.ceil(
                this.container.offsetTop + this.container.offsetHeight - e
              )
            );
          window.scrollTo({ top: i, left: 0, behavior: "smooth" });
        });
    }
    onBlockSelect(t) {
      const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
      null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer());
    }
    onBlockDeselect(t) {
      t.target.closest(Vu).dataset.autoplay &&
        null !== this.flkty &&
        this.flkty.playPlayer();
    }
    onUnload() {
      null !== this.flkty && (this.flkty.destroy(), (this.flkty = null)),
        null !== this.zoomOnScrollEvent &&
          window.removeEventListener("scroll", this.zoomOnScrollEvent);
    }
  }
  ws("slider", [
    {
      onLoad() {
        Qu[this.id] = new Ju(this);
      },
      onUnload(t) {
        Qu[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Qu[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        Qu[this.id].onBlockDeselect(t);
      },
    },
    Xa,
  ]),
    ws("subcollections", Al);
  const Zu = "[data-custom-scrollbar]",
    th = "[data-custom-scrollbar-items]",
    eh = "[data-custom-scrollbar-thumb]";
  class ih {
    constructor(t) {
      (this.container = t),
        (this.scrollbarItems = t.querySelector(th)),
        (this.scrollbar = t.querySelector(Zu)),
        (this.scrollbarThumb = t.querySelector(eh)),
        (this.trackWidth = 0),
        (this.calcScrollbarEvent = () => this.calculateScrollbar()),
        (this.onScrollbarChangeEvent = (t) => this.onScrollbarChange(t)),
        this.scrollbar &&
          this.scrollbarItems &&
          (this.events(),
          this.calculateScrollbar(),
          this.scrollbarItems.children.length &&
            this.calculateTrack(this.scrollbarItems.children[0]));
    }
    calculateTrack(t) {
      const e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
        i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
      this.scrollbar.style.setProperty("--thumb-scale", e),
        this.scrollbar.style.setProperty(
          "--thumb-position",
          this.trackWidth * i + "px"
        );
    }
    calculateScrollbar() {
      if (this.scrollbarItems.children.length) {
        const t = [...this.scrollbarItems.children];
        (this.trackWidth = 0),
          t.forEach((t) => {
            this.trackWidth +=
              t.getBoundingClientRect().width +
              parseInt(window.getComputedStyle(t).marginRight);
          }),
          this.scrollbar.style.setProperty(
            "--track-width",
            `${this.trackWidth}px`
          );
      }
    }
    onScrollbarChange(t) {
      t &&
        t.detail &&
        t.detail.element &&
        this.container.contains(t.detail.element) &&
        this.calculateTrack(t.detail.element);
    }
    events() {
      document.addEventListener("theme:resize:width", this.calcScrollbarEvent),
        document.addEventListener(
          "theme:custom-scrollbar:change",
          this.onScrollbarChangeEvent
        );
    }
    unload() {
      document.removeEventListener(
        "theme:resize:width",
        this.calcScrollbarEvent
      ),
        document.removeEventListener(
          "theme:custom-scrollbar:change",
          this.onScrollbarChangeEvent
        );
    }
  }
  const nh = "[data-tab-link]",
    oh = "[data-tab-content]",
    rh = "[data-custom-scrollbar]",
    sh = "[data-custom-scrollbar-holder]",
    ah = "[data-slider]",
    lh = "[data-tabs-contents]",
    ch = "current",
    dh = "hide",
    uh = "alt",
    hh = "aos-animate",
    ph = "aos-init",
    fh = "data-tab-link",
    mh = "data-tab-content",
    gh = "data-start-index",
    yh = {};
  class vh {
    constructor(t) {
      (this.container = t),
        (this.tabsContents = t.querySelector(lh)),
        (this.animateElementsTimer = null),
        this.container &&
          ((this.scrollable = this.container.querySelector(`${rh}`)),
          this.init(),
          this.initCustomScrollbar());
    }
    init() {
      const t = this.container.querySelectorAll(nh),
        e = this.container.querySelector(
          `[${fh}="${
            this.container.hasAttribute(gh)
              ? this.container.getAttribute(gh)
              : 0
          }"]`
        ),
        i = this.container.querySelector(
          `[${mh}="${
            this.container.hasAttribute(gh)
              ? this.container.getAttribute(gh)
              : 0
          }"]`
        );
      i && i.classList.add(ch),
        e && e.classList.add(ch),
        this.checkVisibleTabLinks(),
        t.length &&
          t.forEach((t) => {
            const e = parseInt(t.getAttribute(fh)),
              i = this.container.querySelector(`[${mh}="${e}"]`);
            t.addEventListener("click", () => {
              this.tabChange(t, i);
            }),
              t.addEventListener("keyup", (e) => {
                (e.which !== slate.utils.keyboardKeys.SPACE &&
                  e.which !== slate.utils.keyboardKeys.ENTER) ||
                  this.tabChange(t, i);
              });
          });
    }
    initCustomScrollbar() {
      this.scrollable && (this.customScrollbar = new ih(this.container));
    }
    tabChange(t, e) {
      if (t.classList.contains(ch)) return;
      const i = t.closest(sh) ? t.closest(sh) : t.parentElement,
        n = parseInt(
          window.getComputedStyle(i).getPropertyValue("padding-left")
        ),
        o = this.container.querySelector(`${oh}.${ch}`),
        r = this.container.querySelector(`${nh}.${ch}`),
        s = e.querySelector(ah);
      o.classList.remove(ch),
        r.classList.remove(ch),
        t.classList.add(ch),
        e.classList.add(ch),
        s &&
          s.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !1 })),
        i.scrollTo({
          top: 0,
          left: t.offsetLeft - i.offsetWidth / 2 + t.offsetWidth / 2 + n,
          behavior: "smooth",
        }),
        t.dispatchEvent(
          new CustomEvent("theme:custom-scrollbar:change", {
            bubbles: !0,
            detail: { element: t },
          })
        ),
        theme.settings.animations &&
          (this.tabsContents.querySelectorAll(`.${ph}`).forEach((t) => {
            t.classList.remove(hh);
          }),
          this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
          (this.animateElementsTimer = setTimeout(() => {
            e.querySelectorAll(`.${ph}`).forEach((t) => {
              t.classList.add(hh);
            });
          }, 150))),
        t.classList.contains(dh) && e.classList.add(dh),
        this.checkVisibleTabLinks();
    }
    checkVisibleTabLinks() {
      const t = this.container.querySelectorAll(nh),
        e = this.container.querySelectorAll(`${nh}.${dh}`);
      t.length - e.length < 2
        ? this.container.classList.add(uh)
        : this.container.classList.remove(uh);
    }
    onBlockSelect(t) {
      const e = t.target;
      e &&
        (e.dispatchEvent(new Event("click")),
        e.parentNode.scrollTo({
          top: 0,
          left: e.offsetLeft - e.clientWidth,
          behavior: "smooth",
        }));
    }
    onUnload() {
      this.customScrollbar && this.customScrollbar.unload();
    }
  }
  ws("tab-collections", [
    Ar,
    Al,
    {
      onLoad() {
        yh[this.id] = new vh(this.container);
      },
      onBlockSelect(t) {
        yh[this.id].onBlockSelect(t);
      },
      onUnload() {
        yh[this.id].onUnload();
      },
    },
  ]);
  const bh = {},
    wh = "[data-slider]",
    Sh = "[data-item]",
    Eh = "flickity-enabled",
    Lh = "data-section-id";
  class kh {
    constructor(t) {
      (this.container = t.container),
        (this.sectionId = this.container.getAttribute(Lh)),
        (this.slider = this.container.querySelector(wh)),
        (this.sliderResizeEvent = () => this.initSlider()),
        (this.flkty = null),
        this.initSlider(),
        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
    }
    initSlider() {
      const t = this.slider.querySelectorAll(Sh).length;
      let i = this.slider.classList.contains(Eh);
      (3 == t && window.innerWidth >= theme.sizes.large) ||
      (2 == t && window.innerWidth >= theme.sizes.small) ||
      1 == t ||
      window.innerWidth < theme.sizes.small
        ? i && this.flkty.destroy()
        : (this.flkty = new e(this.slider, {
            cellSelector: Sh,
            prevNextButtons: !0,
            pageDots: !1,
            groupCells: !0,
            cellAlign: "left",
            contain: !0,
            adaptiveHeight: !1,
          }));
    }
    onBlockSelect(t) {
      if (null !== this.flkty) {
        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
          i = parseInt(this.flkty.slides[0].cells.length),
          n = Math.floor(e / i);
        this.flkty.select(n);
      } else {
        const e =
            this.slider.currentStyle || window.getComputedStyle(this.slider),
          i = parseInt(e.paddingLeft),
          n = t.target.offsetLeft - i;
        this.slider.scrollTo({ top: 0, left: n, behavior: "smooth" });
      }
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.sliderResizeEvent
      );
    }
  }
  ws("testimonials", {
    onLoad() {
      bh[this.id] = new kh(this);
    },
    onUnload(t) {
      bh[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      bh[this.id].onBlockSelect(t);
    },
  }),
    document.addEventListener("DOMContentLoaded", function () {
      Ss("*");
      "true" === document.body.dataset.animations &&
        t.init({ once: !0, offset: 50, duration: 600, startEvent: "load" });
      "scrollBehavior" in document.documentElement.style ||
        B({ url: theme.assets.smoothscroll });
    });
})(
  themeVendor.AOS,
  themeVendor.Flickity,
  themeVendor.Sqrl,
  themeVendor.themeCurrency,
  themeVendor.ajaxinate
),
  (window.slate = window.slate || {}),
  (window.theme = window.theme || {}),
  (function (t, e) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = t.document
          ? e(t, !0)
          : function (t) {
              if (!t.document)
                throw new Error("jQuery requires a window with a document");
              return e(t);
            })
      : e(t);
  })("undefined" != typeof window ? window : this, function (t, e) {
    "use strict";
    var i = [],
      n = Object.getPrototypeOf,
      o = i.slice,
      r = i.flat
        ? function (t) {
            return i.flat.call(t);
          }
        : function (t) {
            return i.concat.apply([], t);
          },
      s = i.push,
      a = i.indexOf,
      l = {},
      c = l.toString,
      d = l.hasOwnProperty,
      u = d.toString,
      h = u.call(Object),
      p = {},
      f = function (t) {
        return "function" == typeof t && "number" != typeof t.nodeType;
      },
      m = function (t) {
        return null != t && t === t.window;
      },
      g = t.document,
      y = { type: !0, src: !0, nonce: !0, noModule: !0 };
    function v(t, e, i) {
      var n,
        o,
        r = (i = i || g).createElement("script");
      if (((r.text = t), e))
        for (n in y)
          (o = e[n] || (e.getAttribute && e.getAttribute(n))) &&
            r.setAttribute(n, o);
      i.head.appendChild(r).parentNode.removeChild(r);
    }
    function b(t) {
      return null == t
        ? t + ""
        : "object" == typeof t || "function" == typeof t
        ? l[c.call(t)] || "object"
        : typeof t;
    }
    var w = "3.5.1",
      S = function (t, e) {
        return new S.fn.init(t, e);
      };
    function E(t) {
      var e = !!t && "length" in t && t.length,
        i = b(t);
      return (
        !f(t) &&
        !m(t) &&
        ("array" === i ||
          0 === e ||
          ("number" == typeof e && 0 < e && e - 1 in t))
      );
    }
    (S.fn = S.prototype =
      {
        jquery: w,
        constructor: S,
        length: 0,
        toArray: function () {
          return o.call(this);
        },
        get: function (t) {
          return null == t
            ? o.call(this)
            : t < 0
            ? this[t + this.length]
            : this[t];
        },
        pushStack: function (t) {
          var e = S.merge(this.constructor(), t);
          return (e.prevObject = this), e;
        },
        each: function (t) {
          return S.each(this, t);
        },
        map: function (t) {
          return this.pushStack(
            S.map(this, function (e, i) {
              return t.call(e, i, e);
            })
          );
        },
        slice: function () {
          return this.pushStack(o.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        even: function () {
          return this.pushStack(
            S.grep(this, function (t, e) {
              return (e + 1) % 2;
            })
          );
        },
        odd: function () {
          return this.pushStack(
            S.grep(this, function (t, e) {
              return e % 2;
            })
          );
        },
        eq: function (t) {
          var e = this.length,
            i = +t + (t < 0 ? e : 0);
          return this.pushStack(0 <= i && i < e ? [this[i]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor();
        },
        push: s,
        sort: i.sort,
        splice: i.splice,
      }),
      (S.extend = S.fn.extend =
        function () {
          var t,
            e,
            i,
            n,
            o,
            r,
            s = arguments[0] || {},
            a = 1,
            l = arguments.length,
            c = !1;
          for (
            "boolean" == typeof s && ((c = s), (s = arguments[a] || {}), a++),
              "object" == typeof s || f(s) || (s = {}),
              a === l && ((s = this), a--);
            a < l;
            a++
          )
            if (null != (t = arguments[a]))
              for (e in t)
                (n = t[e]),
                  "__proto__" !== e &&
                    s !== n &&
                    (c && n && (S.isPlainObject(n) || (o = Array.isArray(n)))
                      ? ((i = s[e]),
                        (r =
                          o && !Array.isArray(i)
                            ? []
                            : o || S.isPlainObject(i)
                            ? i
                            : {}),
                        (o = !1),
                        (s[e] = S.extend(c, r, n)))
                      : void 0 !== n && (s[e] = n));
          return s;
        }),
      S.extend({
        expando: "jQuery" + (w + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (t) {
          throw new Error(t);
        },
        noop: function () {},
        isPlainObject: function (t) {
          var e, i;
          return !(
            !t ||
            "[object Object]" !== c.call(t) ||
            ((e = n(t)) &&
              ("function" !=
                typeof (i = d.call(e, "constructor") && e.constructor) ||
                u.call(i) !== h))
          );
        },
        isEmptyObject: function (t) {
          var e;
          for (e in t) return !1;
          return !0;
        },
        globalEval: function (t, e, i) {
          v(t, { nonce: e && e.nonce }, i);
        },
        each: function (t, e) {
          var i,
            n = 0;
          if (E(t))
            for (i = t.length; n < i && !1 !== e.call(t[n], n, t[n]); n++);
          else for (n in t) if (!1 === e.call(t[n], n, t[n])) break;
          return t;
        },
        makeArray: function (t, e) {
          var i = e || [];
          return (
            null != t &&
              (E(Object(t))
                ? S.merge(i, "string" == typeof t ? [t] : t)
                : s.call(i, t)),
            i
          );
        },
        inArray: function (t, e, i) {
          return null == e ? -1 : a.call(e, t, i);
        },
        merge: function (t, e) {
          for (var i = +e.length, n = 0, o = t.length; n < i; n++)
            t[o++] = e[n];
          return (t.length = o), t;
        },
        grep: function (t, e, i) {
          for (var n = [], o = 0, r = t.length, s = !i; o < r; o++)
            !e(t[o], o) !== s && n.push(t[o]);
          return n;
        },
        map: function (t, e, i) {
          var n,
            o,
            s = 0,
            a = [];
          if (E(t))
            for (n = t.length; s < n; s++)
              null != (o = e(t[s], s, i)) && a.push(o);
          else for (s in t) null != (o = e(t[s], s, i)) && a.push(o);
          return r(a);
        },
        guid: 1,
        support: p,
      }),
      "function" == typeof Symbol &&
        (S.fn[Symbol.iterator] = i[Symbol.iterator]),
      S.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        ),
        function (t, e) {
          l["[object " + e + "]"] = e.toLowerCase();
        }
      );
    var L = (function (t) {
      var e,
        i,
        n,
        o,
        r,
        s,
        a,
        l,
        c,
        d,
        u,
        h,
        p,
        f,
        m,
        g,
        y,
        v,
        b,
        w = "sizzle" + 1 * new Date(),
        S = t.document,
        E = 0,
        L = 0,
        k = lt(),
        x = lt(),
        T = lt(),
        A = lt(),
        C = function (t, e) {
          return t === e && (u = !0), 0;
        },
        q = {}.hasOwnProperty,
        P = [],
        _ = P.pop,
        D = P.push,
        I = P.push,
        O = P.slice,
        F = function (t, e) {
          for (var i = 0, n = t.length; i < n; i++) if (t[i] === e) return i;
          return -1;
        },
        H =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        M = "[\\x20\\t\\r\\n\\f]",
        j =
          "(?:\\\\[\\da-fA-F]{1,6}" +
          M +
          "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
        N =
          "\\[" +
          M +
          "*(" +
          j +
          ")(?:" +
          M +
          "*([*^$|!~]?=)" +
          M +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          j +
          "))|)" +
          M +
          "*\\]",
        B =
          ":(" +
          j +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          N +
          ")*)|.*)\\)|)",
        $ = new RegExp(M + "+", "g"),
        W = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
        z = new RegExp("^" + M + "*," + M + "*"),
        R = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
        V = new RegExp(M + "|>"),
        U = new RegExp(B),
        G = new RegExp("^" + j + "$"),
        K = {
          ID: new RegExp("^#(" + j + ")"),
          CLASS: new RegExp("^\\.(" + j + ")"),
          TAG: new RegExp("^(" + j + "|[*])"),
          ATTR: new RegExp("^" + N),
          PSEUDO: new RegExp("^" + B),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              M +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              M +
              "*(?:([+-]|)" +
              M +
              "*(\\d+)|))" +
              M +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + H + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              M +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              M +
              "*((?:-\\d)?\\d*)" +
              M +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        X = /HTML$/i,
        Y = /^(?:input|select|textarea|button)$/i,
        Q = /^h\d$/i,
        J = /^[^{]+\{\s*\[native \w/,
        Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        tt = /[+~]/,
        et = new RegExp(
          "\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])",
          "g"
        ),
        it = function (t, e) {
          var i = "0x" + t.slice(1) - 65536;
          return (
            e ||
            (i < 0
              ? String.fromCharCode(i + 65536)
              : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320))
          );
        },
        nt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        ot = function (t, e) {
          return e
            ? "\0" === t
              ? "�"
              : t.slice(0, -1) +
                "\\" +
                t.charCodeAt(t.length - 1).toString(16) +
                " "
            : "\\" + t;
        },
        rt = function () {
          h();
        },
        st = wt(
          function (t) {
            return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase();
          },
          { dir: "parentNode", next: "legend" }
        );
      try {
        I.apply((P = O.call(S.childNodes)), S.childNodes),
          P[S.childNodes.length].nodeType;
      } catch (e) {
        I = {
          apply: P.length
            ? function (t, e) {
                D.apply(t, O.call(e));
              }
            : function (t, e) {
                for (var i = t.length, n = 0; (t[i++] = e[n++]); );
                t.length = i - 1;
              },
        };
      }
      function at(t, e, n, o) {
        var r,
          a,
          c,
          d,
          u,
          f,
          y,
          v = e && e.ownerDocument,
          S = e ? e.nodeType : 9;
        if (
          ((n = n || []),
          "string" != typeof t || !t || (1 !== S && 9 !== S && 11 !== S))
        )
          return n;
        if (!o && (h(e), (e = e || p), m)) {
          if (11 !== S && (u = Z.exec(t)))
            if ((r = u[1])) {
              if (9 === S) {
                if (!(c = e.getElementById(r))) return n;
                if (c.id === r) return n.push(c), n;
              } else if (
                v &&
                (c = v.getElementById(r)) &&
                b(e, c) &&
                c.id === r
              )
                return n.push(c), n;
            } else {
              if (u[2]) return I.apply(n, e.getElementsByTagName(t)), n;
              if (
                (r = u[3]) &&
                i.getElementsByClassName &&
                e.getElementsByClassName
              )
                return I.apply(n, e.getElementsByClassName(r)), n;
            }
          if (
            i.qsa &&
            !A[t + " "] &&
            (!g || !g.test(t)) &&
            (1 !== S || "object" !== e.nodeName.toLowerCase())
          ) {
            if (((y = t), (v = e), 1 === S && (V.test(t) || R.test(t)))) {
              for (
                ((v = (tt.test(t) && yt(e.parentNode)) || e) === e &&
                  i.scope) ||
                  ((d = e.getAttribute("id"))
                    ? (d = d.replace(nt, ot))
                    : e.setAttribute("id", (d = w))),
                  a = (f = s(t)).length;
                a--;

              )
                f[a] = (d ? "#" + d : ":scope") + " " + bt(f[a]);
              y = f.join(",");
            }
            try {
              return I.apply(n, v.querySelectorAll(y)), n;
            } catch (e) {
              A(t, !0);
            } finally {
              d === w && e.removeAttribute("id");
            }
          }
        }
        return l(t.replace(W, "$1"), e, n, o);
      }
      function lt() {
        var t = [];
        return function e(i, o) {
          return (
            t.push(i + " ") > n.cacheLength && delete e[t.shift()],
            (e[i + " "] = o)
          );
        };
      }
      function ct(t) {
        return (t[w] = !0), t;
      }
      function dt(t) {
        var e = p.createElement("fieldset");
        try {
          return !!t(e);
        } catch (t) {
          return !1;
        } finally {
          e.parentNode && e.parentNode.removeChild(e), (e = null);
        }
      }
      function ut(t, e) {
        for (var i = t.split("|"), o = i.length; o--; ) n.attrHandle[i[o]] = e;
      }
      function ht(t, e) {
        var i = e && t,
          n =
            i &&
            1 === t.nodeType &&
            1 === e.nodeType &&
            t.sourceIndex - e.sourceIndex;
        if (n) return n;
        if (i) for (; (i = i.nextSibling); ) if (i === e) return -1;
        return t ? 1 : -1;
      }
      function pt(t) {
        return function (e) {
          return "input" === e.nodeName.toLowerCase() && e.type === t;
        };
      }
      function ft(t) {
        return function (e) {
          var i = e.nodeName.toLowerCase();
          return ("input" === i || "button" === i) && e.type === t;
        };
      }
      function mt(t) {
        return function (e) {
          return "form" in e
            ? e.parentNode && !1 === e.disabled
              ? "label" in e
                ? "label" in e.parentNode
                  ? e.parentNode.disabled === t
                  : e.disabled === t
                : e.isDisabled === t || (e.isDisabled !== !t && st(e) === t)
              : e.disabled === t
            : "label" in e && e.disabled === t;
        };
      }
      function gt(t) {
        return ct(function (e) {
          return (
            (e = +e),
            ct(function (i, n) {
              for (var o, r = t([], i.length, e), s = r.length; s--; )
                i[(o = r[s])] && (i[o] = !(n[o] = i[o]));
            })
          );
        });
      }
      function yt(t) {
        return t && void 0 !== t.getElementsByTagName && t;
      }
      for (e in ((i = at.support = {}),
      (r = at.isXML =
        function (t) {
          var e = t.namespaceURI,
            i = (t.ownerDocument || t).documentElement;
          return !X.test(e || (i && i.nodeName) || "HTML");
        }),
      (h = at.setDocument =
        function (t) {
          var e,
            o,
            s = t ? t.ownerDocument || t : S;
          return (
            s != p &&
              9 === s.nodeType &&
              s.documentElement &&
              ((f = (p = s).documentElement),
              (m = !r(p)),
              S != p &&
                (o = p.defaultView) &&
                o.top !== o &&
                (o.addEventListener
                  ? o.addEventListener("unload", rt, !1)
                  : o.attachEvent && o.attachEvent("onunload", rt)),
              (i.scope = dt(function (t) {
                return (
                  f.appendChild(t).appendChild(p.createElement("div")),
                  void 0 !== t.querySelectorAll &&
                    !t.querySelectorAll(":scope fieldset div").length
                );
              })),
              (i.attributes = dt(function (t) {
                return (t.className = "i"), !t.getAttribute("className");
              })),
              (i.getElementsByTagName = dt(function (t) {
                return (
                  t.appendChild(p.createComment("")),
                  !t.getElementsByTagName("*").length
                );
              })),
              (i.getElementsByClassName = J.test(p.getElementsByClassName)),
              (i.getById = dt(function (t) {
                return (
                  (f.appendChild(t).id = w),
                  !p.getElementsByName || !p.getElementsByName(w).length
                );
              })),
              i.getById
                ? ((n.filter.ID = function (t) {
                    var e = t.replace(et, it);
                    return function (t) {
                      return t.getAttribute("id") === e;
                    };
                  }),
                  (n.find.ID = function (t, e) {
                    if (void 0 !== e.getElementById && m) {
                      var i = e.getElementById(t);
                      return i ? [i] : [];
                    }
                  }))
                : ((n.filter.ID = function (t) {
                    var e = t.replace(et, it);
                    return function (t) {
                      var i =
                        void 0 !== t.getAttributeNode &&
                        t.getAttributeNode("id");
                      return i && i.value === e;
                    };
                  }),
                  (n.find.ID = function (t, e) {
                    if (void 0 !== e.getElementById && m) {
                      var i,
                        n,
                        o,
                        r = e.getElementById(t);
                      if (r) {
                        if ((i = r.getAttributeNode("id")) && i.value === t)
                          return [r];
                        for (o = e.getElementsByName(t), n = 0; (r = o[n++]); )
                          if ((i = r.getAttributeNode("id")) && i.value === t)
                            return [r];
                      }
                      return [];
                    }
                  })),
              (n.find.TAG = i.getElementsByTagName
                ? function (t, e) {
                    return void 0 !== e.getElementsByTagName
                      ? e.getElementsByTagName(t)
                      : i.qsa
                      ? e.querySelectorAll(t)
                      : void 0;
                  }
                : function (t, e) {
                    var i,
                      n = [],
                      o = 0,
                      r = e.getElementsByTagName(t);
                    if ("*" === t) {
                      for (; (i = r[o++]); ) 1 === i.nodeType && n.push(i);
                      return n;
                    }
                    return r;
                  }),
              (n.find.CLASS =
                i.getElementsByClassName &&
                function (t, e) {
                  if (void 0 !== e.getElementsByClassName && m)
                    return e.getElementsByClassName(t);
                }),
              (y = []),
              (g = []),
              (i.qsa = J.test(p.querySelectorAll)) &&
                (dt(function (t) {
                  var e;
                  (f.appendChild(t).innerHTML =
                    "<a id='" +
                    w +
                    "'></a><select id='" +
                    w +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    t.querySelectorAll("[msallowcapture^='']").length &&
                      g.push("[*^$]=" + M + "*(?:''|\"\")"),
                    t.querySelectorAll("[selected]").length ||
                      g.push("\\[" + M + "*(?:value|" + H + ")"),
                    t.querySelectorAll("[id~=" + w + "-]").length ||
                      g.push("~="),
                    (e = p.createElement("input")).setAttribute("name", ""),
                    t.appendChild(e),
                    t.querySelectorAll("[name='']").length ||
                      g.push(
                        "\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"
                      ),
                    t.querySelectorAll(":checked").length || g.push(":checked"),
                    t.querySelectorAll("a#" + w + "+*").length ||
                      g.push(".#.+[+~]"),
                    t.querySelectorAll("\\\f"),
                    g.push("[\\r\\n\\f]");
                }),
                dt(function (t) {
                  t.innerHTML =
                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                  var e = p.createElement("input");
                  e.setAttribute("type", "hidden"),
                    t.appendChild(e).setAttribute("name", "D"),
                    t.querySelectorAll("[name=d]").length &&
                      g.push("name" + M + "*[*^$|!~]?="),
                    2 !== t.querySelectorAll(":enabled").length &&
                      g.push(":enabled", ":disabled"),
                    (f.appendChild(t).disabled = !0),
                    2 !== t.querySelectorAll(":disabled").length &&
                      g.push(":enabled", ":disabled"),
                    t.querySelectorAll("*,:x"),
                    g.push(",.*:");
                })),
              (i.matchesSelector = J.test(
                (v =
                  f.matches ||
                  f.webkitMatchesSelector ||
                  f.mozMatchesSelector ||
                  f.oMatchesSelector ||
                  f.msMatchesSelector)
              )) &&
                dt(function (t) {
                  (i.disconnectedMatch = v.call(t, "*")),
                    v.call(t, "[s!='']:x"),
                    y.push("!=", B);
                }),
              (g = g.length && new RegExp(g.join("|"))),
              (y = y.length && new RegExp(y.join("|"))),
              (e = J.test(f.compareDocumentPosition)),
              (b =
                e || J.test(f.contains)
                  ? function (t, e) {
                      var i = 9 === t.nodeType ? t.documentElement : t,
                        n = e && e.parentNode;
                      return (
                        t === n ||
                        !(
                          !n ||
                          1 !== n.nodeType ||
                          !(i.contains
                            ? i.contains(n)
                            : t.compareDocumentPosition &&
                              16 & t.compareDocumentPosition(n))
                        )
                      );
                    }
                  : function (t, e) {
                      if (e)
                        for (; (e = e.parentNode); ) if (e === t) return !0;
                      return !1;
                    }),
              (C = e
                ? function (t, e) {
                    if (t === e) return (u = !0), 0;
                    var n =
                      !t.compareDocumentPosition - !e.compareDocumentPosition;
                    return (
                      n ||
                      (1 &
                        (n =
                          (t.ownerDocument || t) == (e.ownerDocument || e)
                            ? t.compareDocumentPosition(e)
                            : 1) ||
                      (!i.sortDetached && e.compareDocumentPosition(t) === n)
                        ? t == p || (t.ownerDocument == S && b(S, t))
                          ? -1
                          : e == p || (e.ownerDocument == S && b(S, e))
                          ? 1
                          : d
                          ? F(d, t) - F(d, e)
                          : 0
                        : 4 & n
                        ? -1
                        : 1)
                    );
                  }
                : function (t, e) {
                    if (t === e) return (u = !0), 0;
                    var i,
                      n = 0,
                      o = t.parentNode,
                      r = e.parentNode,
                      s = [t],
                      a = [e];
                    if (!o || !r)
                      return t == p
                        ? -1
                        : e == p
                        ? 1
                        : o
                        ? -1
                        : r
                        ? 1
                        : d
                        ? F(d, t) - F(d, e)
                        : 0;
                    if (o === r) return ht(t, e);
                    for (i = t; (i = i.parentNode); ) s.unshift(i);
                    for (i = e; (i = i.parentNode); ) a.unshift(i);
                    for (; s[n] === a[n]; ) n++;
                    return n
                      ? ht(s[n], a[n])
                      : s[n] == S
                      ? -1
                      : a[n] == S
                      ? 1
                      : 0;
                  })),
            p
          );
        }),
      (at.matches = function (t, e) {
        return at(t, null, null, e);
      }),
      (at.matchesSelector = function (t, e) {
        if (
          (h(t),
          i.matchesSelector &&
            m &&
            !A[e + " "] &&
            (!y || !y.test(e)) &&
            (!g || !g.test(e)))
        )
          try {
            var n = v.call(t, e);
            if (
              n ||
              i.disconnectedMatch ||
              (t.document && 11 !== t.document.nodeType)
            )
              return n;
          } catch (t) {
            A(e, !0);
          }
        return 0 < at(e, p, null, [t]).length;
      }),
      (at.contains = function (t, e) {
        return (t.ownerDocument || t) != p && h(t), b(t, e);
      }),
      (at.attr = function (t, e) {
        (t.ownerDocument || t) != p && h(t);
        var o = n.attrHandle[e.toLowerCase()],
          r = o && q.call(n.attrHandle, e.toLowerCase()) ? o(t, e, !m) : void 0;
        return void 0 !== r
          ? r
          : i.attributes || !m
          ? t.getAttribute(e)
          : (r = t.getAttributeNode(e)) && r.specified
          ? r.value
          : null;
      }),
      (at.escape = function (t) {
        return (t + "").replace(nt, ot);
      }),
      (at.error = function (t) {
        throw new Error("Syntax error, unrecognized expression: " + t);
      }),
      (at.uniqueSort = function (t) {
        var e,
          n = [],
          o = 0,
          r = 0;
        if (
          ((u = !i.detectDuplicates),
          (d = !i.sortStable && t.slice(0)),
          t.sort(C),
          u)
        ) {
          for (; (e = t[r++]); ) e === t[r] && (o = n.push(r));
          for (; o--; ) t.splice(n[o], 1);
        }
        return (d = null), t;
      }),
      (o = at.getText =
        function (t) {
          var e,
            i = "",
            n = 0,
            r = t.nodeType;
          if (r) {
            if (1 === r || 9 === r || 11 === r) {
              if ("string" == typeof t.textContent) return t.textContent;
              for (t = t.firstChild; t; t = t.nextSibling) i += o(t);
            } else if (3 === r || 4 === r) return t.nodeValue;
          } else for (; (e = t[n++]); ) i += o(e);
          return i;
        }),
      ((n = at.selectors =
        {
          cacheLength: 50,
          createPseudo: ct,
          match: K,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (t) {
              return (
                (t[1] = t[1].replace(et, it)),
                (t[3] = (t[3] || t[4] || t[5] || "").replace(et, it)),
                "~=" === t[2] && (t[3] = " " + t[3] + " "),
                t.slice(0, 4)
              );
            },
            CHILD: function (t) {
              return (
                (t[1] = t[1].toLowerCase()),
                "nth" === t[1].slice(0, 3)
                  ? (t[3] || at.error(t[0]),
                    (t[4] = +(t[4]
                      ? t[5] + (t[6] || 1)
                      : 2 * ("even" === t[3] || "odd" === t[3]))),
                    (t[5] = +(t[7] + t[8] || "odd" === t[3])))
                  : t[3] && at.error(t[0]),
                t
              );
            },
            PSEUDO: function (t) {
              var e,
                i = !t[6] && t[2];
              return K.CHILD.test(t[0])
                ? null
                : (t[3]
                    ? (t[2] = t[4] || t[5] || "")
                    : i &&
                      U.test(i) &&
                      (e = s(i, !0)) &&
                      (e = i.indexOf(")", i.length - e) - i.length) &&
                      ((t[0] = t[0].slice(0, e)), (t[2] = i.slice(0, e))),
                  t.slice(0, 3));
            },
          },
          filter: {
            TAG: function (t) {
              var e = t.replace(et, it).toLowerCase();
              return "*" === t
                ? function () {
                    return !0;
                  }
                : function (t) {
                    return t.nodeName && t.nodeName.toLowerCase() === e;
                  };
            },
            CLASS: function (t) {
              var e = k[t + " "];
              return (
                e ||
                ((e = new RegExp("(^|" + M + ")" + t + "(" + M + "|$)")) &&
                  k(t, function (t) {
                    return e.test(
                      ("string" == typeof t.className && t.className) ||
                        (void 0 !== t.getAttribute &&
                          t.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (t, e, i) {
              return function (n) {
                var o = at.attr(n, t);
                return null == o
                  ? "!=" === e
                  : !e ||
                      ((o += ""),
                      "=" === e
                        ? o === i
                        : "!=" === e
                        ? o !== i
                        : "^=" === e
                        ? i && 0 === o.indexOf(i)
                        : "*=" === e
                        ? i && -1 < o.indexOf(i)
                        : "$=" === e
                        ? i && o.slice(-i.length) === i
                        : "~=" === e
                        ? -1 < (" " + o.replace($, " ") + " ").indexOf(i)
                        : "|=" === e &&
                          (o === i || o.slice(0, i.length + 1) === i + "-"));
              };
            },
            CHILD: function (t, e, i, n, o) {
              var r = "nth" !== t.slice(0, 3),
                s = "last" !== t.slice(-4),
                a = "of-type" === e;
              return 1 === n && 0 === o
                ? function (t) {
                    return !!t.parentNode;
                  }
                : function (e, i, l) {
                    var c,
                      d,
                      u,
                      h,
                      p,
                      f,
                      m = r !== s ? "nextSibling" : "previousSibling",
                      g = e.parentNode,
                      y = a && e.nodeName.toLowerCase(),
                      v = !l && !a,
                      b = !1;
                    if (g) {
                      if (r) {
                        for (; m; ) {
                          for (h = e; (h = h[m]); )
                            if (
                              a
                                ? h.nodeName.toLowerCase() === y
                                : 1 === h.nodeType
                            )
                              return !1;
                          f = m = "only" === t && !f && "nextSibling";
                        }
                        return !0;
                      }
                      if (((f = [s ? g.firstChild : g.lastChild]), s && v)) {
                        for (
                          b =
                            (p =
                              (c =
                                (d =
                                  (u = (h = g)[w] || (h[w] = {}))[h.uniqueID] ||
                                  (u[h.uniqueID] = {}))[t] || [])[0] === E &&
                              c[1]) && c[2],
                            h = p && g.childNodes[p];
                          (h = (++p && h && h[m]) || (b = p = 0) || f.pop());

                        )
                          if (1 === h.nodeType && ++b && h === e) {
                            d[t] = [E, p, b];
                            break;
                          }
                      } else if (
                        (v &&
                          (b = p =
                            (c =
                              (d =
                                (u = (h = e)[w] || (h[w] = {}))[h.uniqueID] ||
                                (u[h.uniqueID] = {}))[t] || [])[0] === E &&
                            c[1]),
                        !1 === b)
                      )
                        for (
                          ;
                          (h = (++p && h && h[m]) || (b = p = 0) || f.pop()) &&
                          ((a
                            ? h.nodeName.toLowerCase() !== y
                            : 1 !== h.nodeType) ||
                            !++b ||
                            (v &&
                              ((d =
                                (u = h[w] || (h[w] = {}))[h.uniqueID] ||
                                (u[h.uniqueID] = {}))[t] = [E, b]),
                            h !== e));

                        );
                      return (b -= o) === n || (b % n == 0 && 0 <= b / n);
                    }
                  };
            },
            PSEUDO: function (t, e) {
              var i,
                o =
                  n.pseudos[t] ||
                  n.setFilters[t.toLowerCase()] ||
                  at.error("unsupported pseudo: " + t);
              return o[w]
                ? o(e)
                : 1 < o.length
                ? ((i = [t, t, "", e]),
                  n.setFilters.hasOwnProperty(t.toLowerCase())
                    ? ct(function (t, i) {
                        for (var n, r = o(t, e), s = r.length; s--; )
                          t[(n = F(t, r[s]))] = !(i[n] = r[s]);
                      })
                    : function (t) {
                        return o(t, 0, i);
                      })
                : o;
            },
          },
          pseudos: {
            not: ct(function (t) {
              var e = [],
                i = [],
                n = a(t.replace(W, "$1"));
              return n[w]
                ? ct(function (t, e, i, o) {
                    for (var r, s = n(t, null, o, []), a = t.length; a--; )
                      (r = s[a]) && (t[a] = !(e[a] = r));
                  })
                : function (t, o, r) {
                    return (
                      (e[0] = t), n(e, null, r, i), (e[0] = null), !i.pop()
                    );
                  };
            }),
            has: ct(function (t) {
              return function (e) {
                return 0 < at(t, e).length;
              };
            }),
            contains: ct(function (t) {
              return (
                (t = t.replace(et, it)),
                function (e) {
                  return -1 < (e.textContent || o(e)).indexOf(t);
                }
              );
            }),
            lang: ct(function (t) {
              return (
                G.test(t || "") || at.error("unsupported lang: " + t),
                (t = t.replace(et, it).toLowerCase()),
                function (e) {
                  var i;
                  do {
                    if (
                      (i = m
                        ? e.lang
                        : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                    )
                      return (
                        (i = i.toLowerCase()) === t || 0 === i.indexOf(t + "-")
                      );
                  } while ((e = e.parentNode) && 1 === e.nodeType);
                  return !1;
                }
              );
            }),
            target: function (e) {
              var i = t.location && t.location.hash;
              return i && i.slice(1) === e.id;
            },
            root: function (t) {
              return t === f;
            },
            focus: function (t) {
              return (
                t === p.activeElement &&
                (!p.hasFocus || p.hasFocus()) &&
                !!(t.type || t.href || ~t.tabIndex)
              );
            },
            enabled: mt(!1),
            disabled: mt(!0),
            checked: function (t) {
              var e = t.nodeName.toLowerCase();
              return (
                ("input" === e && !!t.checked) ||
                ("option" === e && !!t.selected)
              );
            },
            selected: function (t) {
              return (
                t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
              );
            },
            empty: function (t) {
              for (t = t.firstChild; t; t = t.nextSibling)
                if (t.nodeType < 6) return !1;
              return !0;
            },
            parent: function (t) {
              return !n.pseudos.empty(t);
            },
            header: function (t) {
              return Q.test(t.nodeName);
            },
            input: function (t) {
              return Y.test(t.nodeName);
            },
            button: function (t) {
              var e = t.nodeName.toLowerCase();
              return ("input" === e && "button" === t.type) || "button" === e;
            },
            text: function (t) {
              var e;
              return (
                "input" === t.nodeName.toLowerCase() &&
                "text" === t.type &&
                (null == (e = t.getAttribute("type")) ||
                  "text" === e.toLowerCase())
              );
            },
            first: gt(function () {
              return [0];
            }),
            last: gt(function (t, e) {
              return [e - 1];
            }),
            eq: gt(function (t, e, i) {
              return [i < 0 ? i + e : i];
            }),
            even: gt(function (t, e) {
              for (var i = 0; i < e; i += 2) t.push(i);
              return t;
            }),
            odd: gt(function (t, e) {
              for (var i = 1; i < e; i += 2) t.push(i);
              return t;
            }),
            lt: gt(function (t, e, i) {
              for (var n = i < 0 ? i + e : e < i ? e : i; 0 <= --n; ) t.push(n);
              return t;
            }),
            gt: gt(function (t, e, i) {
              for (var n = i < 0 ? i + e : i; ++n < e; ) t.push(n);
              return t;
            }),
          },
        }).pseudos.nth = n.pseudos.eq),
      { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
        n.pseudos[e] = pt(e);
      for (e in { submit: !0, reset: !0 }) n.pseudos[e] = ft(e);
      function vt() {}
      function bt(t) {
        for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
        return n;
      }
      function wt(t, e, i) {
        var n = e.dir,
          o = e.next,
          r = o || n,
          s = i && "parentNode" === r,
          a = L++;
        return e.first
          ? function (e, i, o) {
              for (; (e = e[n]); ) if (1 === e.nodeType || s) return t(e, i, o);
              return !1;
            }
          : function (e, i, l) {
              var c,
                d,
                u,
                h = [E, a];
              if (l) {
                for (; (e = e[n]); )
                  if ((1 === e.nodeType || s) && t(e, i, l)) return !0;
              } else
                for (; (e = e[n]); )
                  if (1 === e.nodeType || s)
                    if (
                      ((d =
                        (u = e[w] || (e[w] = {}))[e.uniqueID] ||
                        (u[e.uniqueID] = {})),
                      o && o === e.nodeName.toLowerCase())
                    )
                      e = e[n] || e;
                    else {
                      if ((c = d[r]) && c[0] === E && c[1] === a)
                        return (h[2] = c[2]);
                      if (((d[r] = h)[2] = t(e, i, l))) return !0;
                    }
              return !1;
            };
      }
      function St(t) {
        return 1 < t.length
          ? function (e, i, n) {
              for (var o = t.length; o--; ) if (!t[o](e, i, n)) return !1;
              return !0;
            }
          : t[0];
      }
      function Et(t, e, i, n, o) {
        for (var r, s = [], a = 0, l = t.length, c = null != e; a < l; a++)
          (r = t[a]) && ((i && !i(r, n, o)) || (s.push(r), c && e.push(a)));
        return s;
      }
      function Lt(t, e, i, n, o, r) {
        return (
          n && !n[w] && (n = Lt(n)),
          o && !o[w] && (o = Lt(o, r)),
          ct(function (r, s, a, l) {
            var c,
              d,
              u,
              h = [],
              p = [],
              f = s.length,
              m =
                r ||
                (function (t, e, i) {
                  for (var n = 0, o = e.length; n < o; n++) at(t, e[n], i);
                  return i;
                })(e || "*", a.nodeType ? [a] : a, []),
              g = !t || (!r && e) ? m : Et(m, h, t, a, l),
              y = i ? (o || (r ? t : f || n) ? [] : s) : g;
            if ((i && i(g, y, a, l), n))
              for (c = Et(y, p), n(c, [], a, l), d = c.length; d--; )
                (u = c[d]) && (y[p[d]] = !(g[p[d]] = u));
            if (r) {
              if (o || t) {
                if (o) {
                  for (c = [], d = y.length; d--; )
                    (u = y[d]) && c.push((g[d] = u));
                  o(null, (y = []), c, l);
                }
                for (d = y.length; d--; )
                  (u = y[d]) &&
                    -1 < (c = o ? F(r, u) : h[d]) &&
                    (r[c] = !(s[c] = u));
              }
            } else (y = Et(y === s ? y.splice(f, y.length) : y)), o ? o(null, s, y, l) : I.apply(s, y);
          })
        );
      }
      function kt(t) {
        for (
          var e,
            i,
            o,
            r = t.length,
            s = n.relative[t[0].type],
            a = s || n.relative[" "],
            l = s ? 1 : 0,
            d = wt(
              function (t) {
                return t === e;
              },
              a,
              !0
            ),
            u = wt(
              function (t) {
                return -1 < F(e, t);
              },
              a,
              !0
            ),
            h = [
              function (t, i, n) {
                var o =
                  (!s && (n || i !== c)) ||
                  ((e = i).nodeType ? d(t, i, n) : u(t, i, n));
                return (e = null), o;
              },
            ];
          l < r;
          l++
        )
          if ((i = n.relative[t[l].type])) h = [wt(St(h), i)];
          else {
            if ((i = n.filter[t[l].type].apply(null, t[l].matches))[w]) {
              for (o = ++l; o < r && !n.relative[t[o].type]; o++);
              return Lt(
                1 < l && St(h),
                1 < l &&
                  bt(
                    t
                      .slice(0, l - 1)
                      .concat({ value: " " === t[l - 2].type ? "*" : "" })
                  ).replace(W, "$1"),
                i,
                l < o && kt(t.slice(l, o)),
                o < r && kt((t = t.slice(o))),
                o < r && bt(t)
              );
            }
            h.push(i);
          }
        return St(h);
      }
      return (
        (vt.prototype = n.filters = n.pseudos),
        (n.setFilters = new vt()),
        (s = at.tokenize =
          function (t, e) {
            var i,
              o,
              r,
              s,
              a,
              l,
              c,
              d = x[t + " "];
            if (d) return e ? 0 : d.slice(0);
            for (a = t, l = [], c = n.preFilter; a; ) {
              for (s in ((i && !(o = z.exec(a))) ||
                (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
              (i = !1),
              (o = R.exec(a)) &&
                ((i = o.shift()),
                r.push({ value: i, type: o[0].replace(W, " ") }),
                (a = a.slice(i.length))),
              n.filter))
                !(o = K[s].exec(a)) ||
                  (c[s] && !(o = c[s](o))) ||
                  ((i = o.shift()),
                  r.push({ value: i, type: s, matches: o }),
                  (a = a.slice(i.length)));
              if (!i) break;
            }
            return e ? a.length : a ? at.error(t) : x(t, l).slice(0);
          }),
        (a = at.compile =
          function (t, e) {
            var i,
              o,
              r,
              a,
              l,
              d,
              u = [],
              f = [],
              g = T[t + " "];
            if (!g) {
              for (e || (e = s(t)), i = e.length; i--; )
                (g = kt(e[i]))[w] ? u.push(g) : f.push(g);
              (g = T(
                t,
                ((o = f),
                (a = 0 < (r = u).length),
                (l = 0 < o.length),
                (d = function (t, e, i, s, d) {
                  var u,
                    f,
                    g,
                    y = 0,
                    v = "0",
                    b = t && [],
                    w = [],
                    S = c,
                    L = t || (l && n.find.TAG("*", d)),
                    k = (E += null == S ? 1 : Math.random() || 0.1),
                    x = L.length;
                  for (
                    d && (c = e == p || e || d);
                    v !== x && null != (u = L[v]);
                    v++
                  ) {
                    if (l && u) {
                      for (
                        f = 0, e || u.ownerDocument == p || (h(u), (i = !m));
                        (g = o[f++]);

                      )
                        if (g(u, e || p, i)) {
                          s.push(u);
                          break;
                        }
                      d && (E = k);
                    }
                    a && ((u = !g && u) && y--, t && b.push(u));
                  }
                  if (((y += v), a && v !== y)) {
                    for (f = 0; (g = r[f++]); ) g(b, w, e, i);
                    if (t) {
                      if (0 < y)
                        for (; v--; ) b[v] || w[v] || (w[v] = _.call(s));
                      w = Et(w);
                    }
                    I.apply(s, w),
                      d &&
                        !t &&
                        0 < w.length &&
                        1 < y + r.length &&
                        at.uniqueSort(s);
                  }
                  return d && ((E = k), (c = S)), b;
                }),
                a ? ct(d) : d)
              )).selector = t;
            }
            return g;
          }),
        (l = at.select =
          function (t, e, i, o) {
            var r,
              l,
              c,
              d,
              u,
              h = "function" == typeof t && t,
              p = !o && s((t = h.selector || t));
            if (((i = i || []), 1 === p.length)) {
              if (
                2 < (l = p[0] = p[0].slice(0)).length &&
                "ID" === (c = l[0]).type &&
                9 === e.nodeType &&
                m &&
                n.relative[l[1].type]
              ) {
                if (
                  !(e = (n.find.ID(c.matches[0].replace(et, it), e) || [])[0])
                )
                  return i;
                h && (e = e.parentNode), (t = t.slice(l.shift().value.length));
              }
              for (
                r = K.needsContext.test(t) ? 0 : l.length;
                r-- && ((c = l[r]), !n.relative[(d = c.type)]);

              )
                if (
                  (u = n.find[d]) &&
                  (o = u(
                    c.matches[0].replace(et, it),
                    (tt.test(l[0].type) && yt(e.parentNode)) || e
                  ))
                ) {
                  if ((l.splice(r, 1), !(t = o.length && bt(l))))
                    return I.apply(i, o), i;
                  break;
                }
            }
            return (
              (h || a(t, p))(
                o,
                e,
                !m,
                i,
                !e || (tt.test(t) && yt(e.parentNode)) || e
              ),
              i
            );
          }),
        (i.sortStable = w.split("").sort(C).join("") === w),
        (i.detectDuplicates = !!u),
        h(),
        (i.sortDetached = dt(function (t) {
          return 1 & t.compareDocumentPosition(p.createElement("fieldset"));
        })),
        dt(function (t) {
          return (
            (t.innerHTML = "<a href='#'></a>"),
            "#" === t.firstChild.getAttribute("href")
          );
        }) ||
          ut("type|href|height|width", function (t, e, i) {
            if (!i)
              return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2);
          }),
        (i.attributes &&
          dt(function (t) {
            return (
              (t.innerHTML = "<input/>"),
              t.firstChild.setAttribute("value", ""),
              "" === t.firstChild.getAttribute("value")
            );
          })) ||
          ut("value", function (t, e, i) {
            if (!i && "input" === t.nodeName.toLowerCase())
              return t.defaultValue;
          }),
        dt(function (t) {
          return null == t.getAttribute("disabled");
        }) ||
          ut(H, function (t, e, i) {
            var n;
            if (!i)
              return !0 === t[e]
                ? e.toLowerCase()
                : (n = t.getAttributeNode(e)) && n.specified
                ? n.value
                : null;
          }),
        at
      );
    })(t);
    (S.find = L),
      (S.expr = L.selectors),
      (S.expr[":"] = S.expr.pseudos),
      (S.uniqueSort = S.unique = L.uniqueSort),
      (S.text = L.getText),
      (S.isXMLDoc = L.isXML),
      (S.contains = L.contains),
      (S.escapeSelector = L.escape);
    var k = function (t, e, i) {
        for (var n = [], o = void 0 !== i; (t = t[e]) && 9 !== t.nodeType; )
          if (1 === t.nodeType) {
            if (o && S(t).is(i)) break;
            n.push(t);
          }
        return n;
      },
      x = function (t, e) {
        for (var i = []; t; t = t.nextSibling)
          1 === t.nodeType && t !== e && i.push(t);
        return i;
      },
      T = S.expr.match.needsContext;
    function A(t, e) {
      return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
    }
    var C = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function q(t, e, i) {
      return f(e)
        ? S.grep(t, function (t, n) {
            return !!e.call(t, n, t) !== i;
          })
        : e.nodeType
        ? S.grep(t, function (t) {
            return (t === e) !== i;
          })
        : "string" != typeof e
        ? S.grep(t, function (t) {
            return -1 < a.call(e, t) !== i;
          })
        : S.filter(e, t, i);
    }
    (S.filter = function (t, e, i) {
      var n = e[0];
      return (
        i && (t = ":not(" + t + ")"),
        1 === e.length && 1 === n.nodeType
          ? S.find.matchesSelector(n, t)
            ? [n]
            : []
          : S.find.matches(
              t,
              S.grep(e, function (t) {
                return 1 === t.nodeType;
              })
            )
      );
    }),
      S.fn.extend({
        find: function (t) {
          var e,
            i,
            n = this.length,
            o = this;
          if ("string" != typeof t)
            return this.pushStack(
              S(t).filter(function () {
                for (e = 0; e < n; e++) if (S.contains(o[e], this)) return !0;
              })
            );
          for (i = this.pushStack([]), e = 0; e < n; e++) S.find(t, o[e], i);
          return 1 < n ? S.uniqueSort(i) : i;
        },
        filter: function (t) {
          return this.pushStack(q(this, t || [], !1));
        },
        not: function (t) {
          return this.pushStack(q(this, t || [], !0));
        },
        is: function (t) {
          return !!q(
            this,
            "string" == typeof t && T.test(t) ? S(t) : t || [],
            !1
          ).length;
        },
      });
    var P,
      _ = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((S.fn.init = function (t, e, i) {
      var n, o;
      if (!t) return this;
      if (((i = i || P), "string" == typeof t)) {
        if (
          !(n =
            "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length
              ? [null, t, null]
              : _.exec(t)) ||
          (!n[1] && e)
        )
          return !e || e.jquery
            ? (e || i).find(t)
            : this.constructor(e).find(t);
        if (n[1]) {
          if (
            ((e = e instanceof S ? e[0] : e),
            S.merge(
              this,
              S.parseHTML(n[1], e && e.nodeType ? e.ownerDocument || e : g, !0)
            ),
            C.test(n[1]) && S.isPlainObject(e))
          )
            for (n in e) f(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
          return this;
        }
        return (
          (o = g.getElementById(n[2])) && ((this[0] = o), (this.length = 1)),
          this
        );
      }
      return t.nodeType
        ? ((this[0] = t), (this.length = 1), this)
        : f(t)
        ? void 0 !== i.ready
          ? i.ready(t)
          : t(S)
        : S.makeArray(t, this);
    }).prototype = S.fn),
      (P = S(g));
    var D = /^(?:parents|prev(?:Until|All))/,
      I = { children: !0, contents: !0, next: !0, prev: !0 };
    function O(t, e) {
      for (; (t = t[e]) && 1 !== t.nodeType; );
      return t;
    }
    S.fn.extend({
      has: function (t) {
        var e = S(t, this),
          i = e.length;
        return this.filter(function () {
          for (var t = 0; t < i; t++) if (S.contains(this, e[t])) return !0;
        });
      },
      closest: function (t, e) {
        var i,
          n = 0,
          o = this.length,
          r = [],
          s = "string" != typeof t && S(t);
        if (!T.test(t))
          for (; n < o; n++)
            for (i = this[n]; i && i !== e; i = i.parentNode)
              if (
                i.nodeType < 11 &&
                (s
                  ? -1 < s.index(i)
                  : 1 === i.nodeType && S.find.matchesSelector(i, t))
              ) {
                r.push(i);
                break;
              }
        return this.pushStack(1 < r.length ? S.uniqueSort(r) : r);
      },
      index: function (t) {
        return t
          ? "string" == typeof t
            ? a.call(S(t), this[0])
            : a.call(this, t.jquery ? t[0] : t)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (t, e) {
        return this.pushStack(S.uniqueSort(S.merge(this.get(), S(t, e))));
      },
      addBack: function (t) {
        return this.add(
          null == t ? this.prevObject : this.prevObject.filter(t)
        );
      },
    }),
      S.each(
        {
          parent: function (t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null;
          },
          parents: function (t) {
            return k(t, "parentNode");
          },
          parentsUntil: function (t, e, i) {
            return k(t, "parentNode", i);
          },
          next: function (t) {
            return O(t, "nextSibling");
          },
          prev: function (t) {
            return O(t, "previousSibling");
          },
          nextAll: function (t) {
            return k(t, "nextSibling");
          },
          prevAll: function (t) {
            return k(t, "previousSibling");
          },
          nextUntil: function (t, e, i) {
            return k(t, "nextSibling", i);
          },
          prevUntil: function (t, e, i) {
            return k(t, "previousSibling", i);
          },
          siblings: function (t) {
            return x((t.parentNode || {}).firstChild, t);
          },
          children: function (t) {
            return x(t.firstChild);
          },
          contents: function (t) {
            return null != t.contentDocument && n(t.contentDocument)
              ? t.contentDocument
              : (A(t, "template") && (t = t.content || t),
                S.merge([], t.childNodes));
          },
        },
        function (t, e) {
          S.fn[t] = function (i, n) {
            var o = S.map(this, e, i);
            return (
              "Until" !== t.slice(-5) && (n = i),
              n && "string" == typeof n && (o = S.filter(n, o)),
              1 < this.length &&
                (I[t] || S.uniqueSort(o), D.test(t) && o.reverse()),
              this.pushStack(o)
            );
          };
        }
      );
    var F = /[^\x20\t\r\n\f]+/g;
    function H(t) {
      return t;
    }
    function M(t) {
      throw t;
    }
    function j(t, e, i, n) {
      var o;
      try {
        t && f((o = t.promise))
          ? o.call(t).done(e).fail(i)
          : t && f((o = t.then))
          ? o.call(t, e, i)
          : e.apply(void 0, [t].slice(n));
      } catch (t) {
        i.apply(void 0, [t]);
      }
    }
    (S.Callbacks = function (t) {
      var e, i;
      t =
        "string" == typeof t
          ? ((e = t),
            (i = {}),
            S.each(e.match(F) || [], function (t, e) {
              i[e] = !0;
            }),
            i)
          : S.extend({}, t);
      var n,
        o,
        r,
        s,
        a = [],
        l = [],
        c = -1,
        d = function () {
          for (s = s || t.once, r = n = !0; l.length; c = -1)
            for (o = l.shift(); ++c < a.length; )
              !1 === a[c].apply(o[0], o[1]) &&
                t.stopOnFalse &&
                ((c = a.length), (o = !1));
          t.memory || (o = !1), (n = !1), s && (a = o ? [] : "");
        },
        u = {
          add: function () {
            return (
              a &&
                (o && !n && ((c = a.length - 1), l.push(o)),
                (function e(i) {
                  S.each(i, function (i, n) {
                    f(n)
                      ? (t.unique && u.has(n)) || a.push(n)
                      : n && n.length && "string" !== b(n) && e(n);
                  });
                })(arguments),
                o && !n && d()),
              this
            );
          },
          remove: function () {
            return (
              S.each(arguments, function (t, e) {
                for (var i; -1 < (i = S.inArray(e, a, i)); )
                  a.splice(i, 1), i <= c && c--;
              }),
              this
            );
          },
          has: function (t) {
            return t ? -1 < S.inArray(t, a) : 0 < a.length;
          },
          empty: function () {
            return a && (a = []), this;
          },
          disable: function () {
            return (s = l = []), (a = o = ""), this;
          },
          disabled: function () {
            return !a;
          },
          lock: function () {
            return (s = l = []), o || n || (a = o = ""), this;
          },
          locked: function () {
            return !!s;
          },
          fireWith: function (t, e) {
            return (
              s ||
                ((e = [t, (e = e || []).slice ? e.slice() : e]),
                l.push(e),
                n || d()),
              this
            );
          },
          fire: function () {
            return u.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!r;
          },
        };
      return u;
    }),
      S.extend({
        Deferred: function (e) {
          var i = [
              [
                "notify",
                "progress",
                S.Callbacks("memory"),
                S.Callbacks("memory"),
                2,
              ],
              [
                "resolve",
                "done",
                S.Callbacks("once memory"),
                S.Callbacks("once memory"),
                0,
                "resolved",
              ],
              [
                "reject",
                "fail",
                S.Callbacks("once memory"),
                S.Callbacks("once memory"),
                1,
                "rejected",
              ],
            ],
            n = "pending",
            o = {
              state: function () {
                return n;
              },
              always: function () {
                return r.done(arguments).fail(arguments), this;
              },
              catch: function (t) {
                return o.then(null, t);
              },
              pipe: function () {
                var t = arguments;
                return S.Deferred(function (e) {
                  S.each(i, function (i, n) {
                    var o = f(t[n[4]]) && t[n[4]];
                    r[n[1]](function () {
                      var t = o && o.apply(this, arguments);
                      t && f(t.promise)
                        ? t
                            .promise()
                            .progress(e.notify)
                            .done(e.resolve)
                            .fail(e.reject)
                        : e[n[0] + "With"](this, o ? [t] : arguments);
                    });
                  }),
                    (t = null);
                }).promise();
              },
              then: function (e, n, o) {
                var r = 0;
                function s(e, i, n, o) {
                  return function () {
                    var a = this,
                      l = arguments,
                      c = function () {
                        var t, c;
                        if (!(e < r)) {
                          if ((t = n.apply(a, l)) === i.promise())
                            throw new TypeError("Thenable self-resolution");
                          (c =
                            t &&
                            ("object" == typeof t || "function" == typeof t) &&
                            t.then),
                            f(c)
                              ? o
                                ? c.call(t, s(r, i, H, o), s(r, i, M, o))
                                : (r++,
                                  c.call(
                                    t,
                                    s(r, i, H, o),
                                    s(r, i, M, o),
                                    s(r, i, H, i.notifyWith)
                                  ))
                              : (n !== H && ((a = void 0), (l = [t])),
                                (o || i.resolveWith)(a, l));
                        }
                      },
                      d = o
                        ? c
                        : function () {
                            try {
                              c();
                            } catch (t) {
                              S.Deferred.exceptionHook &&
                                S.Deferred.exceptionHook(t, d.stackTrace),
                                r <= e + 1 &&
                                  (n !== M && ((a = void 0), (l = [t])),
                                  i.rejectWith(a, l));
                            }
                          };
                    e
                      ? d()
                      : (S.Deferred.getStackHook &&
                          (d.stackTrace = S.Deferred.getStackHook()),
                        t.setTimeout(d));
                  };
                }
                return S.Deferred(function (t) {
                  i[0][3].add(s(0, t, f(o) ? o : H, t.notifyWith)),
                    i[1][3].add(s(0, t, f(e) ? e : H)),
                    i[2][3].add(s(0, t, f(n) ? n : M));
                }).promise();
              },
              promise: function (t) {
                return null != t ? S.extend(t, o) : o;
              },
            },
            r = {};
          return (
            S.each(i, function (t, e) {
              var s = e[2],
                a = e[5];
              (o[e[1]] = s.add),
                a &&
                  s.add(
                    function () {
                      n = a;
                    },
                    i[3 - t][2].disable,
                    i[3 - t][3].disable,
                    i[0][2].lock,
                    i[0][3].lock
                  ),
                s.add(e[3].fire),
                (r[e[0]] = function () {
                  return (
                    r[e[0] + "With"](this === r ? void 0 : this, arguments),
                    this
                  );
                }),
                (r[e[0] + "With"] = s.fireWith);
            }),
            o.promise(r),
            e && e.call(r, r),
            r
          );
        },
        when: function (t) {
          var e = arguments.length,
            i = e,
            n = Array(i),
            r = o.call(arguments),
            s = S.Deferred(),
            a = function (t) {
              return function (i) {
                (n[t] = this),
                  (r[t] = 1 < arguments.length ? o.call(arguments) : i),
                  --e || s.resolveWith(n, r);
              };
            };
          if (
            e <= 1 &&
            (j(t, s.done(a(i)).resolve, s.reject, !e),
            "pending" === s.state() || f(r[i] && r[i].then))
          )
            return s.then();
          for (; i--; ) j(r[i], a(i), s.reject);
          return s.promise();
        },
      });
    var N = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (S.Deferred.exceptionHook = function (e, i) {
      t.console &&
        t.console.warn &&
        e &&
        N.test(e.name) &&
        t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, i);
    }),
      (S.readyException = function (e) {
        t.setTimeout(function () {
          throw e;
        });
      });
    var B = S.Deferred();
    function $() {
      g.removeEventListener("DOMContentLoaded", $),
        t.removeEventListener("load", $),
        S.ready();
    }
    (S.fn.ready = function (t) {
      return (
        B.then(t).catch(function (t) {
          S.readyException(t);
        }),
        this
      );
    }),
      S.extend({
        isReady: !1,
        readyWait: 1,
        ready: function (t) {
          (!0 === t ? --S.readyWait : S.isReady) ||
            ((S.isReady = !0) !== t && 0 < --S.readyWait) ||
            B.resolveWith(g, [S]);
        },
      }),
      (S.ready.then = B.then),
      "complete" === g.readyState ||
      ("loading" !== g.readyState && !g.documentElement.doScroll)
        ? t.setTimeout(S.ready)
        : (g.addEventListener("DOMContentLoaded", $),
          t.addEventListener("load", $));
    var W = function (t, e, i, n, o, r, s) {
        var a = 0,
          l = t.length,
          c = null == i;
        if ("object" === b(i))
          for (a in ((o = !0), i)) W(t, e, a, i[a], !0, r, s);
        else if (
          void 0 !== n &&
          ((o = !0),
          f(n) || (s = !0),
          c &&
            (s
              ? (e.call(t, n), (e = null))
              : ((c = e),
                (e = function (t, e, i) {
                  return c.call(S(t), i);
                }))),
          e)
        )
          for (; a < l; a++) e(t[a], i, s ? n : n.call(t[a], a, e(t[a], i)));
        return o ? t : c ? e.call(t) : l ? e(t[0], i) : r;
      },
      z = /^-ms-/,
      R = /-([a-z])/g;
    function V(t, e) {
      return e.toUpperCase();
    }
    function U(t) {
      return t.replace(z, "ms-").replace(R, V);
    }
    var G = function (t) {
      return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
    };
    function K() {
      this.expando = S.expando + K.uid++;
    }
    (K.uid = 1),
      (K.prototype = {
        cache: function (t) {
          var e = t[this.expando];
          return (
            e ||
              ((e = {}),
              G(t) &&
                (t.nodeType
                  ? (t[this.expando] = e)
                  : Object.defineProperty(t, this.expando, {
                      value: e,
                      configurable: !0,
                    }))),
            e
          );
        },
        set: function (t, e, i) {
          var n,
            o = this.cache(t);
          if ("string" == typeof e) o[U(e)] = i;
          else for (n in e) o[U(n)] = e[n];
          return o;
        },
        get: function (t, e) {
          return void 0 === e
            ? this.cache(t)
            : t[this.expando] && t[this.expando][U(e)];
        },
        access: function (t, e, i) {
          return void 0 === e || (e && "string" == typeof e && void 0 === i)
            ? this.get(t, e)
            : (this.set(t, e, i), void 0 !== i ? i : e);
        },
        remove: function (t, e) {
          var i,
            n = t[this.expando];
          if (void 0 !== n) {
            if (void 0 !== e) {
              i = (e = Array.isArray(e)
                ? e.map(U)
                : (e = U(e)) in n
                ? [e]
                : e.match(F) || []).length;
              for (; i--; ) delete n[e[i]];
            }
            (void 0 === e || S.isEmptyObject(n)) &&
              (t.nodeType
                ? (t[this.expando] = void 0)
                : delete t[this.expando]);
          }
        },
        hasData: function (t) {
          var e = t[this.expando];
          return void 0 !== e && !S.isEmptyObject(e);
        },
      });
    var X = new K(),
      Y = new K(),
      Q = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      J = /[A-Z]/g;
    function Z(t, e, i) {
      var n, o;
      if (void 0 === i && 1 === t.nodeType)
        if (
          ((n = "data-" + e.replace(J, "-$&").toLowerCase()),
          "string" == typeof (i = t.getAttribute(n)))
        ) {
          try {
            i =
              "true" === (o = i) ||
              ("false" !== o &&
                ("null" === o
                  ? null
                  : o === +o + ""
                  ? +o
                  : Q.test(o)
                  ? JSON.parse(o)
                  : o));
          } catch (t) {}
          Y.set(t, e, i);
        } else i = void 0;
      return i;
    }
    S.extend({
      hasData: function (t) {
        return Y.hasData(t) || X.hasData(t);
      },
      data: function (t, e, i) {
        return Y.access(t, e, i);
      },
      removeData: function (t, e) {
        Y.remove(t, e);
      },
      _data: function (t, e, i) {
        return X.access(t, e, i);
      },
      _removeData: function (t, e) {
        X.remove(t, e);
      },
    }),
      S.fn.extend({
        data: function (t, e) {
          var i,
            n,
            o,
            r = this[0],
            s = r && r.attributes;
          if (void 0 === t) {
            if (
              this.length &&
              ((o = Y.get(r)), 1 === r.nodeType && !X.get(r, "hasDataAttrs"))
            ) {
              for (i = s.length; i--; )
                s[i] &&
                  0 === (n = s[i].name).indexOf("data-") &&
                  ((n = U(n.slice(5))), Z(r, n, o[n]));
              X.set(r, "hasDataAttrs", !0);
            }
            return o;
          }
          return "object" == typeof t
            ? this.each(function () {
                Y.set(this, t);
              })
            : W(
                this,
                function (e) {
                  var i;
                  if (r && void 0 === e)
                    return void 0 !== (i = Y.get(r, t)) ||
                      void 0 !== (i = Z(r, t))
                      ? i
                      : void 0;
                  this.each(function () {
                    Y.set(this, t, e);
                  });
                },
                null,
                e,
                1 < arguments.length,
                null,
                !0
              );
        },
        removeData: function (t) {
          return this.each(function () {
            Y.remove(this, t);
          });
        },
      }),
      S.extend({
        queue: function (t, e, i) {
          var n;
          if (t)
            return (
              (e = (e || "fx") + "queue"),
              (n = X.get(t, e)),
              i &&
                (!n || Array.isArray(i)
                  ? (n = X.access(t, e, S.makeArray(i)))
                  : n.push(i)),
              n || []
            );
        },
        dequeue: function (t, e) {
          e = e || "fx";
          var i = S.queue(t, e),
            n = i.length,
            o = i.shift(),
            r = S._queueHooks(t, e);
          "inprogress" === o && ((o = i.shift()), n--),
            o &&
              ("fx" === e && i.unshift("inprogress"),
              delete r.stop,
              o.call(
                t,
                function () {
                  S.dequeue(t, e);
                },
                r
              )),
            !n && r && r.empty.fire();
        },
        _queueHooks: function (t, e) {
          var i = e + "queueHooks";
          return (
            X.get(t, i) ||
            X.access(t, i, {
              empty: S.Callbacks("once memory").add(function () {
                X.remove(t, [e + "queue", i]);
              }),
            })
          );
        },
      }),
      S.fn.extend({
        queue: function (t, e) {
          var i = 2;
          return (
            "string" != typeof t && ((e = t), (t = "fx"), i--),
            arguments.length < i
              ? S.queue(this[0], t)
              : void 0 === e
              ? this
              : this.each(function () {
                  var i = S.queue(this, t, e);
                  S._queueHooks(this, t),
                    "fx" === t && "inprogress" !== i[0] && S.dequeue(this, t);
                })
          );
        },
        dequeue: function (t) {
          return this.each(function () {
            S.dequeue(this, t);
          });
        },
        clearQueue: function (t) {
          return this.queue(t || "fx", []);
        },
        promise: function (t, e) {
          var i,
            n = 1,
            o = S.Deferred(),
            r = this,
            s = this.length,
            a = function () {
              --n || o.resolveWith(r, [r]);
            };
          for (
            "string" != typeof t && ((e = t), (t = void 0)), t = t || "fx";
            s--;

          )
            (i = X.get(r[s], t + "queueHooks")) &&
              i.empty &&
              (n++, i.empty.add(a));
          return a(), o.promise(e);
        },
      });
    var tt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      et = new RegExp("^(?:([+-])=|)(" + tt + ")([a-z%]*)$", "i"),
      it = ["Top", "Right", "Bottom", "Left"],
      nt = g.documentElement,
      ot = function (t) {
        return S.contains(t.ownerDocument, t);
      },
      rt = { composed: !0 };
    nt.getRootNode &&
      (ot = function (t) {
        return (
          S.contains(t.ownerDocument, t) ||
          t.getRootNode(rt) === t.ownerDocument
        );
      });
    var st = function (t, e) {
      return (
        "none" === (t = e || t).style.display ||
        ("" === t.style.display && ot(t) && "none" === S.css(t, "display"))
      );
    };
    function at(t, e, i, n) {
      var o,
        r,
        s = 20,
        a = n
          ? function () {
              return n.cur();
            }
          : function () {
              return S.css(t, e, "");
            },
        l = a(),
        c = (i && i[3]) || (S.cssNumber[e] ? "" : "px"),
        d =
          t.nodeType &&
          (S.cssNumber[e] || ("px" !== c && +l)) &&
          et.exec(S.css(t, e));
      if (d && d[3] !== c) {
        for (l /= 2, c = c || d[3], d = +l || 1; s--; )
          S.style(t, e, d + c),
            (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0),
            (d /= r);
        (d *= 2), S.style(t, e, d + c), (i = i || []);
      }
      return (
        i &&
          ((d = +d || +l || 0),
          (o = i[1] ? d + (i[1] + 1) * i[2] : +i[2]),
          n && ((n.unit = c), (n.start = d), (n.end = o))),
        o
      );
    }
    var lt = {};
    function ct(t, e) {
      for (var i, n, o, r, s, a, l, c = [], d = 0, u = t.length; d < u; d++)
        (n = t[d]).style &&
          ((i = n.style.display),
          e
            ? ("none" === i &&
                ((c[d] = X.get(n, "display") || null),
                c[d] || (n.style.display = "")),
              "" === n.style.display &&
                st(n) &&
                (c[d] =
                  ((l = s = r = void 0),
                  (s = (o = n).ownerDocument),
                  (a = o.nodeName),
                  (l = lt[a]) ||
                    ((r = s.body.appendChild(s.createElement(a))),
                    (l = S.css(r, "display")),
                    r.parentNode.removeChild(r),
                    "none" === l && (l = "block"),
                    (lt[a] = l)))))
            : "none" !== i && ((c[d] = "none"), X.set(n, "display", i)));
      for (d = 0; d < u; d++) null != c[d] && (t[d].style.display = c[d]);
      return t;
    }
    S.fn.extend({
      show: function () {
        return ct(this, !0);
      },
      hide: function () {
        return ct(this);
      },
      toggle: function (t) {
        return "boolean" == typeof t
          ? t
            ? this.show()
            : this.hide()
          : this.each(function () {
              st(this) ? S(this).show() : S(this).hide();
            });
      },
    });
    var dt,
      ut,
      ht = /^(?:checkbox|radio)$/i,
      pt = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
      ft = /^$|^module$|\/(?:java|ecma)script/i;
    (dt = g.createDocumentFragment().appendChild(g.createElement("div"))),
      (ut = g.createElement("input")).setAttribute("type", "radio"),
      ut.setAttribute("checked", "checked"),
      ut.setAttribute("name", "t"),
      dt.appendChild(ut),
      (p.checkClone = dt.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (dt.innerHTML = "<textarea>x</textarea>"),
      (p.noCloneChecked = !!dt.cloneNode(!0).lastChild.defaultValue),
      (dt.innerHTML = "<option></option>"),
      (p.option = !!dt.lastChild);
    var mt = {
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""],
    };
    function gt(t, e) {
      var i;
      return (
        (i =
          void 0 !== t.getElementsByTagName
            ? t.getElementsByTagName(e || "*")
            : void 0 !== t.querySelectorAll
            ? t.querySelectorAll(e || "*")
            : []),
        void 0 === e || (e && A(t, e)) ? S.merge([t], i) : i
      );
    }
    function yt(t, e) {
      for (var i = 0, n = t.length; i < n; i++)
        X.set(t[i], "globalEval", !e || X.get(e[i], "globalEval"));
    }
    (mt.tbody = mt.tfoot = mt.colgroup = mt.caption = mt.thead),
      (mt.th = mt.td),
      p.option ||
        (mt.optgroup = mt.option =
          [1, "<select multiple='multiple'>", "</select>"]);
    var vt = /<|&#?\w+;/;
    function bt(t, e, i, n, o) {
      for (
        var r,
          s,
          a,
          l,
          c,
          d,
          u = e.createDocumentFragment(),
          h = [],
          p = 0,
          f = t.length;
        p < f;
        p++
      )
        if ((r = t[p]) || 0 === r)
          if ("object" === b(r)) S.merge(h, r.nodeType ? [r] : r);
          else if (vt.test(r)) {
            for (
              s = s || u.appendChild(e.createElement("div")),
                a = (pt.exec(r) || ["", ""])[1].toLowerCase(),
                l = mt[a] || mt._default,
                s.innerHTML = l[1] + S.htmlPrefilter(r) + l[2],
                d = l[0];
              d--;

            )
              s = s.lastChild;
            S.merge(h, s.childNodes), ((s = u.firstChild).textContent = "");
          } else h.push(e.createTextNode(r));
      for (u.textContent = "", p = 0; (r = h[p++]); )
        if (n && -1 < S.inArray(r, n)) o && o.push(r);
        else if (
          ((c = ot(r)), (s = gt(u.appendChild(r), "script")), c && yt(s), i)
        )
          for (d = 0; (r = s[d++]); ) ft.test(r.type || "") && i.push(r);
      return u;
    }
    var wt = /^key/,
      St = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      Et = /^([^.]*)(?:\.(.+)|)/;
    function Lt() {
      return !0;
    }
    function kt() {
      return !1;
    }
    function xt(t, e) {
      return (
        (t ===
          (function () {
            try {
              return g.activeElement;
            } catch (t) {}
          })()) ==
        ("focus" === e)
      );
    }
    function Tt(t, e, i, n, o, r) {
      var s, a;
      if ("object" == typeof e) {
        for (a in ("string" != typeof i && ((n = n || i), (i = void 0)), e))
          Tt(t, a, i, n, e[a], r);
        return t;
      }
      if (
        (null == n && null == o
          ? ((o = i), (n = i = void 0))
          : null == o &&
            ("string" == typeof i
              ? ((o = n), (n = void 0))
              : ((o = n), (n = i), (i = void 0))),
        !1 === o)
      )
        o = kt;
      else if (!o) return t;
      return (
        1 === r &&
          ((s = o),
          ((o = function (t) {
            return S().off(t), s.apply(this, arguments);
          }).guid = s.guid || (s.guid = S.guid++))),
        t.each(function () {
          S.event.add(this, e, o, n, i);
        })
      );
    }
    function At(t, e, i) {
      i
        ? (X.set(t, e, !1),
          S.event.add(t, e, {
            namespace: !1,
            handler: function (t) {
              var n,
                r,
                s = X.get(this, e);
              if (1 & t.isTrigger && this[e]) {
                if (s.length)
                  (S.event.special[e] || {}).delegateType &&
                    t.stopPropagation();
                else if (
                  ((s = o.call(arguments)),
                  X.set(this, e, s),
                  (n = i(this, e)),
                  this[e](),
                  s !== (r = X.get(this, e)) || n
                    ? X.set(this, e, !1)
                    : (r = {}),
                  s !== r)
                )
                  return (
                    t.stopImmediatePropagation(), t.preventDefault(), r.value
                  );
              } else
                s.length &&
                  (X.set(this, e, {
                    value: S.event.trigger(
                      S.extend(s[0], S.Event.prototype),
                      s.slice(1),
                      this
                    ),
                  }),
                  t.stopImmediatePropagation());
            },
          }))
        : void 0 === X.get(t, e) && S.event.add(t, e, Lt);
    }
    (S.event = {
      global: {},
      add: function (t, e, i, n, o) {
        var r,
          s,
          a,
          l,
          c,
          d,
          u,
          h,
          p,
          f,
          m,
          g = X.get(t);
        if (G(t))
          for (
            i.handler && ((i = (r = i).handler), (o = r.selector)),
              o && S.find.matchesSelector(nt, o),
              i.guid || (i.guid = S.guid++),
              (l = g.events) || (l = g.events = Object.create(null)),
              (s = g.handle) ||
                (s = g.handle =
                  function (e) {
                    return void 0 !== S && S.event.triggered !== e.type
                      ? S.event.dispatch.apply(t, arguments)
                      : void 0;
                  }),
              c = (e = (e || "").match(F) || [""]).length;
            c--;

          )
            (p = m = (a = Et.exec(e[c]) || [])[1]),
              (f = (a[2] || "").split(".").sort()),
              p &&
                ((u = S.event.special[p] || {}),
                (p = (o ? u.delegateType : u.bindType) || p),
                (u = S.event.special[p] || {}),
                (d = S.extend(
                  {
                    type: p,
                    origType: m,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: o,
                    needsContext: o && S.expr.match.needsContext.test(o),
                    namespace: f.join("."),
                  },
                  r
                )),
                (h = l[p]) ||
                  (((h = l[p] = []).delegateCount = 0),
                  (u.setup && !1 !== u.setup.call(t, n, f, s)) ||
                    (t.addEventListener && t.addEventListener(p, s))),
                u.add &&
                  (u.add.call(t, d),
                  d.handler.guid || (d.handler.guid = i.guid)),
                o ? h.splice(h.delegateCount++, 0, d) : h.push(d),
                (S.event.global[p] = !0));
      },
      remove: function (t, e, i, n, o) {
        var r,
          s,
          a,
          l,
          c,
          d,
          u,
          h,
          p,
          f,
          m,
          g = X.hasData(t) && X.get(t);
        if (g && (l = g.events)) {
          for (c = (e = (e || "").match(F) || [""]).length; c--; )
            if (
              ((p = m = (a = Et.exec(e[c]) || [])[1]),
              (f = (a[2] || "").split(".").sort()),
              p)
            ) {
              for (
                u = S.event.special[p] || {},
                  h = l[(p = (n ? u.delegateType : u.bindType) || p)] || [],
                  a =
                    a[2] &&
                    new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  s = r = h.length;
                r--;

              )
                (d = h[r]),
                  (!o && m !== d.origType) ||
                    (i && i.guid !== d.guid) ||
                    (a && !a.test(d.namespace)) ||
                    (n && n !== d.selector && ("**" !== n || !d.selector)) ||
                    (h.splice(r, 1),
                    d.selector && h.delegateCount--,
                    u.remove && u.remove.call(t, d));
              s &&
                !h.length &&
                ((u.teardown && !1 !== u.teardown.call(t, f, g.handle)) ||
                  S.removeEvent(t, p, g.handle),
                delete l[p]);
            } else for (p in l) S.event.remove(t, p + e[c], i, n, !0);
          S.isEmptyObject(l) && X.remove(t, "handle events");
        }
      },
      dispatch: function (t) {
        var e,
          i,
          n,
          o,
          r,
          s,
          a = new Array(arguments.length),
          l = S.event.fix(t),
          c = (X.get(this, "events") || Object.create(null))[l.type] || [],
          d = S.event.special[l.type] || {};
        for (a[0] = l, e = 1; e < arguments.length; e++) a[e] = arguments[e];
        if (
          ((l.delegateTarget = this),
          !d.preDispatch || !1 !== d.preDispatch.call(this, l))
        ) {
          for (
            s = S.event.handlers.call(this, l, c), e = 0;
            (o = s[e++]) && !l.isPropagationStopped();

          )
            for (
              l.currentTarget = o.elem, i = 0;
              (r = o.handlers[i++]) && !l.isImmediatePropagationStopped();

            )
              (l.rnamespace &&
                !1 !== r.namespace &&
                !l.rnamespace.test(r.namespace)) ||
                ((l.handleObj = r),
                (l.data = r.data),
                void 0 !==
                  (n = (
                    (S.event.special[r.origType] || {}).handle || r.handler
                  ).apply(o.elem, a)) &&
                  !1 === (l.result = n) &&
                  (l.preventDefault(), l.stopPropagation()));
          return d.postDispatch && d.postDispatch.call(this, l), l.result;
        }
      },
      handlers: function (t, e) {
        var i,
          n,
          o,
          r,
          s,
          a = [],
          l = e.delegateCount,
          c = t.target;
        if (l && c.nodeType && !("click" === t.type && 1 <= t.button))
          for (; c !== this; c = c.parentNode || this)
            if (1 === c.nodeType && ("click" !== t.type || !0 !== c.disabled)) {
              for (r = [], s = {}, i = 0; i < l; i++)
                void 0 === s[(o = (n = e[i]).selector + " ")] &&
                  (s[o] = n.needsContext
                    ? -1 < S(o, this).index(c)
                    : S.find(o, this, null, [c]).length),
                  s[o] && r.push(n);
              r.length && a.push({ elem: c, handlers: r });
            }
        return (
          (c = this),
          l < e.length && a.push({ elem: c, handlers: e.slice(l) }),
          a
        );
      },
      addProp: function (t, e) {
        Object.defineProperty(S.Event.prototype, t, {
          enumerable: !0,
          configurable: !0,
          get: f(e)
            ? function () {
                if (this.originalEvent) return e(this.originalEvent);
              }
            : function () {
                if (this.originalEvent) return this.originalEvent[t];
              },
          set: function (e) {
            Object.defineProperty(this, t, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: e,
            });
          },
        });
      },
      fix: function (t) {
        return t[S.expando] ? t : new S.Event(t);
      },
      special: {
        load: { noBubble: !0 },
        click: {
          setup: function (t) {
            var e = this || t;
            return (
              ht.test(e.type) && e.click && A(e, "input") && At(e, "click", Lt),
              !1
            );
          },
          trigger: function (t) {
            var e = this || t;
            return (
              ht.test(e.type) && e.click && A(e, "input") && At(e, "click"), !0
            );
          },
          _default: function (t) {
            var e = t.target;
            return (
              (ht.test(e.type) &&
                e.click &&
                A(e, "input") &&
                X.get(e, "click")) ||
              A(e, "a")
            );
          },
        },
        beforeunload: {
          postDispatch: function (t) {
            void 0 !== t.result &&
              t.originalEvent &&
              (t.originalEvent.returnValue = t.result);
          },
        },
      },
    }),
      (S.removeEvent = function (t, e, i) {
        t.removeEventListener && t.removeEventListener(e, i);
      }),
      (S.Event = function (t, e) {
        if (!(this instanceof S.Event)) return new S.Event(t, e);
        t && t.type
          ? ((this.originalEvent = t),
            (this.type = t.type),
            (this.isDefaultPrevented =
              t.defaultPrevented ||
              (void 0 === t.defaultPrevented && !1 === t.returnValue)
                ? Lt
                : kt),
            (this.target =
              t.target && 3 === t.target.nodeType
                ? t.target.parentNode
                : t.target),
            (this.currentTarget = t.currentTarget),
            (this.relatedTarget = t.relatedTarget))
          : (this.type = t),
          e && S.extend(this, e),
          (this.timeStamp = (t && t.timeStamp) || Date.now()),
          (this[S.expando] = !0);
      }),
      (S.Event.prototype = {
        constructor: S.Event,
        isDefaultPrevented: kt,
        isPropagationStopped: kt,
        isImmediatePropagationStopped: kt,
        isSimulated: !1,
        preventDefault: function () {
          var t = this.originalEvent;
          (this.isDefaultPrevented = Lt),
            t && !this.isSimulated && t.preventDefault();
        },
        stopPropagation: function () {
          var t = this.originalEvent;
          (this.isPropagationStopped = Lt),
            t && !this.isSimulated && t.stopPropagation();
        },
        stopImmediatePropagation: function () {
          var t = this.originalEvent;
          (this.isImmediatePropagationStopped = Lt),
            t && !this.isSimulated && t.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      S.each(
        {
          altKey: !0,
          bubbles: !0,
          cancelable: !0,
          changedTouches: !0,
          ctrlKey: !0,
          detail: !0,
          eventPhase: !0,
          metaKey: !0,
          pageX: !0,
          pageY: !0,
          shiftKey: !0,
          view: !0,
          char: !0,
          code: !0,
          charCode: !0,
          key: !0,
          keyCode: !0,
          button: !0,
          buttons: !0,
          clientX: !0,
          clientY: !0,
          offsetX: !0,
          offsetY: !0,
          pointerId: !0,
          pointerType: !0,
          screenX: !0,
          screenY: !0,
          targetTouches: !0,
          toElement: !0,
          touches: !0,
          which: function (t) {
            var e = t.button;
            return null == t.which && wt.test(t.type)
              ? null != t.charCode
                ? t.charCode
                : t.keyCode
              : !t.which && void 0 !== e && St.test(t.type)
              ? 1 & e
                ? 1
                : 2 & e
                ? 3
                : 4 & e
                ? 2
                : 0
              : t.which;
          },
        },
        S.event.addProp
      ),
      S.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
        S.event.special[t] = {
          setup: function () {
            return At(this, t, xt), !1;
          },
          trigger: function () {
            return At(this, t), !0;
          },
          delegateType: e,
        };
      }),
      S.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (t, e) {
          S.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function (t) {
              var i,
                n = t.relatedTarget,
                o = t.handleObj;
              return (
                (n && (n === this || S.contains(this, n))) ||
                  ((t.type = o.origType),
                  (i = o.handler.apply(this, arguments)),
                  (t.type = e)),
                i
              );
            },
          };
        }
      ),
      S.fn.extend({
        on: function (t, e, i, n) {
          return Tt(this, t, e, i, n);
        },
        one: function (t, e, i, n) {
          return Tt(this, t, e, i, n, 1);
        },
        off: function (t, e, i) {
          var n, o;
          if (t && t.preventDefault && t.handleObj)
            return (
              (n = t.handleObj),
              S(t.delegateTarget).off(
                n.namespace ? n.origType + "." + n.namespace : n.origType,
                n.selector,
                n.handler
              ),
              this
            );
          if ("object" == typeof t) {
            for (o in t) this.off(o, e, t[o]);
            return this;
          }
          return (
            (!1 !== e && "function" != typeof e) || ((i = e), (e = void 0)),
            !1 === i && (i = kt),
            this.each(function () {
              S.event.remove(this, t, i, e);
            })
          );
        },
      });
    var Ct = /<script|<style|<link/i,
      qt = /checked\s*(?:[^=]|=\s*.checked.)/i,
      Pt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function _t(t, e) {
      return (
        (A(t, "table") &&
          A(11 !== e.nodeType ? e : e.firstChild, "tr") &&
          S(t).children("tbody")[0]) ||
        t
      );
    }
    function Dt(t) {
      return (t.type = (null !== t.getAttribute("type")) + "/" + t.type), t;
    }
    function It(t) {
      return (
        "true/" === (t.type || "").slice(0, 5)
          ? (t.type = t.type.slice(5))
          : t.removeAttribute("type"),
        t
      );
    }
    function Ot(t, e) {
      var i, n, o, r, s, a;
      if (1 === e.nodeType) {
        if (X.hasData(t) && (a = X.get(t).events))
          for (o in (X.remove(e, "handle events"), a))
            for (i = 0, n = a[o].length; i < n; i++) S.event.add(e, o, a[o][i]);
        Y.hasData(t) && ((r = Y.access(t)), (s = S.extend({}, r)), Y.set(e, s));
      }
    }
    function Ft(t, e, i, n) {
      e = r(e);
      var o,
        s,
        a,
        l,
        c,
        d,
        u = 0,
        h = t.length,
        m = h - 1,
        g = e[0],
        y = f(g);
      if (y || (1 < h && "string" == typeof g && !p.checkClone && qt.test(g)))
        return t.each(function (o) {
          var r = t.eq(o);
          y && (e[0] = g.call(this, o, r.html())), Ft(r, e, i, n);
        });
      if (
        h &&
        ((s = (o = bt(e, t[0].ownerDocument, !1, t, n)).firstChild),
        1 === o.childNodes.length && (o = s),
        s || n)
      ) {
        for (l = (a = S.map(gt(o, "script"), Dt)).length; u < h; u++)
          (c = o),
            u !== m &&
              ((c = S.clone(c, !0, !0)), l && S.merge(a, gt(c, "script"))),
            i.call(t[u], c, u);
        if (l)
          for (
            d = a[a.length - 1].ownerDocument, S.map(a, It), u = 0;
            u < l;
            u++
          )
            (c = a[u]),
              ft.test(c.type || "") &&
                !X.access(c, "globalEval") &&
                S.contains(d, c) &&
                (c.src && "module" !== (c.type || "").toLowerCase()
                  ? S._evalUrl &&
                    !c.noModule &&
                    S._evalUrl(
                      c.src,
                      { nonce: c.nonce || c.getAttribute("nonce") },
                      d
                    )
                  : v(c.textContent.replace(Pt, ""), c, d));
      }
      return t;
    }
    function Ht(t, e, i) {
      for (var n, o = e ? S.filter(e, t) : t, r = 0; null != (n = o[r]); r++)
        i || 1 !== n.nodeType || S.cleanData(gt(n)),
          n.parentNode &&
            (i && ot(n) && yt(gt(n, "script")), n.parentNode.removeChild(n));
      return t;
    }
    S.extend({
      htmlPrefilter: function (t) {
        return t;
      },
      clone: function (t, e, i) {
        var n,
          o,
          r,
          s,
          a,
          l,
          c,
          d = t.cloneNode(!0),
          u = ot(t);
        if (
          !(
            p.noCloneChecked ||
            (1 !== t.nodeType && 11 !== t.nodeType) ||
            S.isXMLDoc(t)
          )
        )
          for (s = gt(d), n = 0, o = (r = gt(t)).length; n < o; n++)
            (a = r[n]),
              "input" === (c = (l = s[n]).nodeName.toLowerCase()) &&
              ht.test(a.type)
                ? (l.checked = a.checked)
                : ("input" !== c && "textarea" !== c) ||
                  (l.defaultValue = a.defaultValue);
        if (e)
          if (i)
            for (
              r = r || gt(t), s = s || gt(d), n = 0, o = r.length;
              n < o;
              n++
            )
              Ot(r[n], s[n]);
          else Ot(t, d);
        return (
          0 < (s = gt(d, "script")).length && yt(s, !u && gt(t, "script")), d
        );
      },
      cleanData: function (t) {
        for (
          var e, i, n, o = S.event.special, r = 0;
          void 0 !== (i = t[r]);
          r++
        )
          if (G(i)) {
            if ((e = i[X.expando])) {
              if (e.events)
                for (n in e.events)
                  o[n] ? S.event.remove(i, n) : S.removeEvent(i, n, e.handle);
              i[X.expando] = void 0;
            }
            i[Y.expando] && (i[Y.expando] = void 0);
          }
      },
    }),
      S.fn.extend({
        detach: function (t) {
          return Ht(this, t, !0);
        },
        remove: function (t) {
          return Ht(this, t);
        },
        text: function (t) {
          return W(
            this,
            function (t) {
              return void 0 === t
                ? S.text(this)
                : this.empty().each(function () {
                    (1 !== this.nodeType &&
                      11 !== this.nodeType &&
                      9 !== this.nodeType) ||
                      (this.textContent = t);
                  });
            },
            null,
            t,
            arguments.length
          );
        },
        append: function () {
          return Ft(this, arguments, function (t) {
            (1 !== this.nodeType &&
              11 !== this.nodeType &&
              9 !== this.nodeType) ||
              _t(this, t).appendChild(t);
          });
        },
        prepend: function () {
          return Ft(this, arguments, function (t) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var e = _t(this, t);
              e.insertBefore(t, e.firstChild);
            }
          });
        },
        before: function () {
          return Ft(this, arguments, function (t) {
            this.parentNode && this.parentNode.insertBefore(t, this);
          });
        },
        after: function () {
          return Ft(this, arguments, function (t) {
            this.parentNode &&
              this.parentNode.insertBefore(t, this.nextSibling);
          });
        },
        empty: function () {
          for (var t, e = 0; null != (t = this[e]); e++)
            1 === t.nodeType && (S.cleanData(gt(t, !1)), (t.textContent = ""));
          return this;
        },
        clone: function (t, e) {
          return (
            (t = null != t && t),
            (e = null == e ? t : e),
            this.map(function () {
              return S.clone(this, t, e);
            })
          );
        },
        html: function (t) {
          return W(
            this,
            function (t) {
              var e = this[0] || {},
                i = 0,
                n = this.length;
              if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
              if (
                "string" == typeof t &&
                !Ct.test(t) &&
                !mt[(pt.exec(t) || ["", ""])[1].toLowerCase()]
              ) {
                t = S.htmlPrefilter(t);
                try {
                  for (; i < n; i++)
                    1 === (e = this[i] || {}).nodeType &&
                      (S.cleanData(gt(e, !1)), (e.innerHTML = t));
                  e = 0;
                } catch (t) {}
              }
              e && this.empty().append(t);
            },
            null,
            t,
            arguments.length
          );
        },
        replaceWith: function () {
          var t = [];
          return Ft(
            this,
            arguments,
            function (e) {
              var i = this.parentNode;
              S.inArray(this, t) < 0 &&
                (S.cleanData(gt(this)), i && i.replaceChild(e, this));
            },
            t
          );
        },
      }),
      S.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (t, e) {
          S.fn[t] = function (t) {
            for (var i, n = [], o = S(t), r = o.length - 1, a = 0; a <= r; a++)
              (i = a === r ? this : this.clone(!0)),
                S(o[a])[e](i),
                s.apply(n, i.get());
            return this.pushStack(n);
          };
        }
      );
    var Mt = new RegExp("^(" + tt + ")(?!px)[a-z%]+$", "i"),
      jt = function (e) {
        var i = e.ownerDocument.defaultView;
        return (i && i.opener) || (i = t), i.getComputedStyle(e);
      },
      Nt = function (t, e, i) {
        var n,
          o,
          r = {};
        for (o in e) (r[o] = t.style[o]), (t.style[o] = e[o]);
        for (o in ((n = i.call(t)), e)) t.style[o] = r[o];
        return n;
      },
      Bt = new RegExp(it.join("|"), "i");
    function $t(t, e, i) {
      var n,
        o,
        r,
        s,
        a = t.style;
      return (
        (i = i || jt(t)) &&
          ("" !== (s = i.getPropertyValue(e) || i[e]) ||
            ot(t) ||
            (s = S.style(t, e)),
          !p.pixelBoxStyles() &&
            Mt.test(s) &&
            Bt.test(e) &&
            ((n = a.width),
            (o = a.minWidth),
            (r = a.maxWidth),
            (a.minWidth = a.maxWidth = a.width = s),
            (s = i.width),
            (a.width = n),
            (a.minWidth = o),
            (a.maxWidth = r))),
        void 0 !== s ? s + "" : s
      );
    }
    function Wt(t, e) {
      return {
        get: function () {
          if (!t()) return (this.get = e).apply(this, arguments);
          delete this.get;
        },
      };
    }
    !(function () {
      function e() {
        if (d) {
          (c.style.cssText =
            "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
            (d.style.cssText =
              "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
            nt.appendChild(c).appendChild(d);
          var e = t.getComputedStyle(d);
          (n = "1%" !== e.top),
            (l = 12 === i(e.marginLeft)),
            (d.style.right = "60%"),
            (s = 36 === i(e.right)),
            (o = 36 === i(e.width)),
            (d.style.position = "absolute"),
            (r = 12 === i(d.offsetWidth / 3)),
            nt.removeChild(c),
            (d = null);
        }
      }
      function i(t) {
        return Math.round(parseFloat(t));
      }
      var n,
        o,
        r,
        s,
        a,
        l,
        c = g.createElement("div"),
        d = g.createElement("div");
      d.style &&
        ((d.style.backgroundClip = "content-box"),
        (d.cloneNode(!0).style.backgroundClip = ""),
        (p.clearCloneStyle = "content-box" === d.style.backgroundClip),
        S.extend(p, {
          boxSizingReliable: function () {
            return e(), o;
          },
          pixelBoxStyles: function () {
            return e(), s;
          },
          pixelPosition: function () {
            return e(), n;
          },
          reliableMarginLeft: function () {
            return e(), l;
          },
          scrollboxSize: function () {
            return e(), r;
          },
          reliableTrDimensions: function () {
            var e, i, n, o;
            return (
              null == a &&
                ((e = g.createElement("table")),
                (i = g.createElement("tr")),
                (n = g.createElement("div")),
                (e.style.cssText = "position:absolute;left:-11111px"),
                (i.style.height = "1px"),
                (n.style.height = "9px"),
                nt.appendChild(e).appendChild(i).appendChild(n),
                (o = t.getComputedStyle(i)),
                (a = 3 < parseInt(o.height)),
                nt.removeChild(e)),
              a
            );
          },
        }));
    })();
    var zt = ["Webkit", "Moz", "ms"],
      Rt = g.createElement("div").style,
      Vt = {};
    function Ut(t) {
      return (
        S.cssProps[t] ||
        Vt[t] ||
        (t in Rt
          ? t
          : (Vt[t] =
              (function (t) {
                for (
                  var e = t[0].toUpperCase() + t.slice(1), i = zt.length;
                  i--;

                )
                  if ((t = zt[i] + e) in Rt) return t;
              })(t) || t))
      );
    }
    var Gt = /^(none|table(?!-c[ea]).+)/,
      Kt = /^--/,
      Xt = { position: "absolute", visibility: "hidden", display: "block" },
      Yt = { letterSpacing: "0", fontWeight: "400" };
    function Qt(t, e, i) {
      var n = et.exec(e);
      return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e;
    }
    function Jt(t, e, i, n, o, r) {
      var s = "width" === e ? 1 : 0,
        a = 0,
        l = 0;
      if (i === (n ? "border" : "content")) return 0;
      for (; s < 4; s += 2)
        "margin" === i && (l += S.css(t, i + it[s], !0, o)),
          n
            ? ("content" === i && (l -= S.css(t, "padding" + it[s], !0, o)),
              "margin" !== i &&
                (l -= S.css(t, "border" + it[s] + "Width", !0, o)))
            : ((l += S.css(t, "padding" + it[s], !0, o)),
              "padding" !== i
                ? (l += S.css(t, "border" + it[s] + "Width", !0, o))
                : (a += S.css(t, "border" + it[s] + "Width", !0, o)));
      return (
        !n &&
          0 <= r &&
          (l +=
            Math.max(
              0,
              Math.ceil(
                t["offset" + e[0].toUpperCase() + e.slice(1)] - r - l - a - 0.5
              )
            ) || 0),
        l
      );
    }
    function Zt(t, e, i) {
      var n = jt(t),
        o =
          (!p.boxSizingReliable() || i) &&
          "border-box" === S.css(t, "boxSizing", !1, n),
        r = o,
        s = $t(t, e, n),
        a = "offset" + e[0].toUpperCase() + e.slice(1);
      if (Mt.test(s)) {
        if (!i) return s;
        s = "auto";
      }
      return (
        ((!p.boxSizingReliable() && o) ||
          (!p.reliableTrDimensions() && A(t, "tr")) ||
          "auto" === s ||
          (!parseFloat(s) && "inline" === S.css(t, "display", !1, n))) &&
          t.getClientRects().length &&
          ((o = "border-box" === S.css(t, "boxSizing", !1, n)),
          (r = a in t) && (s = t[a])),
        (s = parseFloat(s) || 0) +
          Jt(t, e, i || (o ? "border" : "content"), r, n, s) +
          "px"
      );
    }
    function te(t, e, i, n, o) {
      return new te.prototype.init(t, e, i, n, o);
    }
    S.extend({
      cssHooks: {
        opacity: {
          get: function (t, e) {
            if (e) {
              var i = $t(t, "opacity");
              return "" === i ? "1" : i;
            }
          },
        },
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: {},
      style: function (t, e, i, n) {
        if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
          var o,
            r,
            s,
            a = U(e),
            l = Kt.test(e),
            c = t.style;
          if (
            (l || (e = Ut(a)),
            (s = S.cssHooks[e] || S.cssHooks[a]),
            void 0 === i)
          )
            return s && "get" in s && void 0 !== (o = s.get(t, !1, n))
              ? o
              : c[e];
          "string" == (r = typeof i) &&
            (o = et.exec(i)) &&
            o[1] &&
            ((i = at(t, e, o)), (r = "number")),
            null != i &&
              i == i &&
              ("number" !== r ||
                l ||
                (i += (o && o[3]) || (S.cssNumber[a] ? "" : "px")),
              p.clearCloneStyle ||
                "" !== i ||
                0 !== e.indexOf("background") ||
                (c[e] = "inherit"),
              (s && "set" in s && void 0 === (i = s.set(t, i, n))) ||
                (l ? c.setProperty(e, i) : (c[e] = i)));
        }
      },
      css: function (t, e, i, n) {
        var o,
          r,
          s,
          a = U(e);
        return (
          Kt.test(e) || (e = Ut(a)),
          (s = S.cssHooks[e] || S.cssHooks[a]) &&
            "get" in s &&
            (o = s.get(t, !0, i)),
          void 0 === o && (o = $t(t, e, n)),
          "normal" === o && e in Yt && (o = Yt[e]),
          "" === i || i
            ? ((r = parseFloat(o)), !0 === i || isFinite(r) ? r || 0 : o)
            : o
        );
      },
    }),
      S.each(["height", "width"], function (t, e) {
        S.cssHooks[e] = {
          get: function (t, i, n) {
            if (i)
              return !Gt.test(S.css(t, "display")) ||
                (t.getClientRects().length && t.getBoundingClientRect().width)
                ? Zt(t, e, n)
                : Nt(t, Xt, function () {
                    return Zt(t, e, n);
                  });
          },
          set: function (t, i, n) {
            var o,
              r = jt(t),
              s = !p.scrollboxSize() && "absolute" === r.position,
              a = (s || n) && "border-box" === S.css(t, "boxSizing", !1, r),
              l = n ? Jt(t, e, n, a, r) : 0;
            return (
              a &&
                s &&
                (l -= Math.ceil(
                  t["offset" + e[0].toUpperCase() + e.slice(1)] -
                    parseFloat(r[e]) -
                    Jt(t, e, "border", !1, r) -
                    0.5
                )),
              l &&
                (o = et.exec(i)) &&
                "px" !== (o[3] || "px") &&
                ((t.style[e] = i), (i = S.css(t, e))),
              Qt(0, i, l)
            );
          },
        };
      }),
      (S.cssHooks.marginLeft = Wt(p.reliableMarginLeft, function (t, e) {
        if (e)
          return (
            (parseFloat($t(t, "marginLeft")) ||
              t.getBoundingClientRect().left -
                Nt(t, { marginLeft: 0 }, function () {
                  return t.getBoundingClientRect().left;
                })) + "px"
          );
      })),
      S.each({ margin: "", padding: "", border: "Width" }, function (t, e) {
        (S.cssHooks[t + e] = {
          expand: function (i) {
            for (
              var n = 0, o = {}, r = "string" == typeof i ? i.split(" ") : [i];
              n < 4;
              n++
            )
              o[t + it[n] + e] = r[n] || r[n - 2] || r[0];
            return o;
          },
        }),
          "margin" !== t && (S.cssHooks[t + e].set = Qt);
      }),
      S.fn.extend({
        css: function (t, e) {
          return W(
            this,
            function (t, e, i) {
              var n,
                o,
                r = {},
                s = 0;
              if (Array.isArray(e)) {
                for (n = jt(t), o = e.length; s < o; s++)
                  r[e[s]] = S.css(t, e[s], !1, n);
                return r;
              }
              return void 0 !== i ? S.style(t, e, i) : S.css(t, e);
            },
            t,
            e,
            1 < arguments.length
          );
        },
      }),
      (((S.Tween = te).prototype = {
        constructor: te,
        init: function (t, e, i, n, o, r) {
          (this.elem = t),
            (this.prop = i),
            (this.easing = o || S.easing._default),
            (this.options = e),
            (this.start = this.now = this.cur()),
            (this.end = n),
            (this.unit = r || (S.cssNumber[i] ? "" : "px"));
        },
        cur: function () {
          var t = te.propHooks[this.prop];
          return t && t.get ? t.get(this) : te.propHooks._default.get(this);
        },
        run: function (t) {
          var e,
            i = te.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = e =
                  S.easing[this.easing](
                    t,
                    this.options.duration * t,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = e = t),
            (this.now = (this.end - this.start) * e + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            i && i.set ? i.set(this) : te.propHooks._default.set(this),
            this
          );
        },
      }).init.prototype = te.prototype),
      ((te.propHooks = {
        _default: {
          get: function (t) {
            var e;
            return 1 !== t.elem.nodeType ||
              (null != t.elem[t.prop] && null == t.elem.style[t.prop])
              ? t.elem[t.prop]
              : (e = S.css(t.elem, t.prop, "")) && "auto" !== e
              ? e
              : 0;
          },
          set: function (t) {
            S.fx.step[t.prop]
              ? S.fx.step[t.prop](t)
              : 1 !== t.elem.nodeType ||
                (!S.cssHooks[t.prop] && null == t.elem.style[Ut(t.prop)])
              ? (t.elem[t.prop] = t.now)
              : S.style(t.elem, t.prop, t.now + t.unit);
          },
        },
      }).scrollTop = te.propHooks.scrollLeft =
        {
          set: function (t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
          },
        }),
      (S.easing = {
        linear: function (t) {
          return t;
        },
        swing: function (t) {
          return 0.5 - Math.cos(t * Math.PI) / 2;
        },
        _default: "swing",
      }),
      (S.fx = te.prototype.init),
      (S.fx.step = {});
    var ee,
      ie,
      ne,
      oe,
      re = /^(?:toggle|show|hide)$/,
      se = /queueHooks$/;
    function ae() {
      ie &&
        (!1 === g.hidden && t.requestAnimationFrame
          ? t.requestAnimationFrame(ae)
          : t.setTimeout(ae, S.fx.interval),
        S.fx.tick());
    }
    function le() {
      return (
        t.setTimeout(function () {
          ee = void 0;
        }),
        (ee = Date.now())
      );
    }
    function ce(t, e) {
      var i,
        n = 0,
        o = { height: t };
      for (e = e ? 1 : 0; n < 4; n += 2 - e)
        o["margin" + (i = it[n])] = o["padding" + i] = t;
      return e && (o.opacity = o.width = t), o;
    }
    function de(t, e, i) {
      for (
        var n,
          o = (ue.tweeners[e] || []).concat(ue.tweeners["*"]),
          r = 0,
          s = o.length;
        r < s;
        r++
      )
        if ((n = o[r].call(i, e, t))) return n;
    }
    function ue(t, e, i) {
      var n,
        o,
        r = 0,
        s = ue.prefilters.length,
        a = S.Deferred().always(function () {
          delete l.elem;
        }),
        l = function () {
          if (o) return !1;
          for (
            var e = ee || le(),
              i = Math.max(0, c.startTime + c.duration - e),
              n = 1 - (i / c.duration || 0),
              r = 0,
              s = c.tweens.length;
            r < s;
            r++
          )
            c.tweens[r].run(n);
          return (
            a.notifyWith(t, [c, n, i]),
            n < 1 && s
              ? i
              : (s || a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c]), !1)
          );
        },
        c = a.promise({
          elem: t,
          props: S.extend({}, e),
          opts: S.extend(
            !0,
            { specialEasing: {}, easing: S.easing._default },
            i
          ),
          originalProperties: e,
          originalOptions: i,
          startTime: ee || le(),
          duration: i.duration,
          tweens: [],
          createTween: function (e, i) {
            var n = S.Tween(
              t,
              c.opts,
              e,
              i,
              c.opts.specialEasing[e] || c.opts.easing
            );
            return c.tweens.push(n), n;
          },
          stop: function (e) {
            var i = 0,
              n = e ? c.tweens.length : 0;
            if (o) return this;
            for (o = !0; i < n; i++) c.tweens[i].run(1);
            return (
              e
                ? (a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c, e]))
                : a.rejectWith(t, [c, e]),
              this
            );
          },
        }),
        d = c.props;
      for (
        (function (t, e) {
          var i, n, o, r, s;
          for (i in t)
            if (
              ((o = e[(n = U(i))]),
              (r = t[i]),
              Array.isArray(r) && ((o = r[1]), (r = t[i] = r[0])),
              i !== n && ((t[n] = r), delete t[i]),
              (s = S.cssHooks[n]) && ("expand" in s))
            )
              for (i in ((r = s.expand(r)), delete t[n], r))
                (i in t) || ((t[i] = r[i]), (e[i] = o));
            else e[n] = o;
        })(d, c.opts.specialEasing);
        r < s;
        r++
      )
        if ((n = ue.prefilters[r].call(c, t, d, c.opts)))
          return (
            f(n.stop) &&
              (S._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)),
            n
          );
      return (
        S.map(d, de, c),
        f(c.opts.start) && c.opts.start.call(t, c),
        c
          .progress(c.opts.progress)
          .done(c.opts.done, c.opts.complete)
          .fail(c.opts.fail)
          .always(c.opts.always),
        S.fx.timer(S.extend(l, { elem: t, anim: c, queue: c.opts.queue })),
        c
      );
    }
    (S.Animation = S.extend(ue, {
      tweeners: {
        "*": [
          function (t, e) {
            var i = this.createTween(t, e);
            return at(i.elem, t, et.exec(e), i), i;
          },
        ],
      },
      tweener: function (t, e) {
        f(t) ? ((e = t), (t = ["*"])) : (t = t.match(F));
        for (var i, n = 0, o = t.length; n < o; n++)
          (i = t[n]),
            (ue.tweeners[i] = ue.tweeners[i] || []),
            ue.tweeners[i].unshift(e);
      },
      prefilters: [
        function (t, e, i) {
          var n,
            o,
            r,
            s,
            a,
            l,
            c,
            d,
            u = "width" in e || "height" in e,
            h = this,
            p = {},
            f = t.style,
            m = t.nodeType && st(t),
            g = X.get(t, "fxshow");
          for (n in (i.queue ||
            (null == (s = S._queueHooks(t, "fx")).unqueued &&
              ((s.unqueued = 0),
              (a = s.empty.fire),
              (s.empty.fire = function () {
                s.unqueued || a();
              })),
            s.unqueued++,
            h.always(function () {
              h.always(function () {
                s.unqueued--, S.queue(t, "fx").length || s.empty.fire();
              });
            })),
          e))
            if (((o = e[n]), re.test(o))) {
              if (
                (delete e[n],
                (r = r || "toggle" === o),
                o === (m ? "hide" : "show"))
              ) {
                if ("show" !== o || !g || void 0 === g[n]) continue;
                m = !0;
              }
              p[n] = (g && g[n]) || S.style(t, n);
            }
          if ((l = !S.isEmptyObject(e)) || !S.isEmptyObject(p))
            for (n in (u &&
              1 === t.nodeType &&
              ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
              null == (c = g && g.display) && (c = X.get(t, "display")),
              "none" === (d = S.css(t, "display")) &&
                (c
                  ? (d = c)
                  : (ct([t], !0),
                    (c = t.style.display || c),
                    (d = S.css(t, "display")),
                    ct([t]))),
              ("inline" === d || ("inline-block" === d && null != c)) &&
                "none" === S.css(t, "float") &&
                (l ||
                  (h.done(function () {
                    f.display = c;
                  }),
                  null == c && ((d = f.display), (c = "none" === d ? "" : d))),
                (f.display = "inline-block"))),
            i.overflow &&
              ((f.overflow = "hidden"),
              h.always(function () {
                (f.overflow = i.overflow[0]),
                  (f.overflowX = i.overflow[1]),
                  (f.overflowY = i.overflow[2]);
              })),
            (l = !1),
            p))
              l ||
                (g
                  ? "hidden" in g && (m = g.hidden)
                  : (g = X.access(t, "fxshow", { display: c })),
                r && (g.hidden = !m),
                m && ct([t], !0),
                h.done(function () {
                  for (n in (m || ct([t]), X.remove(t, "fxshow"), p))
                    S.style(t, n, p[n]);
                })),
                (l = de(m ? g[n] : 0, n, h)),
                n in g ||
                  ((g[n] = l.start), m && ((l.end = l.start), (l.start = 0)));
        },
      ],
      prefilter: function (t, e) {
        e ? ue.prefilters.unshift(t) : ue.prefilters.push(t);
      },
    })),
      (S.speed = function (t, e, i) {
        var n =
          t && "object" == typeof t
            ? S.extend({}, t)
            : {
                complete: i || (!i && e) || (f(t) && t),
                duration: t,
                easing: (i && e) || (e && !f(e) && e),
              };
        return (
          S.fx.off
            ? (n.duration = 0)
            : "number" != typeof n.duration &&
              (n.duration in S.fx.speeds
                ? (n.duration = S.fx.speeds[n.duration])
                : (n.duration = S.fx.speeds._default)),
          (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
          (n.old = n.complete),
          (n.complete = function () {
            f(n.old) && n.old.call(this), n.queue && S.dequeue(this, n.queue);
          }),
          n
        );
      }),
      S.fn.extend({
        fadeTo: function (t, e, i, n) {
          return this.filter(st)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: e }, t, i, n);
        },
        animate: function (t, e, i, n) {
          var o = S.isEmptyObject(t),
            r = S.speed(e, i, n),
            s = function () {
              var e = ue(this, S.extend({}, t), r);
              (o || X.get(this, "finish")) && e.stop(!0);
            };
          return (
            (s.finish = s),
            o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s)
          );
        },
        stop: function (t, e, i) {
          var n = function (t) {
            var e = t.stop;
            delete t.stop, e(i);
          };
          return (
            "string" != typeof t && ((i = e), (e = t), (t = void 0)),
            e && this.queue(t || "fx", []),
            this.each(function () {
              var e = !0,
                o = null != t && t + "queueHooks",
                r = S.timers,
                s = X.get(this);
              if (o) s[o] && s[o].stop && n(s[o]);
              else for (o in s) s[o] && s[o].stop && se.test(o) && n(s[o]);
              for (o = r.length; o--; )
                r[o].elem !== this ||
                  (null != t && r[o].queue !== t) ||
                  (r[o].anim.stop(i), (e = !1), r.splice(o, 1));
              (!e && i) || S.dequeue(this, t);
            })
          );
        },
        finish: function (t) {
          return (
            !1 !== t && (t = t || "fx"),
            this.each(function () {
              var e,
                i = X.get(this),
                n = i[t + "queue"],
                o = i[t + "queueHooks"],
                r = S.timers,
                s = n ? n.length : 0;
              for (
                i.finish = !0,
                  S.queue(this, t, []),
                  o && o.stop && o.stop.call(this, !0),
                  e = r.length;
                e--;

              )
                r[e].elem === this &&
                  r[e].queue === t &&
                  (r[e].anim.stop(!0), r.splice(e, 1));
              for (e = 0; e < s; e++)
                n[e] && n[e].finish && n[e].finish.call(this);
              delete i.finish;
            })
          );
        },
      }),
      S.each(["toggle", "show", "hide"], function (t, e) {
        var i = S.fn[e];
        S.fn[e] = function (t, n, o) {
          return null == t || "boolean" == typeof t
            ? i.apply(this, arguments)
            : this.animate(ce(e, !0), t, n, o);
        };
      }),
      S.each(
        {
          slideDown: ce("show"),
          slideUp: ce("hide"),
          slideToggle: ce("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (t, e) {
          S.fn[t] = function (t, i, n) {
            return this.animate(e, t, i, n);
          };
        }
      ),
      (S.timers = []),
      (S.fx.tick = function () {
        var t,
          e = 0,
          i = S.timers;
        for (ee = Date.now(); e < i.length; e++)
          (t = i[e])() || i[e] !== t || i.splice(e--, 1);
        i.length || S.fx.stop(), (ee = void 0);
      }),
      (S.fx.timer = function (t) {
        S.timers.push(t), S.fx.start();
      }),
      (S.fx.interval = 13),
      (S.fx.start = function () {
        ie || ((ie = !0), ae());
      }),
      (S.fx.stop = function () {
        ie = null;
      }),
      (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (S.fn.delay = function (e, i) {
        return (
          (e = (S.fx && S.fx.speeds[e]) || e),
          (i = i || "fx"),
          this.queue(i, function (i, n) {
            var o = t.setTimeout(i, e);
            n.stop = function () {
              t.clearTimeout(o);
            };
          })
        );
      }),
      (ne = g.createElement("input")),
      (oe = g.createElement("select").appendChild(g.createElement("option"))),
      (ne.type = "checkbox"),
      (p.checkOn = "" !== ne.value),
      (p.optSelected = oe.selected),
      ((ne = g.createElement("input")).value = "t"),
      (ne.type = "radio"),
      (p.radioValue = "t" === ne.value);
    var he,
      pe = S.expr.attrHandle;
    S.fn.extend({
      attr: function (t, e) {
        return W(this, S.attr, t, e, 1 < arguments.length);
      },
      removeAttr: function (t) {
        return this.each(function () {
          S.removeAttr(this, t);
        });
      },
    }),
      S.extend({
        attr: function (t, e, i) {
          var n,
            o,
            r = t.nodeType;
          if (3 !== r && 8 !== r && 2 !== r)
            return void 0 === t.getAttribute
              ? S.prop(t, e, i)
              : ((1 === r && S.isXMLDoc(t)) ||
                  (o =
                    S.attrHooks[e.toLowerCase()] ||
                    (S.expr.match.bool.test(e) ? he : void 0)),
                void 0 !== i
                  ? null === i
                    ? void S.removeAttr(t, e)
                    : o && "set" in o && void 0 !== (n = o.set(t, i, e))
                    ? n
                    : (t.setAttribute(e, i + ""), i)
                  : o && "get" in o && null !== (n = o.get(t, e))
                  ? n
                  : null == (n = S.find.attr(t, e))
                  ? void 0
                  : n);
        },
        attrHooks: {
          type: {
            set: function (t, e) {
              if (!p.radioValue && "radio" === e && A(t, "input")) {
                var i = t.value;
                return t.setAttribute("type", e), i && (t.value = i), e;
              }
            },
          },
        },
        removeAttr: function (t, e) {
          var i,
            n = 0,
            o = e && e.match(F);
          if (o && 1 === t.nodeType)
            for (; (i = o[n++]); ) t.removeAttribute(i);
        },
      }),
      (he = {
        set: function (t, e, i) {
          return !1 === e ? S.removeAttr(t, i) : t.setAttribute(i, i), i;
        },
      }),
      S.each(S.expr.match.bool.source.match(/\w+/g), function (t, e) {
        var i = pe[e] || S.find.attr;
        pe[e] = function (t, e, n) {
          var o,
            r,
            s = e.toLowerCase();
          return (
            n ||
              ((r = pe[s]),
              (pe[s] = o),
              (o = null != i(t, e, n) ? s : null),
              (pe[s] = r)),
            o
          );
        };
      });
    var fe = /^(?:input|select|textarea|button)$/i,
      me = /^(?:a|area)$/i;
    function ge(t) {
      return (t.match(F) || []).join(" ");
    }
    function ye(t) {
      return (t.getAttribute && t.getAttribute("class")) || "";
    }
    function ve(t) {
      return Array.isArray(t) ? t : ("string" == typeof t && t.match(F)) || [];
    }
    S.fn.extend({
      prop: function (t, e) {
        return W(this, S.prop, t, e, 1 < arguments.length);
      },
      removeProp: function (t) {
        return this.each(function () {
          delete this[S.propFix[t] || t];
        });
      },
    }),
      S.extend({
        prop: function (t, e, i) {
          var n,
            o,
            r = t.nodeType;
          if (3 !== r && 8 !== r && 2 !== r)
            return (
              (1 === r && S.isXMLDoc(t)) ||
                ((e = S.propFix[e] || e), (o = S.propHooks[e])),
              void 0 !== i
                ? o && "set" in o && void 0 !== (n = o.set(t, i, e))
                  ? n
                  : (t[e] = i)
                : o && "get" in o && null !== (n = o.get(t, e))
                ? n
                : t[e]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (t) {
              var e = S.find.attr(t, "tabindex");
              return e
                ? parseInt(e, 10)
                : fe.test(t.nodeName) || (me.test(t.nodeName) && t.href)
                ? 0
                : -1;
            },
          },
        },
        propFix: { for: "htmlFor", class: "className" },
      }),
      p.optSelected ||
        (S.propHooks.selected = {
          get: function (t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex, null;
          },
          set: function (t) {
            var e = t.parentNode;
            e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
          },
        }),
      S.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          S.propFix[this.toLowerCase()] = this;
        }
      ),
      S.fn.extend({
        addClass: function (t) {
          var e,
            i,
            n,
            o,
            r,
            s,
            a,
            l = 0;
          if (f(t))
            return this.each(function (e) {
              S(this).addClass(t.call(this, e, ye(this)));
            });
          if ((e = ve(t)).length)
            for (; (i = this[l++]); )
              if (((o = ye(i)), (n = 1 === i.nodeType && " " + ge(o) + " "))) {
                for (s = 0; (r = e[s++]); )
                  n.indexOf(" " + r + " ") < 0 && (n += r + " ");
                o !== (a = ge(n)) && i.setAttribute("class", a);
              }
          return this;
        },
        removeClass: function (t) {
          var e,
            i,
            n,
            o,
            r,
            s,
            a,
            l = 0;
          if (f(t))
            return this.each(function (e) {
              S(this).removeClass(t.call(this, e, ye(this)));
            });
          if (!arguments.length) return this.attr("class", "");
          if ((e = ve(t)).length)
            for (; (i = this[l++]); )
              if (((o = ye(i)), (n = 1 === i.nodeType && " " + ge(o) + " "))) {
                for (s = 0; (r = e[s++]); )
                  for (; -1 < n.indexOf(" " + r + " "); )
                    n = n.replace(" " + r + " ", " ");
                o !== (a = ge(n)) && i.setAttribute("class", a);
              }
          return this;
        },
        toggleClass: function (t, e) {
          var i = typeof t,
            n = "string" === i || Array.isArray(t);
          return "boolean" == typeof e && n
            ? e
              ? this.addClass(t)
              : this.removeClass(t)
            : f(t)
            ? this.each(function (i) {
                S(this).toggleClass(t.call(this, i, ye(this), e), e);
              })
            : this.each(function () {
                var e, o, r, s;
                if (n)
                  for (o = 0, r = S(this), s = ve(t); (e = s[o++]); )
                    r.hasClass(e) ? r.removeClass(e) : r.addClass(e);
                else
                  (void 0 !== t && "boolean" !== i) ||
                    ((e = ye(this)) && X.set(this, "__className__", e),
                    this.setAttribute &&
                      this.setAttribute(
                        "class",
                        e || !1 === t ? "" : X.get(this, "__className__") || ""
                      ));
              });
        },
        hasClass: function (t) {
          var e,
            i,
            n = 0;
          for (e = " " + t + " "; (i = this[n++]); )
            if (1 === i.nodeType && -1 < (" " + ge(ye(i)) + " ").indexOf(e))
              return !0;
          return !1;
        },
      });
    var be = /\r/g;
    S.fn.extend({
      val: function (t) {
        var e,
          i,
          n,
          o = this[0];
        return arguments.length
          ? ((n = f(t)),
            this.each(function (i) {
              var o;
              1 === this.nodeType &&
                (null == (o = n ? t.call(this, i, S(this).val()) : t)
                  ? (o = "")
                  : "number" == typeof o
                  ? (o += "")
                  : Array.isArray(o) &&
                    (o = S.map(o, function (t) {
                      return null == t ? "" : t + "";
                    })),
                ((e =
                  S.valHooks[this.type] ||
                  S.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in e &&
                  void 0 !== e.set(this, o, "value")) ||
                  (this.value = o));
            }))
          : o
          ? (e = S.valHooks[o.type] || S.valHooks[o.nodeName.toLowerCase()]) &&
            "get" in e &&
            void 0 !== (i = e.get(o, "value"))
            ? i
            : "string" == typeof (i = o.value)
            ? i.replace(be, "")
            : null == i
            ? ""
            : i
          : void 0;
      },
    }),
      S.extend({
        valHooks: {
          option: {
            get: function (t) {
              var e = S.find.attr(t, "value");
              return null != e ? e : ge(S.text(t));
            },
          },
          select: {
            get: function (t) {
              var e,
                i,
                n,
                o = t.options,
                r = t.selectedIndex,
                s = "select-one" === t.type,
                a = s ? null : [],
                l = s ? r + 1 : o.length;
              for (n = r < 0 ? l : s ? r : 0; n < l; n++)
                if (
                  ((i = o[n]).selected || n === r) &&
                  !i.disabled &&
                  (!i.parentNode.disabled || !A(i.parentNode, "optgroup"))
                ) {
                  if (((e = S(i).val()), s)) return e;
                  a.push(e);
                }
              return a;
            },
            set: function (t, e) {
              for (
                var i, n, o = t.options, r = S.makeArray(e), s = o.length;
                s--;

              )
                ((n = o[s]).selected =
                  -1 < S.inArray(S.valHooks.option.get(n), r)) && (i = !0);
              return i || (t.selectedIndex = -1), r;
            },
          },
        },
      }),
      S.each(["radio", "checkbox"], function () {
        (S.valHooks[this] = {
          set: function (t, e) {
            if (Array.isArray(e))
              return (t.checked = -1 < S.inArray(S(t).val(), e));
          },
        }),
          p.checkOn ||
            (S.valHooks[this].get = function (t) {
              return null === t.getAttribute("value") ? "on" : t.value;
            });
      }),
      (p.focusin = "onfocusin" in t);
    var we = /^(?:focusinfocus|focusoutblur)$/,
      Se = function (t) {
        t.stopPropagation();
      };
    S.extend(S.event, {
      trigger: function (e, i, n, o) {
        var r,
          s,
          a,
          l,
          c,
          u,
          h,
          p,
          y = [n || g],
          v = d.call(e, "type") ? e.type : e,
          b = d.call(e, "namespace") ? e.namespace.split(".") : [];
        if (
          ((s = p = a = n = n || g),
          3 !== n.nodeType &&
            8 !== n.nodeType &&
            !we.test(v + S.event.triggered) &&
            (-1 < v.indexOf(".") &&
              ((v = (b = v.split(".")).shift()), b.sort()),
            (c = v.indexOf(":") < 0 && "on" + v),
            ((e = e[S.expando]
              ? e
              : new S.Event(v, "object" == typeof e && e)).isTrigger = o
              ? 2
              : 3),
            (e.namespace = b.join(".")),
            (e.rnamespace = e.namespace
              ? new RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (e.result = void 0),
            e.target || (e.target = n),
            (i = null == i ? [e] : S.makeArray(i, [e])),
            (h = S.event.special[v] || {}),
            o || !h.trigger || !1 !== h.trigger.apply(n, i)))
        ) {
          if (!o && !h.noBubble && !m(n)) {
            for (
              l = h.delegateType || v, we.test(l + v) || (s = s.parentNode);
              s;
              s = s.parentNode
            )
              y.push(s), (a = s);
            a === (n.ownerDocument || g) &&
              y.push(a.defaultView || a.parentWindow || t);
          }
          for (r = 0; (s = y[r++]) && !e.isPropagationStopped(); )
            (p = s),
              (e.type = 1 < r ? l : h.bindType || v),
              (u =
                (X.get(s, "events") || Object.create(null))[e.type] &&
                X.get(s, "handle")) && u.apply(s, i),
              (u = c && s[c]) &&
                u.apply &&
                G(s) &&
                ((e.result = u.apply(s, i)),
                !1 === e.result && e.preventDefault());
          return (
            (e.type = v),
            o ||
              e.isDefaultPrevented() ||
              (h._default && !1 !== h._default.apply(y.pop(), i)) ||
              !G(n) ||
              (c &&
                f(n[v]) &&
                !m(n) &&
                ((a = n[c]) && (n[c] = null),
                (S.event.triggered = v),
                e.isPropagationStopped() && p.addEventListener(v, Se),
                n[v](),
                e.isPropagationStopped() && p.removeEventListener(v, Se),
                (S.event.triggered = void 0),
                a && (n[c] = a))),
            e.result
          );
        }
      },
      simulate: function (t, e, i) {
        var n = S.extend(new S.Event(), i, { type: t, isSimulated: !0 });
        S.event.trigger(n, null, e);
      },
    }),
      S.fn.extend({
        trigger: function (t, e) {
          return this.each(function () {
            S.event.trigger(t, e, this);
          });
        },
        triggerHandler: function (t, e) {
          var i = this[0];
          if (i) return S.event.trigger(t, e, i, !0);
        },
      }),
      p.focusin ||
        S.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
          var i = function (t) {
            S.event.simulate(e, t.target, S.event.fix(t));
          };
          S.event.special[e] = {
            setup: function () {
              var n = this.ownerDocument || this.document || this,
                o = X.access(n, e);
              o || n.addEventListener(t, i, !0), X.access(n, e, (o || 0) + 1);
            },
            teardown: function () {
              var n = this.ownerDocument || this.document || this,
                o = X.access(n, e) - 1;
              o
                ? X.access(n, e, o)
                : (n.removeEventListener(t, i, !0), X.remove(n, e));
            },
          };
        });
    var Ee = t.location,
      Le = { guid: Date.now() },
      ke = /\?/;
    S.parseXML = function (e) {
      var i;
      if (!e || "string" != typeof e) return null;
      try {
        i = new t.DOMParser().parseFromString(e, "text/xml");
      } catch (e) {
        i = void 0;
      }
      return (
        (i && !i.getElementsByTagName("parsererror").length) ||
          S.error("Invalid XML: " + e),
        i
      );
    };
    var xe = /\[\]$/,
      Te = /\r?\n/g,
      Ae = /^(?:submit|button|image|reset|file)$/i,
      Ce = /^(?:input|select|textarea|keygen)/i;
    function qe(t, e, i, n) {
      var o;
      if (Array.isArray(e))
        S.each(e, function (e, o) {
          i || xe.test(t)
            ? n(t, o)
            : qe(
                t + "[" + ("object" == typeof o && null != o ? e : "") + "]",
                o,
                i,
                n
              );
        });
      else if (i || "object" !== b(e)) n(t, e);
      else for (o in e) qe(t + "[" + o + "]", e[o], i, n);
    }
    (S.param = function (t, e) {
      var i,
        n = [],
        o = function (t, e) {
          var i = f(e) ? e() : e;
          n[n.length] =
            encodeURIComponent(t) +
            "=" +
            encodeURIComponent(null == i ? "" : i);
        };
      if (null == t) return "";
      if (Array.isArray(t) || (t.jquery && !S.isPlainObject(t)))
        S.each(t, function () {
          o(this.name, this.value);
        });
      else for (i in t) qe(i, t[i], e, o);
      return n.join("&");
    }),
      S.fn.extend({
        serialize: function () {
          return S.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var t = S.prop(this, "elements");
            return t ? S.makeArray(t) : this;
          })
            .filter(function () {
              var t = this.type;
              return (
                this.name &&
                !S(this).is(":disabled") &&
                Ce.test(this.nodeName) &&
                !Ae.test(t) &&
                (this.checked || !ht.test(t))
              );
            })
            .map(function (t, e) {
              var i = S(this).val();
              return null == i
                ? null
                : Array.isArray(i)
                ? S.map(i, function (t) {
                    return { name: e.name, value: t.replace(Te, "\r\n") };
                  })
                : { name: e.name, value: i.replace(Te, "\r\n") };
            })
            .get();
        },
      });
    var Pe = /%20/g,
      _e = /#.*$/,
      De = /([?&])_=[^&]*/,
      Ie = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      Oe = /^(?:GET|HEAD)$/,
      Fe = /^\/\//,
      He = {},
      Me = {},
      je = "*/".concat("*"),
      Ne = g.createElement("a");
    function Be(t) {
      return function (e, i) {
        "string" != typeof e && ((i = e), (e = "*"));
        var n,
          o = 0,
          r = e.toLowerCase().match(F) || [];
        if (f(i))
          for (; (n = r[o++]); )
            "+" === n[0]
              ? ((n = n.slice(1) || "*"), (t[n] = t[n] || []).unshift(i))
              : (t[n] = t[n] || []).push(i);
      };
    }
    function $e(t, e, i, n) {
      var o = {},
        r = t === Me;
      function s(a) {
        var l;
        return (
          (o[a] = !0),
          S.each(t[a] || [], function (t, a) {
            var c = a(e, i, n);
            return "string" != typeof c || r || o[c]
              ? r
                ? !(l = c)
                : void 0
              : (e.dataTypes.unshift(c), s(c), !1);
          }),
          l
        );
      }
      return s(e.dataTypes[0]) || (!o["*"] && s("*"));
    }
    function We(t, e) {
      var i,
        n,
        o = S.ajaxSettings.flatOptions || {};
      for (i in e) void 0 !== e[i] && ((o[i] ? t : n || (n = {}))[i] = e[i]);
      return n && S.extend(!0, t, n), t;
    }
    (Ne.href = Ee.href),
      S.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: Ee.href,
          type: "GET",
          isLocal:
            /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
              Ee.protocol
            ),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": je,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript",
          },
          contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON",
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": JSON.parse,
            "text xml": S.parseXML,
          },
          flatOptions: { url: !0, context: !0 },
        },
        ajaxSetup: function (t, e) {
          return e ? We(We(t, S.ajaxSettings), e) : We(S.ajaxSettings, t);
        },
        ajaxPrefilter: Be(He),
        ajaxTransport: Be(Me),
        ajax: function (e, i) {
          "object" == typeof e && ((i = e), (e = void 0)), (i = i || {});
          var n,
            o,
            r,
            s,
            a,
            l,
            c,
            d,
            u,
            h,
            p = S.ajaxSetup({}, i),
            f = p.context || p,
            m = p.context && (f.nodeType || f.jquery) ? S(f) : S.event,
            y = S.Deferred(),
            v = S.Callbacks("once memory"),
            b = p.statusCode || {},
            w = {},
            E = {},
            L = "canceled",
            k = {
              readyState: 0,
              getResponseHeader: function (t) {
                var e;
                if (c) {
                  if (!s)
                    for (s = {}; (e = Ie.exec(r)); )
                      s[e[1].toLowerCase() + " "] = (
                        s[e[1].toLowerCase() + " "] || []
                      ).concat(e[2]);
                  e = s[t.toLowerCase() + " "];
                }
                return null == e ? null : e.join(", ");
              },
              getAllResponseHeaders: function () {
                return c ? r : null;
              },
              setRequestHeader: function (t, e) {
                return (
                  null == c &&
                    ((t = E[t.toLowerCase()] = E[t.toLowerCase()] || t),
                    (w[t] = e)),
                  this
                );
              },
              overrideMimeType: function (t) {
                return null == c && (p.mimeType = t), this;
              },
              statusCode: function (t) {
                var e;
                if (t)
                  if (c) k.always(t[k.status]);
                  else for (e in t) b[e] = [b[e], t[e]];
                return this;
              },
              abort: function (t) {
                var e = t || L;
                return n && n.abort(e), x(0, e), this;
              },
            };
          if (
            (y.promise(k),
            (p.url = ((e || p.url || Ee.href) + "").replace(
              Fe,
              Ee.protocol + "//"
            )),
            (p.type = i.method || i.type || p.method || p.type),
            (p.dataTypes = (p.dataType || "*").toLowerCase().match(F) || [""]),
            null == p.crossDomain)
          ) {
            l = g.createElement("a");
            try {
              (l.href = p.url),
                (l.href = l.href),
                (p.crossDomain =
                  Ne.protocol + "//" + Ne.host != l.protocol + "//" + l.host);
            } catch (e) {
              p.crossDomain = !0;
            }
          }
          if (
            (p.data &&
              p.processData &&
              "string" != typeof p.data &&
              (p.data = S.param(p.data, p.traditional)),
            $e(He, p, i, k),
            c)
          )
            return k;
          for (u in ((d = S.event && p.global) &&
            0 == S.active++ &&
            S.event.trigger("ajaxStart"),
          (p.type = p.type.toUpperCase()),
          (p.hasContent = !Oe.test(p.type)),
          (o = p.url.replace(_e, "")),
          p.hasContent
            ? p.data &&
              p.processData &&
              0 ===
                (p.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              (p.data = p.data.replace(Pe, "+"))
            : ((h = p.url.slice(o.length)),
              p.data &&
                (p.processData || "string" == typeof p.data) &&
                ((o += (ke.test(o) ? "&" : "?") + p.data), delete p.data),
              !1 === p.cache &&
                ((o = o.replace(De, "$1")),
                (h = (ke.test(o) ? "&" : "?") + "_=" + Le.guid++ + h)),
              (p.url = o + h)),
          p.ifModified &&
            (S.lastModified[o] &&
              k.setRequestHeader("If-Modified-Since", S.lastModified[o]),
            S.etag[o] && k.setRequestHeader("If-None-Match", S.etag[o])),
          ((p.data && p.hasContent && !1 !== p.contentType) || i.contentType) &&
            k.setRequestHeader("Content-Type", p.contentType),
          k.setRequestHeader(
            "Accept",
            p.dataTypes[0] && p.accepts[p.dataTypes[0]]
              ? p.accepts[p.dataTypes[0]] +
                  ("*" !== p.dataTypes[0] ? ", " + je + "; q=0.01" : "")
              : p.accepts["*"]
          ),
          p.headers))
            k.setRequestHeader(u, p.headers[u]);
          if (p.beforeSend && (!1 === p.beforeSend.call(f, k, p) || c))
            return k.abort();
          if (
            ((L = "abort"),
            v.add(p.complete),
            k.done(p.success),
            k.fail(p.error),
            (n = $e(Me, p, i, k)))
          ) {
            if (((k.readyState = 1), d && m.trigger("ajaxSend", [k, p]), c))
              return k;
            p.async &&
              0 < p.timeout &&
              (a = t.setTimeout(function () {
                k.abort("timeout");
              }, p.timeout));
            try {
              (c = !1), n.send(w, x);
            } catch (e) {
              if (c) throw e;
              x(-1, e);
            }
          } else x(-1, "No Transport");
          function x(e, i, s, l) {
            var u,
              h,
              g,
              w,
              E,
              L = i;
            c ||
              ((c = !0),
              a && t.clearTimeout(a),
              (n = void 0),
              (r = l || ""),
              (k.readyState = 0 < e ? 4 : 0),
              (u = (200 <= e && e < 300) || 304 === e),
              s &&
                (w = (function (t, e, i) {
                  for (
                    var n, o, r, s, a = t.contents, l = t.dataTypes;
                    "*" === l[0];

                  )
                    l.shift(),
                      void 0 === n &&
                        (n = t.mimeType || e.getResponseHeader("Content-Type"));
                  if (n)
                    for (o in a)
                      if (a[o] && a[o].test(n)) {
                        l.unshift(o);
                        break;
                      }
                  if (l[0] in i) r = l[0];
                  else {
                    for (o in i) {
                      if (!l[0] || t.converters[o + " " + l[0]]) {
                        r = o;
                        break;
                      }
                      s || (s = o);
                    }
                    r = r || s;
                  }
                  if (r) return r !== l[0] && l.unshift(r), i[r];
                })(p, k, s)),
              !u &&
                -1 < S.inArray("script", p.dataTypes) &&
                (p.converters["text script"] = function () {}),
              (w = (function (t, e, i, n) {
                var o,
                  r,
                  s,
                  a,
                  l,
                  c = {},
                  d = t.dataTypes.slice();
                if (d[1])
                  for (s in t.converters) c[s.toLowerCase()] = t.converters[s];
                for (r = d.shift(); r; )
                  if (
                    (t.responseFields[r] && (i[t.responseFields[r]] = e),
                    !l &&
                      n &&
                      t.dataFilter &&
                      (e = t.dataFilter(e, t.dataType)),
                    (l = r),
                    (r = d.shift()))
                  )
                    if ("*" === r) r = l;
                    else if ("*" !== l && l !== r) {
                      if (!(s = c[l + " " + r] || c["* " + r]))
                        for (o in c)
                          if (
                            (a = o.split(" "))[1] === r &&
                            (s = c[l + " " + a[0]] || c["* " + a[0]])
                          ) {
                            !0 === s
                              ? (s = c[o])
                              : !0 !== c[o] && ((r = a[0]), d.unshift(a[1]));
                            break;
                          }
                      if (!0 !== s)
                        if (s && t.throws) e = s(e);
                        else
                          try {
                            e = s(e);
                          } catch (t) {
                            return {
                              state: "parsererror",
                              error: s
                                ? t
                                : "No conversion from " + l + " to " + r,
                            };
                          }
                    }
                return { state: "success", data: e };
              })(p, w, k, u)),
              u
                ? (p.ifModified &&
                    ((E = k.getResponseHeader("Last-Modified")) &&
                      (S.lastModified[o] = E),
                    (E = k.getResponseHeader("etag")) && (S.etag[o] = E)),
                  204 === e || "HEAD" === p.type
                    ? (L = "nocontent")
                    : 304 === e
                    ? (L = "notmodified")
                    : ((L = w.state), (h = w.data), (u = !(g = w.error))))
                : ((g = L), (!e && L) || ((L = "error"), e < 0 && (e = 0))),
              (k.status = e),
              (k.statusText = (i || L) + ""),
              u ? y.resolveWith(f, [h, L, k]) : y.rejectWith(f, [k, L, g]),
              k.statusCode(b),
              (b = void 0),
              d &&
                m.trigger(u ? "ajaxSuccess" : "ajaxError", [k, p, u ? h : g]),
              v.fireWith(f, [k, L]),
              d &&
                (m.trigger("ajaxComplete", [k, p]),
                --S.active || S.event.trigger("ajaxStop")));
          }
          return k;
        },
        getJSON: function (t, e, i) {
          return S.get(t, e, i, "json");
        },
        getScript: function (t, e) {
          return S.get(t, void 0, e, "script");
        },
      }),
      S.each(["get", "post"], function (t, e) {
        S[e] = function (t, i, n, o) {
          return (
            f(i) && ((o = o || n), (n = i), (i = void 0)),
            S.ajax(
              S.extend(
                { url: t, type: e, dataType: o, data: i, success: n },
                S.isPlainObject(t) && t
              )
            )
          );
        };
      }),
      S.ajaxPrefilter(function (t) {
        var e;
        for (e in t.headers)
          "content-type" === e.toLowerCase() &&
            (t.contentType = t.headers[e] || "");
      }),
      (S._evalUrl = function (t, e, i) {
        return S.ajax({
          url: t,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          converters: { "text script": function () {} },
          dataFilter: function (t) {
            S.globalEval(t, e, i);
          },
        });
      }),
      S.fn.extend({
        wrapAll: function (t) {
          var e;
          return (
            this[0] &&
              (f(t) && (t = t.call(this[0])),
              (e = S(t, this[0].ownerDocument).eq(0).clone(!0)),
              this[0].parentNode && e.insertBefore(this[0]),
              e
                .map(function () {
                  for (var t = this; t.firstElementChild; )
                    t = t.firstElementChild;
                  return t;
                })
                .append(this)),
            this
          );
        },
        wrapInner: function (t) {
          return f(t)
            ? this.each(function (e) {
                S(this).wrapInner(t.call(this, e));
              })
            : this.each(function () {
                var e = S(this),
                  i = e.contents();
                i.length ? i.wrapAll(t) : e.append(t);
              });
        },
        wrap: function (t) {
          var e = f(t);
          return this.each(function (i) {
            S(this).wrapAll(e ? t.call(this, i) : t);
          });
        },
        unwrap: function (t) {
          return (
            this.parent(t)
              .not("body")
              .each(function () {
                S(this).replaceWith(this.childNodes);
              }),
            this
          );
        },
      }),
      (S.expr.pseudos.hidden = function (t) {
        return !S.expr.pseudos.visible(t);
      }),
      (S.expr.pseudos.visible = function (t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
      }),
      (S.ajaxSettings.xhr = function () {
        try {
          return new t.XMLHttpRequest();
        } catch (t) {}
      });
    var ze = { 0: 200, 1223: 204 },
      Re = S.ajaxSettings.xhr();
    (p.cors = !!Re && "withCredentials" in Re),
      (p.ajax = Re = !!Re),
      S.ajaxTransport(function (e) {
        var i, n;
        if (p.cors || (Re && !e.crossDomain))
          return {
            send: function (o, r) {
              var s,
                a = e.xhr();
              if (
                (a.open(e.type, e.url, e.async, e.username, e.password),
                e.xhrFields)
              )
                for (s in e.xhrFields) a[s] = e.xhrFields[s];
              for (s in (e.mimeType &&
                a.overrideMimeType &&
                a.overrideMimeType(e.mimeType),
              e.crossDomain ||
                o["X-Requested-With"] ||
                (o["X-Requested-With"] = "XMLHttpRequest"),
              o))
                a.setRequestHeader(s, o[s]);
              (i = function (t) {
                return function () {
                  i &&
                    ((i =
                      n =
                      a.onload =
                      a.onerror =
                      a.onabort =
                      a.ontimeout =
                      a.onreadystatechange =
                        null),
                    "abort" === t
                      ? a.abort()
                      : "error" === t
                      ? "number" != typeof a.status
                        ? r(0, "error")
                        : r(a.status, a.statusText)
                      : r(
                          ze[a.status] || a.status,
                          a.statusText,
                          "text" !== (a.responseType || "text") ||
                            "string" != typeof a.responseText
                            ? { binary: a.response }
                            : { text: a.responseText },
                          a.getAllResponseHeaders()
                        ));
                };
              }),
                (a.onload = i()),
                (n = a.onerror = a.ontimeout = i("error")),
                void 0 !== a.onabort
                  ? (a.onabort = n)
                  : (a.onreadystatechange = function () {
                      4 === a.readyState &&
                        t.setTimeout(function () {
                          i && n();
                        });
                    }),
                (i = i("abort"));
              try {
                a.send((e.hasContent && e.data) || null);
              } catch (o) {
                if (i) throw o;
              }
            },
            abort: function () {
              i && i();
            },
          };
      }),
      S.ajaxPrefilter(function (t) {
        t.crossDomain && (t.contents.script = !1);
      }),
      S.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /\b(?:java|ecma)script\b/ },
        converters: {
          "text script": function (t) {
            return S.globalEval(t), t;
          },
        },
      }),
      S.ajaxPrefilter("script", function (t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET");
      }),
      S.ajaxTransport("script", function (t) {
        var e, i;
        if (t.crossDomain || t.scriptAttrs)
          return {
            send: function (n, o) {
              (e = S("<script>")
                .attr(t.scriptAttrs || {})
                .prop({ charset: t.scriptCharset, src: t.url })
                .on(
                  "load error",
                  (i = function (t) {
                    e.remove(),
                      (i = null),
                      t && o("error" === t.type ? 404 : 200, t.type);
                  })
                )),
                g.head.appendChild(e[0]);
            },
            abort: function () {
              i && i();
            },
          };
      });
    var Ve,
      Ue = [],
      Ge = /(=)\?(?=&|$)|\?\?/;
    S.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var t = Ue.pop() || S.expando + "_" + Le.guid++;
        return (this[t] = !0), t;
      },
    }),
      S.ajaxPrefilter("json jsonp", function (e, i, n) {
        var o,
          r,
          s,
          a =
            !1 !== e.jsonp &&
            (Ge.test(e.url)
              ? "url"
              : "string" == typeof e.data &&
                0 ===
                  (e.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                Ge.test(e.data) &&
                "data");
        if (a || "jsonp" === e.dataTypes[0])
          return (
            (o = e.jsonpCallback =
              f(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
            a
              ? (e[a] = e[a].replace(Ge, "$1" + o))
              : !1 !== e.jsonp &&
                (e.url += (ke.test(e.url) ? "&" : "?") + e.jsonp + "=" + o),
            (e.converters["script json"] = function () {
              return s || S.error(o + " was not called"), s[0];
            }),
            (e.dataTypes[0] = "json"),
            (r = t[o]),
            (t[o] = function () {
              s = arguments;
            }),
            n.always(function () {
              void 0 === r ? S(t).removeProp(o) : (t[o] = r),
                e[o] && ((e.jsonpCallback = i.jsonpCallback), Ue.push(o)),
                s && f(r) && r(s[0]),
                (s = r = void 0);
            }),
            "script"
          );
      }),
      (p.createHTMLDocument =
        (((Ve = g.implementation.createHTMLDocument("").body).innerHTML =
          "<form></form><form></form>"),
        2 === Ve.childNodes.length)),
      (S.parseHTML = function (t, e, i) {
        return "string" != typeof t
          ? []
          : ("boolean" == typeof e && ((i = e), (e = !1)),
            e ||
              (p.createHTMLDocument
                ? (((n = (e =
                    g.implementation.createHTMLDocument("")).createElement(
                    "base"
                  )).href = g.location.href),
                  e.head.appendChild(n))
                : (e = g)),
            (r = !i && []),
            (o = C.exec(t))
              ? [e.createElement(o[1])]
              : ((o = bt([t], e, r)),
                r && r.length && S(r).remove(),
                S.merge([], o.childNodes)));
        var n, o, r;
      }),
      (S.fn.load = function (t, e, i) {
        var n,
          o,
          r,
          s = this,
          a = t.indexOf(" ");
        return (
          -1 < a && ((n = ge(t.slice(a))), (t = t.slice(0, a))),
          f(e)
            ? ((i = e), (e = void 0))
            : e && "object" == typeof e && (o = "POST"),
          0 < s.length &&
            S.ajax({ url: t, type: o || "GET", dataType: "html", data: e })
              .done(function (t) {
                (r = arguments),
                  s.html(n ? S("<div>").append(S.parseHTML(t)).find(n) : t);
              })
              .always(
                i &&
                  function (t, e) {
                    s.each(function () {
                      i.apply(this, r || [t.responseText, e, t]);
                    });
                  }
              ),
          this
        );
      }),
      (S.expr.pseudos.animated = function (t) {
        return S.grep(S.timers, function (e) {
          return t === e.elem;
        }).length;
      }),
      (S.offset = {
        setOffset: function (t, e, i) {
          var n,
            o,
            r,
            s,
            a,
            l,
            c = S.css(t, "position"),
            d = S(t),
            u = {};
          "static" === c && (t.style.position = "relative"),
            (a = d.offset()),
            (r = S.css(t, "top")),
            (l = S.css(t, "left")),
            ("absolute" === c || "fixed" === c) && -1 < (r + l).indexOf("auto")
              ? ((s = (n = d.position()).top), (o = n.left))
              : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
            f(e) && (e = e.call(t, i, S.extend({}, a))),
            null != e.top && (u.top = e.top - a.top + s),
            null != e.left && (u.left = e.left - a.left + o),
            "using" in e
              ? e.using.call(t, u)
              : ("number" == typeof u.top && (u.top += "px"),
                "number" == typeof u.left && (u.left += "px"),
                d.css(u));
        },
      }),
      S.fn.extend({
        offset: function (t) {
          if (arguments.length)
            return void 0 === t
              ? this
              : this.each(function (e) {
                  S.offset.setOffset(this, t, e);
                });
          var e,
            i,
            n = this[0];
          return n
            ? n.getClientRects().length
              ? ((e = n.getBoundingClientRect()),
                (i = n.ownerDocument.defaultView),
                { top: e.top + i.pageYOffset, left: e.left + i.pageXOffset })
              : { top: 0, left: 0 }
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var t,
              e,
              i,
              n = this[0],
              o = { top: 0, left: 0 };
            if ("fixed" === S.css(n, "position")) e = n.getBoundingClientRect();
            else {
              for (
                e = this.offset(),
                  i = n.ownerDocument,
                  t = n.offsetParent || i.documentElement;
                t &&
                (t === i.body || t === i.documentElement) &&
                "static" === S.css(t, "position");

              )
                t = t.parentNode;
              t &&
                t !== n &&
                1 === t.nodeType &&
                (((o = S(t).offset()).top += S.css(t, "borderTopWidth", !0)),
                (o.left += S.css(t, "borderLeftWidth", !0)));
            }
            return {
              top: e.top - o.top - S.css(n, "marginTop", !0),
              left: e.left - o.left - S.css(n, "marginLeft", !0),
            };
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var t = this.offsetParent;
              t && "static" === S.css(t, "position");

            )
              t = t.offsetParent;
            return t || nt;
          });
        },
      }),
      S.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (t, e) {
          var i = "pageYOffset" === e;
          S.fn[t] = function (n) {
            return W(
              this,
              function (t, n, o) {
                var r;
                if (
                  (m(t) ? (r = t) : 9 === t.nodeType && (r = t.defaultView),
                  void 0 === o)
                )
                  return r ? r[e] : t[n];
                r
                  ? r.scrollTo(i ? r.pageXOffset : o, i ? o : r.pageYOffset)
                  : (t[n] = o);
              },
              t,
              n,
              arguments.length
            );
          };
        }
      ),
      S.each(["top", "left"], function (t, e) {
        S.cssHooks[e] = Wt(p.pixelPosition, function (t, i) {
          if (i)
            return (i = $t(t, e)), Mt.test(i) ? S(t).position()[e] + "px" : i;
        });
      }),
      S.each({ Height: "height", Width: "width" }, function (t, e) {
        S.each(
          { padding: "inner" + t, content: e, "": "outer" + t },
          function (i, n) {
            S.fn[n] = function (o, r) {
              var s = arguments.length && (i || "boolean" != typeof o),
                a = i || (!0 === o || !0 === r ? "margin" : "border");
              return W(
                this,
                function (e, i, o) {
                  var r;
                  return m(e)
                    ? 0 === n.indexOf("outer")
                      ? e["inner" + t]
                      : e.document.documentElement["client" + t]
                    : 9 === e.nodeType
                    ? ((r = e.documentElement),
                      Math.max(
                        e.body["scroll" + t],
                        r["scroll" + t],
                        e.body["offset" + t],
                        r["offset" + t],
                        r["client" + t]
                      ))
                    : void 0 === o
                    ? S.css(e, i, a)
                    : S.style(e, i, o, a);
                },
                e,
                s ? o : void 0,
                s
              );
            };
          }
        );
      }),
      S.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (t, e) {
          S.fn[e] = function (t) {
            return this.on(e, t);
          };
        }
      ),
      S.fn.extend({
        bind: function (t, e, i) {
          return this.on(t, null, e, i);
        },
        unbind: function (t, e) {
          return this.off(t, null, e);
        },
        delegate: function (t, e, i, n) {
          return this.on(e, t, i, n);
        },
        undelegate: function (t, e, i) {
          return 1 === arguments.length
            ? this.off(t, "**")
            : this.off(e, t || "**", i);
        },
        hover: function (t, e) {
          return this.mouseenter(t).mouseleave(e || t);
        },
      }),
      S.each(
        "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
          " "
        ),
        function (t, e) {
          S.fn[e] = function (t, i) {
            return 0 < arguments.length
              ? this.on(e, null, t, i)
              : this.trigger(e);
          };
        }
      );
    var Ke = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (S.proxy = function (t, e) {
      var i, n, r;
      if (("string" == typeof e && ((i = t[e]), (e = t), (t = i)), f(t)))
        return (
          (n = o.call(arguments, 2)),
          ((r = function () {
            return t.apply(e || this, n.concat(o.call(arguments)));
          }).guid = t.guid =
            t.guid || S.guid++),
          r
        );
    }),
      (S.holdReady = function (t) {
        t ? S.readyWait++ : S.ready(!0);
      }),
      (S.isArray = Array.isArray),
      (S.parseJSON = JSON.parse),
      (S.nodeName = A),
      (S.isFunction = f),
      (S.isWindow = m),
      (S.camelCase = U),
      (S.type = b),
      (S.now = Date.now),
      (S.isNumeric = function (t) {
        var e = S.type(t);
        return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t));
      }),
      (S.trim = function (t) {
        return null == t ? "" : (t + "").replace(Ke, "");
      }),
      "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
          return S;
        });
    var Xe = t.jQuery,
      Ye = t.$;
    return (
      (S.noConflict = function (e) {
        return (
          t.$ === S && (t.$ = Ye), e && t.jQuery === S && (t.jQuery = Xe), S
        );
      }),
      void 0 === e && (t.jQuery = t.$ = S),
      S
    );
  }),
  (function (t, e) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define([], e)
      : "object" == typeof exports
      ? (exports.AOS = e())
      : (t.AOS = e());
  })(this, function () {
    return (function (t) {
      function e(n) {
        if (i[n]) return i[n].exports;
        var o = (i[n] = { exports: {}, id: n, loaded: !1 });
        return (
          t[n].call(o.exports, o, o.exports, e), (o.loaded = !0), o.exports
        );
      }
      var i = {};
      return (e.m = t), (e.c = i), (e.p = "dist/"), e(0);
    })([
      function (t, e, i) {
        "use strict";
        function n(t) {
          return t && t.__esModule ? t : { default: t };
        }
        var o =
            Object.assign ||
            function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var i = arguments[e];
                for (var n in i)
                  Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
              }
              return t;
            },
          r = (n(i(1)), i(6)),
          s = n(r),
          a = n(i(7)),
          l = n(i(8)),
          c = n(i(9)),
          d = n(i(10)),
          u = n(i(11)),
          h = n(i(14)),
          p = [],
          f = !1,
          m = document.all && !window.atob,
          g = {
            offset: 120,
            delay: 0,
            easing: "ease",
            duration: 400,
            disable: !1,
            once: !1,
            startEvent: "DOMContentLoaded",
            throttleDelay: 99,
            debounceDelay: 50,
            disableMutationObserver: !1,
          },
          y = function () {
            if (
              (arguments.length > 0 &&
                void 0 !== arguments[0] &&
                arguments[0] &&
                (f = !0),
              f)
            )
              return (p = (0, u.default)(p, g)), (0, d.default)(p, g.once), p;
          },
          v = function () {
            (p = (0, h.default)()), y();
          };
        t.exports = {
          init: function (t) {
            return (
              (g = o(g, t)),
              (p = (0, h.default)()),
              (function (t) {
                return (
                  !0 === t ||
                  ("mobile" === t && c.default.mobile()) ||
                  ("phone" === t && c.default.phone()) ||
                  ("tablet" === t && c.default.tablet()) ||
                  ("function" == typeof t && !0 === t())
                );
              })(g.disable) || m
                ? void p.forEach(function (t, e) {
                    t.node.removeAttribute("data-aos"),
                      t.node.removeAttribute("data-aos-easing"),
                      t.node.removeAttribute("data-aos-duration"),
                      t.node.removeAttribute("data-aos-delay");
                  })
                : (document
                    .querySelector("body")
                    .setAttribute("data-aos-easing", g.easing),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-duration", g.duration),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-delay", g.delay),
                  "DOMContentLoaded" === g.startEvent &&
                  ["complete", "interactive"].indexOf(document.readyState) > -1
                    ? y(!0)
                    : "load" === g.startEvent
                    ? window.addEventListener(g.startEvent, function () {
                        y(!0);
                      })
                    : document.addEventListener(g.startEvent, function () {
                        y(!0);
                      }),
                  window.addEventListener(
                    "resize",
                    (0, a.default)(y, g.debounceDelay, !0)
                  ),
                  window.addEventListener(
                    "orientationchange",
                    (0, a.default)(y, g.debounceDelay, !0)
                  ),
                  window.addEventListener(
                    "scroll",
                    (0, s.default)(function () {
                      (0, d.default)(p, g.once);
                    }, g.throttleDelay)
                  ),
                  g.disableMutationObserver || (0, l.default)("[data-aos]", v),
                  p)
            );
          },
          refresh: y,
          refreshHard: v,
        };
      },
      function (t, e) {},
      ,
      ,
      ,
      ,
      function (t, e) {
        (function (e) {
          "use strict";
          function i(t, e, i) {
            function o(e) {
              var i = u,
                n = h;
              return (u = h = void 0), (y = e), (f = t.apply(n, i));
            }
            function s(t) {
              var i = t - g;
              return void 0 === g || i >= e || i < 0 || (E && t - y >= p);
            }
            function l() {
              var t = S();
              return s(t)
                ? c(t)
                : void (m = setTimeout(
                    l,
                    (function (t) {
                      var i = e - (t - g);
                      return E ? w(i, p - (t - y)) : i;
                    })(t)
                  ));
            }
            function c(t) {
              return (m = void 0), L && u ? o(t) : ((u = h = void 0), f);
            }
            function d() {
              var t = S(),
                i = s(t);
              if (((u = arguments), (h = this), (g = t), i)) {
                if (void 0 === m)
                  return (function (t) {
                    return (y = t), (m = setTimeout(l, e)), v ? o(t) : f;
                  })(g);
                if (E) return (m = setTimeout(l, e)), o(g);
              }
              return void 0 === m && (m = setTimeout(l, e)), f;
            }
            var u,
              h,
              p,
              f,
              m,
              g,
              y = 0,
              v = !1,
              E = !1,
              L = !0;
            if ("function" != typeof t) throw new TypeError(a);
            return (
              (e = r(e) || 0),
              n(i) &&
                ((v = !!i.leading),
                (p = (E = "maxWait" in i) ? b(r(i.maxWait) || 0, e) : p),
                (L = "trailing" in i ? !!i.trailing : L)),
              (d.cancel = function () {
                void 0 !== m && clearTimeout(m),
                  (y = 0),
                  (u = g = h = m = void 0);
              }),
              (d.flush = function () {
                return void 0 === m ? f : c(S());
              }),
              d
            );
          }
          function n(t) {
            var e = void 0 === t ? "undefined" : s(t);
            return !!t && ("object" == e || "function" == e);
          }
          function o(t) {
            return (
              "symbol" == (void 0 === t ? "undefined" : s(t)) ||
              ((function (t) {
                return !!t && "object" == (void 0 === t ? "undefined" : s(t));
              })(t) &&
                v.call(t) == c)
            );
          }
          function r(t) {
            if ("number" == typeof t) return t;
            if (o(t)) return l;
            if (n(t)) {
              var e = "function" == typeof t.valueOf ? t.valueOf() : t;
              t = n(e) ? e + "" : e;
            }
            if ("string" != typeof t) return 0 === t ? t : +t;
            t = t.replace(d, "");
            var i = h.test(t);
            return i || p.test(t)
              ? f(t.slice(2), i ? 2 : 8)
              : u.test(t)
              ? l
              : +t;
          }
          var s =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  },
            a = "Expected a function",
            l = NaN,
            c = "[object Symbol]",
            d = /^\s+|\s+$/g,
            u = /^[-+]0x[0-9a-f]+$/i,
            h = /^0b[01]+$/i,
            p = /^0o[0-7]+$/i,
            f = parseInt,
            m =
              "object" == (void 0 === e ? "undefined" : s(e)) &&
              e &&
              e.Object === Object &&
              e,
            g =
              "object" ==
                ("undefined" == typeof self ? "undefined" : s(self)) &&
              self &&
              self.Object === Object &&
              self,
            y = m || g || Function("return this")(),
            v = Object.prototype.toString,
            b = Math.max,
            w = Math.min,
            S = function () {
              return y.Date.now();
            };
          t.exports = function (t, e, o) {
            var r = !0,
              s = !0;
            if ("function" != typeof t) throw new TypeError(a);
            return (
              n(o) &&
                ((r = "leading" in o ? !!o.leading : r),
                (s = "trailing" in o ? !!o.trailing : s)),
              i(t, e, { leading: r, maxWait: e, trailing: s })
            );
          };
        }).call(
          e,
          (function () {
            return this;
          })()
        );
      },
      function (t, e) {
        (function (e) {
          "use strict";
          function i(t) {
            var e = void 0 === t ? "undefined" : r(t);
            return !!t && ("object" == e || "function" == e);
          }
          function n(t) {
            return (
              "symbol" == (void 0 === t ? "undefined" : r(t)) ||
              ((function (t) {
                return !!t && "object" == (void 0 === t ? "undefined" : r(t));
              })(t) &&
                y.call(t) == l)
            );
          }
          function o(t) {
            if ("number" == typeof t) return t;
            if (n(t)) return a;
            if (i(t)) {
              var e = "function" == typeof t.valueOf ? t.valueOf() : t;
              t = i(e) ? e + "" : e;
            }
            if ("string" != typeof t) return 0 === t ? t : +t;
            t = t.replace(c, "");
            var o = u.test(t);
            return o || h.test(t)
              ? p(t.slice(2), o ? 2 : 8)
              : d.test(t)
              ? a
              : +t;
          }
          var r =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  },
            s = "Expected a function",
            a = NaN,
            l = "[object Symbol]",
            c = /^\s+|\s+$/g,
            d = /^[-+]0x[0-9a-f]+$/i,
            u = /^0b[01]+$/i,
            h = /^0o[0-7]+$/i,
            p = parseInt,
            f =
              "object" == (void 0 === e ? "undefined" : r(e)) &&
              e &&
              e.Object === Object &&
              e,
            m =
              "object" ==
                ("undefined" == typeof self ? "undefined" : r(self)) &&
              self &&
              self.Object === Object &&
              self,
            g = f || m || Function("return this")(),
            y = Object.prototype.toString,
            v = Math.max,
            b = Math.min,
            w = function () {
              return g.Date.now();
            };
          t.exports = function (t, e, n) {
            function r(e) {
              var i = u,
                n = h;
              return (u = h = void 0), (y = e), (f = t.apply(n, i));
            }
            function a(t) {
              var i = t - g;
              return void 0 === g || i >= e || i < 0 || (E && t - y >= p);
            }
            function l() {
              var t = w();
              return a(t)
                ? c(t)
                : void (m = setTimeout(
                    l,
                    (function (t) {
                      var i = e - (t - g);
                      return E ? b(i, p - (t - y)) : i;
                    })(t)
                  ));
            }
            function c(t) {
              return (m = void 0), L && u ? r(t) : ((u = h = void 0), f);
            }
            function d() {
              var t = w(),
                i = a(t);
              if (((u = arguments), (h = this), (g = t), i)) {
                if (void 0 === m)
                  return (function (t) {
                    return (y = t), (m = setTimeout(l, e)), S ? r(t) : f;
                  })(g);
                if (E) return (m = setTimeout(l, e)), r(g);
              }
              return void 0 === m && (m = setTimeout(l, e)), f;
            }
            var u,
              h,
              p,
              f,
              m,
              g,
              y = 0,
              S = !1,
              E = !1,
              L = !0;
            if ("function" != typeof t) throw new TypeError(s);
            return (
              (e = o(e) || 0),
              i(n) &&
                ((S = !!n.leading),
                (p = (E = "maxWait" in n) ? v(o(n.maxWait) || 0, e) : p),
                (L = "trailing" in n ? !!n.trailing : L)),
              (d.cancel = function () {
                void 0 !== m && clearTimeout(m),
                  (y = 0),
                  (u = g = h = m = void 0);
              }),
              (d.flush = function () {
                return void 0 === m ? f : c(w());
              }),
              d
            );
          };
        }).call(
          e,
          (function () {
            return this;
          })()
        );
      },
      function (t, e) {
        "use strict";
        function i(t) {
          t &&
            t.forEach(function (t) {
              var e = Array.prototype.slice.call(t.addedNodes),
                i = Array.prototype.slice.call(t.removedNodes),
                n = e.concat(i).filter(function (t) {
                  return t.hasAttribute && t.hasAttribute("data-aos");
                }).length;
              n && r();
            });
        }
        Object.defineProperty(e, "__esModule", { value: !0 });
        var n = window.document,
          o =
            window.MutationObserver ||
            window.WebKitMutationObserver ||
            window.MozMutationObserver,
          r = function () {};
        e.default = function (t, e) {
          var s = new o(i);
          (r = e),
            s.observe(n.documentElement, {
              childList: !0,
              subtree: !0,
              removedNodes: !0,
            });
        };
      },
      function (t, e) {
        "use strict";
        function i() {
          return navigator.userAgent || navigator.vendor || window.opera || "";
        }
        Object.defineProperty(e, "__esModule", { value: !0 });
        var n = (function () {
            function t(t, e) {
              for (var i = 0; i < e.length; i++) {
                var n = e[i];
                (n.enumerable = n.enumerable || !1),
                  (n.configurable = !0),
                  "value" in n && (n.writable = !0),
                  Object.defineProperty(t, n.key, n);
              }
            }
            return function (e, i, n) {
              return i && t(e.prototype, i), n && t(e, n), e;
            };
          })(),
          o =
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
          r =
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
          s =
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
          a =
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
          l = (function () {
            function t() {
              !(function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              })(this, t);
            }
            return (
              n(t, [
                {
                  key: "phone",
                  value: function () {
                    var t = i();
                    return !(!o.test(t) && !r.test(t.substr(0, 4)));
                  },
                },
                {
                  key: "mobile",
                  value: function () {
                    var t = i();
                    return !(!s.test(t) && !a.test(t.substr(0, 4)));
                  },
                },
                {
                  key: "tablet",
                  value: function () {
                    return this.mobile() && !this.phone();
                  },
                },
              ]),
              t
            );
          })();
        e.default = new l();
      },
      function (t, e) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: !0 });
        e.default = function (t, e) {
          var i = window.pageYOffset,
            n = window.innerHeight;
          t.forEach(function (t, o) {
            !(function (t, e, i) {
              var n = t.node.getAttribute("data-aos-once");
              e > t.position
                ? t.node.classList.add("aos-animate")
                : void 0 !== n &&
                  ("false" === n || (!i && "true" !== n)) &&
                  t.node.classList.remove("aos-animate");
            })(t, n + i, e);
          });
        };
      },
      function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: !0 });
        var n = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(i(12));
        e.default = function (t, e) {
          return (
            t.forEach(function (t, i) {
              t.node.classList.add("aos-init"),
                (t.position = (0, n.default)(t.node, e.offset));
            }),
            t
          );
        };
      },
      function (t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: !0 });
        var n = (function (t) {
          return t && t.__esModule ? t : { default: t };
        })(i(13));
        e.default = function (t, e) {
          var i = 0,
            o = 0,
            r = window.innerHeight,
            s = {
              offset: t.getAttribute("data-aos-offset"),
              anchor: t.getAttribute("data-aos-anchor"),
              anchorPlacement: t.getAttribute("data-aos-anchor-placement"),
            };
          switch (
            (s.offset && !isNaN(s.offset) && (o = parseInt(s.offset)),
            s.anchor &&
              document.querySelectorAll(s.anchor) &&
              (t = document.querySelectorAll(s.anchor)[0]),
            (i = (0, n.default)(t).top),
            s.anchorPlacement)
          ) {
            case "top-bottom":
              break;
            case "center-bottom":
              i += t.offsetHeight / 2;
              break;
            case "bottom-bottom":
              i += t.offsetHeight;
              break;
            case "top-center":
              i += r / 2;
              break;
            case "bottom-center":
              i += r / 2 + t.offsetHeight;
              break;
            case "center-center":
              i += r / 2 + t.offsetHeight / 2;
              break;
            case "top-top":
              i += r;
              break;
            case "bottom-top":
              i += t.offsetHeight + r;
              break;
            case "center-top":
              i += t.offsetHeight / 2 + r;
          }
          return s.anchorPlacement || s.offset || isNaN(e) || (o = e), i + o;
        };
      },
      function (t, e) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: !0 });
        e.default = function (t) {
          for (
            var e = 0, i = 0;
            t && !isNaN(t.offsetLeft) && !isNaN(t.offsetTop);

          )
            (e += t.offsetLeft - ("BODY" != t.tagName ? t.scrollLeft : 0)),
              (i += t.offsetTop - ("BODY" != t.tagName ? t.scrollTop : 0)),
              (t = t.offsetParent);
          return { top: i, left: e };
        };
      },
      function (t, e) {
        "use strict";
        Object.defineProperty(e, "__esModule", { value: !0 });
        e.default = function (t) {
          return (
            (t = t || document.querySelectorAll("[data-aos]")),
            Array.prototype.map.call(t, function (t) {
              return { node: t };
            })
          );
        };
      },
    ]);
  }),
  (PaloAlto.debounce = function (t, e, i) {
    var n;
    return function () {
      var o = this,
        r = arguments,
        s = i && !n;
      clearTimeout(n),
        (n = setTimeout(function () {
          (n = null), i || t.apply(o, r);
        }, e)),
        s && t.apply(o, r);
    };
  }),
  function () {
    function t(t) {
      return M(t) && tt.call(t, "callee") && !rt.call(t, "callee");
    }
    function e(t, e) {
      return t.push.apply(t, e), t;
    }
    function i(t) {
      return function (e) {
        return null == e ? R : e[t];
      };
    }
    function n(t) {
      return t instanceof o ? t : new o(t);
    }
    function o(t, e) {
      (this.__wrapped__ = t), (this.__actions__ = []), (this.__chain__ = !!e);
    }
    function r(t, e, i) {
      if ("function" != typeof t) throw new TypeError("Expected a function");
      return setTimeout(function () {
        t.apply(R, i);
      }, e);
    }
    function s(t, e, i) {
      for (var n = -1, o = t.length; ++n < o; ) {
        var r = t[n],
          s = e(r);
        if (null != s && (a === R ? s == s : i(s, a)))
          var a = s,
            l = r;
      }
      return l;
    }
    function a(t, e) {
      var i = [];
      return (
        dt(t, function (t, n, o) {
          e(t, n, o) && i.push(t);
        }),
        i
      );
    }
    function l(t, i, n, o, r) {
      var s = -1,
        a = t.length;
      for (n || (n = k), r || (r = []); ++s < a; ) {
        var c = t[s];
        0 < i && n(c)
          ? 1 < i
            ? l(c, i - 1, n, o, r)
            : e(r, c)
          : o || (r[r.length] = c);
      }
      return r;
    }
    function c(t, e) {
      return t && ut(t, e, Lt);
    }
    function d(t, e) {
      return a(e, function (e) {
        return F(t[e]);
      });
    }
    function u(t, e) {
      return t > e;
    }
    function h(t, e, i, n, o) {
      return (
        t === e ||
        (null == t || null == e || (!M(t) && !M(e))
          ? t != t && e != e
          : (function (t, e, i, n, o, r) {
              var s = yt(t),
                a = yt(e),
                l = s ? "[object Array]" : it.call(t),
                c = a ? "[object Array]" : it.call(e),
                d =
                  ((l = "[object Arguments]" == l ? "[object Object]" : l),
                  (c = "[object Arguments]" == c ? "[object Object]" : c),
                  "[object Object]" == l);
              (a = "[object Object]" == c), (c = l == c);
              r || (r = []);
              var u = pt(r, function (e) {
                  return e[0] == t;
                }),
                h = pt(r, function (t) {
                  return t[0] == e;
                });
              if (u && h) return u[1] == e;
              if ((r.push([t, e]), r.push([e, t]), c && !d)) {
                if (s)
                  i = (function (t, e, i, n, o, r) {
                    var s = t.length,
                      a = e.length;
                    if (s != a && !(1 & i && a > s)) return !1;
                    a = -1;
                    for (var l = !0, c = 2 & i ? [] : R; ++a < s; ) {
                      var d = t[a],
                        u = e[a];
                      if (void 0 !== R) {
                        l = !1;
                        break;
                      }
                      if (c) {
                        if (
                          !w(e, function (t, e) {
                            if (!q(c, e) && (d === t || o(d, t, i, n, r)))
                              return c.push(e);
                          })
                        ) {
                          l = !1;
                          break;
                        }
                      } else if (d !== u && !o(d, u, i, n, r)) {
                        l = !1;
                        break;
                      }
                    }
                    return l;
                  })(t, e, i, n, o, r);
                else
                  t: {
                    switch (l) {
                      case "[object Boolean]":
                      case "[object Date]":
                      case "[object Number]":
                        i = I(+t, +e);
                        break t;
                      case "[object Error]":
                        i = t.name == e.name && t.message == e.message;
                        break t;
                      case "[object RegExp]":
                      case "[object String]":
                        i = t == e + "";
                        break t;
                    }
                    i = !1;
                  }
                return r.pop(), i;
              }
              return 1 & i ||
                ((s = d && tt.call(t, "__wrapped__")),
                (l = a && tt.call(e, "__wrapped__")),
                !s && !l)
                ? !!c &&
                    ((i = (function (t, e, i, n, o, r) {
                      var s = 1 & i,
                        a = Lt(t),
                        l = a.length,
                        c = Lt(e).length;
                      if (l != c && !s) return !1;
                      for (var d = l; d--; ) {
                        var u = a[d];
                        if (!(s ? u in e : tt.call(e, u))) return !1;
                      }
                      for (c = !0; ++d < l; ) {
                        var h = t[(u = a[d])],
                          p = e[u];
                        if (void 0 !== R || (h !== p && !o(h, p, i, n, r))) {
                          c = !1;
                          break;
                        }
                        s || (s = "constructor" == u);
                      }
                      return (
                        c &&
                          !s &&
                          ((i = t.constructor),
                          (n = e.constructor),
                          i != n &&
                            "constructor" in t &&
                            "constructor" in e &&
                            !(
                              "function" == typeof i &&
                              i instanceof i &&
                              "function" == typeof n &&
                              n instanceof n
                            ) &&
                            (c = !1)),
                        c
                      );
                    })(t, e, i, n, o, r)),
                    r.pop(),
                    i)
                : ((s = s ? t.value() : t),
                  (l = l ? e.value() : e),
                  (i = o(s, l, i, n, r)),
                  r.pop(),
                  i);
            })(t, e, i, n, h, o))
      );
    }
    function p(t) {
      return "function" == typeof t
        ? t
        : null == t
        ? W
        : ("object" == typeof t ? g : i)(t);
    }
    function f(t, e) {
      return t < e;
    }
    function m(t, e) {
      var i = -1,
        n = O(t) ? Array(t.length) : [];
      return (
        dt(t, function (t, o, r) {
          n[++i] = e(t, o, r);
        }),
        n
      );
    }
    function g(t) {
      var e = at(t);
      return function (i) {
        var n = e.length;
        if (null == i) return !n;
        for (i = Object(i); n--; ) {
          var o = e[n];
          if (!(o in i) || !h(t[o], i[o], 3)) return !1;
        }
        return !0;
      };
    }
    function y(t) {
      return ht(T(t, void 0, W), t + "");
    }
    function v(t, e, i) {
      var n = -1,
        o = t.length;
      for (
        0 > e && (e = -e > o ? 0 : o + e),
          0 > (i = i > o ? o : i) && (i += o),
          o = e > i ? 0 : (i - e) >>> 0,
          e >>>= 0,
          i = Array(o);
        ++n < o;

      )
        i[n] = t[n + e];
      return i;
    }
    function b(t) {
      return v(t, 0, t.length);
    }
    function w(t, e) {
      var i;
      return (
        dt(t, function (t, n, o) {
          return !(i = e(t, n, o));
        }),
        !!i
      );
    }
    function S(t, e, i) {
      var n = !i;
      i || (i = {});
      for (var o = -1, r = e.length; ++o < r; ) {
        var s = e[o],
          a = R;
        if ((a === R && (a = t[s]), n)) i[s] = a;
        else {
          var l = i,
            c = l[s];
          (tt.call(l, s) && I(c, a) && (a !== R || s in l)) || (l[s] = a);
        }
      }
      return i;
    }
    function E(t) {
      return y(function (e, i) {
        var n = -1,
          o = i.length,
          r = 1 < o ? i[o - 1] : R;
        r = 3 < t.length && "function" == typeof r ? (o--, r) : R;
        for (e = Object(e); ++n < o; ) {
          var s = i[n];
          s && t(e, s, n, r);
        }
        return e;
      });
    }
    function L(t, e, i) {
      if ("function" != typeof t) throw new TypeError("Expected a function");
      var n = (function (t) {
        return function () {
          var e = arguments,
            i = ct(t.prototype);
          return H((e = t.apply(i, e))) ? e : i;
        };
      })(t);
      return function o() {
        for (
          var r = -1,
            s = arguments.length,
            a = -1,
            l = i.length,
            c = Array(l + s),
            d = this && this !== X && this instanceof o ? n : t;
          ++a < l;

        )
          c[a] = i[a];
        for (; s--; ) c[a++] = arguments[++r];
        return d.apply(e, c);
      };
    }
    function k(e) {
      return yt(e) || t(e);
    }
    function x(t) {
      var e = [];
      if (null != t) for (var i in Object(t)) e.push(i);
      return e;
    }
    function T(t, e, i) {
      return (
        (e = lt(e === R ? t.length - 1 : e, 0)),
        function () {
          for (
            var n = arguments, o = -1, r = lt(n.length - e, 0), s = Array(r);
            ++o < r;

          )
            s[o] = n[e + o];
          for (o = -1, r = Array(e + 1); ++o < e; ) r[o] = n[o];
          return (r[e] = i(s)), t.apply(this, r);
        }
      );
    }
    function A(t) {
      return null != t && t.length ? l(t, 1) : [];
    }
    function C(t) {
      return t && t.length ? t[0] : R;
    }
    function q(t, e, i) {
      var n = null == t ? 0 : t.length;
      i =
        ((i = "number" == typeof i ? (0 > i ? lt(n + i, 0) : i) : 0) || 0) - 1;
      for (var o = e == e; ++i < n; ) {
        var r = t[i];
        if (o ? r === e : r != r) return i;
      }
      return -1;
    }
    function P(t, e) {
      return dt(t, p(e));
    }
    function _(t, e, i) {
      return (function (t, e, i, n, o) {
        return (
          o(t, function (t, o, r) {
            i = n ? ((n = !1), t) : e(i, t, o, r);
          }),
          i
        );
      })(t, p(e), i, 3 > arguments.length, dt);
    }
    function D(t, e) {
      var i;
      if ("function" != typeof e) throw new TypeError("Expected a function");
      return (
        (t = vt(t)),
        function () {
          return (
            0 < --t && (i = e.apply(this, arguments)), 1 >= t && (e = R), i
          );
        }
      );
    }
    function I(t, e) {
      return t === e || (t != t && e != e);
    }
    function O(t) {
      var e;
      return (
        (e = null != t) &&
          (e =
            "number" == typeof (e = t.length) &&
            -1 < e &&
            0 == e % 1 &&
            9007199254740991 >= e),
        e && !F(t)
      );
    }
    function F(t) {
      return (
        !!H(t) &&
        ("[object Function]" == (t = it.call(t)) ||
          "[object GeneratorFunction]" == t ||
          "[object AsyncFunction]" == t ||
          "[object Proxy]" == t)
      );
    }
    function H(t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    }
    function M(t) {
      return null != t && "object" == typeof t;
    }
    function j(t) {
      return "number" == typeof t || (M(t) && "[object Number]" == it.call(t));
    }
    function N(t) {
      return (
        "string" == typeof t ||
        (!yt(t) && M(t) && "[object String]" == it.call(t))
      );
    }
    function B(t) {
      return "string" == typeof t ? t : null == t ? "" : t + "";
    }
    function $(t) {
      return null == t
        ? []
        : (function (t, e) {
            return m(e, function (e) {
              return t[e];
            });
          })(t, Lt(t));
    }
    function W(t) {
      return t;
    }
    function z(t, i, n) {
      var o = Lt(i),
        r = d(i, o);
      null != n ||
        (H(i) && (r.length || !o.length)) ||
        ((n = i), (i = t), (t = this), (r = d(i, Lt(i))));
      var s = !(H(n) && "chain" in n && !n.chain),
        a = F(t);
      return (
        dt(r, function (n) {
          var o = i[n];
          (t[n] = o),
            a &&
              (t.prototype[n] = function () {
                var i = this.__chain__;
                if (s || i) {
                  var n = t(this.__wrapped__);
                  return (
                    (n.__actions__ = b(this.__actions__)).push({
                      func: o,
                      args: arguments,
                      thisArg: t,
                    }),
                    (n.__chain__ = i),
                    n
                  );
                }
                return o.apply(t, e([this.value()], arguments));
              });
        }),
        t
      );
    }
    var R,
      V = /[&<>"']/g,
      U = RegExp(V.source),
      G = /^(?:0|[1-9]\d*)$/,
      K = "object" == typeof self && self && self.Object === Object && self,
      X =
        ("object" == typeof global &&
          global &&
          global.Object === Object &&
          global) ||
        K ||
        Function("return this")(),
      Y =
        (K =
          "object" == typeof exports &&
          exports &&
          !exports.nodeType &&
          exports) &&
        "object" == typeof module &&
        module &&
        !module.nodeType &&
        module,
      Q = (function (t) {
        return function (e) {
          return null == t ? R : t[e];
        };
      })({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }),
      J = Array.prototype,
      Z = Object.prototype,
      tt = Z.hasOwnProperty,
      et = 0,
      it = Z.toString,
      nt = X._,
      ot = Object.create,
      rt = Z.propertyIsEnumerable,
      st = X.isFinite,
      at = (function (t, e) {
        return function (i) {
          return t(e(i));
        };
      })(Object.keys, Object),
      lt = Math.max,
      ct = (function () {
        function t() {}
        return function (e) {
          return H(e)
            ? ot
              ? ot(e)
              : ((t.prototype = e), (e = new t()), (t.prototype = R), e)
            : {};
        };
      })();
    (o.prototype = ct(n.prototype)), (o.prototype.constructor = o);
    var dt = (function (t, e) {
        return function (e, i) {
          if (null == e) return e;
          if (!O(e)) return t(e, i);
          for (
            var n = e.length, o = -1, r = Object(e);
            ++o < n && !1 !== i(r[o], o, r);

          );
          return e;
        };
      })(c),
      ut = function (t, e, i) {
        for (var n = -1, o = Object(t), r = (i = i(t)).length; r--; ) {
          var s = i[++n];
          if (!1 === e(o[s], s, o)) break;
        }
        return t;
      },
      ht = W,
      pt = function (t, e, i) {
        var n = Object(t);
        if (!O(t)) {
          var o = p(e);
          (t = Lt(t)),
            (e = function (t) {
              return o(n[t], t, n);
            });
        }
        return (
          (e = (function (t, e, i) {
            var n = null == t ? 0 : t.length;
            if (!n) return -1;
            0 > (i = null == i ? 0 : vt(i)) && (i = lt(n + i, 0));
            t: {
              for (e = p(e), n = t.length, i += -1; ++i < n; )
                if (e(t[i], i, t)) {
                  t = i;
                  break t;
                }
              t = -1;
            }
            return t;
          })(t, e, i)),
          -1 < e ? n[o ? t[e] : e] : R
        );
      },
      ft = y(function (t, e, i) {
        return L(t, e, i);
      }),
      mt = y(function (t, e) {
        return r(t, 1, e);
      }),
      gt = y(function (t, e, i) {
        return r(t, bt(e) || 0, i);
      }),
      yt = Array.isArray,
      vt = Number,
      bt = Number,
      wt = E(function (t, e) {
        S(e, at(e), t);
      }),
      St = E(function (t, e) {
        S(e, x(e), t);
      }),
      Et = y(function (t, e) {
        t = Object(t);
        var i,
          n = -1,
          o = e.length,
          r = 2 < o ? e[2] : R;
        if ((i = r)) {
          i = e[0];
          var s = e[1];
          if (H(r)) {
            if ("number" == (l = typeof s)) {
              if ((l = O(r)))
                var a = typeof s,
                  l =
                    !!(l = null == (l = r.length) ? 9007199254740991 : l) &&
                    ("number" == a || ("symbol" != a && G.test(s))) &&
                    -1 < s &&
                    0 == s % 1 &&
                    s < l;
            } else l = "string" == l && s in r;
            i = !!l && I(r[s], i);
          } else i = !1;
        }
        for (i && (o = 1); ++n < o; )
          for (r = e[n], s = -1, l = (i = kt(r)).length; ++s < l; ) {
            var c = t[(a = i[s])];
            (c === R || (I(c, Z[a]) && !tt.call(t, a))) && (t[a] = r[a]);
          }
        return t;
      }),
      Lt = at,
      kt = x,
      xt = (function (t) {
        return ht(T(t, R, A), t + "");
      })(function (t, e) {
        return null == t
          ? {}
          : (function (t, e) {
              return (
                (t = Object(t)),
                _(
                  e,
                  function (e, i) {
                    return i in t && (e[i] = t[i]), e;
                  },
                  {}
                )
              );
            })(t, e);
      });
    (n.assignIn = St),
      (n.before = D),
      (n.bind = ft),
      (n.chain = function (t) {
        return ((t = n(t)).__chain__ = !0), t;
      }),
      (n.compact = function (t) {
        return a(t, Boolean);
      }),
      (n.concat = function () {
        var t = arguments.length;
        if (!t) return [];
        for (var i = Array(t - 1), n = arguments[0]; t--; )
          i[t - 1] = arguments[t];
        return e(yt(n) ? b(n) : [n], l(i, 1));
      }),
      (n.create = function (t, e) {
        var i = ct(t);
        return null == e ? i : wt(i, e);
      }),
      (n.defaults = Et),
      (n.defer = mt),
      (n.delay = gt),
      (n.filter = function (t, e) {
        return a(t, p(e));
      }),
      (n.flatten = A),
      (n.flattenDeep = function (t) {
        return null != t && t.length ? l(t, Infinity) : [];
      }),
      (n.iteratee = p),
      (n.keys = Lt),
      (n.map = function (t, e) {
        return m(t, p(e));
      }),
      (n.matches = function (t) {
        return g(wt({}, t));
      }),
      (n.mixin = z),
      (n.negate = function (t) {
        if ("function" != typeof t) throw new TypeError("Expected a function");
        return function () {
          return !t.apply(this, arguments);
        };
      }),
      (n.once = function (t) {
        return D(2, t);
      }),
      (n.pick = xt),
      (n.slice = function (t, e, i) {
        var n = null == t ? 0 : t.length;
        return (i = i === R ? n : +i), n ? v(t, null == e ? 0 : +e, i) : [];
      }),
      (n.sortBy = function (t, e) {
        var n = 0;
        return (
          (e = p(e)),
          m(
            m(t, function (t, i, o) {
              return { value: t, index: n++, criteria: e(t, i, o) };
            }).sort(function (t, e) {
              var i;
              t: {
                i = t.criteria;
                var n = e.criteria;
                if (i !== n) {
                  var o = i !== R,
                    r = null === i,
                    s = i == i,
                    a = n !== R,
                    l = null === n,
                    c = n == n;
                  if ((!l && i > n) || (r && a && c) || (!o && c) || !s) {
                    i = 1;
                    break t;
                  }
                  if ((!r && i < n) || (l && o && s) || (!a && s) || !c) {
                    i = -1;
                    break t;
                  }
                }
                i = 0;
              }
              return i || t.index - e.index;
            }),
            i("value")
          )
        );
      }),
      (n.tap = function (t, e) {
        return e(t), t;
      }),
      (n.thru = function (t, e) {
        return e(t);
      }),
      (n.toArray = function (t) {
        return O(t) ? (t.length ? b(t) : []) : $(t);
      }),
      (n.values = $),
      (n.extend = St),
      z(n, n),
      (n.clone = function (t) {
        return H(t) ? (yt(t) ? b(t) : S(t, at(t))) : t;
      }),
      (n.escape = function (t) {
        return (t = B(t)) && U.test(t) ? t.replace(V, Q) : t;
      }),
      (n.every = function (t, e, i) {
        return (function (t, e) {
          var i = !0;
          return (
            dt(t, function (t, n, o) {
              return (i = !!e(t, n, o));
            }),
            i
          );
        })(t, p((e = i ? R : e)));
      }),
      (n.find = pt),
      (n.forEach = P),
      (n.has = function (t, e) {
        return null != t && tt.call(t, e);
      }),
      (n.head = C),
      (n.identity = W),
      (n.indexOf = q),
      (n.isArguments = t),
      (n.isArray = yt),
      (n.isBoolean = function (t) {
        return (
          !0 === t || !1 === t || (M(t) && "[object Boolean]" == it.call(t))
        );
      }),
      (n.isDate = function (t) {
        return M(t) && "[object Date]" == it.call(t);
      }),
      (n.isEmpty = function (e) {
        return O(e) && (yt(e) || N(e) || F(e.splice) || t(e))
          ? !e.length
          : !at(e).length;
      }),
      (n.isEqual = function (t, e) {
        return h(t, e);
      }),
      (n.isFinite = function (t) {
        return "number" == typeof t && st(t);
      }),
      (n.isFunction = F),
      (n.isNaN = function (t) {
        return j(t) && t != +t;
      }),
      (n.isNull = function (t) {
        return null === t;
      }),
      (n.isNumber = j),
      (n.isObject = H),
      (n.isRegExp = function (t) {
        return M(t) && "[object RegExp]" == it.call(t);
      }),
      (n.isString = N),
      (n.isUndefined = function (t) {
        return t === R;
      }),
      (n.last = function (t) {
        var e = null == t ? 0 : t.length;
        return e ? t[e - 1] : R;
      }),
      (n.max = function (t) {
        return t && t.length ? s(t, W, u) : R;
      }),
      (n.min = function (t) {
        return t && t.length ? s(t, W, f) : R;
      }),
      (n.noConflict = function () {
        return X._ === this && (X._ = nt), this;
      }),
      (n.noop = function () {}),
      (n.reduce = _),
      (n.result = function (t, e, i) {
        return (
          (e = null == t ? R : t[e]) === R && (e = i), F(e) ? e.call(t) : e
        );
      }),
      (n.size = function (t) {
        return null == t ? 0 : (t = O(t) ? t : at(t)).length;
      }),
      (n.some = function (t, e, i) {
        return w(t, p((e = i ? R : e)));
      }),
      (n.uniqueId = function (t) {
        var e = ++et;
        return B(t) + e;
      }),
      (n.each = P),
      (n.first = C),
      z(
        n,
        (function () {
          var t = {};
          return (
            c(n, function (e, i) {
              tt.call(n.prototype, i) || (t[i] = e);
            }),
            t
          );
        })(),
        { chain: !1 }
      ),
      (n.VERSION = "4.17.15"),
      dt(
        "pop join replace reverse split push shift sort splice unshift".split(
          " "
        ),
        function (t) {
          var e = (/^(?:replace|split)$/.test(t) ? String.prototype : J)[t],
            i = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru",
            o = /^(?:pop|join|replace|shift)$/.test(t);
          n.prototype[t] = function () {
            var t = arguments;
            if (o && !this.__chain__) {
              var n = this.value();
              return e.apply(yt(n) ? n : [], t);
            }
            return this[i](function (i) {
              return e.apply(yt(i) ? i : [], t);
            });
          };
        }
      ),
      (n.prototype.toJSON =
        n.prototype.valueOf =
        n.prototype.value =
          function () {
            return (function (t, i) {
              return _(
                i,
                function (t, i) {
                  return i.func.apply(i.thisArg, e([t], i.args));
                },
                t
              );
            })(this.__wrapped__, this.__actions__);
          }),
      "function" == typeof define && "object" == typeof define.amd && define.amd
        ? ((X._ = n),
          define(function () {
            return n;
          }))
        : Y
        ? (((Y.exports = n)._ = n), (K._ = n))
        : (X._ = n);
  }.call(this),
  (PaloAlto.initListeners = (function () {
    function t() {
      this.entries = [];
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        add(t, e, i) {
          this.entries.push({ element: t, event: e, fn: i }),
            t.addEventListener(e, i);
        },
        removeAll() {
          this.entries = this.entries.filter(function (t) {
            return t.element.removeEventListener(t.event, t.fn), !1;
          });
        },
      })),
      t
    );
  })()),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define([], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.Rellax = e());
  })("undefined" != typeof window ? window : global, function () {
    var t = function (e, i) {
      "use strict";
      var n = Object.create(t.prototype),
        o = 0,
        r = 0,
        s = [],
        a = !0,
        l =
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.msRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          function (t) {
            return setTimeout(t, 1e3 / 60);
          },
        c = null,
        d = !1;
      try {
        var u = Object.defineProperty({}, "passive", {
          get: function () {
            d = !0;
          },
        });
        window.addEventListener("testPassive", null, u),
          window.removeEventListener("testPassive", null, u);
      } catch (e) {}
      var h =
          window.cancelAnimationFrame ||
          window.mozCancelAnimationFrame ||
          clearTimeout,
        p =
          window.transformProp ||
          (function () {
            var t = document.createElement("div");
            if (null === t.style.transform) {
              var e,
                i = ["Webkit", "Moz", "ms"];
              for (e in i)
                if (void 0 !== t.style[i[e] + "Transform"])
                  return i[e] + "Transform";
            }
            return "transform";
          })();
      if (
        ((n.options = { round: !0, frame: null, callback: function () {} }),
        i &&
          Object.keys(i).forEach(function (t) {
            n.options[t] = i[t];
          }),
        0 <
          (e =
            "string" == typeof (e = e || ".rellax")
              ? document.querySelectorAll(e)
              : [e]).length)
      ) {
        if (((n.elems = e), n.options.frame && !n.options.frame.nodeType)) {
          if (!(e = document.querySelector(n.options.frame)))
            return void console.warn(
              "Rellax: The frame you're trying to use doesn't exist."
            );
          n.options.frame = e;
        }
        var f = function () {
            for (var t = 0; t < s.length; t++)
              n.elems[t].style.cssText = s[t].style;
            (s = []),
              (r = window.innerHeight),
              window.innerWidth,
              g(),
              (function () {
                for (var t = 0; t < n.elems.length; t++) {
                  var e = m(n.elems[t]);
                  s.push(e);
                }
              })(),
              b(),
              a && (window.addEventListener("resize", f), (a = !1), v());
          },
          m = function (t) {
            var e = t.getAttribute("data-rellax-zindex") || 0,
              i = 0 + t.getBoundingClientRect().top,
              n = t.clientHeight || t.offsetHeight || t.scrollHeight,
              o = 0 + t.getBoundingClientRect().left,
              r = t.clientWidth || t.offsetWidth || t.scrollWidth,
              s = t.style.cssText,
              a = "",
              l = /transform\s*:/i.exec(s);
            return (
              l &&
                ((t = l.index),
                (a = (t = (l = s.slice(t)).indexOf(";"))
                  ? " " + l.slice(11, t).replace(/\s/g, "")
                  : " " + l.slice(11).replace(/\s/g, ""))),
              {
                top: i,
                left: o,
                height: n,
                width: r,
                style: s,
                transform: a,
                zindex: e,
              }
            );
          },
          g = function () {
            return (
              o !=
              (o =
                (
                  document.documentElement ||
                  document.body.parentNode ||
                  document.body
                ).scrollTop || window.pageYOffset)
            );
          },
          y = function () {
            window.removeEventListener("resize", y),
              window.removeEventListener("orientationchange", y),
              window.removeEventListener("scroll", y),
              document.removeEventListener("touchmove", y),
              (c = l(v));
          },
          v = function () {
            g() && !1 === a
              ? (b(), (c = l(v)))
              : ((c = null),
                window.addEventListener("resize", y),
                window.addEventListener("orientationchange", y),
                window.addEventListener("scroll", y, !!d && { passive: !0 }),
                document.addEventListener(
                  "touchmove",
                  y,
                  !!d && { passive: !0 }
                ));
          },
          b = function () {
            for (var t = 0; t < n.elems.length; t++) {
              var e =
                  (d = n.elems[t].parentNode).clientHeight ||
                  d.offsetHeight ||
                  d.scrollHeight,
                i = d.getBoundingClientRect().top + o,
                a = e + i,
                l = s[t].height - e;
              if (a < o || o + r < i) return;
              var c = document.body,
                d = document.documentElement;
              (d = Math.max(
                c.scrollHeight,
                c.offsetHeight,
                d.clientHeight,
                d.scrollHeight,
                d.offsetHeight
              )),
                (l =
                  "translate3d(0px," +
                  (i < r
                    ? (l / (e + i)) * -(o + i - i) + l / 2
                    : d - a < r
                    ? (l / (e + (d - a))) * -(o + r - i) + l / 2
                    : (l / (e + r)) * -(o + r - i) + l / 2) +
                  "px," +
                  s[t].zindex +
                  "px) " +
                  s[t].transform);
              n.elems[t].style[p] = l;
            }
          };
        return (
          (n.destroy = function () {
            for (var t = 0; t < n.elems.length; t++)
              n.elems[t].style.cssText = s[t].style;
            a || (window.removeEventListener("resize", f), (a = !0)),
              h(c),
              (c = null);
          }),
          f(),
          (n.refresh = f),
          n
        );
      }
      console.warn("Rellax: The elements you're trying to select don't exist.");
    };
    return t;
  }),
  (function (t, e) {
    "object" == typeof exports && "object" == typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define([], e)
      : "object" == typeof exports
      ? (exports.scrollLock = e())
      : (t.scrollLock = e());
  })(this, function () {
    return (function (t) {
      var e = {};
      function i(n) {
        if (e[n]) return e[n].exports;
        var o = (e[n] = { i: n, l: !1, exports: {} });
        return t[n].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
      }
      return (
        (i.m = t),
        (i.c = e),
        (i.d = function (t, e, n) {
          i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
        }),
        (i.r = function (t) {
          "undefined" != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
            Object.defineProperty(t, "__esModule", { value: !0 });
        }),
        (i.t = function (t, e) {
          if ((1 & e && (t = i(t)), 8 & e)) return t;
          if (4 & e && "object" == typeof t && t && t.__esModule) return t;
          var n = Object.create(null);
          if (
            (i.r(n),
            Object.defineProperty(n, "default", { enumerable: !0, value: t }),
            2 & e && "string" != typeof t)
          )
            for (var o in t)
              i.d(
                n,
                o,
                function (e) {
                  return t[e];
                }.bind(null, o)
              );
          return n;
        }),
        (i.n = function (t) {
          var e =
            t && t.__esModule
              ? function () {
                  return t.default;
                }
              : function () {
                  return t;
                };
          return i.d(e, "a", e), e;
        }),
        (i.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (i.p = ""),
        i((i.s = 0))
      );
    })([
      function (t, e, i) {
        "use strict";
        i.r(e);
        var n = function (t) {
            return Array.isArray(t) ? t : [t];
          },
          o = function (t) {
            return t instanceof Node;
          },
          r = function (t, e) {
            if (t && e) {
              t = t instanceof NodeList ? t : [t];
              for (var i = 0; i < t.length && !0 !== e(t[i], i, t.length); i++);
            }
          },
          s = function (t) {
            return console.error("[scroll-lock] ".concat(t));
          },
          a = function (t) {
            if (Array.isArray(t)) return t.join(", ");
          },
          l = function (t) {
            var e = [];
            return (
              r(t, function (t) {
                return e.push(t);
              }),
              e
            );
          },
          c = function (t, e) {
            var i =
              3 < arguments.length && void 0 !== arguments[3]
                ? arguments[3]
                : document;
            if (
              (!(2 < arguments.length && void 0 !== arguments[2]) ||
                arguments[2]) &&
              -1 !== l(i.querySelectorAll(e)).indexOf(t)
            )
              return t;
            for (
              ;
              (t = t.parentElement) &&
              -1 === l(i.querySelectorAll(e)).indexOf(t);

            );
            return t;
          },
          d = function (t, e) {
            var i =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : document;
            return -1 !== l(i.querySelectorAll(e)).indexOf(t);
          },
          u = function (t) {
            if (t) return "hidden" === getComputedStyle(t).overflow;
          },
          h = function (t) {
            if (t) return !!u(t) || t.scrollTop <= 0;
          },
          p = function (t) {
            if (t) {
              if (u(t)) return !0;
              var e = t.scrollTop;
              return t.scrollHeight <= e + t.offsetHeight;
            }
          },
          f = function (t) {
            if (t) return !!u(t) || t.scrollLeft <= 0;
          },
          m = function (t) {
            if (t) {
              if (u(t)) return !0;
              var e = t.scrollLeft;
              return t.scrollWidth <= e + t.offsetWidth;
            }
          };
        i.d(e, "disablePageScroll", function () {
          return v;
        }),
          i.d(e, "enablePageScroll", function () {
            return b;
          }),
          i.d(e, "getScrollState", function () {
            return w;
          }),
          i.d(e, "clearQueueScrollLocks", function () {
            return S;
          }),
          i.d(e, "getTargetScrollBarWidth", function () {
            return E;
          }),
          i.d(e, "getCurrentTargetScrollBarWidth", function () {
            return L;
          }),
          i.d(e, "getPageScrollBarWidth", function () {
            return k;
          }),
          i.d(e, "getCurrentPageScrollBarWidth", function () {
            return x;
          }),
          i.d(e, "addScrollableTarget", function () {
            return T;
          }),
          i.d(e, "removeScrollableTarget", function () {
            return A;
          }),
          i.d(e, "addScrollableSelector", function () {
            return C;
          }),
          i.d(e, "removeScrollableSelector", function () {
            return q;
          }),
          i.d(e, "addLockableTarget", function () {
            return P;
          }),
          i.d(e, "addLockableSelector", function () {
            return _;
          }),
          i.d(e, "setFillGapMethod", function () {
            return D;
          }),
          i.d(e, "addFillGapTarget", function () {
            return I;
          }),
          i.d(e, "removeFillGapTarget", function () {
            return O;
          }),
          i.d(e, "addFillGapSelector", function () {
            return F;
          }),
          i.d(e, "removeFillGapSelector", function () {
            return H;
          }),
          i.d(e, "refillGaps", function () {
            return M;
          });
        var g = ["padding", "margin", "width", "max-width", "none"],
          y = {
            scroll: !0,
            queue: 0,
            scrollableSelectors: ["[data-scroll-lock-scrollable]"],
            lockableSelectors: ["body", "[data-scroll-lock-lockable]"],
            fillGapSelectors: [
              "body",
              "[data-scroll-lock-fill-gap]",
              "[data-scroll-lock-lockable]",
            ],
            fillGapMethod: g[0],
            startTouchY: 0,
            startTouchX: 0,
          },
          v = function (t) {
            y.queue <= 0 && ((y.scroll = !1), j(), R()), T(t), y.queue++;
          },
          b = function (t) {
            0 < y.queue && y.queue--,
              y.queue <= 0 && ((y.scroll = !0), N(), V()),
              A(t);
          },
          w = function () {
            return y.scroll;
          },
          S = function () {
            y.queue = 0;
          },
          E = function (t) {
            var e =
              1 < arguments.length && void 0 !== arguments[1] && arguments[1];
            if (o(t)) {
              var i = t.style.overflowY;
              e
                ? w() ||
                  (t.style.overflowY = t.getAttribute(
                    "data-scroll-lock-saved-overflow-y-property"
                  ))
                : (t.style.overflowY = "scroll");
              var n = L(t);
              return (t.style.overflowY = i), n;
            }
            return 0;
          },
          L = function (t) {
            if (o(t)) {
              if (t === document.body) {
                var e = document.documentElement.clientWidth;
                return window.innerWidth - e;
              }
              var i = t.style.borderLeftWidth,
                n = t.style.borderRightWidth;
              (t.style.borderLeftWidth = "0px"),
                (t.style.borderRightWidth = "0px");
              var r = t.offsetWidth - t.clientWidth;
              return (
                (t.style.borderLeftWidth = i), (t.style.borderRightWidth = n), r
              );
            }
            return 0;
          },
          k = function () {
            var t =
              0 < arguments.length && void 0 !== arguments[0] && arguments[0];
            return E(document.body, t);
          },
          x = function () {
            return L(document.body);
          },
          T = function (t) {
            t &&
              n(t).map(function (t) {
                r(t, function (t) {
                  o(t)
                    ? t.setAttribute("data-scroll-lock-scrollable", "")
                    : s('"'.concat(t, '" is not a Element.'));
                });
              });
          },
          A = function (t) {
            t &&
              n(t).map(function (t) {
                r(t, function (t) {
                  o(t)
                    ? t.removeAttribute("data-scroll-lock-scrollable")
                    : s('"'.concat(t, '" is not a Element.'));
                });
              });
          },
          C = function (t) {
            t &&
              n(t).map(function (t) {
                y.scrollableSelectors.push(t);
              });
          },
          q = function (t) {
            t &&
              n(t).map(function (t) {
                y.scrollableSelectors = y.scrollableSelectors.filter(function (
                  e
                ) {
                  return e !== t;
                });
              });
          },
          P = function (t) {
            t &&
              (n(t).map(function (t) {
                r(t, function (t) {
                  o(t)
                    ? t.setAttribute("data-scroll-lock-lockable", "")
                    : s('"'.concat(t, '" is not a Element.'));
                });
              }),
              w() || j());
          },
          _ = function (t) {
            t &&
              (n(t).map(function (t) {
                y.lockableSelectors.push(t);
              }),
              w() || j(),
              F(t));
          },
          D = function (t) {
            if (t)
              if (-1 !== g.indexOf(t)) (y.fillGapMethod = t), M();
              else {
                var e = g.join(", ");
                s(
                  '"'
                    .concat(
                      t,
                      '" method is not available!\nAvailable fill gap methods: '
                    )
                    .concat(e, ".")
                );
              }
          },
          I = function (t) {
            t &&
              n(t).map(function (t) {
                r(t, function (t) {
                  o(t)
                    ? (t.setAttribute("data-scroll-lock-fill-gap", ""),
                      y.scroll || G(t))
                    : s('"'.concat(t, '" is not a Element.'));
                });
              });
          },
          O = function (t) {
            t &&
              n(t).map(function (t) {
                r(t, function (t) {
                  o(t)
                    ? (t.removeAttribute("data-scroll-lock-fill-gap"),
                      y.scroll || X(t))
                    : s('"'.concat(t, '" is not a Element.'));
                });
              });
          },
          F = function (t) {
            t &&
              n(t).map(function (t) {
                -1 === y.fillGapSelectors.indexOf(t) &&
                  (y.fillGapSelectors.push(t), y.scroll || U(t));
              });
          },
          H = function (t) {
            t &&
              n(t).map(function (t) {
                (y.fillGapSelectors = y.fillGapSelectors.filter(function (e) {
                  return e !== t;
                })),
                  y.scroll || K(t);
              });
          },
          M = function () {
            y.scroll || R();
          },
          j = function () {
            var t = a(y.lockableSelectors);
            B(t);
          },
          N = function () {
            var t = a(y.lockableSelectors);
            $(t);
          },
          B = function (t) {
            var e = document.querySelectorAll(t);
            r(e, function (t) {
              W(t);
            });
          },
          $ = function (t) {
            var e = document.querySelectorAll(t);
            r(e, function (t) {
              z(t);
            });
          },
          W = function (t) {
            if (o(t) && "true" !== t.getAttribute("data-scroll-lock-locked")) {
              var e = window.getComputedStyle(t);
              t.setAttribute(
                "data-scroll-lock-saved-overflow-y-property",
                e.overflowY
              ),
                t.setAttribute(
                  "data-scroll-lock-saved-inline-overflow-property",
                  t.style.overflow
                ),
                t.setAttribute(
                  "data-scroll-lock-saved-inline-overflow-y-property",
                  t.style.overflowY
                ),
                (t.style.overflow = "hidden"),
                t.setAttribute("data-scroll-lock-locked", "true");
            }
          },
          z = function (t) {
            o(t) &&
              "true" === t.getAttribute("data-scroll-lock-locked") &&
              ((t.style.overflow = t.getAttribute(
                "data-scroll-lock-saved-inline-overflow-property"
              )),
              (t.style.overflowY = t.getAttribute(
                "data-scroll-lock-saved-inline-overflow-y-property"
              )),
              t.removeAttribute("data-scroll-lock-saved-overflow-property"),
              t.removeAttribute(
                "data-scroll-lock-saved-inline-overflow-property"
              ),
              t.removeAttribute(
                "data-scroll-lock-saved-inline-overflow-y-property"
              ),
              t.removeAttribute("data-scroll-lock-locked"));
          },
          R = function () {
            y.fillGapSelectors.map(function (t) {
              U(t);
            });
          },
          V = function () {
            y.fillGapSelectors.map(function (t) {
              K(t);
            });
          },
          U = function (t) {
            var e = document.querySelectorAll(t),
              i = -1 !== y.lockableSelectors.indexOf(t);
            r(e, function (t) {
              G(t, i);
            });
          },
          G = function (t) {
            var e =
              1 < arguments.length && void 0 !== arguments[1] && arguments[1];
            if (o(t)) {
              var i;
              if ("" === t.getAttribute("data-scroll-lock-lockable") || e)
                i = E(t, !0);
              else {
                var n = c(t, a(y.lockableSelectors));
                i = E(n, !0);
              }
              "true" === t.getAttribute("data-scroll-lock-filled-gap") && X(t);
              var r = window.getComputedStyle(t);
              if (
                (t.setAttribute("data-scroll-lock-filled-gap", "true"),
                t.setAttribute(
                  "data-scroll-lock-current-fill-gap-method",
                  y.fillGapMethod
                ),
                "margin" === y.fillGapMethod)
              ) {
                var s = parseFloat(r.marginRight);
                t.style.marginRight = "".concat(s + i, "px");
              } else if ("width" === y.fillGapMethod)
                t.style.width = "calc(100% - ".concat(i, "px)");
              else if ("max-width" === y.fillGapMethod)
                t.style.maxWidth = "calc(100% - ".concat(i, "px)");
              else if ("padding" === y.fillGapMethod) {
                var l = parseFloat(r.paddingRight);
                t.style.paddingRight = "".concat(l + i, "px");
              }
            }
          },
          K = function (t) {
            var e = document.querySelectorAll(t);
            r(e, function (t) {
              X(t);
            });
          },
          X = function (t) {
            if (
              o(t) &&
              "true" === t.getAttribute("data-scroll-lock-filled-gap")
            ) {
              var e = t.getAttribute(
                "data-scroll-lock-current-fill-gap-method"
              );
              t.removeAttribute("data-scroll-lock-filled-gap"),
                t.removeAttribute("data-scroll-lock-current-fill-gap-method"),
                "margin" === e
                  ? (t.style.marginRight = "")
                  : "width" === e
                  ? (t.style.width = "")
                  : "max-width" === e
                  ? (t.style.maxWidth = "")
                  : "padding" === e && (t.style.paddingRight = "");
            }
          };
        "undefined" != typeof window &&
          window.addEventListener("resize", function (t) {
            M();
          }),
          "undefined" != typeof document &&
            (document.addEventListener("touchstart", function (t) {
              y.scroll ||
                ((y.startTouchY = t.touches[0].clientY),
                (y.startTouchX = t.touches[0].clientX));
            }),
            document.addEventListener(
              "touchmove",
              function (t) {
                if (!y.scroll) {
                  var e = y.startTouchY,
                    i = y.startTouchX,
                    n = t.touches[0].clientY,
                    o = t.touches[0].clientX;
                  if (t.touches.length < 2) {
                    var r = a(y.scrollableSelectors),
                      s = e < n,
                      l = n < e,
                      u = i < o,
                      g = o < i,
                      v = e + 3 < n,
                      b = n < e - 3,
                      w = i + 3 < o,
                      S = o < i - 3;
                    !(function e(i) {
                      var n =
                        1 < arguments.length &&
                        void 0 !== arguments[1] &&
                        arguments[1];
                      if (i) {
                        var o = c(i, r, !1);
                        if (d(i, 'input[type="range"]')) return !1;
                        if (
                          n ||
                          (d(i, 'textarea, [contenteditable="true"]') &&
                            c(i, r)) ||
                          d(i, r)
                        ) {
                          var a = !1;
                          f(i) && m(i)
                            ? ((s && h(i)) || (l && p(i))) && (a = !0)
                            : h(i) && p(i)
                            ? ((u && f(i)) || (g && m(i))) && (a = !0)
                            : ((v && h(i)) ||
                                (b && p(i)) ||
                                (w && f(i)) ||
                                (S && m(i))) &&
                              (a = !0),
                            a && (o ? e(o, !0) : t.preventDefault());
                        } else e(o);
                      } else t.preventDefault();
                    })(t.target);
                  }
                }
              },
              { passive: !1 }
            ),
            document.addEventListener("touchend", function (t) {
              y.scroll || ((y.startTouchY = 0), (y.startTouchX = 0));
            }));
        var Y = {
            hide: function (t) {
              s(
                '"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget'
              ),
                v(t);
            },
            show: function (t) {
              s(
                '"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget'
              ),
                b(t);
            },
            toggle: function (t) {
              s('"toggle" is deprecated! Do not use it.'), w() ? v() : b(t);
            },
            getState: function () {
              return (
                s(
                  '"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate'
                ),
                w()
              );
            },
            getWidth: function () {
              return (
                s(
                  '"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth'
                ),
                k()
              );
            },
            getCurrentWidth: function () {
              return (
                s(
                  '"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth'
                ),
                x()
              );
            },
            setScrollableTargets: function (t) {
              s(
                '"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget'
              ),
                T(t);
            },
            setFillGapSelectors: function (t) {
              s(
                '"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector'
              ),
                F(t);
            },
            setFillGapTargets: function (t) {
              s(
                '"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget'
              ),
                I(t);
            },
            clearQueue: function () {
              s(
                '"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks'
              ),
                S();
            },
          },
          Q = (function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var i = null != arguments[e] ? arguments[e] : {},
                n = Object.keys(i);
              "function" == typeof Object.getOwnPropertySymbols &&
                (n = n.concat(
                  Object.getOwnPropertySymbols(i).filter(function (t) {
                    return Object.getOwnPropertyDescriptor(i, t).enumerable;
                  })
                )),
                n.forEach(function (e) {
                  var n, o, r;
                  (n = t),
                    (r = i[(o = e)]),
                    o in n
                      ? Object.defineProperty(n, o, {
                          value: r,
                          enumerable: !0,
                          configurable: !0,
                          writable: !0,
                        })
                      : (n[o] = r);
                });
            }
            return t;
          })(
            {
              disablePageScroll: v,
              enablePageScroll: b,
              getScrollState: w,
              clearQueueScrollLocks: S,
              getTargetScrollBarWidth: E,
              getCurrentTargetScrollBarWidth: L,
              getPageScrollBarWidth: k,
              getCurrentPageScrollBarWidth: x,
              addScrollableSelector: C,
              removeScrollableSelector: q,
              addScrollableTarget: T,
              removeScrollableTarget: A,
              addLockableSelector: _,
              addLockableTarget: P,
              addFillGapSelector: F,
              removeFillGapSelector: H,
              addFillGapTarget: I,
              removeFillGapTarget: O,
              setFillGapMethod: D,
              refillGaps: M,
              _state: y,
            },
            Y
          );
        e.default = Q;
      },
    ]).default;
  }),
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? e(exports)
      : "function" == typeof define && define.amd
      ? define(["exports"], e)
      : e(
          ((t =
            "undefined" != typeof globalThis ? globalThis : t || self).Sqrl =
            {})
        );
  })(this, function (t) {
    "use strict";
    function e(t) {
      var i,
        n,
        o = new Error(t);
      return (
        (i = o),
        (n = e.prototype),
        Object.setPrototypeOf ? Object.setPrototypeOf(i, n) : (i.__proto__ = n),
        o
      );
    }
    function i(t, i, n) {
      var o = i.slice(0, n).split(/\n/),
        r = o.length,
        s = o[r - 1].length + 1;
      throw e(
        (t +=
          " at line " +
          r +
          " col " +
          s +
          ":\n\n  " +
          i.split(/\n/)[r - 1] +
          "\n  " +
          Array(s).join(" ") +
          "^")
      );
    }
    e.prototype = Object.create(Error.prototype, {
      name: { value: "Squirrelly Error", enumerable: !1 },
    });
    var n = new Function("return this")().Promise,
      o = !1;
    try {
      o = new Function("return (async function(){}).constructor")();
    } catch (t) {
      if (!(t instanceof SyntaxError)) throw t;
    }
    function r(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }
    function s(t, e, i) {
      for (var n in e)
        r(e, n) &&
          (null == e[n] ||
          "object" != typeof e[n] ||
          ("storage" !== n && "prefixes" !== n) ||
          i
            ? (t[n] = e[n])
            : (t[n] = s({}, e[n])));
      return t;
    }
    var a = /^async +/,
      l = /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})*}|(?!\${)[^\\`])*`/g,
      c = /'(?:\\[\s\w"'\\`]|[^\n\r'\\])*?'/g,
      d = /"(?:\\[\s\w"'\\`]|[^\n\r"\\])*?"/g,
      u = /[.*+\-?^${}()|[\]\\]/g;
    function h(t) {
      return u.test(t) ? t.replace(u, "\\$&") : t;
    }
    function p(t, n) {
      n.rmWhitespace &&
        (t = t.replace(/[\r\n]+/g, "\n").replace(/^\s+|\s+$/gm, "")),
        (l.lastIndex = 0),
        (c.lastIndex = 0),
        (d.lastIndex = 0);
      var o = n.prefixes,
        r = [o.h, o.b, o.i, o.r, o.c, o.e].reduce(function (t, e) {
          return t && e ? t + "|" + h(e) : e ? h(e) : t;
        }, ""),
        s = new RegExp(
          "([|()]|=>)|('|\"|`|\\/\\*)|\\s*((\\/)?(-|_)?" + h(n.tags[1]) + ")",
          "g"
        ),
        u = new RegExp(
          "([^]*?)" + h(n.tags[0]) + "(-|_)?\\s*(" + r + ")?\\s*",
          "g"
        ),
        p = 0,
        f = !1;
      function m(e, o) {
        var r,
          h = { f: [] },
          m = 0,
          g = "c";
        function y(e) {
          var o = t.slice(p, e),
            r = o.trim();
          if ("f" === g)
            "safe" === r
              ? (h.raw = !0)
              : n.async && a.test(r)
              ? ((r = r.replace(a, "")), h.f.push([r, "", !0]))
              : h.f.push([r, ""]);
          else if ("fp" === g) h.f[h.f.length - 1][1] += r;
          else if ("err" === g) {
            if (r) {
              var s = o.search(/\S/);
              i("invalid syntax", t, p + s);
            }
          } else h[g] = r;
          p = e + 1;
        }
        for (
          "h" === o || "b" === o || "c" === o
            ? (g = "n")
            : "r" === o && ((h.raw = !0), (o = "i")),
            s.lastIndex = p;
          null !== (r = s.exec(t));

        ) {
          var v = r[1],
            b = r[2],
            w = r[3],
            S = r[4],
            E = r[5],
            L = r.index;
          if (v)
            "(" === v
              ? (0 === m &&
                  ("n" === g
                    ? (y(L), (g = "p"))
                    : "f" === g && (y(L), (g = "fp"))),
                m++)
              : ")" === v
              ? 0 == --m && "c" !== g && (y(L), (g = "err"))
              : 0 === m && "|" === v
              ? (y(L), (g = "f"))
              : "=>" === v && (y(L), (p += 1), (g = "res"));
          else if (b)
            if ("/*" === b) {
              var k = t.indexOf("*/", s.lastIndex);
              -1 === k && i("unclosed comment", t, r.index),
                (s.lastIndex = k + 2);
            } else
              "'" === b
                ? ((c.lastIndex = r.index),
                  c.exec(t)
                    ? (s.lastIndex = c.lastIndex)
                    : i("unclosed string", t, r.index))
                : '"' === b
                ? ((d.lastIndex = r.index),
                  d.exec(t)
                    ? (s.lastIndex = d.lastIndex)
                    : i("unclosed string", t, r.index))
                : "`" === b &&
                  ((l.lastIndex = r.index),
                  l.exec(t)
                    ? (s.lastIndex = l.lastIndex)
                    : i("unclosed string", t, r.index));
          else if (w)
            return (
              y(L),
              (p = L + r[0].length),
              (u.lastIndex = p),
              (f = E),
              S && "h" === o && (o = "s"),
              (h.t = o),
              h
            );
        }
        return i("unclosed tag", t, e), h;
      }
      var g = (function r(s, l) {
        (s.b = []), (s.d = []);
        var c,
          d = !1,
          h = [];
        function g(t, e) {
          t &&
            (t = (function (t, e, i, n) {
              var o, r;
              return (
                "string" == typeof e.autoTrim
                  ? (o = r = e.autoTrim)
                  : Array.isArray(e.autoTrim) &&
                    ((o = e.autoTrim[1]), (r = e.autoTrim[0])),
                (i || !1 === i) && (o = i),
                (n || !1 === n) && (r = n),
                "slurp" === o && "slurp" === r
                  ? t.trim()
                  : ("_" === o || "slurp" === o
                      ? (t = String.prototype.trimLeft
                          ? t.trimLeft()
                          : t.replace(/^[\s\uFEFF\xA0]+/, ""))
                      : ("-" !== o && "nl" !== o) ||
                        (t = t.replace(/^(?:\n|\r|\r\n)/, "")),
                    "_" === r || "slurp" === r
                      ? (t = String.prototype.trimRight
                          ? t.trimRight()
                          : t.replace(/[\s\uFEFF\xA0]+$/, ""))
                      : ("-" !== r && "nl" !== r) ||
                        (t = t.replace(/(?:\n|\r|\r\n)$/, "")),
                    t)
              );
            })(t, n, f, e)) &&
            ((t = t.replace(/\\|'/g, "\\$&").replace(/\r\n|\n|\r/g, "\\n")),
            h.push(t));
        }
        for (; null !== (c = u.exec(t)); ) {
          var y,
            v = c[1],
            b = c[2],
            w = c[3] || "";
          for (var S in o)
            if (o[S] === w) {
              y = S;
              break;
            }
          g(v, b),
            (p = c.index + c[0].length),
            y || i("unrecognized tag type: " + w, t, p);
          var E = m(c.index, y),
            L = E.t;
          if ("h" === L) {
            var k = E.n || "";
            n.async && a.test(k) && ((E.a = !0), (E.n = k.replace(a, ""))),
              (E = r(E)),
              h.push(E);
          } else if ("c" === L) {
            if (s.n === E.n) return d ? ((d.d = h), s.b.push(d)) : (s.d = h), s;
            i("Helper start and end don't match", t, c.index + c[0].length);
          } else if ("b" === L) {
            d ? ((d.d = h), s.b.push(d)) : (s.d = h);
            var x = E.n || "";
            n.async && a.test(x) && ((E.a = !0), (E.n = x.replace(a, ""))),
              (d = E),
              (h = []);
          } else if ("s" === L) {
            var T = E.n || "";
            n.async && a.test(T) && ((E.a = !0), (E.n = T.replace(a, ""))),
              h.push(E);
          } else h.push(E);
        }
        if (!l) throw e('unclosed helper "' + s.n + '"');
        return g(t.slice(p, t.length), !1), (s.d = h), s;
      })({ f: [] }, !0);
      if (n.plugins)
        for (var y = 0; y < n.plugins.length; y++) {
          var v = n.plugins[y];
          v.processAST && (g.d = v.processAST(g.d, n));
        }
      return g.d;
    }
    function f(t, e) {
      var i = p(t, e),
        n =
          "var tR='';" +
          (e.useWith ? "with(" + e.varName + "||{}){" : "") +
          b(i, e) +
          "if(cb){cb(null,tR)} return tR" +
          (e.useWith ? "}" : "");
      if (e.plugins)
        for (var o = 0; o < e.plugins.length; o++) {
          var r = e.plugins[o];
          r.processFnString && (n = r.processFnString(n, e));
        }
      return n;
    }
    function m(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i][0],
          o = e[i][1];
        (t = (e[i][2] ? "await " : "") + "c.l('F','" + n + "')(" + t),
          o && (t += "," + o),
          (t += ")");
      }
      return t;
    }
    function g(t, e, i, n, o, r) {
      var s =
        "{exec:" + (o ? "async " : "") + v(i, e, t) + ",params:[" + n + "]";
      return (
        r && (s += ",name:'" + r + "'"), o && (s += ",async:true"), s + "}"
      );
    }
    function y(t, e) {
      for (var i = "[", n = 0; n < t.length; n++) {
        var o = t[n];
        (i += g(e, o.res || "", o.d, o.p || "", o.a, o.n)),
          n < t.length && (i += ",");
      }
      return i + "]";
    }
    function v(t, e, i) {
      return "function(" + e + "){var tR='';" + b(t, i) + "return tR}";
    }
    function b(t, e) {
      for (var i = 0, n = t.length, o = ""; i < n; i++) {
        var r = t[i];
        if ("string" == typeof r) o += "tR+='" + r + "';";
        else {
          var s = r.t,
            a = r.c || "",
            l = r.f,
            c = r.n || "",
            d = r.p || "",
            u = r.res || "",
            h = r.b,
            p = !!r.a;
          if ("i" === s) {
            e.defaultFilter &&
              (a = "c.l('F','" + e.defaultFilter + "')(" + a + ")");
            var f = m(a, l);
            !r.raw && e.autoEscape && (f = "c.l('F','e')(" + f + ")"),
              (o += "tR+=" + f + ";");
          } else if ("h" === s)
            if (e.storage.nativeHelpers.get(c))
              o += e.storage.nativeHelpers.get(c)(r, e);
            else {
              var v =
                (p ? "await " : "") +
                "c.l('H','" +
                c +
                "')(" +
                g(e, u, r.d, d, p);
              (v += h ? "," + y(h, e) : ",[]"),
                (o += "tR+=" + m((v += ",c)"), l) + ";");
            }
          else
            "s" === s
              ? (o +=
                  "tR+=" +
                  m(
                    (p ? "await " : "") +
                      "c.l('H','" +
                      c +
                      "')({params:[" +
                      d +
                      "]},[],c)",
                    l
                  ) +
                  ";")
              : "e" === s && (o += a + "\n");
        }
      }
      return o;
    }
    var w = (function () {
        function t(t) {
          this.cache = t;
        }
        return (
          (t.prototype.define = function (t, e) {
            this.cache[t] = e;
          }),
          (t.prototype.get = function (t) {
            return this.cache[t];
          }),
          (t.prototype.remove = function (t) {
            delete this.cache[t];
          }),
          (t.prototype.reset = function () {
            this.cache = {};
          }),
          (t.prototype.load = function (t) {
            s(this.cache, t, !0);
          }),
          t
        );
      })(),
      S = new w({});
    function E(t, i, n, o) {
      if (i && i.length > 0)
        throw e(
          (o ? "Native" : "") + "Helper '" + t + "' doesn't accept blocks"
        );
      if (n && n.length > 0)
        throw e(
          (o ? "Native" : "") + "Helper '" + t + "' doesn't accept filters"
        );
    }
    var L = new w({
        each: function (t, e) {
          var i = "",
            n = t.params[0];
          if ((E("each", e, !1), t.async))
            return new Promise(function (e) {
              !(function t(e, i, n, o, r) {
                n(e[i], i).then(function (s) {
                  (o += s), i === e.length - 1 ? r(o) : t(e, i + 1, n, o, r);
                });
              })(n, 0, t.exec, i, e);
            });
          for (var o = 0; o < n.length; o++) i += t.exec(n[o], o);
          return i;
        },
        foreach: function (t, e) {
          var i = t.params[0];
          if ((E("foreach", e, !1), t.async))
            return new Promise(function (e) {
              !(function t(e, i, n, o, r, s) {
                o(i[n], e[i[n]]).then(function (a) {
                  (r += a), n === i.length - 1 ? s(r) : t(e, i, n + 1, o, r, s);
                });
              })(i, Object.keys(i), 0, t.exec, "", e);
            });
          var n = "";
          for (var o in i) r(i, o) && (n += t.exec(o, i[o]));
          return n;
        },
        include: function (t, i, n) {
          E("include", i, !1);
          var o = n.storage.templates.get(t.params[0]);
          if (!o) throw e('Could not fetch template "' + t.params[0] + '"');
          return o(t.params[1], n);
        },
        extends: function (t, i, n) {
          var o = t.params[1] || {};
          o.content = t.exec();
          for (var r = 0; r < i.length; r++) {
            var s = i[r];
            o[s.name] = s.exec();
          }
          var a = n.storage.templates.get(t.params[0]);
          if (!a) throw e('Could not fetch template "' + t.params[0] + '"');
          return a(o, n);
        },
        useScope: function (t, e) {
          return E("useScope", e, !1), t.exec(t.params[0]);
        },
      }),
      k = new w({
        if: function (t, e) {
          E("if", !1, t.f, !0);
          var i = "if(" + t.p + "){" + b(t.d, e) + "}";
          if (t.b)
            for (var n = 0; n < t.b.length; n++) {
              var o = t.b[n];
              "else" === o.n
                ? (i += "else{" + b(o.d, e) + "}")
                : "elif" === o.n &&
                  (i += "else if(" + o.p + "){" + b(o.d, e) + "}");
            }
          return i;
        },
        try: function (t, i) {
          if (
            (E("try", !1, t.f, !0),
            !t.b || 1 !== t.b.length || "catch" !== t.b[0].n)
          )
            throw e("native helper 'try' only accepts 1 block, 'catch'");
          var n = "try{" + b(t.d, i) + "}",
            o = t.b[0];
          return (
            n +
            "catch" +
            (o.res ? "(" + o.res + ")" : "") +
            "{" +
            b(o.d, i) +
            "}"
          );
        },
        block: function (t, e) {
          return (
            E("block", t.b, t.f, !0),
            "if(!" +
              e.varName +
              "[" +
              t.p +
              "]){tR+=(" +
              v(t.d, "", e) +
              ")()}else{tR+=" +
              e.varName +
              "[" +
              t.p +
              "]}"
          );
        },
      }),
      x = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      };
    function T(t) {
      return x[t];
    }
    var A = new w({
        e: function (t) {
          var e = String(t);
          return /[&<>"']/.test(e) ? e.replace(/[&<>"']/g, T) : e;
        },
      }),
      C = {
        varName: "it",
        autoTrim: [!1, "nl"],
        autoEscape: !0,
        defaultFilter: !1,
        tags: ["{{", "}}"],
        l: function (t, i) {
          if ("H" === t) {
            var n = this.storage.helpers.get(i);
            if (n) return n;
            throw e("Can't find helper '" + i + "'");
          }
          if ("F" === t) {
            var o = this.storage.filters.get(i);
            if (o) return o;
            throw e("Can't find filter '" + i + "'");
          }
        },
        async: !1,
        storage: { helpers: L, nativeHelpers: k, filters: A, templates: S },
        prefixes: { h: "@", b: "#", i: "", r: "*", c: "/", e: "!" },
        cache: !1,
        plugins: [],
        useWith: !1,
      };
    function q(t, e) {
      var i = {};
      return s(i, C), e && s(i, e), t && s(i, t), i.l.bind(i), i;
    }
    function P(t, i) {
      var n = q(i || {}),
        r = Function;
      if (n.async) {
        if (!o) throw e("This environment doesn't support async/await");
        r = o;
      }
      try {
        return new r(n.varName, "c", "cb", f(t, n));
      } catch (i) {
        throw i instanceof SyntaxError
          ? e(
              "Bad template syntax\n\n" +
                i.message +
                "\n" +
                Array(i.message.length + 1).join("=") +
                "\n" +
                f(t, n)
            )
          : i;
      }
    }
    function _(t, e) {
      var i;
      return e.cache && e.name && e.storage.templates.get(e.name)
        ? e.storage.templates.get(e.name)
        : ((i = "function" == typeof t ? t : P(t, e)),
          e.cache && e.name && e.storage.templates.define(e.name, i),
          i);
    }
    C.l.bind(C),
      (t.compile = P),
      (t.compileScope = b),
      (t.compileScopeIntoFunction = v),
      (t.compileToString = f),
      (t.defaultConfig = C),
      (t.filters = A),
      (t.getConfig = q),
      (t.helpers = L),
      (t.nativeHelpers = k),
      (t.parse = p),
      (t.render = function (t, i, o, r) {
        var s = q(o || {});
        if (!s.async) return _(t, s)(i, s);
        if (!r) {
          if ("function" == typeof n)
            return new n(function (e, n) {
              try {
                e(_(t, s)(i, s));
              } catch (t) {
                n(t);
              }
            });
          throw e(
            "Please provide a callback function, this env doesn't support Promises"
          );
        }
        try {
          _(t, s)(i, s, r);
        } catch (t) {
          return r(t);
        }
      }),
      (t.templates = S),
      Object.defineProperty(t, "__esModule", { value: !0 });
  });
const throttle = (t, e) => {
  let i, n;
  return function o(...r) {
    const s = Date.now();
    (n = clearTimeout(n)),
      !i || s - i >= e
        ? (t.apply(null, r), (i = s))
        : (n = setTimeout(o.bind(null, ...r), e - (s - i)));
  };
};
function preload(t, e) {
  "string" == typeof t && (t = [t]);
  for (let i = 0; i < t.length; i++) {
    loadImage(getSizedImageUrl(t[i], e));
  }
}
function loadImage(t) {
  new Image().src = t;
}
function imageSize(t) {
  const e = t.match(
    /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
  );
  return e ? e[1] : null;
}
function getSizedImageUrl(t, e) {
  if (null === e) return t;
  if ("master" === e) return removeProtocol(t);
  const i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  if (i) {
    const n = t.split(i[0]),
      o = i[0];
    return removeProtocol(`${n[0]}_${e}${o}`);
  }
  return null;
}
function removeProtocol(t) {
  return t.replace(/http(s)?:/, "");
}
var images = Object.freeze({
  __proto__: null,
  preload: preload,
  loadImage: loadImage,
  imageSize: imageSize,
  getSizedImageUrl: getSizedImageUrl,
  removeProtocol: removeProtocol,
});
function loadingAnimation() {
  document.documentElement.classList.remove("is-loading");
}
(PaloAlto.ThemeProduct = {
  getVariantFromId: function (t, e) {
    if ((this._validateProductStructure(t), "number" != typeof e))
      throw new TypeError(e + " is not a Number.");
    return (
      t.variants.filter(function (t) {
        return t.id === e;
      })[0] || null
    );
  },
  getVariantFromSerializedArray: function (t, e) {
    this._validateProductStructure(t);
    var i = this._createOptionArrayFromOptionCollection(t, e);
    return this.getVariantFromOptionArray(t, i);
  },
  getVariantFromOptionArray: function (t, e) {
    return (
      this._validateProductStructure(t),
      this._validateOptionsArray(e),
      t.variants.filter(function (t) {
        return e.every(function (e, i) {
          return t.options[i] === e;
        });
      })[0] || null
    );
  },
  _createOptionArrayFromOptionCollection: function (t, e) {
    this._validateProductStructure(t), this._validateSerializedArray(e);
    var i = [];
    return (
      e.forEach(function (e) {
        for (var n = 0; n < t.options.length; n++) {
          if (
            (t.options[n].name || t.options[n]).toLowerCase() ===
            e.name.toLowerCase()
          ) {
            i[n] = e.value;
            break;
          }
        }
      }),
      i
    );
  },
  _validateProductStructure: function (t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  },
  _validateSerializedArray: function (t) {
    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
    if (0 === t.length) throw new Error(t + " is empty.");
    if (!t[0].hasOwnProperty("name"))
      throw new Error(t[0] + "does not contain name key.");
    if ("string" != typeof t[0].name)
      throw new TypeError(
        "Invalid value type passed for name of option " +
          t[0].name +
          ". Value should be string."
      );
  },
  _validateOptionsArray: function (t) {
    if (Array.isArray(t) && "object" == typeof t[0])
      throw new Error(t + "is not a valid array of options.");
  },
}),
  (PaloAlto.ProductForm = (function () {
    const t = '[name="id"]',
      e = '[name="selling_plan"]',
      i = '[name^="options"]',
      n = '[name="quantity"]',
      o = '[name^="properties"]';
    function r(r, s, a) {
      (this.element = r),
        (this.form =
          "FORM" == this.element.tagName
            ? this.element
            : this.element.querySelector("form")),
        (this.product = this._validateProductObject(s)),
        (this.variantElement = this.element.querySelector(t)),
        (a = a || {}),
        (this._listeners = new PaloAlto.initListeners()),
        this._listeners.add(
          this.element,
          "submit",
          this._onSubmit.bind(this, a)
        ),
        (this.optionInputs = this._initInputs(i, a.onOptionChange)),
        (this.planInputs = this._initInputs(e, a.onPlanChange)),
        (this.quantityInputs = this._initInputs(n, a.onQuantityChange)),
        (this.propertyInputs = this._initInputs(o, a.onPropertyChange));
    }
    return (
      (r.prototype = $.extend({}, r.prototype, {
        destroy() {
          this._listeners.removeAll();
        },
        options() {
          return this._serializeInputValues(this.optionInputs, function (t) {
            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
          });
        },
        variant() {
          const t = this.options();
          return t.length
            ? PaloAlto.ThemeProduct.getVariantFromSerializedArray(
                this.product,
                t
              )
            : this.product.variants[0];
        },
        plan(t) {
          let e = { allocation: null, group: null, detail: null };
          const i = new FormData(this.form).get("selling_plan");
          return (
            i &&
              t &&
              (e.allocation = t.selling_plan_allocations.find(function (t) {
                return t.selling_plan_id.toString() === i.toString();
              })),
            e.allocation &&
              (e.group = this.product.selling_plan_groups.find(function (t) {
                return (
                  t.id.toString() ===
                  e.allocation.selling_plan_group_id.toString()
                );
              })),
            e.group &&
              (e.detail = e.group.selling_plans.find(function (t) {
                return t.id.toString() === i.toString();
              })),
            e && e.allocation && e.detail && e.allocation ? e : null
          );
        },
        properties() {
          return this._serializeInputValues(this.propertyInputs, function (t) {
            return (
              (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t
            );
          });
        },
        quantity() {
          return this.quantityInputs[0]
            ? Number.parseInt(this.quantityInputs[0].value, 10)
            : 1;
        },
        getFormState() {
          const t = this.variant();
          return {
            options: this.options(),
            variant: t,
            properties: this.properties(),
            quantity: this.quantity(),
            plan: this.plan(t),
          };
        },
        _setIdInputValue(t) {
          t && t.id
            ? (this.variantElement.value = t.id.toString())
            : (this.variantElement.value = ""),
            this.variantElement.dispatchEvent(new Event("change"));
        },
        _onSubmit(t, e) {
          (e.dataset = this.getFormState()),
            t.onFormSubmit && t.onFormSubmit(e);
        },
        _onOptionChange(t) {
          this._setIdInputValue(t.dataset.variant);
        },
        _onFormEvent(t) {
          return void 0 === t
            ? Function.prototype.bind()
            : function (e) {
                (e.dataset = this.getFormState()),
                  this._setIdInputValue(e.dataset.variant),
                  t(e);
              }.bind(this);
        },
        _initInputs(t, e) {
          return Array.prototype.slice
            .call(this.element.querySelectorAll(t))
            .map(
              function (t) {
                return (
                  this._listeners.add(t, "change", this._onFormEvent(e)), t
                );
              }.bind(this)
            );
        },
        _serializeInputValues: (t, e) =>
          t.reduce(function (t, i) {
            return (
              (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
                t.push(e({ name: i.name, value: i.value })),
              t
            );
          }, []),
        _validateProductObject(t) {
          if ("object" != typeof t)
            throw new TypeError(t + " is not an object.");
          if (void 0 === t.variants[0].options)
            throw new TypeError(
              "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
            );
          return t;
        },
      })),
      r
    );
  })()),
  (slate.a11y = {
    state: { firstFocusable: null, lastFocusable: null, trigger: null },
    pageLinkFocus: function (t) {
      var e = "js-focus-hidden";
      t.first()
        .attr("tabIndex", "-1")
        .focus()
        .addClass(e)
        .one("blur", function () {
          t.first().removeClass(e).removeAttr("tabindex");
        });
    },
    trapFocus: function (t) {
      var e = Array.from(
        t.container.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
        )
      ).filter(function (t) {
        var e = t.offsetWidth,
          i = t.offsetHeight;
        return (
          0 !== e &&
          0 !== i &&
          "none" !== getComputedStyle(t).getPropertyValue("display")
        );
      });
      (e = e.filter(function (t) {
        return !t.classList.contains("deferred-media__poster");
      })),
        (this.state.firstFocusable = e[0]),
        (this.state.lastFocusable = e[e.length - 1]),
        t.elementToFocus ||
          (t.elementToFocus = this.state.firstFocusable || t.container),
        this._setupHandlers(),
        document.addEventListener("focusin", this._onFocusInHandler),
        document.addEventListener("focusout", this._onFocusOutHandler),
        t.container.setAttribute("tabindex", "-1"),
        t.elementToFocus.focus();
    },
    removeTrapFocus: function (t) {
      const e = !document.body.classList.contains("no-outline");
      t && t.container && t.container.removeAttribute("tabindex"),
        document.removeEventListener("focusin", this._onFocusInHandler),
        this.state.trigger && e && this.state.trigger.focus();
    },
    _manageFocus: function (t) {
      t.keyCode === slate.utils.keyboardKeys.TAB &&
        (t.target !== this.state.lastFocusable ||
          t.shiftKey ||
          (t.preventDefault(), this.state.firstFocusable.focus()),
        t.target === this.state.firstFocusable &&
          t.shiftKey &&
          (t.preventDefault(), this.state.lastFocusable.focus()));
    },
    _onFocusOut: function () {
      document.removeEventListener("keydown", this._manageFocusHandler);
    },
    _onFocusIn: function (t) {
      (t.target !== this.state.lastFocusable &&
        t.target !== this.state.firstFocusable) ||
        document.addEventListener("keydown", this._manageFocusHandler);
    },
    _setupHandlers: function () {
      this._onFocusInHandler ||
        (this._onFocusInHandler = this._onFocusIn.bind(this)),
        this._onFocusOutHandler ||
          (this._onFocusOutHandler = this._onFocusIn.bind(this)),
        this._manageFocusHandler ||
          (this._manageFocusHandler = this._manageFocus.bind(this));
    },
  }),
  (slate.Currency = {
    formatMoney: function (t, e) {
      "string" == typeof t && (t = t.replace(".", ""));
      var i = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        o = e || "${{amount}}";
      function r(t, e, i, n) {
        if (((i = i || ","), (n = n || "."), isNaN(t) || null === t)) return 0;
        var o = (t = (t / 100).toFixed(e)).split(".");
        return (
          o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
          (o[1] ? n + o[1] : "")
        );
      }
      switch (o.match(n)[1]) {
        case "amount":
          i = r(t, 2);
          break;
        case "amount_no_decimals":
          i = r(t, 0);
          break;
        case "amount_with_comma_separator":
          i = r(t, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          i = r(t, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          i = r(t, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          i = r(t, 2, "'");
      }
      return o.replace(n, i);
    },
  }),
  (slate.utils = {
    findInstance: function (t, e, i) {
      for (var n = 0; n < t.length; n++) if (t[n][e] === i) return t[n];
    },
    removeInstance: function (t, e, i) {
      for (var n = t.length; n--; )
        if (t[n][e] === i) {
          t.splice(n, 1);
          break;
        }
      return t;
    },
    compact: function (t) {
      for (var e = -1, i = null == t ? 0 : t.length, n = 0, o = []; ++e < i; ) {
        var r = t[e];
        r && (o[n++] = r);
      }
      return o;
    },
    defaultTo: function (t, e) {
      return null == t || t != t ? e : t;
    },
    keyboardKeys: {
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      SPACE: 32,
      LEFTARROW: 37,
      RIGHTARROW: 39,
    },
  }),
  (PaloAlto.initCollapsible = (function () {
    const t = "[data-collapsible-trigger]",
      e = "[data-collapsible-content]",
      i = "data-collapsible-trigger-mobile",
      n = "aria-expanded",
      o = "aria-controls",
      r = "aria-hidden",
      s = "is-expanded";
    function a(e) {
      (this.container = e),
        (this.triggers = this.container.querySelectorAll(t)),
        (this.resetHeight = 0),
        (this._listeners = new PaloAlto.initListeners()),
        this.init();
    }
    return (
      (a.prototype = $.extend({}, a.prototype, {
        init() {
          (this.isTransitioning = !1),
            this.triggers.forEach((t) => {
              this._listeners.add(t, "click", (e) =>
                this.collapsibleToggleEvent(e, t)
              ),
                this._listeners.add(t, "keyup", (e) =>
                  this.collapsibleToggleEvent(e, t)
                );
            });
        },
        collapsibleToggleEvent(t, r) {
          t.preventDefault();
          const a = r.getAttribute(o),
            l = document.getElementById(a),
            c = r.hasAttribute(i),
            d = r.classList.contains(s),
            u = t.keyCode === slate.utils.keyboardKeys.SPACE,
            h = t.keyCode === slate.utils.keyboardKeys.ESCAPE,
            p = window.innerWidth < theme.sizes.small;
          let f = l.querySelector(e).offsetHeight;
          this.isTransitioning ||
            ((!t.keyCode || u || h) &&
              ((!d && h) ||
                (c && !p) ||
                ((this.isTransitioning = !0),
                d &&
                  setTimeout(() => {
                    (f = 0), this.setDropdownHeight(l, f, d);
                  }, 0),
                r.setAttribute(n, !d),
                r.classList.toggle(s, !d),
                this.setDropdownHeight(l, f, d))));
        },
        setDropdownHeight(t, e, i) {
          (t.style.height = `${e}px`),
            t.setAttribute(r, i),
            t.classList.toggle(s, !i),
            this.resetHeight && clearTimeout(this.resetHeight),
            0 == e &&
              (this.resetHeight = setTimeout(() => {
                t.style.height = "";
              }, 500)),
            i
              ? (this.isTransitioning = !1)
              : setTimeout(() => {
                  (t.style.height = "auto"), (this.isTransitioning = !1);
                }, 500);
        },
        onUnload() {
          this._listeners.removeAll();
        },
      })),
      a
    );
  })()),
  (PaloAlto.initFocusVisibility = function () {
    const t = "no-outline";
    document.addEventListener("keyup", (e) => {
      e.keyCode === slate.utils.keyboardKeys.TAB &&
        document.body.classList.remove(t);
    }),
      document.addEventListener("mousedown", () => {
        document.body.classList.add(t);
      });
  }),
  (PaloAlto.initTransparentHeader = function () {
    const t = "body",
      e = "[data-main]",
      i = "[data-site-header]",
      n = "[data-prevent-transparent-header]",
      o = "transparent-header",
      r = "site-header--transparent",
      s = "has-transparent-header",
      a = document.querySelector(t),
      l = a.querySelector(i),
      c = "true" === l.getAttribute("data-transparent"),
      d = a.querySelector(e).children[0];
    if (!d) return;
    const u = d.querySelector(`${n}:first-of-type`);
    (isHeaderTransparent = c && d.classList.contains(o) && !u),
      isHeaderTransparent
        ? (l.classList.add(r), a.classList.add(s))
        : (l.classList.remove(r), a.classList.remove(s));
  }),
  (PaloAlto.initSections = function () {
    new PaloAlto.Sections().register("header", PaloAlto.Header),
      $(document).on(
        "shopify:section:load shopify:section:reorder shopify:section:unload",
        function () {
          setTimeout(() => {
            PaloAlto.initTransparentHeader(),
              PaloAlto.setMainSpacing(),
              AOS.refreshHard();
          }, 300);
        }
      );
  }),
  (PaloAlto.Drawer = {
    attributes: { ariaExpanded: "aria-expanded" },
    selectors: {
      drawer: "[data-drawer]",
      drawerToggle: "[data-drawer-toggle]",
      scroller: "[data-scroll]",
    },
    classes: { open: "is-open", drawerOpen: "js-drawer-open" },
    init: function () {
      (this.drawers = document.querySelectorAll(this.selectors.drawer)),
        (this.drawerToggleButtons = document.querySelectorAll(
          this.selectors.drawerToggle
        )),
        (this.collapsible = null),
        (this.drawerToggleEvent = throttle((t) => {
          this.toggle(t);
        }, 150)),
        (this.keyPressCloseEvent = throttle((t) => {
          t.keyCode === slate.utils.keyboardKeys.ESCAPE && this.close(t);
        }, 150)),
        (this.drawerCloseEvent = (t) => {
          const e = document.querySelector(
              `${this.selectors.drawer}.${this.classes.open}`
            ),
            i = t.target.matches(this.selectors.drawerToggle),
            n = !!e && e.contains(t.target);
          i || n || this.close(t);
        }),
        this.drawerToggleButtons.forEach((t) => {
          t.addEventListener("click", this.drawerToggleEvent);
        }),
        this.drawers.forEach((t) => {
          t.addEventListener("keyup", this.keyPressCloseEvent),
            (this.collapsible = new PaloAlto.initCollapsible(t));
        }),
        document.addEventListener("click", this.drawerCloseEvent);
    },
    toggle: function (t) {
      t.preventDefault();
      const e = document.querySelector(
        `#${t.target.getAttribute("aria-controls")}`
      );
      if (!e) return;
      e.classList.contains(this.classes.open) ? this.close() : this.open(t);
    },
    open: function (t) {
      const e = t.target,
        i = document.querySelector(
          `#${t.target.getAttribute("aria-controls")}`
        );
      if (!i) return;
      const n = i.querySelector(this.selectors.scroller) || i;
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: n })
      ),
        document.dispatchEvent(new CustomEvent("theme:drawer:open"), {
          bubbles: !0,
        }),
        document.body.classList.add(this.classes.drawerOpen),
        i.classList.add(this.classes.open),
        e.setAttribute(this.attributes.ariaExpanded, !0),
        setTimeout(() => {
          (slate.a11y.state.trigger = e),
            slate.a11y.trapFocus({ container: i });
        });
    },
    close: function () {
      if (!document.body.classList.contains(this.classes.drawerOpen)) return;
      const t = document.querySelector(
        `${this.selectors.drawer}.${this.classes.open}`
      );
      this.drawerToggleButtons.forEach((t) => {
        t.setAttribute(this.attributes.ariaExpanded, !1);
      });
      document.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })
      ),
        slate.a11y.removeTrapFocus({ container: t }),
        t.classList.remove(this.classes.open),
        document.body.classList.remove(this.classes.drawerOpen),
        document.dispatchEvent(new CustomEvent("theme:drawer:close"), {
          bubbles: !0,
        });
    },
    destroy: function () {
      this.close(),
        this.drawerToggleButtons.forEach((t) => {
          t.removeEventListener("click", this.drawerToggleEvent);
        }),
        this.drawers.forEach((t) => {
          t.removeEventListener("keyup", this.keyPressCloseEvent);
        }),
        document.removeEventListener("click", this.drawerCloseEvent),
        null != this.collapsible && this.collapsible.onUnload();
    },
  }),
  (PaloAlto.Sections = function () {
    (this.constructors = {}),
      (this.instances = []),
      $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  }),
  (PaloAlto.Sections.prototype = _.assignIn({}, PaloAlto.Sections.prototype, {
    _createInstance: function (t, e) {
      var i = $(t),
        n = i.attr("data-section-id"),
        o = i.attr("data-section-type");
      if (((e = e || this.constructors[o]), !_.isUndefined(e))) {
        var r = _.assignIn(new e(t), { id: n, type: o, container: t });
        this.instances.push(r);
      }
    },
    _onSectionLoad: function (t) {
      var e = $("[data-section-id]", t.target)[0];
      e && this._createInstance(e);
    },
    _onSectionUnload: function (t) {
      this.instances = _.filter(this.instances, function (e) {
        var i = e.id === t.detail.sectionId;
        return i && _.isFunction(e.onUnload) && e.onUnload(t), !i;
      });
    },
    _onSelect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t);
    },
    _onDeselect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t);
    },
    _onBlockSelect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t);
    },
    _onBlockDeselect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) &&
        _.isFunction(e.onBlockDeselect) &&
        e.onBlockDeselect(t);
    },
    register: function (t, e) {
      (this.constructors[t] = e),
        $("[data-section-type=" + t + "]").each(
          function (t, i) {
            this._createInstance(i, e);
          }.bind(this)
        );
    },
  })),
  (PaloAlto.setMainSpacing = function () {
    const t = "[data-site-header]",
      e = "[data-page-container]",
      i = ".template-list-collections",
      n = "[data-collection-filters]",
      o = "has-scrolled",
      r = "header--sticky",
      s = "header--relative";
    document.body.classList.remove(o);
    const a = document.querySelector(e),
      l = document.querySelector(t),
      c = l.parentNode,
      d = "fixed" == l.dataset.position,
      u = document.querySelector(i),
      h = document.querySelector(n),
      p = isHeaderTransparent ? 0 : parseInt(l.clientHeight);
    (window.initialHeaderHeight = parseInt(l.dataset.height)),
      (a.style.paddingTop = p + "px"),
      d && !h ? c.classList.add(r) : c.classList.remove(r),
      !d && u && c.classList.add(s),
      document.dispatchEvent(new CustomEvent("theme:scroll"), { bubbles: !1 });
  });
let prev = window.pageYOffset,
  up = null,
  down = null,
  wasUp = null,
  wasDown = null,
  scrollLockTimer = 0;
const classes = {
  quickViewVisible: "js-quick-view-visible",
  cartDrawerOpen: "js-drawer-open-cart",
};
function dispatchScrollEvent() {
  const t = window.pageYOffset;
  t > prev
    ? ((down = !0), (up = !1))
    : t < prev
    ? ((down = !1), (up = !0))
    : ((up = null), (down = null)),
    (prev = t),
    document.dispatchEvent(
      new CustomEvent("theme:scroll", {
        detail: { up: up, down: down, position: t },
        bubbles: !1,
      })
    ),
    up &&
      !wasUp &&
      document.dispatchEvent(
        new CustomEvent("theme:scroll:up", {
          detail: { position: t },
          bubbles: !1,
        })
      ),
    down &&
      !wasDown &&
      document.dispatchEvent(
        new CustomEvent("theme:scroll:down", {
          detail: { position: t },
          bubbles: !1,
        })
      ),
    (wasDown = down),
    (wasUp = up);
}
function lock(t) {
  setTimeout(() => {
    scrollLockTimer && clearTimeout(scrollLockTimer),
      scrollLock.disablePageScroll(t.detail, {
        allowTouchMove: (t) => "TEXTAREA" === t.tagName,
      }),
      document.documentElement.setAttribute("data-scroll-locked", "");
  });
}
function unlock(t) {
  const e = t.detail;
  e ? (scrollLockTimer = setTimeout(removeScrollLock, e)) : removeScrollLock();
}
function removeScrollLock() {
  document.body.classList.contains(classes.quickViewVisible) ||
    document.body.classList.contains(classes.cartDrawerOpen) ||
    (scrollLock.clearQueueScrollLocks(),
    scrollLock.enablePageScroll(),
    document.documentElement.removeAttribute("data-scroll-locked"));
}
function scrollListener() {
  let t;
  window.addEventListener(
    "scroll",
    function () {
      t && window.cancelAnimationFrame(t),
        (t = window.requestAnimationFrame(function () {
          dispatchScrollEvent();
        }));
    },
    { passive: !0 }
  ),
    window.addEventListener("theme:scroll:lock", lock),
    window.addEventListener("theme:scroll:unlock", unlock);
}
const scrollTopButton = document.querySelector("[data-scroll-top-button]");
function getScrollbarWidth() {
  const t = document.createElement("div");
  (t.style.visibility = "hidden"),
    (t.style.overflow = "scroll"),
    (t.style.msOverflowStyle = "scrollbar"),
    document.body.appendChild(t);
  const e = document.createElement("div");
  t.appendChild(e);
  const i = t.offsetWidth - e.offsetWidth;
  return t.parentNode.removeChild(t), i;
}
function singles(t, e) {
  let i = 0;
  e.forEach((t) => {
    i = t.offsetHeight > i ? t.offsetHeight : i;
  });
  const n = t.querySelectorAll("[data-overflow-background]");
  [t, ...n].forEach((t) => {
    t.style.setProperty("min-height", `calc(${i}px + var(--header-height)`);
  });
}
function doubles(t) {
  if (window.innerWidth < window.theme.sizes.small) {
    return void t.querySelectorAll("[data-overflow-frame]").forEach((t) => {
      const e = t.querySelectorAll("[data-overflow-content]");
      singles(t, e);
    });
  }
  let e = 0;
  const i = t.querySelectorAll("[data-overflow-frame]");
  t.querySelectorAll("[data-overflow-content]").forEach((t) => {
    t.offsetHeight > e && (e = t.offsetHeight);
  });
  [...i, ...t.querySelectorAll("[data-overflow-background]")].forEach((t) => {
    t.style.setProperty("min-height", `${e}px`);
  }),
    t.style.setProperty("min-height", `${e}px`);
}
function preventOverflow(t) {
  const e = t.querySelectorAll("[data-overflow-container]");
  e &&
    e.forEach((t) => {
      const e = t.querySelectorAll("[data-overflow-content]");
      singles(t, e),
        document.addEventListener("theme:resize", () => {
          singles(t, e);
        });
    });
  const i = t.querySelectorAll("[data-overflow-wrapper]");
  i &&
    i.forEach((t) => {
      doubles(t),
        document.addEventListener("theme:resize", () => {
          doubles(t);
        });
    });
}
scrollTopButton &&
  (scrollTopButton.addEventListener("click", () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }),
  document.addEventListener(
    "scroll",
    throttle(() => {
      scrollTopButton.classList.toggle(
        "is-visible",
        window.pageYOffset > window.innerHeight
      );
    }, 150)
  )),
  Sqrl.filters.define("handle", function (t) {
    t = t.toLowerCase();
    for (var e = ['"', "'", "\\", "(", ")", "[", "]"], i = 0; i < e.length; ++i)
      t = t.replace(e[i], "");
    return (
      "-" == (t = t.replace(/\W+/g, "-")).charAt(t.length - 1) &&
        (t = t.replace(/-+\z/, "")),
      "-" == t.charAt(0) && (t = t.replace(/\A-+/, "")),
      t
    );
  }),
  Sqrl.filters.define("last", function (t) {
    const e = t.split("-");
    return e[e.length - 1];
  }),
  Sqrl.filters.define("asset_url", function (t) {
    let e = theme.assets.image;
    return (e = e.replace("image", t)), e;
  }),
  (PaloAlto.BgSet = {
    render: function (t, e) {
      let i = "";
      return (
        -1 != t.indexOf("no-image") && -1 != t.indexOf("2048x.gif") && (e = 1),
        (i +=
          t.replace("_2048x.", "_180x.") +
          " 180w " +
          Math.round(180 / e) +
          "h,"),
        (i +=
          t.replace("_2048x.", "_360x.") +
          " 360w " +
          Math.round(360 / e) +
          "h,"),
        (i +=
          t.replace("_2048x.", "_540x.") +
          " 540w " +
          Math.round(540 / e) +
          "h,"),
        (i +=
          t.replace("_2048x.", "_720x.") +
          " 720w " +
          Math.round(720 / e) +
          "h,"),
        (i +=
          t.replace("_2048x.", "_900x.") +
          " 900w " +
          Math.round(900 / e) +
          "h,"),
        (i +=
          t.replace("_2048x.", "_1080x.") +
          " 1080w " +
          Math.round(1080 / e) +
          "h,"),
        (i +=
          t.replace("_2048x.", "_1296x.") +
          " 1296w " +
          Math.round(1296 / e) +
          "h,"),
        (i +=
          t.replace("_2048x.", "_1512x.") +
          " 1512w " +
          Math.round(1512 / e) +
          "h,"),
        (i +=
          t.replace("_2048x.", "_1728x.") +
          " 1728w " +
          Math.round(1728 / e) +
          "h,"),
        (i +=
          t.replace("_2048x.", "_1950x.") +
          " 1950w " +
          Math.round(1950 / e) +
          "h,"),
        (i += t + " 2048w " + Math.round(2048 / e) + "h"),
        i
      );
    },
  }),
  (PaloAlto.FetchError = (function () {
    function t(t) {
      (this.status = t.status || null),
        (this.headers = t.headers || null),
        (this.json = t.json || null),
        (this.body = t.body || null);
    }
    return (t.prototype = Error.prototype), t;
  })()),
  (PaloAlto.fetchProduct = function (t) {
    const e = `${theme.routes.root}products/${t}.js`;
    return window
      .fetch(e)
      .then((t) => {
        if (t.ok) return t.json();
      })
      .catch((t) => {
        console.error(t);
      });
  }),
  (PaloAlto.formatPrices = function (t, e = !1) {
    const i = t.price <= t.compare_at_price_min,
      n = !t.available,
      o = theme.settings.showSoldBadge,
      r = theme.settings.showSaleBadge,
      s = theme.settings.showSavingBadge,
      a = theme.settings.savingBadgeType;
    let l = !1,
      c = !1,
      d = !1,
      u = t.price,
      h = t.compare_at_price,
      p = h - u;
    s &&
      !e &&
      (t.variants.length > 1 &&
        t.variants.forEach((t) => {
          const e = t.compare_at_price - t.price;
          e > p && ((p = e), (u = t.price), (h = t.compare_at_price));
        }),
      p > 0 &&
        ((u =
          "percentage" === a
            ? `${Math.round((100 * (-u / h + 1)).toFixed(2))}%`
            : slate.Currency.formatMoney(p, theme.moneyFormat)),
        (d = theme.strings.saving_badge.replace("{{ discount }}", u)),
        t.variants.length > 1 &&
          (d = theme.strings.saving_up_to_badge.replace("{{ discount }}", u)))),
      o && n && (l = theme.strings.sold_out),
      r && i && !n && !d && (c = theme.strings.sale_badge_text);
    return {
      ...t,
      soldBadgeText: l,
      saleBadgeText: c,
      savingBadgeText: d,
      compare_at_price_max: slate.Currency.formatMoney(
        t.compare_at_price_max,
        theme.moneyFormat
      ),
      compare_at_price_min: slate.Currency.formatMoney(
        t.compare_at_price_min,
        theme.moneyFormat
      ),
      price_max: slate.Currency.formatMoney(t.price_max, theme.moneyFormat),
      price_min: slate.Currency.formatMoney(t.price_min, theme.moneyFormat),
      unit_price: slate.Currency.formatMoney(t.unit_price, theme.moneyFormat),
    };
  }),
  (PaloAlto.HoverDisclosure = (function () {
    const t = "data-hover-disclosure-toggle",
      e = "[data-site-header]",
      i = "[data-top-link]",
      n = "[data-stagger]",
      o = "[data-stagger-first]",
      r = "[data-stagger-second]",
      s = "is-visible",
      a = "meganav--visible",
      l = "meganav--is-transitioning",
      c = "grandparent";
    function d(n) {
      (this.disclosure = n),
        (this.wrapper = n.closest(e)),
        (this.key = this.disclosure.id),
        (this.trigger = document.querySelector(`[${t}='${this.key}']`)),
        (this.link = this.trigger.querySelector(i)),
        (this.grandparent = this.trigger.classList.contains(c)),
        (this.transitionTimeout = 0),
        this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        this.connectHoverToggle(),
        this.handleTablets(),
        this.staggerChildAnimations();
    }
    return (
      (d.prototype = $.extend({}, d.prototype, {
        showDisclosure(t) {
          t &&
            t.type &&
            "mouseenter" === t.type &&
            this.wrapper.classList.add(l),
            this.grandparent
              ? this.wrapper.classList.add(a)
              : this.wrapper.classList.remove(a),
            this.trigger.setAttribute("aria-expanded", !0),
            this.trigger.classList.add(s),
            this.disclosure.classList.add(s),
            this.transitionTimeout && clearTimeout(this.transitionTimeout),
            (this.transitionTimeout = setTimeout(() => {
              this.wrapper.classList.remove(l);
            }, 200));
        },
        hideDisclosure() {
          this.disclosure.classList.remove(s),
            this.trigger.classList.remove(s),
            this.trigger.setAttribute("aria-expanded", !1),
            this.wrapper.classList.remove(a, l);
        },
        staggerChildAnimations() {
          this.disclosure.querySelectorAll(n).forEach((t, e) => {
            t.style.transitionDelay = 50 * e + 10 + "ms";
          });
          this.disclosure.querySelectorAll(o).forEach((t, e) => {
            const i = 150 * e;
            (t.style.transitionDelay = `${i}ms`),
              t.parentElement.querySelectorAll(r).forEach((t, e) => {
                const n = 20 * (e + 1);
                t.style.transitionDelay = `${i + n}ms`;
              });
          });
        },
        handleTablets() {
          this.trigger.addEventListener(
            "touchstart",
            function (t) {
              this.disclosure.classList.contains(s) ||
                (t.preventDefault(), this.showDisclosure(t));
            }.bind(this),
            { passive: !0 }
          );
        },
        connectHoverToggle() {
          this.trigger.addEventListener("mouseenter", (t) =>
            this.showDisclosure(t)
          ),
            this.link.addEventListener("focus", (t) => this.showDisclosure(t)),
            this.trigger.addEventListener("mouseleave", () =>
              this.hideDisclosure()
            ),
            this.trigger.addEventListener("focusout", (t) => {
              this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
            }),
            this.disclosure.addEventListener("keyup", (t) => {
              t.which === slate.utils.keyboardKeys.ESCAPE &&
                this.hideDisclosure();
            });
        },
        onBlockSelect(t) {
          this.disclosure.contains(t.target) && this.showDisclosure(t);
        },
        onBlockDeselect(t) {
          this.disclosure.contains(t.target) && this.hideDisclosure();
        },
      })),
      d
    );
  })()),
  (PaloAlto.NavSearch = (function () {
    const t = "body",
      e = "[data-site-header]",
      i = "[data-nav-search-open]",
      n = "[data-nav-search-close]",
      o = "[data-nav-search-form]",
      r = "[data-nav-search-container]",
      s = "[data-nav-search-scroller]",
      a = "[data-nav-search-results]",
      l = "[data-nav-search-input]",
      c = "[data-popular-search-link]",
      d = "[product-grid-item-template]",
      u = "[data-products-wrap]",
      h = "[noresult-item-template]",
      p = "[data-results-pagination]",
      f = "push-up",
      m = "js-drawer-open-cart",
      g = "js-drawer-open",
      y = "is-searching",
      v = "is-search-visible",
      b = "nav-search--is-visible",
      w = "is-pagination-visible";
    function S(f) {
      (this.container = f),
        (this.searchInput = this.container.querySelector(l)),
        (this.searchClose = this.container.querySelector(n)),
        (this.searchContainer = this.container.querySelector(r)),
        (this.popularLinks = this.container.querySelectorAll(c)),
        (this.scrollableElement = this.container.querySelector(s)),
        (this.searchResultsContainer = this.container.querySelector(a)),
        (this.searchForm = this.container.querySelector(o)),
        (this.resultsPagination = this.container.querySelector(p)),
        (this.productTemplate = document.querySelector(d).innerHTML),
        (this.productsWrapper = document.querySelector(u)),
        (this.noresultTemplate = document.querySelector(h).innerHTML),
        (this.searchOpen = document.querySelectorAll(i)),
        (this.bodySelector = document.querySelector(t)),
        (this.headerSelector = document.querySelector(e)),
        (this.isNavDrawerOpen = this.bodySelector.classList.contains(g)),
        (this.isCartDrawerOpen = this.bodySelector.classList.contains(m)),
        (this.result = null),
        (this.openSearchTimeout = 0),
        (this.linkOpened = null),
        this.init();
    }
    return (
      (S.prototype = $.extend({}, S.prototype, {
        init() {
          this.initListeners(), this.initSearch();
        },
        initSearch() {
          this.searchInput.addEventListener(
            "input",
            PaloAlto.debounce(
              function (t) {
                const e = t.target.value;
                e && e.length > 1
                  ? (this.searchContainer.classList.add(y, f),
                    this.fetchProductSuggestions(e))
                  : this.reset();
              }.bind(this),
              300
            )
          ),
            this.searchInput.addEventListener("clear", this.reset.bind(this));
        },
        initListeners() {
          return (
            this.container.addEventListener("keyup", (t) => {
              t.keyCode === slate.utils.keyboardKeys.ESCAPE &&
                (t.stopImmediatePropagation(), this.close());
            }),
            this.searchOpen.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault(), this.open(), (this.linkOpened = t.target);
              });
            }),
            this.searchClose.addEventListener("click", (t) => {
              t.preventDefault(), this.close();
            }),
            this.popularLinks.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault();
                const e = t.target.textContent;
                (this.searchInput.value = e),
                  (window.location.href = `${theme.routes.search_url}?type=product&q=${e}&options[prefix]=last`);
              });
            }),
            this.linkOpened
          );
        },
        open() {
          this.isNavDrawerOpen || this.isCartDrawerOpen
            ? (PaloAlto.Drawer.close(),
              this.openSearchTimeout && clearTimeout(this.openSearchTimeout),
              (this.openSearchTimeout = setTimeout(this.openSearch, 400)))
            : this.openSearch();
        },
        openSearch() {
          this.headerSelector.classList.add(v),
            this.container.classList.add(b),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", {
                bubbles: !0,
                detail: this.scrollableElement,
              })
            ),
            setTimeout(() => {
              slate.a11y.trapFocus({
                container: this.container,
                elementToFocus: this.searchInput,
              });
            }, 100);
        },
        close() {
          this.headerSelector.classList.contains(v) &&
            (this.reset(),
            slate.a11y.removeTrapFocus({ container: this.container }),
            this.headerSelector.classList.remove(v),
            this.container.classList.remove(b),
            setTimeout(() => {
              slate.a11y.trapFocus({
                container: this.headerSelector,
                elementToFocus: this.linkOpened,
              });
            }, 100),
            setTimeout(() => {
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
            }, 250));
        },
        reset(t = !0) {
          (this.productsWrapper.innerHTML = ""),
            (this.searchInput.val = ""),
            slate.a11y.removeTrapFocus(),
            t &&
              (this.searchContainer.classList.remove([y, f]),
              this.searchResultsContainer.classList.remove(w));
        },
        fetchProductSuggestions(t) {
          fetch(
            `/search/suggest.json?q=${encodeURIComponent(
              t
            )}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`
          )
            .then(this.handleErrors)
            .then((t) => t.json())
            .then(
              (t) => (
                (this.result = t.resources.results),
                this.fetchProducts(this.result.products)
              )
            )
            .then((e) => {
              (this.productsWrapper.innerHTML = ""),
                this.searchResultsContainer.classList.remove(w),
                "" === e
                  ? this.injectHTML($(u)[0], this.renderNoResult())
                  : (this.injectHTML($(u)[0], e),
                    this.result.products.length > 9 &&
                      ((this.resultsPagination.getElementsByTagName(
                        "a"
                      )[0].href = `${theme.routes.search_url}?type=product&q=${t}&options[prefix]=last`),
                      this.searchResultsContainer.classList.add(w)),
                    slate.a11y.removeTrapFocus({ container: this.container }),
                    slate.a11y.trapFocus({
                      container: this.container,
                      elementToFocus: this.searchInput,
                    })),
                this.searchContainer.classList.remove(y);
            })
            .catch((t) => {
              console.error(t);
            });
        },
        injectHTML(t, e) {
          t.innerHTML += e;
        },
        renderNoResult() {
          const t = { text: theme.strings.no_results };
          return Sqrl.render(this.noresultTemplate, { item: t });
        },
        fetchProducts(t) {
          const e = [];
          return (
            t.forEach((t) => {
              e.push(
                PaloAlto.fetchProduct(t.handle).then((t) => {
                  const e = PaloAlto.formatPrices(t);
                  return this.renderProduct(e);
                })
              );
            }),
            Promise.all(e).then((t) => {
              let e = "";
              return (
                t.forEach((t) => {
                  e += t;
                }),
                e
              );
            })
          );
        },
        renderProduct(t) {
          const e = t.title.replace(/(<([^>]+)>)/gi, "");
          let i = null,
            n = "";
          if ((void 0 !== t.media && (i = t.media[0]), i)) {
            let t = !1;
            "contain" == theme.settings.gridImageSize &&
              (t =
                i.preview_image.aspect_ratio >
                theme.settings.gridImageAspectRatio
                  ? "landscape"
                  : "portrait"),
              (n = {
                thumb: PaloAlto.BgSet.render(
                  getSizedImageUrl(i.preview_image.src, "2048x"),
                  i.preview_image.aspect_ratio
                ),
                aspectRatio: i.preview_image.aspect_ratio,
                layout: t,
              });
          } else n = { thumb: theme.assets.no_image, alt: "", aspectRatio: 1 };
          const o = { ...t, title: e, image: n };
          return Sqrl.render(this.productTemplate, { product: o });
        },
        handleErrors: (t) =>
          t.ok
            ? t
            : t.json().then(function (e) {
                throw new PaloAlto.FetchError({
                  status: t.statusText,
                  headers: t.headers,
                  json: e,
                });
              }),
      })),
      S
    );
  })()),
  (PaloAlto.ProductModel = (function () {
    let t = {},
      e = {},
      i = {};
    const n = {
        productMediaWrapper: "[data-product-single-media-wrapper]",
        mediaGroup: "[data-product-single-media-group]",
        productXr: "[data-shopify-xr]",
        mediaId: "data-media-id",
        model3d: "data-shopify-model3d-id",
        modelViewer: "model-viewer",
        modelJson: "#ModelJson-",
        deferredMedia: "[data-deferred-media]",
        deferredMediaButton: "[data-deferred-media-button]",
      },
      o = { isLoading: "is-loading", mediaHidden: "media--hidden" };
    function r(t, r) {
      if (t.querySelector(n.deferredMedia).getAttribute("loaded")) return;
      t.classList.add(o.isLoading);
      const l = document.createElement("div");
      l.appendChild(
        t.querySelector("template").content.firstElementChild.cloneNode(!0)
      );
      const c = l.querySelector("model-viewer"),
        d = t.querySelector(n.deferredMedia);
      d.appendChild(c), d.setAttribute("loaded", !0);
      const u = t.dataset.mediaId,
        h = c.dataset.modelId,
        p = t.closest(n.mediaGroup).parentElement.querySelector(n.productXr);
      (i[r] = { element: p, defaultId: h }),
        (e[u] = {
          modelId: h,
          mediaId: u,
          sectionId: r,
          container: t,
          element: c,
        }),
        window.ShopifyXR
          ? a()
          : window.Shopify.loadFeatures([
              { name: "shopify-xr", version: "1.0", onLoad: s },
              { name: "model-viewer-ui", version: "1.0", onLoad: a },
            ]);
    }
    function s(e) {
      if (e) console.warn(e);
      else if (window.ShopifyXR) {
        for (const e in t)
          if (t.hasOwnProperty(e)) {
            const i = t[e];
            if (i.loaded) continue;
            const o = document.querySelector(`${n.modelJson}${e}`);
            o &&
              (window.ShopifyXR.addModels(JSON.parse(o.innerHTML)),
              (i.loaded = !0));
          }
        window.ShopifyXR.setupXRElements();
      } else
        document.addEventListener("shopify_xr_initialized", function () {
          s();
        });
    }
    function a(t) {
      if (t) console.warn(t);
      else
        for (const t in e)
          if (e.hasOwnProperty(t)) {
            const i = e[t];
            i.modelViewerUi ||
              ((i.modelViewerUi = new Shopify.ModelViewerUI(i.element)), l(i));
          }
    }
    function l(t) {
      const e = i[t.sectionId];
      t.container.addEventListener("theme:media:visible", function () {
        e.element.setAttribute(n.model3d, t.modelId),
          window.theme.touch ||
            (t.modelViewerUi.play(),
            t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
              bubbles: !0,
            }));
      }),
        t.container.addEventListener("theme:media:hidden", function () {
          t.modelViewerUi.pause();
        }),
        t.container.addEventListener("xrLaunch", function () {
          t.modelViewerUi.pause();
        }),
        t.element.addEventListener("load", () => {
          e.element.setAttribute(n.model3d, t.modelId),
            t.container.classList.remove(o.isLoading),
            t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
              bubbles: !0,
            });
        }),
        t.element.addEventListener(
          "shopify_model_viewer_ui_toggle_play",
          function () {
            c(t.mediaId),
              t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                bubbles: !0,
              });
          }
        ),
        t.element.addEventListener(
          "shopify_model_viewer_ui_toggle_pause",
          function () {
            t.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
              bubbles: !0,
            });
          }
        ),
        c(t.mediaId);
    }
    function c(t) {
      const e = `[${n.mediaId}="${t}"]`,
        i = document.querySelectorAll(`${n.productMediaWrapper}:not(${e})`);
      i.length &&
        i.forEach((t) => {
          t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            t.classList.add(o.mediaHidden);
        });
    }
    return {
      init: function (e, i) {
        t[i] = { loaded: !1 };
        const o = e.querySelector(n.deferredMediaButton);
        o && o.addEventListener("click", r.bind(this, e, i));
      },
      loadContent: r,
      removeSectionModels: function (i) {
        for (const t in e)
          if (e.hasOwnProperty(t)) {
            e[t].sectionId === i && delete e[t];
          }
        delete t[i], delete theme.mediaInstances[i];
      },
    };
  })()),
  (PaloAlto.Header = (function () {
    const t = "[data-announcement-wrapper]",
      e = "[data-collection-filters]",
      i = "[data-hover-disclosure]",
      n = "[data-logo]",
      o = "[data-collapsible-trigger]",
      r = "[data-nav]",
      s = "[data-nav-icons]",
      a = "[data-nav-item]",
      l = "[data-nav-link-mobile]",
      c = "[data-nav-search]",
      d = "[data-wrapper]",
      u = {
        jsDrawerOpenAll: ["js-drawer-open", "js-drawer-open-cart"],
        headerTransparent: "site-header--transparent",
        headerLoading: "site-header--loading",
        hasScrolled: "has-scrolled",
        hideHeader: "hide-header",
        navCompress: "nav--compress",
        headerSticky: "header--sticky",
      };
    function h(t) {
      (this.container = t),
        (this.header = t),
        (this.headerSection = t.parentNode),
        (this.headerWrapper = t.querySelector(d)),
        (this.logo = t.querySelector(n)),
        (this.nav = t.querySelector(r)),
        (this.navIcons = t.querySelector(s)),
        (this.navDrawerCloseEvent = null),
        (this.headerStateEvent = (t) => this.headerState(t)),
        PaloAlto.initTransparentHeader(),
        PaloAlto.setMainSpacing(),
        PaloAlto.Drawer.init(),
        (this.sections = []);
      const o = this.container.querySelectorAll(i);
      o.length &&
        o.forEach((t) => {
          this.sections.push(new PaloAlto.HoverDisclosure(t));
        }),
        this.controlNav(),
        this.initMobileNav(),
        window.addEventListener("load", this.controlNav.bind(this)),
        document.addEventListener(
          "theme:resize:width",
          this.controlNav.bind(this)
        );
      const a = document.querySelector(c),
        l = document.querySelector(e);
      a && new PaloAlto.NavSearch(a),
        l
          ? this.header.classList.remove(u.headerLoading)
          : this.initStickyHeader();
    }
    return (
      (h.prototype = $.extend({}, h.prototype, {
        initStickyHeader: function () {
          (this.position = this.header.dataset.position),
            "fixed" === this.position
              ? this.headerSection.classList.add(u.headerSticky)
              : this.headerSection.classList.remove(u.headerSticky),
            this.header.classList.remove(u.headerLoading),
            this.headerState(),
            document.addEventListener("theme:scroll", this.headerStateEvent);
        },
        headerState: function (e) {
          const i = parseInt(
              this.header.dataset.height || this.header.offsetHeight
            ),
            n = document.querySelector(t),
            o = i + (n ? n.offsetHeight : 0),
            r = window.pageYOffset || document.documentElement.scrollTop,
            s = e && e.detail && e.detail.up;
          "fixed" === this.position &&
            (r > o
              ? (document.body.classList.add(u.hasScrolled),
                this.header.classList.remove(u.headerTransparent))
              : (document.body.classList.remove(u.hasScrolled),
                window.isHeaderTransparent &&
                  this.header.classList.add(u.headerTransparent)),
            r < o && s
              ? document.body.classList.add(u.hideHeader)
              : document.body.classList.remove(u.hideHeader));
        },
        controlNav: function () {
          this.nav.classList.remove(u.navCompress);
          const t = "center" === this.header.dataset.navAlignment,
            e = "left" === this.header.dataset.navAlignment,
            i =
              this.headerWrapper.currentStyle ||
              window.getComputedStyle(this.headerWrapper),
            n =
              this.headerWrapper.clientWidth -
              parseFloat(i.paddingLeft) -
              parseFloat(i.paddingRight),
            o = this.logo ? this.logo.offsetWidth : 0,
            r = this.navIcons ? this.navIcons.offsetWidth : 0;
          let s = n - o - r - 20,
            a = this.getNavItemsWidth();
          t && (s = n - 2 * (Math.max(o, r) + 20)),
            e && (s = (n - (o + 40)) / 2),
            a > s
              ? this.nav.classList.add(u.navCompress)
              : this.nav.classList.remove(u.navCompress);
        },
        getNavItemsWidth: function () {
          let t = 0;
          const e = this.nav.querySelectorAll(a);
          return (
            e.length &&
              e.forEach((e) => {
                t += Math.ceil(e.offsetWidth);
              }),
            t
          );
        },
        initMobileNav: function () {
          if ("link" === theme.settings.mobileMenuBehaviour) return;
          const t = this.headerSection.querySelectorAll(l);
          t.length &&
            t.forEach((t) => {
              t.addEventListener("click", (e) => {
                const i = t.parentNode.querySelectorAll(o).length,
                  n = t.nextElementSibling;
                i &&
                  (e.preventDefault(),
                  n.dispatchEvent(new Event("click"), { bubbles: !0 }));
              });
            });
        },
        onUnload: function () {
          PaloAlto.Drawer.close(),
            PaloAlto.Drawer.destroy(),
            document.body.classList.remove(...u.jsDrawerOpenAll),
            document.removeEventListener("theme:scroll", this.headerStateEvent),
            document.removeEventListener("theme:resize:width", this.controlNav),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
            "function" == typeof window.cart.destroy && window.cart.destroy();
        },
      })),
      h
    );
  })()),
  $.ajaxSetup({ cache: !1 }),
  document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${getScrollbarWidth()}px`
  ),
  document.addEventListener("DOMContentLoaded", function () {
    PaloAlto.initSections(),
      PaloAlto.initFocusVisibility(),
      document.addEventListener("theme:resize:width", PaloAlto.setMainSpacing);
    const t = window.location.hash,
      e = t.substr(1, t.length);
    null !== document.getElementById(e) &&
      slate.a11y.pageLinkFocus($(window.location.hash));
    const i = document.querySelector(".in-page-link");
    i &&
      i.addEventListener("click", function (t) {
        slate.a11y.pageLinkFocus($(t.currentTarget.hash));
      });
  }),
  (PaloAlto.updateHash = function (t) {
    (window.location.hash = "#" + t),
      $("#" + t)
        .attr("tabindex", -1)
        .focus();
  }),
  document.addEventListener("shopify:section:load", () => {
    window.dispatchEvent(new Event("resize"), { bubbles: !0 }),
      preventOverflow(document);
  }),
  void 0 !== theme.settings.newHash &&
    PaloAlto.updateHash(theme.settings.newHash),
  scrollListener(),
  window.addEventListener("load", () => {
    preventOverflow(document), loadingAnimation();
  });
